//     wink-lexicon
//     English lexicon useful in NLP/NLU
//
//     Copyright (C)  GRAYPE Systems Private Limited
//
//     This file is part of “wink-lexicon”.
//
//     Permission is hereby granted, free of charge, to any person obtaining a
//     copy of this software and associated documentation files (the "Software"),
//     to deal in the Software without restriction, including without limitation
//     the rights to use, copy, modify, merge, publish, distribute, sublicense,
//     and/or sell copies of the Software, and to permit persons to whom the
//     Software is furnished to do so, subject to the following conditions:
//
//     The above copyright notice and this permission notice shall be included
//     in all copies or substantial portions of the Software.
//
//     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//     OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
//     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
//     THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
//     LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
//     FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
//     DEALINGS IN THE SOFTWARE.
//
// This is manually curated list of commonly used english words along withes
// their most frequently used part-of-speech form.
//
// A portion of this data is derived from the fnTBL project. The fnTBL is
// copyright by Johns Hopkins University and Radu Florian and Grace Ngai.
// It is sourced from www.cs.jhu.edu/~rflorian/fntbl/index.html;
// licensed under the MIT "like" License. You may obtain a copy of the License
// at www.cs.jhu.edu/~rflorian/fntbl/license.html.

/* eslint max-lines: [ 'error', 15000 ] */

/** @ignore */
// Define each part-of-speech here.
var POS = 'POS';
var MD = 'MD';
var VBP = 'VBP';
var DT = 'DT';
var VBZ = 'VBZ';
var NN = 'NN';
var VBG = 'VBG';
var VB = 'VB';
var VBN = 'VBN';
var NNS = 'NNS';
var JJ = 'JJ';
var IN = 'IN';
var RB = 'RB';
var VBD = 'VBD';
var UH = 'UH';
var CC = 'CC';
var FW = 'FW';
var JJS = 'JJS';
var JJR = 'JJR';
var RBR = 'RBR';
var PRP = 'PRP';
var PRP$ = 'PRP$';
var WRB = 'WRB';
var NNP = 'NNP';
var RBS = 'RBS';
var EX = 'EX';
var TO = 'TO';
var WP = 'WP';
var WDT = 'WDT';
var WP$ = 'WP$';
var CD = 'CD';
var LS = 'LS';
var RP = 'RP';
var PDT = 'PDT';
var NNPS = 'NNPS'; // Define each possible pos combinations that various words can have.

var A_VB = [VB];
var A_MD = [MD];
var A_MD_VBD_NNP = [MD, VBD, NNP];
var A_VBP = [VBP];
var A_POS = [POS];
var A_POS_VBZ_PRP_NNP = [POS, VBZ, PRP, NNP];
var A_DT_VB_VBN_NNP_FW_JJ_LS_NN = [DT, VB, VBN, NNP, FW, JJ, LS, NN];
var A_VBP_FW_RB = [VBP, FW, RB];
var A_DT_CC_JJ_NNP = [DT, CC, JJ, NNP];
var A_VBP_NNP = [VBP, NNP];
var A_VBZ = [VBZ];
var A_NN = [NN];
var A_VBG = [VBG];
var A_VB_NN_VBP = [VB, NN, VBP];
var A_VBN_VBD_JJ = [VBN, VBD, JJ];
var A_NNS = [NNS];
var A_JJ = [JJ];
var A_JJ_VBD_VBN = [JJ, VBD, VBN];
var A_IN_JJ_RB_RP_RBR = [IN, JJ, RB, RP, RBR];
var A_IN_JJ_RB = [IN, JJ, RB];
var A_RB = [RB];
var A_JJ_NN = [JJ, NN];
var A_VBG_JJ = [VBG, JJ];
var A_VB_VBP = [VB, VBP];
var A_VBN_JJ_VBD = [VBN, JJ, VBD];
var A_JJ_VBD = [JJ, VBD];
var A_JJ_NN_VBP = [JJ, NN, VBP];
var A_NN_VB_VBP = [NN, VB, VBP];
var A_NNS_VBZ = [NNS, VBZ];
var A_VBN_JJ = [VBN, JJ];
var A_NN_VB = [NN, VB];
var A_VBN = [VBN];
var A_VBN_VBD = [VBN, VBD];
var A_NN_VBP_RB_VB = [NN, VBP, RB, VB];
var A_NN_VBP_VB = [NN, VBP, VB];
var A_NN_VBG_JJ = [NN, VBG, JJ];
var A_VBD_VBN = [VBD, VBN];
var A_VBN_VBD_JJ_NN = [VBN, VBD, JJ, NN];
var A_NN_JJ = [NN, JJ];
var A_VBD_VBN_JJ = [VBD, VBN, JJ];
var A_VBP_VB = [VBP, VB];
var A_IN_RB_RP = [IN, RB, RP];
var A_VBG_JJ_NN = [VBG, JJ, NN];
var A_VBG_NN = [VBG, NN];
var A_NN_FW = [NN, FW];
var A_VBD_JJ_VBN = [VBD, JJ, VBN];
var A_VBZ_NNS = [VBZ, NNS];
var A_NN_JJ_VB_VBP = [NN, JJ, VB, VBP];
var A_NN_VBG = [NN, VBG];
var A_VB_VBP_NN = [VB, VBP, NN];
var A_NNS_RB = [NNS, RB];
var A_IN = [IN];
var A_NN_VBP = [NN, VBP];
var A_VBN_JJ_NNS_VBD = [VBN, JJ, NNS, VBD];
var A_NN_NNS = [NN, NNS];
var A_RB_IN = [RB, IN];
var A_UH = [UH];
var A_UH_VBP = [UH, VBP];
var A_RB_JJ = [RB, JJ];
var A_NN_VB_VBN_VBP = [NN, VB, VBN, VBP];
var A_JJ_VBG = [JJ, VBG];
var A_JJ_RB = [JJ, RB];
var A_DT_RB_PDT = [DT, RB, PDT];
var A_VBN_JJ_VB_VBD = [VBN, JJ, VB, VBD];
var A_IN_RB = [IN, RB];
var A_VB_VBP_JJ = [VB, VBP, JJ];
var A_JJ_VBP_NN_VB = [JJ, VBP, NN, VB];
var A_CC_VBP_JJ_RB_NNP = [CC, VBP, JJ, RB, NNP];
var A_DT_JJ_NN = [DT, JJ, NN];
var A_DT_RB = [DT, RB];
var A_RB_RP_JJ = [RB, RP, JJ];
var A_NNS_JJ = [NNS, JJ];
var A_JJ_VBP_VB = [JJ, VBP, VB];
var A_NNS_VBN = [NNS, VBN];
var A_JJ_VB = [JJ, VB];
var A_IN_NNP_JJ_RB = [IN, NNP, JJ, RB];
var A_RB_RP = [RB, RP];
var A_IN_VBD_RB_RP = [IN, VBD, RB, RP];
var A_VBD = [VBD];
var A_VBP_NN_VB = [VBP, NN, VB];
var A_JJ_NN_VB_VBP = [JJ, NN, VB, VBP];
var A_VB_JJ_VBP = [VB, JJ, VBP];
var A_JJ_RB_VB = [JJ, RB, VB];
var A_NN_UH = [NN, UH];
var A_RB_IN_JJ_NN_RP_VB_VBP = [RB, IN, JJ, NN, RP, VB, VBP];
var A_JJ_NN_RB = [JJ, NN, RB];
var A_VBD_JJ = [VBD, JJ];
var A_NN_VBP_JJ_RB_VB = [NN, VBP, JJ, RB, VB];
var A_NN_JJ_VBG = [NN, JJ, VBG];
var A_NN_VBP_JJ_VB = [NN, VBP, JJ, VB];
var A_VB_VBN_VBP = [VB, VBN, VBP];
var A_NN_VBN_JJ = [NN, VBN, JJ];
var A_VB_JJ_NN_VBD_VBN_VBP = [VB, JJ, NN, VBD, VBN, VBP];
var A_VB_VBD_VBN_VBP = [VB, VBD, VBN, VBP];
var A_IN_NN_RB_RP = [IN, NN, RB, RP];
var A_FW_NN = [FW, NN];
var A_NN_RB = [NN, RB];
var A_VB_NN = [VB, NN];
var A_JJS_RBS_NN_RB = [JJS, RBS, NN, RB];
var A_NN_RB_VB_VBD_VBN_VBP = [NN, RB, VB, VBD, VBN, VBP];
var A_JJR_JJ_RB_VB_RBR = [JJR, JJ, RB, VB, RBR];
var A_NN_VBD_VBN_VBP_VB = [NN, VBD, VBN, VBP, VB];
var A_NN_VBD_VBN_JJ_RB_VB = [NN, VBD, VBN, JJ, RB, VB];
var A_NNS_NNPS = [NNS, NNPS];
var A_JJ_NN_VB = [JJ, NN, VB];
var A_JJ_NN_RB_VB = [JJ, NN, RB, VB];
var A_JJ_NNS_NN_VB = [JJ, NNS, NN, VB];
var A_JJ_VBG_RB = [JJ, VBG, RB];
var A_JJ_VBN = [JJ, VBN];
var A_NN_RB_VB = [NN, RB, VB];
var A_JJ_VBG_NN = [JJ, VBG, NN];
var A_VBD_VBP_JJ_NN_VB = [VBD, VBP, JJ, NN, VB];
var A_NN_JJ_VB = [NN, JJ, VB];
var A_NN_VBP_JJ_RB = [NN, VBP, JJ, RB];
var A_NN_JJ_VB_VBD_VBN = [NN, JJ, VB, VBD, VBN];
var A_VB_VBN_VBP_NN = [VB, VBN, VBP, NN];
var A_NN_NNP = [NN, NNP];
var A_CC_IN_JJ_RB = [CC, IN, JJ, RB];
var A_NN_CC_VBP_VB = [NN, CC, VBP, VB];
var A_VBG_NN_JJ = [VBG, NN, JJ];
var A_VB_VBP_JJ_NN = [VB, VBP, JJ, NN];
var A_NN_VBP_JJ = [NN, VBP, JJ];
var A_VB_JJ_NN_VBP = [VB, JJ, NN, VBP];
var A_VBZ_NNS_NN = [VBZ, NNS, NN];
var A_VBN_VBD_VB = [VBN, VBD, VB];
var A_MD_NN_VB = [MD, NN, VB];
var A_NN_JJ_VB_VBD_VBN_VBP = [NN, JJ, VB, VBD, VBN, VBP];
var A_NNS_NN = [NNS, NN];
var A_NN_VB_VBG_VBP = [NN, VB, VBG, VBP];
var A_NN_JJ_RB_VB_VBP = [NN, JJ, RB, VB, VBP];
var A_JJ_VBP_RB_VB = [JJ, VBP, RB, VB];
var A_JJ_RB_VB_VBP = [JJ, RB, VB, VBP];
var A_VB_VBP_JJ_NN_RB = [VB, VBP, JJ, NN, RB];
var A_VBD_VBN_JJ_NN_VB = [VBD, VBN, JJ, NN, VB];
var A_JJR_JJ_RB_RBR = [JJR, JJ, RB, RBR];
var A_JJS = [JJS];
var A_NN_FW_VB = [NN, FW, VB];
var A_VB_VBD_VBN_VBP_VBZ_JJ = [VB, VBD, VBN, VBP, VBZ, JJ];
var A_NNS_VBZ_NN = [NNS, VBZ, NN];
var A_JJR = [JJR];
var A_JJ_VB_VBP = [JJ, VB, VBP];
var A_NNS_NN_VBZ = [NNS, NN, VBZ];
var A_JJ_NN_RB_VB_VBP = [JJ, NN, RB, VB, VBP];
var A_NN_IN_JJ_RB_VB_VBP = [NN, IN, JJ, RB, VB, VBP];
var A_NN_RP_VB_VBP = [NN, RP, VB, VBP];
var A_VB_JJ_NN_RB_VBP = [VB, JJ, NN, RB, VBP];
var A_NNS_VBP_VBZ = [NNS, VBP, VBZ];
var A_NN_JJ_RB = [NN, JJ, RB];
var A_VB_VBD_VBN_VBP_JJ_NN = [VB, VBD, VBN, VBP, JJ, NN];
var A_NN_JJ_UH = [NN, JJ, UH];
var A_JJ_VBN_RB = [JJ, VBN, RB];
var A_JJ_NN_RB_VB_UH = [JJ, NN, RB, VB, UH];
var A_JJ_NN_VBG = [JJ, NN, VBG];
var A_VB_VBP_MD_NN = [VB, VBP, MD, NN];
var A_JJ_NN_RB_VBN = [JJ, NN, RB, VBN];
var A_JJ_NN_RB_UH = [JJ, NN, RB, UH];
var A_VB_JJ_NN = [VB, JJ, NN];
var A_VB_VBP_FW_NN = [VB, VBP, FW, NN];
var A_VB_FW_NN_VBP = [VB, FW, NN, VBP];
var A_JJ_NN_VBN = [JJ, NN, VBN];
var A_VBD_JJ_NN_VB = [VBD, JJ, NN, VB];
var A_VBP_FW_NN_VB_NNS_VBZ = [VBP, FW, NN, VB, NNS, VBZ];
var A_JJ_VBP_NN_RB_VB = [JJ, VBP, NN, RB, VB];
var A_RB_RBR_VBP_IN_JJ_NN_RP_VB = [RB, RBR, VBP, IN, JJ, NN, RP, VB];
var A_JJ_IN_NN_RB_NNS = [JJ, IN, NN, RB, NNS];
var A_DT = [DT];
var A_JJ_VBN_NN = [JJ, VBN, NN];
var A_DT_CC_IN_RB_RBR = [DT, CC, IN, RB, RBR];
var A_VB_JJ = [VB, JJ];
var A_JJR_JJ_NN = [JJR, JJ, NN];
var A_NN_NNS_JJ = [NN, NNS, JJ];
var A_RB_JJ_NN = [RB, JJ, NN];
var A_RB_NN = [RB, NN];
var A_VBD_JJ_VB_VBN = [VBD, JJ, VB, VBN];
var A_VBG_JJ_NN_VBN = [VBG, JJ, NN, VBN];
var A_NNS_VBN_VBZ = [NNS, VBN, VBZ];
var A_RB_JJ_VB = [RB, JJ, VB];
var A_RB_RBR_RP = [RB, RBR, RP];
var A_IN_VB = [IN, VB];
var A_VB_VBP_NNP = [VB, VBP, NNP];
var A_VBP_VB_IN = [VBP, VB, IN];
var A_VBN_VBD_JJ_VB = [VBN, VBD, JJ, VB];
var A_VB_VBP_VBZ = [VB, VBP, VBZ];
var A_JJ_NNS = [JJ, NNS];
var A_RB_IN_JJ = [RB, IN, JJ];
var A_RB_JJ_NN_RP = [RB, JJ, NN, RP];
var A_RBR_JJR_RB = [RBR, JJR, RB];
var A_FW = [FW];
var A_NN_VB_VBD_VBP = [NN, VB, VBD, VBP];
var A_JJ_NN_RB_NNS = [JJ, NN, RB, NNS];
var A_JJR_RB_RBR = [JJR, RB, RBR];
var A_NN_VB_VBP_VBZ = [NN, VB, VBP, VBZ];
var A_JJ_IN_NN = [JJ, IN, NN];
var A_NN_RB_VB_NNS = [NN, RB, VB, NNS];
var A_VB_VBN_VBP_JJ_NN_RB_VBD = [VB, VBN, VBP, JJ, NN, RB, VBD];
var A_VBG_JJ_RB = [VBG, JJ, RB];
var A_IN_NNP_CC_JJ_RB_RP = [IN, NNP, CC, JJ, RB, RP];
var A_VB_VBP_UH = [VB, VBP, UH];
var A_NN_FW_VB_NNP_VBP = [NN, FW, VB, NNP, VBP];
var A_RB_JJ_NN_VB = [RB, JJ, NN, VB];
var A_VBD_VBN_VB = [VBD, VBN, VB];
var A_VBN_VBD_VBG = [VBN, VBD, VBG];
var A_VB_JJ_NN_RP_VBP = [VB, JJ, NN, RP, VBP];
var A_NN_RB_VB_VBP_JJ = [NN, RB, VB, VBP, JJ];
var A_VB_JJ_VBP_NN = [VB, JJ, VBP, NN];
var A_VBZ_VBN = [VBZ, VBN];
var A_VBP_JJ_NN_VB_VBN = [VBP, JJ, NN, VB, VBN];
var A_PRP_VB = [PRP, VB];
var A_NNS_UH = [NNS, UH];
var A_UH_NN = [UH, NN];
var A_VBZ_VBP_NNS = [VBZ, VBP, NNS];
var A_VBD_VBN_VBP = [VBD, VBN, VBP];
var A_PRP_JJ = [PRP, JJ];
var A_PRP$_PRP = [PRP$, PRP];
var A_PRP = [PRP];
var A_JJ_NN_RB_RP = [JJ, NN, RB, RP];
var A_VBD_JJ_NN_VB_VBN_VBP = [VBD, JJ, NN, VB, VBN, VBP];
var A_VB_NN_RB_VBP = [VB, NN, RB, VBP];
var A_NN_VB_UH_JJ = [NN, VB, UH, JJ];
var A_NNS_VBZ_JJ = [NNS, VBZ, JJ];
var A_WRB = [WRB];
var A_RB_RBR_WRB = [RB, RBR, WRB];
var A_VBN_JJ_NN_VB_VBD_VBP = [VBN, JJ, NN, VB, VBD, VBP];
var A_JJ_NNS_NN_RB = [JJ, NNS, NN, RB];
var A_NNS_FW = [NNS, FW];
var A_IN_FW_NN_RB_RP_NNP_RBR_VBD = [IN, FW, NN, RB, RP, NNP, RBR, VBD];
var A_VBP_VBN_VB = [VBP, VBN, VB];
var A_RB_UH = [RB, UH];
var A_IN_JJ_NN_RB = [IN, JJ, NN, RB];
var A_IN_RP = [IN, RP]; // var A_VBZ_RB_NNS_VBP = [ VBZ, RB, NNS, VBP ];

var A_PRP$ = [PRP$];
var A_RB_JJ_RP = [RB, JJ, RP];
var A_RB_VBN = [RB, VBN];
var A_RB_JJ_RP_JJR_RBR = [RB, JJ, RP, JJR, RBR];
var A_JJS_JJ = [JJS, JJ];
var A_VBD_VBP_JJ_VB = [VBD, VBP, JJ, VB];
var A_VB_VBN_VBP_JJ_NN = [VB, VBN, VBP, JJ, NN];
var A_VBD_VBN_JJ_NN = [VBD, VBN, JJ, NN];
var A_JJS_RBS_JJ = [JJS, RBS, JJ];
var A_VBZ_JJ_NNS = [VBZ, JJ, NNS];
var A_VBN_JJ_NN_RB_VBD = [VBN, JJ, NN, RB, VBD];
var A_JJR_JJS_CC_RB_RBR_RBS = [JJR, JJS, CC, RB, RBR, RBS];
var A_VB_VBD_VBN_VBP_NN = [VB, VBD, VBN, VBP, NN];
var A_IN_JJ_NN_VB_VBP = [IN, JJ, NN, VB, VBP];
var A_VB_RB_VBP_JJ = [VB, RB, VBP, JJ];
var A_JJ_VBP_RB = [JJ, VBP, RB];
var A_NN_RB_JJ = [NN, RB, JJ];
var A_NN_NNP_VB_VBP = [NN, NNP, VB, VBP];
var A_JJR_RBR_VBP_JJ_RB_VB = [JJR, RBR, VBP, JJ, RB, VB];
var A_NN_JJ_VB_UH = [NN, JJ, VB, UH];
var A_JJ_DT_NN_RB_VB_NNS_PDT = [JJ, DT, NN, RB, VB, NNS, PDT];
var A_VBN_JJ_VBD_VBP = [VBN, JJ, VBD, VBP];
var A_NN_JJ_RB_VB = [NN, JJ, RB, VB];
var A_FW_NN_RB = [FW, NN, RB];
var A_NN_JJ_VB_JJR = [NN, JJ, VB, JJR];
var A_NN_VBP_VB_UH = [NN, VBP, VB, UH];
var A_MD_NNP = [MD, NNP];
var A_PRP_FW = [PRP, FW];
var A_RB_NN_JJ = [RB, NN, JJ];
var A_NNP = [NNP];
var A_MD_NN = [MD, NN];
var A_NN_PRP$_JJ_VB_PRP_VBP = [NN, PRP$, JJ, VB, PRP, VBP];
var A_NN_JJ_VB_NNP = [NN, JJ, VB, NNP];
var A_JJR_JJ_NN_RB_RP_RBR = [JJR, JJ, NN, RB, RP, RBR];
var A_RBS_JJ_NN_RB_JJS = [RBS, JJ, NN, RB, JJS];
var A_JJ_DT_NN_RB = [JJ, DT, NN, RB];
var A_MD_JJ_NN = [MD, JJ, NN];
var A_PRP$_UH_PRP_JJ = [PRP$, UH, PRP, JJ];
var A_NN_VB_UH_VBP = [NN, VB, UH, VBP];
var A_IN_RB_VB_JJ = [IN, RB, VB, JJ];
var A_NN_VBP_MD_VB = [NN, VBP, MD, VB];
var A_VBZ_NNS_VBP_VB = [VBZ, NNS, VBP, VB];
var A_DT_NN_RB_CC = [DT, NN, RB, CC];
var A_RB_RBR = [RB, RBR];
var A_JJ_IN_RB = [JJ, IN, RB];
var A_DT_JJ_NN_RB_UH = [DT, JJ, NN, RB, UH];
var A_CC = [CC];
var A_RB_NN_JJS_JJ = [RB, NN, JJS, JJ];
var A_NN_JJ_VBP_VB = [NN, JJ, VBP, VB];
var A_RB_JJ_NN_UH = [RB, JJ, NN, UH];
var A_VBN_VBD_VBP = [VBN, VBD, VBP];
var A_IN_RB_RP_NNP = [IN, RB, RP, NNP];
var A_IN_JJ_NN_RB_RP = [IN, JJ, NN, RB, RP];
var A_RBR = [RBR];
var A_JJ_RB_VB_UH = [JJ, RB, VB, UH];
var A_IN_NNP_RBR_JJ_RB_RP = [IN, NNP, RBR, JJ, RB, RP];
var A_JJ_VBP_NN_RB_RP_VB = [JJ, VBP, NN, RB, RP, VB];
var A_VB_NNPS_VBP = [VB, NNPS, VBP];
var A_CC_NNP = [CC, NNP];
var A_NN_VBP_IN_VB = [NN, VBP, IN, VB];
var A_VBD_JJ_VBN_VBP = [VBD, JJ, VBN, VBP];
var A_PRP_JJ_PRP$ = [PRP, JJ, PRP$];
var A_IN_RP_JJ_RB = [IN, RP, JJ, RB];
var A_JJ_VBN_VBP_VB = [JJ, VBN, VBP, VB];
var A_VBD_VB_VBN = [VBD, VB, VBN];
var A_JJ_VBP_NN = [JJ, VBP, NN];
var A_JJ_VBN_IN_NN_RB = [JJ, VBN, IN, NN, RB];
var A_VB_VBD_VBP_NN = [VB, VBD, VBP, NN];
var A_NN_VBP_JJR_VB = [NN, VBP, JJR, VB];
var A_IN_FW_RP_NNP = [IN, FW, RP, NNP];
var A_JJ_NN_NNP = [JJ, NN, NNP];
var A_NNS_JJ_NN = [NNS, JJ, NN];
var A_NN_VB_JJ = [NN, VB, JJ];
var A_NN_RP = [NN, RP];
var A_VBZ_NNS_VBP = [VBZ, NNS, VBP];
var A_VB_UH_VBP = [VB, UH, VBP];
var A_CC_IN_JJ_NN_RB = [CC, IN, JJ, NN, RB];
var A_NN_VB_NNS = [NN, VB, NNS];
var A_NN_FW_IN_JJ_VB_VBD_VBP = [NN, FW, IN, JJ, VB, VBD, VBP];
var A_VB_FW_IN_VBP = [VB, FW, IN, VBP];
var A_JJ_VBD_VBG_VBN = [JJ, VBD, VBG, VBN];
var A_VBN_JJ_NN_VB_VBD = [VBN, JJ, NN, VB, VBD];
var A_NN_JJ_VBP = [NN, JJ, VBP];
var A_FW_IN_JJ_NN = [FW, IN, JJ, NN];
var A_VBN_VBD_VBP_JJ = [VBN, VBD, VBP, JJ];
var A_VBG_IN = [VBG, IN];
var A_RB_PDT = [RB, PDT];
var A_VBG_NN_RP = [VBG, NN, RP];
var A_NN_JJ_VB_VBP_VBZ = [NN, JJ, VB, VBP, VBZ];
var A_VB_NN_VBD_VBN_VBP = [VB, NN, VBD, VBN, VBP];
var A_VBN_VB_VBD = [VBN, VB, VBD];
var A_VBD_JJ_VB_VBN_VBP = [VBD, JJ, VB, VBN, VBP];
var A_JJ_NNS_NN = [JJ, NNS, NN];
var A_NNS_FW_NN = [NNS, FW, NN];
var A_JJ_VBD_VBN_RB_VB = [JJ, VBD, VBN, RB, VB];
var A_NN_RB_VB_IN_JJ = [NN, RB, VB, IN, JJ];
var A_VBD_VBP_JJ_NN = [VBD, VBP, JJ, NN];
var A_NN_IN_JJ_VBP_RB_VB = [NN, IN, JJ, VBP, RB, VB];
var A_NN_VBP_FW_IN_RB_VB = [NN, VBP, FW, IN, RB, VB];
var A_VBG_JJ_NN_RB = [VBG, JJ, NN, RB];
var A_NNS_JJ_VBZ = [NNS, JJ, VBZ];
var A_VB_IN_VBP = [VB, IN, VBP];
var A_VBP_FW_NN_NNP_VB_UH = [VBP, FW, NN, NNP, VB, UH];
var A_VBN_JJ_RB_VBD = [VBN, JJ, RB, VBD];
var A_NN_VBN = [NN, VBN];
var A_NN_PRP = [NN, PRP];
var A_VBN_VBD_VBP_JJ_NN_VB = [VBN, VBD, VBP, JJ, NN, VB];
var A_VBD_VBN_JJ_VB = [VBD, VBN, JJ, VB];
var A_NN_VBD_VBN = [NN, VBD, VBN];
var A_VBN_VBD_JJ_NN_VB = [VBN, VBD, JJ, NN, VB];
var A_NN_JJ_JJR = [NN, JJ, JJR];
var A_VB_FW_VBP = [VB, FW, VBP];
var A_RB_CC_FW_IN = [RB, CC, FW, IN];
var A_JJ_NNS_RB = [JJ, NNS, RB];
var A_DT_NN_RB = [DT, NN, RB];
var A_RB_WRB = [RB, WRB];
var A_JJ_RB_UH = [JJ, RB, UH];
var A_NN_RB_VB_VBP = [NN, RB, VB, VBP];
var A_NN_JJ_RB_VB_VBP_VBZ = [NN, JJ, RB, VB, VBP, VBZ];
var A_RB_JJ_NN_JJS = [RB, JJ, NN, JJS];
var A_VB_NN_VBD = [VB, NN, VBD];
var A_NN_VBD_VBN_VBP_JJ_VB = [NN, VBD, VBN, VBP, JJ, VB];
var A_VBD_JJ_VBN_VB = [VBD, JJ, VBN, VB];
var A_VB_VBP_NN_RP = [VB, VBP, NN, RP];
var A_NNS_VBZ_RB = [NNS, VBZ, RB];
var A_NN_JJR = [NN, JJR];
var A_JJ_PDT_DT = [JJ, PDT, DT];
var A_JJ_FW = [JJ, FW];
var A_JJ_PDT_RB_UH = [JJ, PDT, RB, UH];
var A_VBP_JJ_NN_VB = [VBP, JJ, NN, VB];
var A_NN_VBD_VBP_VB = [NN, VBD, VBP, VB];
var A_IN_RB_RBR = [IN, RB, RBR];
var A_NNS_VBZ_VB_UH = [NNS, VBZ, VB, UH];
var A_IN_DT_NN_RB_RP_UH_WP_VBP_WDT = [IN, DT, NN, RB, RP, UH, WP, VBP, WDT];
var A_DT_VBD_VBP_IN_JJ_NN_NNP_PDT = [DT, VBD, VBP, IN, JJ, NN, NNP, PDT];
var A_NNS_VBD = [NNS, VBD];
var A_PRP_DT = [PRP, DT];
var A_EX_RB_UH = [EX, RB, UH];
var A_RB_CC = [RB, CC];
var A_VBP_VB_NN = [VBP, VB, NN];
var A_VBZ_VB = [VBZ, VB];
var A_IN_RB_VBD = [IN, RB, VBD];
var A_VBD_NN_VBN = [VBD, NN, VBN];
var A_IN_JJ_RB_RP = [IN, JJ, RB, RP];
var A_NNS_VBZ_CC_RB = [NNS, VBZ, CC, RB];
var A_TO_RB = [TO, RB];
var A_RB_IN_RP = [RB, IN, RP];
var A_JJ_NN_VBP_RB_VB = [JJ, NN, VBP, RB, VB];
var A_VBN_RBR_VBD_JJ = [VBN, RBR, VBD, JJ];
var A_NN_VBD_VBP_JJ_VB = [NN, VBD, VBP, JJ, VB];
var A_JJ_NNP_NN = [JJ, NNP, NN];
var A_IN_JJ_NN = [IN, JJ, NN];
var A_IN_JJ_RB_RP_VB_NNP_RBR = [IN, JJ, RB, RP, VB, NNP, RBR];
var A_JJ_JJR_RB = [JJ, JJR, RB];
var A_VBN_NN_VB_VBD_VBP_JJ = [VBN, NN, VB, VBD, VBP, JJ];
var A_NNP_NN = [NNP, NN];
var A_IN_CC_FW = [IN, CC, FW];
var A_NN_VB_JJR_VBP = [NN, VB, JJR, VBP];
var A_NN_NNP_VB = [NN, NNP, VB];
var A_PRP_VBP = [PRP, VBP];
var A_VBN_VB = [VBN, VB];
var A_RB_VBP_JJ_NN_VB_UH = [RB, VBP, JJ, NN, VB, UH];
var A_NN_JJ_RB_JJS = [NN, JJ, RB, JJS];
var A_JJ_NN_VBD_VB_VBP = [JJ, NN, VBD, VB, VBP];
var A_WP_WDT = [WP, WDT];
var A_WDT_RB_WP = [WDT, RB, WP];
var A_WRB_IN = [WRB, IN];
var A_IN_CC = [IN, CC];
var A_WDT_WP = [WDT, WP];
var A_IN_JJ_NN_RB_VB = [IN, JJ, NN, RB, VB];
var A_WP_NN = [WP, NN];
var A_WP = [WP];
var A_JJ_NN_RP = [JJ, NN, RP];
var A_WP$ = [WP$];
var A_MD_VBP_NN_RB_VB = [MD, VBP, NN, RB, VB];
var A_NN_VBP_JJ_VB_JJR = [NN, VBP, JJ, VB, JJR];
var A_JJ_IN_NN_RB_VBN_VBP = [JJ, IN, NN, RB, VBN, VBP];
var A_NN_VBD_VBN_VB = [NN, VBD, VBN, VB];
var A_UH_RB = [UH, RB];
var A_PRP_VBP_RP = [PRP, VBP, RP];
var A_JJ_NN_NNS = [JJ, NN, NNS];
var A_CD = [CD];
var A_VBN_VBP = [VBN, VBP];
var A_JJR_RBR = [JJR, RBR];
var A_JJS_RBS = [JJS, RBS];
var A_VBN_JJ_NN_VBD = [VBN, JJ, NN, VBD];
var A_VBD_VBN_JJ_RB_VB = [VBD, VBN, JJ, RB, VB];
var A_JJR_NN = [JJR, NN];
var A_JJ_NN_VB_VBN = [JJ, NN, VB, VBN];
var A_JJR_RBR_RB = [JJR, RBR, RB];
var A_VBD_NN = [VBD, NN];
var A_RBR_JJR_JJ_NN_RB = [RBR, JJR, JJ, NN, RB];
var A_VBD_JJ_NN_VBN = [VBD, JJ, NN, VBN];
var A_JJ_JJR_RBR_RB_VB = [JJ, JJR, RBR, RB, VB];
var A_VBD_VBN_VBP_VB = [VBD, VBN, VBP, VB];
var A_VBN_NN_VBD = [VBN, NN, VBD];
var A_JJR_RBR_JJ_RB = [JJR, RBR, JJ, RB];
var A_JJS_RB_RBS = [JJS, RB, RBS];
var A_FW_NNP_DT_NN = [FW, NNP, DT, NN];
var A_RB_JJR_RBR = [RB, JJR, RBR];
var A_JJ_VB_NNP_VBP = [JJ, VB, NNP, VBP];
var A_VB_JJ_VBD_VBN_VBP = [VB, JJ, VBD, VBN, VBP];
var A_JJR_RBR_JJ = [JJR, RBR, JJ];
var A_NN_FW_IN_JJ = [NN, FW, IN, JJ];
var A_VBD_VBN_VBP_NN_VB = [VBD, VBN, VBP, NN, VB];
var A_NN_VBD_VBN_JJ_VB = [NN, VBD, VBN, JJ, VB];
var A_NN_VBN_JJ_VB = [NN, VBN, JJ, VB];
var A_VBD_NNP_VBN = [VBD, NNP, VBN];
var A_RBR_RB = [RBR, RB];
var A_VBN_VBG = [VBN, VBG];
var A_NN_FW_JJ_RB = [NN, FW, JJ, RB];
var A_VBD_VB = [VBD, VB];
var A_VBD_NN_NNS_VBN = [VBD, NN, NNS, VBN];
var A_JJR_JJ_RBR = [JJR, JJ, RBR]; // Define lexicon using the above combos.

var lexicon = Object.create(null);
lexicon['\''] = A_POS;
lexicon['\'d'] = A_MD_VBD_NNP;
lexicon['\'ll'] = A_MD;
lexicon['\'m'] = A_VBP;
lexicon['\'re'] = A_VBP;
lexicon['\'s'] = A_POS_VBZ_PRP_NNP;
lexicon['\'ve'] = A_VBP_VB;
lexicon['n\'t'] = A_RB;
lexicon['&'] = A_CC;
lexicon['%'] = A_NN_JJ;
lexicon.a = A_DT_VB_VBN_NNP_FW_JJ_LS_NN;
lexicon.am = A_VBP_FW_RB;
lexicon.an = A_DT_CC_JJ_NNP;
lexicon.are = A_VBP_NNP;
lexicon.ai = A_VBP;
lexicon.abandons = A_VBZ;
lexicon.abandonment = A_NN;
lexicon.abandoning = A_VBG;
lexicon.abandon = A_VB_NN_VBP;
lexicon.abandoned = A_VBN_VBD_JJ;
lexicon.ability = A_NN;
lexicon.abilities = A_NNS;
lexicon.able = A_JJ;
lexicon.abortive = A_JJ;
lexicon.abortions = A_NNS;
lexicon.abort = A_VB;
lexicon.abortion = A_NN;
lexicon.aborted = A_JJ_VBD_VBN;
lexicon.aborting = A_VBG;
lexicon.about = A_IN_JJ_RB_RP_RBR;
lexicon.above = A_IN_JJ_RB;
lexicon.abroad = A_RB;
lexicon.abroade = A_RB;
lexicon.absence = A_NN;
lexicon.absences = A_NNS;
lexicon.absolutes = A_NNS;
lexicon.absolute = A_JJ_NN;
lexicon.absolution = A_NN;
lexicon.absolutely = A_RB;
lexicon.absoluteness = A_NN;
lexicon.absolutism = A_NN;
lexicon.absorbs = A_VBZ;
lexicon.absorbency = A_NN;
lexicon.absorbing = A_VBG_JJ;
lexicon.absorbent = A_JJ;
lexicon.absorb = A_VB_VBP;
lexicon.absorbers = A_NNS;
lexicon.absorber = A_NN;
lexicon.absorbed = A_VBN_JJ_VBD;
lexicon.abstractive = A_JJ;
lexicon.abstractly = A_RB;
lexicon.abstracts = A_NNS;
lexicon.abstracting = A_VBG;
lexicon.abstracted = A_JJ_VBD;
lexicon.abstraction = A_NN;
lexicon.abstractions = A_NNS;
lexicon.abstract = A_JJ_NN_VBP;
lexicon.abused = A_VBN_JJ_VBD;
lexicon.abuser = A_NN;
lexicon.abuses = A_NNS;
lexicon.abusive = A_JJ;
lexicon.abusable = A_JJ;
lexicon.abusing = A_VBG;
lexicon.abusers = A_NNS;
lexicon.abuse = A_NN_VB_VBP;
lexicon.academic = A_JJ_NN;
lexicon.academically = A_RB;
lexicon.academics = A_NNS;
lexicon.academe = A_NN;
lexicon.accelerations = A_NNS;
lexicon.accelerator = A_NN;
lexicon.accelerating = A_VBG_JJ;
lexicon.accelerates = A_VBZ;
lexicon.accelerated = A_VBN_JJ_VBD;
lexicon.acceleration = A_NN;
lexicon.accelerators = A_NNS;
lexicon.accelerate = A_VB_VBP;
lexicon.accents = A_NNS_VBZ;
lexicon.accenting = A_NN;
lexicon.accented = A_VBN_JJ;
lexicon.accent = A_NN_VB;
lexicon.accept = A_VB_VBP;
lexicon.acceptability = A_NN;
lexicon.acceptances = A_NNS;
lexicon.acceptance = A_NN;
lexicon.accepting = A_VBG_JJ;
lexicon.accepts = A_VBZ;
lexicon.acceptable = A_JJ;
lexicon.accepted = A_VBN_VBD_JJ;
lexicon.accesses = A_NNS;
lexicon.accessed = A_VBN;
lexicon.access = A_NN_VB;
lexicon.accessibility = A_NN;
lexicon.accessible = A_JJ;
lexicon.accessions = A_NNS;
lexicon.accidently = A_RB;
lexicon.accidents = A_NNS;
lexicon.accident = A_NN;
lexicon.accommodates = A_VBZ;
lexicon.accommodated = A_VBN;
lexicon.accommodations = A_NNS;
lexicon.accommodative = A_JJ;
lexicon.accommodate = A_VB_VBP;
lexicon.accommodating = A_VBG;
lexicon.accommodation = A_NN;
lexicon.accompaniments = A_NNS;
lexicon.accompanying = A_VBG_JJ;
lexicon.accompanies = A_VBZ;
lexicon.accompanied = A_VBN_VBD;
lexicon.accompany = A_VB_VBP;
lexicon.accompaniment = A_NN;
lexicon.accomplishing = A_VBG;
lexicon.accomplishes = A_VBZ;
lexicon.accomplished = A_VBN_JJ_VBD;
lexicon.accomplishments = A_NNS;
lexicon.accomplishment = A_NN;
lexicon.accomplish = A_VB_VBP;
lexicon.accorded = A_VBN_VBD;
lexicon.according = A_VBG;
lexicon.accordance = A_NN;
lexicon.accord = A_NN_VBP_RB_VB;
lexicon.accordingly = A_RB;
lexicon.accords = A_NNS_VBZ;
lexicon.account = A_NN_VBP_VB;
lexicon.accounting = A_NN_VBG_JJ;
lexicon.accounts = A_NNS_VBZ;
lexicon.accountability = A_NN;
lexicon.accountant = A_NN;
lexicon.accountants = A_NNS;
lexicon.accounted = A_VBD_VBN;
lexicon.accountable = A_JJ;
lexicon.accuracy = A_NN;
lexicon.accurately = A_RB;
lexicon.accurate = A_JJ;
lexicon.accuse = A_VB_VBP;
lexicon.accuses = A_VBZ;
lexicon.accuser = A_NN;
lexicon.accused = A_VBN_VBD_JJ_NN;
lexicon.accusers = A_NNS;
lexicon.accusing = A_VBG_JJ;
lexicon.accusations = A_NNS;
lexicon.accusation = A_NN;
lexicon.accusingly = A_RB;
lexicon.achieving = A_VBG;
lexicon.achievement = A_NN;
lexicon.achieve = A_VB_VBP;
lexicon.achievements = A_NNS;
lexicon.achieved = A_VBN_VBD_JJ;
lexicon.achieves = A_VBZ;
lexicon.achievable = A_JJ;
lexicon.acid = A_NN_JJ;
lexicon.acidity = A_NN;
lexicon.acids = A_NNS;
lexicon.acidly = A_RB;
lexicon.acknowledged = A_VBD_VBN_JJ;
lexicon.acknowledges = A_VBZ;
lexicon.acknowledgment = A_NN;
lexicon.acknowledge = A_VBP_VB;
lexicon.acknowledgments = A_NNS;
lexicon.acknowledging = A_VBG;
lexicon.acknowledgement = A_NN;
lexicon.acquirers = A_NNS;
lexicon.acquire = A_VB_NN_VBP;
lexicon.acquiring = A_VBG;
lexicon.acquired = A_VBN_JJ_VBD;
lexicon.acquirer = A_NN;
lexicon.acquires = A_VBZ;
lexicon.acquisitive = A_JJ;
lexicon.acquisition = A_NN;
lexicon.acquisitiveness = A_NN;
lexicon.acquisitions = A_NNS;
lexicon.across = A_IN_RB_RP;
lexicon.act = A_NN_VBP_VB;
lexicon.acting = A_VBG_JJ_NN;
lexicon.acts = A_NNS_VBZ;
lexicon.acted = A_VBD_VBN;
lexicon.actionable = A_JJ;
lexicon.action = A_NN;
lexicon.actions = A_NNS;
lexicon.activating = A_VBG;
lexicon.activation = A_NN;
lexicon.activity = A_NN;
lexicon.actively = A_RB;
lexicon.actives = A_NNS;
lexicon.activism = A_NN;
lexicon.activated = A_VBN_JJ;
lexicon.activate = A_VBP_VB;
lexicon.activities = A_NNS;
lexicon.active = A_JJ_NN;
lexicon.activists = A_NNS_VBZ;
lexicon.activist = A_NN_JJ;
lexicon.actors = A_NNS;
lexicon.actor = A_NN;
lexicon.actresses = A_NNS;
lexicon.actress = A_NN;
lexicon.actual = A_JJ;
lexicon.actually = A_RB;
lexicon.actuality = A_NN;
lexicon.actualities = A_NNS;
lexicon.adding = A_VBG_NN;
lexicon.ad = A_NN_FW;
lexicon.added = A_VBD_JJ_VBN;
lexicon.ads = A_NNS;
lexicon.adapt = A_VB_VBP;
lexicon.adaptation = A_NN;
lexicon.adaptable = A_JJ;
lexicon.adapter = A_NN;
lexicon.adapted = A_VBN_VBD;
lexicon.adaptations = A_NNS;
lexicon.adapts = A_VBZ;
lexicon.adapters = A_NNS;
lexicon.adaptability = A_NN;
lexicon.adapting = A_VBG_NN;
lexicon.adds = A_VBZ;
lexicon.add = A_VB_VBP;
lexicon.additional = A_JJ;
lexicon.addition = A_NN;
lexicon.additives = A_NNS;
lexicon.additive = A_NN;
lexicon.additionally = A_RB;
lexicon.additions = A_NNS;
lexicon.address = A_NN_VBP_VB;
lexicon.addressing = A_VBG;
lexicon.addresses = A_NNS_VBZ;
lexicon.addressed = A_VBN_JJ_VBD;
lexicon.adequately = A_RB;
lexicon.adequate = A_JJ;
lexicon.adjusters = A_NNS;
lexicon.adjusting = A_VBG_NN;
lexicon.adjust = A_VB_VBP;
lexicon.adjusted = A_VBN_JJ_VBD;
lexicon.adjustable = A_JJ;
lexicon.adjustables = A_NNS;
lexicon.adjuster = A_NN;
lexicon.adjustment = A_NN;
lexicon.adjustments = A_NNS;
lexicon.adjusts = A_VBZ;
lexicon.administering = A_VBG;
lexicon.administer = A_VB_VBP;
lexicon.administers = A_VBZ;
lexicon.administered = A_VBN_VBD;
lexicon.administrate = A_VB;
lexicon.administrator = A_NN;
lexicon.administrators = A_NNS;
lexicon.administrations = A_NNS;
lexicon.administrative = A_JJ;
lexicon.administratively = A_RB;
lexicon.administration = A_NN;
lexicon.admire = A_VB_VBP;
lexicon.admiral = A_NN;
lexicon.admirals = A_NNS;
lexicon.admirably = A_RB;
lexicon.admirable = A_JJ;
lexicon.admirers = A_NNS;
lexicon.admired = A_VBD_VBN_JJ;
lexicon.admires = A_VBZ;
lexicon.admirer = A_NN;
lexicon.admiringly = A_RB;
lexicon.admiring = A_VBG;
lexicon.admiration = A_NN;
lexicon.admission = A_NN;
lexicon.admissions = A_NNS;
lexicon.admissible = A_JJ;
lexicon.admitted = A_VBD_VBN_JJ;
lexicon.admitting = A_VBG;
lexicon.admits = A_VBZ_NNS;
lexicon.admittedly = A_RB;
lexicon.admit = A_VB_VBP;
lexicon.adolescent = A_NN_JJ;
lexicon.adolescents = A_NNS;
lexicon.adolescence = A_NN;
lexicon.adoptive = A_JJ;
lexicon.adopted = A_VBN_VBD_JJ;
lexicon.adoptable = A_JJ;
lexicon.adopts = A_VBZ;
lexicon.adoptions = A_NNS;
lexicon.adopters = A_NNS;
lexicon.adopting = A_VBG;
lexicon.adopt = A_VB_VBP;
lexicon.adoption = A_NN;
lexicon.adult = A_NN_JJ;
lexicon.adults = A_NNS;
lexicon.advance = A_NN_JJ_VB_VBP;
lexicon.advancements = A_NNS;
lexicon.advancers = A_NNS;
lexicon.advancement = A_NN;
lexicon.advancing = A_VBG_JJ;
lexicon.advancer = A_NN;
lexicon.advances = A_NNS_VBZ;
lexicon.advanced = A_VBD_VBN_JJ;
lexicon.advantages = A_NNS;
lexicon.advantageous = A_JJ;
lexicon.advantage = A_NN_VB;
lexicon.advantageously = A_RB;
lexicon.adventurers = A_NNS;
lexicon.adventure = A_NN_VB;
lexicon.adventurer = A_NN;
lexicon.adventures = A_NNS;
lexicon.adventurously = A_RB;
lexicon.adventuring = A_NN;
lexicon.adventurism = A_NN;
lexicon.adventurous = A_JJ;
lexicon.advertising = A_NN_VBG;
lexicon.advertisement = A_NN;
lexicon.advertise = A_VB_VBP;
lexicon.advertisers = A_NNS;
lexicon.advertises = A_VBZ;
lexicon.advertiser = A_NN;
lexicon.advertisements = A_NNS;
lexicon.advertised = A_VBN_JJ_VBD;
lexicon.advice = A_NN;
lexicon.advisedly = A_RB;
lexicon.advisers = A_NNS;
lexicon.advisement = A_NN;
lexicon.advisable = A_JJ;
lexicon.advising = A_VBG_NN;
lexicon.adviser = A_NN;
lexicon.advises = A_VBZ;
lexicon.advised = A_VBN_VBD_JJ;
lexicon.advisability = A_NN;
lexicon.advise = A_VB_VBP_NN;
lexicon.advocate = A_NN_VB_VBP;
lexicon.advocating = A_VBG;
lexicon.advocated = A_VBN_VBD;
lexicon.advocates = A_NNS_VBZ;
lexicon.aesthetically = A_RB;
lexicon.aesthetes = A_NNS;
lexicon.aesthetic = A_JJ_NN;
lexicon.aesthetics = A_NNS;
lexicon.affairs = A_NNS;
lexicon.affair = A_NN;
lexicon.affect = A_VB_VBP_NN;
lexicon.affecting = A_VBG;
lexicon.affectations = A_NNS;
lexicon.affectation = A_NN;
lexicon.affects = A_VBZ_NNS;
lexicon.affections = A_NNS;
lexicon.affected = A_VBN_JJ_VBD;
lexicon.affectingly = A_RB;
lexicon.affection = A_NN;
lexicon.affords = A_VBZ;
lexicon.afford = A_VB_VBP;
lexicon.affordability = A_NN;
lexicon.affordable = A_JJ;
lexicon.affording = A_VBG;
lexicon.afforded = A_VBN_VBD;
lexicon.afraid = A_JJ;
lexicon.after = A_IN_RB_RP;
lexicon.afternoon = A_NN;
lexicon.afternoons = A_NNS_RB;
lexicon.afterward = A_RB;
lexicon.afterwards = A_RB;
lexicon.again = A_RB;
lexicon.against = A_IN;
lexicon.age = A_NN_VBP;
lexicon.aged = A_VBN_JJ_NNS_VBD;
lexicon.aging = A_VBG_JJ_NN;
lexicon.ages = A_NNS_VBZ;
lexicon.agencies = A_NNS;
lexicon.agency = A_NN;
lexicon.agendas = A_NNS;
lexicon.agenda = A_NN_NNS;
lexicon.agents = A_NNS;
lexicon.agent = A_NN;
lexicon.aggressions = A_NNS;
lexicon.aggression = A_NN;
lexicon.aggressively = A_RB;
lexicon.aggressive = A_JJ;
lexicon.aggressiveness = A_NN;
lexicon.ago = A_RB_IN;
lexicon.agree = A_VB_VBP;
lexicon.agreed = A_VBD_VBN_JJ;
lexicon.agrees = A_VBZ;
lexicon.agreeing = A_VBG;
lexicon.agreement = A_NN;
lexicon.agreements = A_NNS;
lexicon.agriculturals = A_NNS;
lexicon.agriculturally = A_RB;
lexicon.agricultural = A_JJ;
lexicon.agriculture = A_NN;
lexicon.ahs = A_UH;
lexicon.ah = A_UH_VBP;
lexicon.ahead = A_RB_JJ;
lexicon.aids = A_NNS_VBZ;
lexicon.aid = A_NN_VB_VBP;
lexicon.aide = A_NN;
lexicon.aided = A_VBN_VBD;
lexicon.aides = A_NNS;
lexicon.aiding = A_VBG;
lexicon.aim = A_NN_VBP_VB;
lexicon.aims = A_VBZ_NNS;
lexicon.aimed = A_VBN_VBD;
lexicon.aiming = A_VBG;
lexicon.airings = A_NNS;
lexicon.air = A_NN_VB_VBN_VBP;
lexicon.airing = A_VBG_NN;
lexicon.aired = A_VBN_VBD;
lexicon.airs = A_NNS_VBZ;
lexicon.aircraft = A_NN_NNS;
lexicon.airline = A_NN;
lexicon.airliners = A_NNS;
lexicon.airliner = A_NN;
lexicon.airlines = A_NNS;
lexicon.airplanes = A_NNS_VBZ;
lexicon.airplane = A_NN;
lexicon.airports = A_NNS;
lexicon.airport = A_NN;
lexicon.aisle = A_NN;
lexicon.aisles = A_NNS;
lexicon.alarmism = A_NN;
lexicon.alarmed = A_VBN_JJ;
lexicon.alarming = A_JJ_VBG;
lexicon.alarmingly = A_RB;
lexicon.alarm = A_NN_VB;
lexicon.alarms = A_NNS_VBZ;
lexicon.albums = A_NNS;
lexicon.album = A_NN;
lexicon.alcoholic = A_JJ_NN;
lexicon.alcohol = A_NN;
lexicon.alcoholics = A_NNS;
lexicon.alcoholism = A_NN;
lexicon.alcohols = A_NNS;
lexicon.alienating = A_VBG_JJ;
lexicon.aliens = A_NNS;
lexicon.alienate = A_VB;
lexicon.alienation = A_NN;
lexicon.alien = A_JJ_NN;
lexicon.alienated = A_VBN_VBD;
lexicon.alienates = A_VBZ;
lexicon.alike = A_RB_JJ;
lexicon.alive = A_JJ_RB;
lexicon.all = A_DT_RB_PDT;
lexicon.allegations = A_NNS;
lexicon.alleging = A_VBG;
lexicon.allegedly = A_RB;
lexicon.alleged = A_VBN_JJ_VBD;
lexicon.alleges = A_VBZ_NNS;
lexicon.allegation = A_NN;
lexicon.allege = A_VBP_VB;
lexicon.alleys = A_NNS;
lexicon.alley = A_NN;
lexicon.alliance = A_NN;
lexicon.alliances = A_NNS;
lexicon.allowance = A_NN;
lexicon.allowing = A_VBG;
lexicon.allowances = A_NNS;
lexicon.allowed = A_VBN_JJ_VB_VBD;
lexicon.allow = A_VB_VBP;
lexicon.allowable = A_JJ;
lexicon.allows = A_VBZ;
lexicon.allies = A_NNS;
lexicon.allied = A_VBN_JJ_VBD;
lexicon.ally = A_NN_VB;
lexicon.allying = A_VBG;
lexicon.almost = A_RB_JJ;
lexicon.alone = A_RB_JJ;
lexicon.aloneness = A_NN;
lexicon.along = A_IN_RB_RP;
lexicon.alongside = A_IN_RB;
lexicon.already = A_RB;
lexicon.also = A_RB;
lexicon.altered = A_VBN_JJ_VBD;
lexicon.altering = A_VBG;
lexicon.alterations = A_NNS;
lexicon.alter = A_VB_VBP_JJ;
lexicon.alteration = A_NN;
lexicon.alters = A_VBZ;
lexicon.alternating = A_VBG;
lexicon.alternated = A_VBD_VBN;
lexicon.alternate = A_JJ_VBP_NN_VB;
lexicon.alternative = A_NN_JJ;
lexicon.alternates = A_VBZ_NNS;
lexicon.alternatively = A_RB;
lexicon.alternation = A_NN;
lexicon.alternately = A_RB;
lexicon.alternatives = A_NNS;
lexicon.although = A_IN;
lexicon.altogether = A_RB;
lexicon.aluminum = A_NN_JJ;
lexicon.always = A_RB;
lexicon.amazingly = A_RB;
lexicon.amazing = A_JJ;
lexicon.amazed = A_VBN_VBD_JJ;
lexicon.amazement = A_NN;
lexicon.amaze = A_VB_VBP;
lexicon.ambassadors = A_NNS;
lexicon.ambassador = A_NN;
lexicon.ambition = A_NN;
lexicon.ambitions = A_NNS;
lexicon.ambitious = A_JJ;
lexicon.ambitiously = A_RB;
lexicon.amend = A_VB_VBP;
lexicon.amendment = A_NN;
lexicon.amending = A_VBG;
lexicon.amendments = A_NNS;
lexicon.amended = A_VBN_VBD;
lexicon.amid = A_IN;
lexicon.amide = A_NN;
lexicon.among = A_IN;
lexicon.amounts = A_NNS_VBZ;
lexicon.amounted = A_VBD_VBN;
lexicon.amount = A_NN_VB_VBP;
lexicon.amounting = A_VBG;
lexicon.analysis = A_NN;
lexicon.analyst = A_NN;
lexicon.analystics = A_NNS;
lexicon.analysts = A_NNS;
lexicon.analyzable = A_JJ;
lexicon.analyze = A_VB_VBP;
lexicon.analyzer = A_NN;
lexicon.analyzes = A_VBZ;
lexicon.analyzed = A_VBN_VBD;
lexicon.analyzing = A_VBG_NN;
lexicon.ancestors = A_NNS;
lexicon.ancestor = A_NN;
lexicon.ancients = A_NNS;
lexicon.anciently = A_RB;
lexicon.ancient = A_JJ_NN;
lexicon.and = A_CC_VBP_JJ_RB_NNP;
lexicon.angel = A_NN;
lexicon.angelic = A_JJ;
lexicon.angels = A_NNS;
lexicon.angers = A_VBZ;
lexicon.angered = A_VBN_JJ_VBD;
lexicon.angering = A_VBG;
lexicon.anger = A_NN_VBP;
lexicon.angle = A_NN_VB;
lexicon.angles = A_NNS;
lexicon.angling = A_VBG_NN;
lexicon.angry = A_JJ;
lexicon.animals = A_NNS;
lexicon.animation = A_NN;
lexicon.animism = A_NN;
lexicon.animized = A_VBN;
lexicon.animate = A_JJ;
lexicon.animal = A_NN_JJ;
lexicon.animates = A_VBZ;
lexicon.animated = A_JJ_VBD_VBN;
lexicon.ankles = A_NNS;
lexicon.ankle = A_NN;
lexicon.anniversaries = A_NNS;
lexicon.anniversary = A_NN;
lexicon.announcements = A_NNS;
lexicon.announcment = A_NN;
lexicon.announcement = A_NN;
lexicon.announcer = A_NN;
lexicon.announces = A_VBZ;
lexicon.announced = A_VBD_VBN_JJ;
lexicon.announce = A_VB_VBP;
lexicon.announcers = A_NNS;
lexicon.announcing = A_VBG;
lexicon.annually = A_RB;
lexicon.annualized = A_VBN_VBD_JJ;
lexicon.annual = A_JJ_NN;
lexicon.anonymous = A_JJ;
lexicon.anonymously = A_RB;
lexicon.anonymity = A_NN;
lexicon.another = A_DT_JJ_NN;
lexicon.answers = A_NNS_VBZ;
lexicon.answered = A_VBD_VBN;
lexicon.answerable = A_JJ;
lexicon.answering = A_VBG_NN;
lexicon.answer = A_NN_VB_VBP;
lexicon.anticipated = A_VBN_JJ_VBD;
lexicon.anticipates = A_VBZ;
lexicon.anticipations = A_NNS;
lexicon.anticipation = A_NN;
lexicon.anticipating = A_VBG;
lexicon.anticipate = A_VB_VBP;
lexicon.anxiety = A_NN;
lexicon.anxieties = A_NNS;
lexicon.anxiously = A_RB;
lexicon.anxious = A_JJ;
lexicon.any = A_DT_RB;
lexicon.ani = A_JJ;
lexicon.anybody = A_NN;
lexicon.anymore = A_RB;
lexicon.anyone = A_NN;
lexicon.anything = A_NN;
lexicon.anyway = A_RB;
lexicon.anyways = A_UH;
lexicon.anywhere = A_RB;
lexicon.apartment = A_NN;
lexicon.apart = A_RB_RP_JJ;
lexicon.apartments = A_NNS;
lexicon.apologizes = A_VBZ;
lexicon.apologized = A_VBD_VBN;
lexicon.apologies = A_NNS;
lexicon.apology = A_NN;
lexicon.apologize = A_VB;
lexicon.apologizing = A_VBG;
lexicon.apparent = A_JJ_NN;
lexicon.apparently = A_RB;
lexicon.apparency = A_NN;
lexicon.appeal = A_NN_VBP_VB;
lexicon.appeals = A_NNS_VBZ;
lexicon.appealed = A_VBD_VBN;
lexicon.appealing = A_JJ_VBG;
lexicon.appears = A_VBZ_NNS;
lexicon.appeared = A_VBD_VBN;
lexicon.appear = A_VB_VBP;
lexicon.appearing = A_VBG;
lexicon.appearance = A_NN;
lexicon.appearances = A_NNS;
lexicon.apples = A_NNS_JJ;
lexicon.apple = A_NN;
lexicon.application = A_NN;
lexicon.applicator = A_NN;
lexicon.applicant = A_NN;
lexicon.applicants = A_NNS;
lexicon.applications = A_NNS;
lexicon.applicators = A_NNS;
lexicon.applicable = A_JJ;
lexicon.applicability = A_NN;
lexicon.applying = A_VBG;
lexicon.applied = A_VBN_VBD_JJ;
lexicon.applies = A_VBZ;
lexicon.apply = A_VB_VBP;
lexicon.appointments = A_NNS;
lexicon.appoints = A_VBZ;
lexicon.appointment = A_NN;
lexicon.appointing = A_VBG;
lexicon.appointed = A_VBN_JJ_VBD;
lexicon.appoint = A_VB;
lexicon.appreciatively = A_RB;
lexicon.appreciation = A_NN;
lexicon.appreciative = A_JJ;
lexicon.appreciations = A_NNS;
lexicon.appreciably = A_RB;
lexicon.appreciate = A_VB_VBP;
lexicon.appreciates = A_VBZ;
lexicon.appreciated = A_VBN_VBD_JJ;
lexicon.appreciable = A_JJ;
lexicon.appreciating = A_VBG_NN;
lexicon.approaches = A_NNS_VBZ;
lexicon.approached = A_VBD_VBN;
lexicon.approachable = A_JJ;
lexicon.approach = A_NN_VB_VBP;
lexicon.approaching = A_VBG;
lexicon.appropriators = A_NNS;
lexicon.appropriations = A_NNS;
lexicon.appropriation = A_NN;
lexicon.appropriately = A_RB;
lexicon.appropriateness = A_NN;
lexicon.appropriating = A_VBG_NN;
lexicon.appropriate = A_JJ_VBP_VB;
lexicon.appropriated = A_VBN_VBD;
lexicon.appropriates = A_VBZ;
lexicon.approving = A_VBG;
lexicon.approval = A_NN;
lexicon.approve = A_VB_VBP;
lexicon.approved = A_VBD_VBN_JJ;
lexicon.approvals = A_NNS;
lexicon.approves = A_VBZ;
lexicon.approvingly = A_RB;
lexicon.approximation = A_NN;
lexicon.approximations = A_NNS;
lexicon.approximately = A_RB_JJ;
lexicon.approximates = A_VBZ;
lexicon.approximated = A_VBN_JJ_VBD;
lexicon.approximate = A_JJ_VBP_NN_VB;
lexicon.architects = A_NNS;
lexicon.architect = A_NN;
lexicon.architectural = A_JJ;
lexicon.architecture = A_NN;
lexicon.architectures = A_NNS;
lexicon.architecturally = A_RB;
lexicon.areas = A_NNS_VBN;
lexicon.area = A_NN;
lexicon.arenas = A_NNS;
lexicon.arena = A_NN;
lexicon.arguing = A_VBG_NN;
lexicon.argues = A_VBZ;
lexicon.argued = A_VBD_VBN;
lexicon.argue = A_VBP_VB;
lexicon.argumentation = A_NN;
lexicon.argument = A_NN;
lexicon.arguments = A_NNS;
lexicon.arising = A_VBG;
lexicon.arises = A_VBZ;
lexicon.arise = A_VB_VBP;
lexicon.armful = A_NN;
lexicon.armed = A_VBN_JJ;
lexicon.arming = A_NN;
lexicon.arms = A_NNS;
lexicon.arm = A_NN_VB;
lexicon.armies = A_NNS;
lexicon.army = A_NN;
lexicon.around = A_IN_RB_RP;
lexicon.arrangements = A_NNS;
lexicon.arrange = A_VB_VBP;
lexicon.arrangers = A_NNS;
lexicon.arranged = A_VBN_VBD;
lexicon.arranges = A_VBZ;
lexicon.arranging = A_VBG;
lexicon.arrangement = A_NN;
lexicon.arrayed = A_VBN;
lexicon.arrays = A_NNS;
lexicon.array = A_NN;
lexicon.arrests = A_NNS;
lexicon.arrest = A_NN_VBP_VB;
lexicon.arrested = A_VBN_VBD;
lexicon.arresting = A_VBG_JJ;
lexicon.arriving = A_VBG;
lexicon.arrives = A_VBZ;
lexicon.arrived = A_VBD_VBN;
lexicon.arrive = A_VB_VBP;
lexicon.arrivals = A_NNS;
lexicon.arrival = A_NN;
lexicon.arrows = A_NNS;
lexicon.arrow = A_NN;
lexicon.arrowed = A_JJ;
lexicon.artfulness = A_NN;
lexicon.arts = A_NNS;
lexicon.artfully = A_RB;
lexicon.artful = A_JJ;
lexicon.art = A_NN_VBP;
lexicon.articles = A_NNS;
lexicon.article = A_NN;
lexicon.articulated = A_VBN;
lexicon.articulations = A_NNS;
lexicon.articulation = A_NN;
lexicon.articulate = A_JJ_VB;
lexicon.artifacts = A_NNS;
lexicon.artifact = A_NN;
lexicon.artificiality = A_NN;
lexicon.artificial = A_JJ_NN;
lexicon.artificially = A_RB;
lexicon.artistically = A_RB;
lexicon.artistic = A_JJ;
lexicon.artist = A_NN;
lexicon.artists = A_NNS;
lexicon.as = A_IN_NNP_JJ_RB;
lexicon.ash = A_NN;
lexicon.ashes = A_NNS;
lexicon.asides = A_NNS;
lexicon.aside = A_RB_RP;
lexicon.ask = A_VB_VBP;
lexicon.asked = A_VBD_VBN_JJ;
lexicon.asks = A_VBZ;
lexicon.asking = A_VBG_JJ_NN;
lexicon.asleep = A_RB_JJ;
lexicon.aspects = A_NNS;
lexicon.aspect = A_NN;
lexicon.ass = A_NN;
lexicon.asses = A_NNS;
lexicon.assaulted = A_VBD_VBN;
lexicon.assaults = A_NNS;
lexicon.assault = A_NN_VBP;
lexicon.assaulting = A_VBG;
lexicon.assembling = A_VBG_NN;
lexicon.assembly = A_NN;
lexicon.assemble = A_VB_VBP;
lexicon.assemblies = A_NNS;
lexicon.assembles = A_VBZ;
lexicon.assembled = A_VBN_VBD_JJ;
lexicon.asserting = A_VBG;
lexicon.assertion = A_NN;
lexicon.assertedly = A_RB;
lexicon.assertions = A_NNS;
lexicon.assertiveness = A_NN;
lexicon.asserted = A_VBD_VBN;
lexicon.asserts = A_VBZ;
lexicon.assert = A_VB_VBP;
lexicon.assertive = A_JJ;
lexicon.assessing = A_VBG;
lexicon.assess = A_VB_VBP;
lexicon.assessment = A_NN;
lexicon.assesses = A_VBZ;
lexicon.assessed = A_VBN_VBD;
lexicon.assessments = A_NNS;
lexicon.assets = A_NNS;
lexicon.asset = A_NN;
lexicon.assigns = A_VBZ_NNS;
lexicon.assigned = A_VBN_VBD_JJ;
lexicon.assignment = A_NN;
lexicon.assign = A_VB_VBP;
lexicon.assigning = A_VBG;
lexicon.assignments = A_NNS;
lexicon.assists = A_VBZ_NNS;
lexicon.assistant = A_NN_JJ;
lexicon.assistance = A_NN;
lexicon.assist = A_VB_NN_VBP;
lexicon.assisted = A_VBN_VBD;
lexicon.assistants = A_NNS;
lexicon.assisting = A_VBG;
lexicon.associating = A_VBG;
lexicon.associate = A_JJ_VBP_NN_VB;
lexicon.associated = A_VBN_VBD_JJ;
lexicon.associates = A_NNS_VBZ;
lexicon.association = A_NN;
lexicon.associations = A_NNS;
lexicon.associatively = A_RB;
lexicon.assuming = A_VBG;
lexicon.assumed = A_VBN_VBD_JJ;
lexicon.assumes = A_VBZ;
lexicon.assume = A_VB_VBP;
lexicon.assumptions = A_NNS;
lexicon.assumption = A_NN;
lexicon.assurance = A_NN;
lexicon.assures = A_VBZ;
lexicon.assuring = A_VBG;
lexicon.assuredly = A_RB;
lexicon.assure = A_VB_VBP;
lexicon.assured = A_VBN_VBD_JJ_NN;
lexicon.assurances = A_NNS;
lexicon.astronomer = A_NN;
lexicon.astronomical = A_JJ;
lexicon.astronomically = A_RB;
lexicon.at = A_IN_VBD_RB_RP;
lexicon.ate = A_VBD;
lexicon.athletes = A_NNS;
lexicon.athletics = A_NNS;
lexicon.athletic = A_JJ;
lexicon.athlete = A_NN;
lexicon.athletically = A_RB;
lexicon.atmospheric = A_JJ;
lexicon.atmosphere = A_NN;
lexicon.atmospheres = A_NNS;
lexicon.atop = A_IN;
lexicon.attachments = A_NNS;
lexicon.attach = A_VB_VBP;
lexicon.attachment = A_NN;
lexicon.attache = A_NN;
lexicon.attaching = A_VBG;
lexicon.attaches = A_VBZ;
lexicon.attached = A_VBN_JJ_VBD;
lexicon.attack = A_NN_VBP_VB;
lexicon.attacked = A_VBN_VBD;
lexicon.attacker = A_NN;
lexicon.attacking = A_VBG_NN;
lexicon.attacks = A_NNS_VBZ;
lexicon.attackers = A_NNS;
lexicon.attempting = A_VBG;
lexicon.attempt = A_NN_VBP_VB;
lexicon.attempted = A_VBD_JJ_VBN;
lexicon.attempts = A_NNS_VBZ;
lexicon.attendant = A_NN_JJ;
lexicon.attendents = A_NNS;
lexicon.attends = A_VBZ;
lexicon.attending = A_VBG;
lexicon.attended = A_VBD_VBN;
lexicon.attendance = A_NN;
lexicon.attendent = A_NN;
lexicon.attend = A_VB_VBP;
lexicon.attendants = A_NNS;
lexicon.attention = A_NN;
lexicon.attentive = A_JJ;
lexicon.attentions = A_NNS;
lexicon.attentively = A_RB;
lexicon.attitude = A_NN;
lexicon.attitudes = A_NNS;
lexicon.attorney = A_NN;
lexicon.attorneys = A_NNS;
lexicon.attract = A_VB_VBP;
lexicon.attracts = A_VBZ;
lexicon.attractively = A_RB;
lexicon.attractive = A_JJ;
lexicon.attractiveness = A_NN;
lexicon.attractions = A_NNS;
lexicon.attracted = A_VBN_VBD;
lexicon.attractant = A_NN;
lexicon.attraction = A_NN;
lexicon.attracting = A_VBG;
lexicon.attributed = A_VBD_VBN;
lexicon.attributions = A_NNS;
lexicon.attributes = A_NNS_VBZ;
lexicon.attribute = A_VBP_NN_VB;
lexicon.attributable = A_JJ;
lexicon.attributing = A_VBG;
lexicon.auction = A_NN_VB;
lexicon.auctions = A_NNS_VBZ;
lexicon.auctioneer = A_NN;
lexicon.auctioning = A_NN;
lexicon.auctioned = A_VBN_VBD;
lexicon.audience = A_NN;
lexicon.audiences = A_NNS;
lexicon.aunt = A_NN;
lexicon.aunts = A_NNS;
lexicon.authored = A_VBN;
lexicon.authoring = A_VBG;
lexicon.authorizes = A_VBZ;
lexicon.authority = A_NN;
lexicon.authorize = A_VB;
lexicon.authorization = A_NN;
lexicon.authorized = A_VBN_VBD_JJ;
lexicon.authorities = A_NNS;
lexicon.authorizations = A_NNS;
lexicon.authorizing = A_VBG;
lexicon.authors = A_NNS;
lexicon.author = A_NN;
lexicon.autos = A_NNS;
lexicon.auto = A_NN;
lexicon.automatically = A_RB;
lexicon.automatic = A_JJ_NN;
lexicon.automobiles = A_NNS;
lexicon.automobile = A_NN;
lexicon.autonomy = A_NN;
lexicon.availabilities = A_NNS;
lexicon.availed = A_VBD;
lexicon.availability = A_NN;
lexicon.available = A_JJ;
lexicon.avail = A_NN_VB;
lexicon.availing = A_VBG;
lexicon.averaging = A_VBG_JJ_NN;
lexicon.averaged = A_VBD_VBN;
lexicon.averages = A_NNS_VBZ;
lexicon.average = A_JJ_NN_VB_VBP;
lexicon.avoids = A_VBZ;
lexicon.avoiding = A_VBG;
lexicon.avoidable = A_JJ;
lexicon.avoidance = A_NN;
lexicon.avoid = A_VB_JJ_VBP;
lexicon.avoided = A_VBN_JJ_VBD;
lexicon.awaiting = A_VBG;
lexicon.await = A_VB_VBP;
lexicon.awaited = A_VBD_JJ_VBN;
lexicon.awaits = A_VBZ;
lexicon.awake = A_JJ_RB_VB;
lexicon.awarding = A_VBG_NN;
lexicon.award = A_NN_VBP_VB;
lexicon.awards = A_NNS_VBZ;
lexicon.awarded = A_VBN_VBD;
lexicon.aware = A_JJ;
lexicon.awareness = A_NN;
lexicon.away = A_RB_RP;
lexicon.awaye = A_RB;
lexicon.awfulness = A_NN;
lexicon.awful = A_JJ_RB;
lexicon.awfully = A_RB;
lexicon.aw = A_UH;
lexicon.babies = A_NNS;
lexicon.baby = A_NN_UH;
lexicon.backed = A_VBN_JJ_VBD;
lexicon.backs = A_NNS_VBZ;
lexicon.back = A_RB_IN_JJ_NN_RP_VB_VBP;
lexicon.backing = A_VBG_NN;
lexicon.backgrounds = A_NNS;
lexicon.background = A_NN_JJ;
lexicon.backyard = A_NN;
lexicon.backyards = A_NNS;
lexicon.bacteria = A_NNS;
lexicon.badness = A_NN;
lexicon.bads = A_NNS;
lexicon.bad = A_JJ_NN_RB;
lexicon.badly = A_RB;
lexicon.bag = A_NN_VB;
lexicon.bags = A_NNS_VBZ;
lexicon.bagged = A_VBD_JJ;
lexicon.bake = A_JJ_VB;
lexicon.bakes = A_VBZ;
lexicon.baked = A_JJ_VBD_VBN;
lexicon.baking = A_NN_VBG;
lexicon.balances = A_NNS_VBZ;
lexicon.balanced = A_JJ_VBD_VBN;
lexicon.balancing = A_NN_VBG;
lexicon.balance = A_NN_VBP_JJ_RB_VB;
lexicon.balled = A_VBN;
lexicon.ball = A_NN;
lexicon.balling = A_VBG;
lexicon.balls = A_NNS;
lexicon.ballooned = A_VBN_VBD;
lexicon.balloon = A_NN_VBP_VB;
lexicon.balloons = A_NNS_VBZ;
lexicon.ballooning = A_NN_VBG;
lexicon.ballot = A_NN;
lexicon.balloting = A_NN;
lexicon.ballots = A_NNS;
lexicon.banning = A_VBG_NN;
lexicon.banned = A_VBN_VBD;
lexicon.ban = A_NN_VB_VBP;
lexicon.bans = A_NNS_VBZ;
lexicon.banana = A_NN;
lexicon.bananas = A_NNS;
lexicon.banding = A_VBG;
lexicon.bands = A_NNS;
lexicon.band = A_NN_VB;
lexicon.banded = A_VBN;
lexicon.banked = A_VBD_JJ_VBN;
lexicon.banking = A_NN_JJ_VBG;
lexicon.bank = A_NN_VBP_VB;
lexicon.banks = A_NNS_VBZ;
lexicon.banker = A_NN;
lexicon.bankers = A_NNS;
lexicon.bankruptcies = A_NNS;
lexicon.bankruptcy = A_NN;
lexicon.barring = A_VBG;
lexicon.bar = A_NN_VB_VBP;
lexicon.bars = A_NNS_VBZ;
lexicon.barred = A_VBN_VBD;
lexicon.bared = A_VBD;
lexicon.bare = A_JJ_VB;
lexicon.baring = A_VBG;
lexicon.barely = A_RB;
lexicon.barn = A_NN;
lexicon.barns = A_NNS;
lexicon.barrel = A_NN_VB;
lexicon.barrels = A_NNS;
lexicon.barreling = A_VBG;
lexicon.barrier = A_NN;
lexicon.barriers = A_NNS;
lexicon.based = A_VBN_VBD;
lexicon.bases = A_NNS_VBZ;
lexicon.base = A_NN_VBP_JJ_VB;
lexicon.basing = A_VBG;
lexicon.baseballs = A_NNS;
lexicon.baseball = A_NN;
lexicon.basements = A_NNS;
lexicon.basement = A_NN;
lexicon.basically = A_RB;
lexicon.basic = A_JJ_NN;
lexicon.basics = A_NNS;
lexicon.basis = A_NN;
lexicon.baskets = A_NNS;
lexicon.basket = A_NN;
lexicon.basketball = A_NN;
lexicon.batting = A_VBG_NN;
lexicon.bat = A_NN_VB;
lexicon.bats = A_NNS_VBZ;
lexicon.batted = A_VBD_VBN;
lexicon.bathe = A_VB;
lexicon.bath = A_NN;
lexicon.bathing = A_NN_VBG;
lexicon.baths = A_NNS_VBZ;
lexicon.bathed = A_VBN_VBD;
lexicon.bathrooms = A_NNS;
lexicon.bathroom = A_NN;
lexicon.batteries = A_NNS;
lexicon.batterie = A_NN;
lexicon.battery = A_NN;
lexicon.battle = A_NN_VBP_VB;
lexicon.battles = A_NNS_VBZ;
lexicon.battled = A_VBD_VBN;
lexicon.battling = A_VBG_NN;
lexicon.bays = A_NNS;
lexicon.bay = A_NN;
lexicon.bayed = A_VBD_VBN;
lexicon.baying = A_NN_VBG;
lexicon.being = A_VBG_JJ_NN;
lexicon.beings = A_NNS;
lexicon.be = A_VB_VBN_VBP;
lexicon.beaching = A_VBG;
lexicon.beach = A_NN;
lexicon.beached = A_JJ;
lexicon.beaches = A_NNS;
lexicon.beams = A_NNS_VBZ;
lexicon.beaming = A_VBG_JJ;
lexicon.beamed = A_VBN;
lexicon.beam = A_NN_VB;
lexicon.beans = A_NNS;
lexicon.bean = A_NN_VBN_JJ;
lexicon.bears = A_VBZ_NNS;
lexicon.bear = A_VB_NN_VBP;
lexicon.bearings = A_NNS;
lexicon.bearing = A_VBG_JJ_NN;
lexicon.beard = A_NN;
lexicon.bearded = A_JJ_VBD_VBN;
lexicon.beards = A_NNS;
lexicon.beastly = A_JJ;
lexicon.beast = A_NN;
lexicon.beasts = A_NNS;
lexicon.beats = A_VBZ_NNS;
lexicon.beating = A_VBG_NN;
lexicon.beatings = A_NNS;
lexicon.beat = A_VB_JJ_NN_VBD_VBN_VBP;
lexicon.beautiful = A_JJ;
lexicon.beauty = A_NN;
lexicon.beautifully = A_RB;
lexicon.beauties = A_NNS;
lexicon.because = A_IN_RB;
lexicon.become = A_VB_VBD_VBN_VBP;
lexicon.becomes = A_VBZ;
lexicon.becomed = A_VBN;
lexicon.becoming = A_VBG_NN;
lexicon.bed = A_NN_VB_VBP;
lexicon.beds = A_NNS;
lexicon.bedding = A_NN;
lexicon.bedded = A_VBN;
lexicon.bedroom = A_NN;
lexicon.bedrooms = A_NNS;
lexicon.bee = A_NN;
lexicon.bees = A_NNS;
lexicon.beefs = A_VBZ;
lexicon.beef = A_NN_VB_VBP;
lexicon.beefed = A_VBN_VBD;
lexicon.beefing = A_VBG;
lexicon.beer = A_NN;
lexicon.beers = A_NNS;
lexicon.before = A_IN_RB_RP;
lexicon.begged = A_VBD_VBN;
lexicon.beg = A_VBP_VB;
lexicon.begs = A_VBZ;
lexicon.begging = A_VBG_NN;
lexicon.begins = A_VBZ;
lexicon.beginnings = A_NNS;
lexicon.begining = A_NN;
lexicon.begin = A_VB_VBP;
lexicon.beginning = A_VBG_JJ_NN;
lexicon.behalf = A_NN;
lexicon.behave = A_VB_VBP;
lexicon.behaving = A_VBG;
lexicon.behaves = A_VBZ;
lexicon.behaved = A_VBD_VBN;
lexicon.behavioral = A_JJ;
lexicon.behaviors = A_NNS;
lexicon.behaviorally = A_RB;
lexicon.behavior = A_NN;
lexicon.behind = A_IN_NN_RB_RP;
lexicon.belief = A_NN;
lexicon.beliefs = A_NNS;
lexicon.believing = A_VBG;
lexicon.believer = A_NN;
lexicon.believes = A_VBZ;
lexicon.believed = A_VBD_VBN;
lexicon.believability = A_NN;
lexicon.believably = A_RB;
lexicon.believable = A_JJ;
lexicon.believers = A_NNS;
lexicon.believe = A_VBP_VB;
lexicon.bell = A_NN;
lexicon.belle = A_FW_NN;
lexicon.bells = A_NNS;
lexicon.belled = A_JJ;
lexicon.belles = A_NNS;
lexicon.bellies = A_NNS;
lexicon.belly = A_NN_RB;
lexicon.belongs = A_VBZ;
lexicon.belongings = A_NNS;
lexicon.belonged = A_VBD_VBN;
lexicon.belong = A_VB_VBP_JJ;
lexicon.belonging = A_VBG_NN;
lexicon.below = A_IN_RB;
lexicon.belt = A_NN;
lexicon.belts = A_NNS_VBZ;
lexicon.belted = A_VBD;
lexicon.belting = A_NN_VBG;
lexicon.benches = A_NNS;
lexicon.bench = A_NN_VB;
lexicon.bends = A_NNS_VBZ;
lexicon.bending = A_VBG;
lexicon.bend = A_VB_NN;
lexicon.beneath = A_IN_RB;
lexicon.benefited = A_VBD_VBN;
lexicon.benefiting = A_VBG;
lexicon.benefits = A_NNS_VBZ;
lexicon.benefit = A_NN_VB_VBP;
lexicon.beside = A_IN_RB;
lexicon.besides = A_IN_RB;
lexicon.best = A_JJS_RBS_NN_RB;
lexicon.bested = A_VBN_VBD;
lexicon.bestes = A_NNS;
lexicon.besting = A_VBG;
lexicon.bet = A_NN_RB_VB_VBD_VBN_VBP;
lexicon.bets = A_NNS;
lexicon.betting = A_VBG_NN;
lexicon.betterment = A_NN;
lexicon.bettering = A_VBG;
lexicon.bettered = A_VBD;
lexicon.betters = A_NNS;
lexicon.better = A_JJR_JJ_RB_VB_RBR;
lexicon.between = A_IN_RB;
lexicon.beyond = A_IN_RB;
lexicon.bias = A_NN;
lexicon.biased = A_VBN;
lexicon.biases = A_NNS;
lexicon.bicycling = A_NN;
lexicon.bicycles = A_NNS;
lexicon.bicycle = A_NN;
lexicon.bidding = A_NN_VBG_JJ;
lexicon.bids = A_NNS_VBZ;
lexicon.bid = A_NN_VBD_VBN_VBP_VB;
lexicon.bigness = A_NN;
lexicon.big = A_JJ;
lexicon.bike = A_NN;
lexicon.bikes = A_NNS;
lexicon.biking = A_NN;
lexicon.bill = A_NN_VBP_VB;
lexicon.billings = A_NNS;
lexicon.bills = A_NNS_VBZ;
lexicon.billing = A_NN_VBG;
lexicon.billed = A_VBN_JJ_VBD;
lexicon.billions = A_NNS;
lexicon.binding = A_NN_JJ_VBG;
lexicon.binds = A_VBZ;
lexicon.bind = A_NN_VB_VBP;
lexicon.biography = A_NN;
lexicon.biographies = A_NNS;
lexicon.biology = A_NN;
lexicon.biologic = A_JJ;
lexicon.biological = A_JJ_NN;
lexicon.biologically = A_RB;
lexicon.birds = A_NNS;
lexicon.bird = A_NN;
lexicon.birth = A_NN;
lexicon.births = A_NNS;
lexicon.birthed = A_VBN;
lexicon.birthday = A_NN;
lexicon.birthdays = A_NNS;
lexicon.bishops = A_NNS;
lexicon.bishop = A_NN;
lexicon.bits = A_NNS;
lexicon.bit = A_NN_VBD_VBN_JJ_RB_VB;
lexicon.bites = A_NNS_VBZ;
lexicon.biting = A_VBG_JJ;
lexicon.bite = A_VB_VBP_NN;
lexicon.bitingly = A_RB;
lexicon.bitee = A_NN;
lexicon.bitters = A_NNS;
lexicon.bitter = A_JJ;
lexicon.bitterness = A_NN;
lexicon.bitterly = A_RB;
lexicon.blackness = A_NN;
lexicon.blacked = A_VBN;
lexicon.blacks = A_NNS_NNPS;
lexicon.black = A_JJ_NN_VB;
lexicon.blacking = A_NN;
lexicon.blades = A_NNS;
lexicon.blade = A_NN;
lexicon.blames = A_VBZ;
lexicon.blamed = A_VBD_VBN;
lexicon.blame = A_VB_NN_VBP;
lexicon.blaming = A_VBG;
lexicon.blanks = A_NNS;
lexicon.blank = A_JJ_NN_RB_VB;
lexicon.blanket = A_NN_VBP_JJ_VB;
lexicon.blankets = A_NNS_VBZ;
lexicon.blanketed = A_VBD;
lexicon.blasts = A_NNS;
lexicon.blasting = A_VBG_JJ;
lexicon.blast = A_NN_VB;
lexicon.blasted = A_VBD_VBN;
lexicon.blended = A_JJ_VBD_VBN;
lexicon.blending = A_VBG_NN;
lexicon.blends = A_NNS;
lexicon.blend = A_NN_VBP_VB;
lexicon.bless = A_VB;
lexicon.blessed = A_VBN_JJ_VBD;
lexicon.blessing = A_NN_VBG;
lexicon.blessings = A_NNS;
lexicon.blinding = A_JJ_VBG;
lexicon.blind = A_JJ_NNS_NN_VB;
lexicon.blinded = A_VBN;
lexicon.blindness = A_NN;
lexicon.blinds = A_NNS_VBZ;
lexicon.blindly = A_RB;
lexicon.blinking = A_JJ_VBG_RB;
lexicon.blink = A_VB_NN;
lexicon.blinks = A_VBZ;
lexicon.blinked = A_VBD;
lexicon.blocks = A_NNS_VBZ;
lexicon.blocked = A_VBN_JJ_VBD;
lexicon.block = A_NN_VBP_JJ_VB;
lexicon.blocking = A_VBG_JJ_NN;
lexicon.blond = A_JJ_NN;
lexicon.blondes = A_NNS;
lexicon.blonde = A_JJ_NN;
lexicon.blooded = A_VBN;
lexicon.blood = A_NN;
lexicon.bloods = A_NNS;
lexicon.bloodied = A_JJ_VBN;
lexicon.bloody = A_JJ;
lexicon.blow = A_NN_VB_VBP;
lexicon.blowing = A_VBG_NN;
lexicon.blows = A_NNS_VBZ;
lexicon.blues = A_NNS_JJ;
lexicon.blue = A_JJ_NN;
lexicon.boards = A_NNS_VBZ;
lexicon.board = A_NN_RB_VB;
lexicon.boarded = A_VBD_VBN_JJ;
lexicon.boarding = A_VBG_NN;
lexicon.boardings = A_NNS;
lexicon.boastings = A_NNS;
lexicon.boasted = A_VBD_VBN;
lexicon.boast = A_VBP_NN_VB;
lexicon.boastful = A_JJ;
lexicon.boastfully = A_RB;
lexicon.boasting = A_VBG;
lexicon.boasts = A_VBZ;
lexicon.boat = A_NN;
lexicon.boating = A_NN_VBG;
lexicon.boats = A_NNS;
lexicon.bodied = A_JJ;
lexicon.bodies = A_NNS_VBZ;
lexicon.body = A_NN;
lexicon.boils = A_VBZ;
lexicon.boiled = A_VBN_VBD_JJ;
lexicon.boil = A_VB_NN;
lexicon.boiling = A_VBG_NN;
lexicon.boldness = A_NN;
lexicon.boldly = A_RB;
lexicon.bold = A_JJ;
lexicon.bolting = A_VBG;
lexicon.bolted = A_VBN_VBD;
lexicon.bolts = A_NNS;
lexicon.bolt = A_NN_VB;
lexicon.bomb = A_NN_VB;
lexicon.bombing = A_NN_VBG;
lexicon.bombed = A_VBN_VBD;
lexicon.bombings = A_NNS;
lexicon.bombs = A_NNS;
lexicon.bonded = A_VBN_JJ;
lexicon.bonding = A_VBG_NN;
lexicon.bonds = A_NNS;
lexicon.bond = A_NN_JJ;
lexicon.bone = A_NN;
lexicon.boned = A_VBN;
lexicon.bones = A_NNS;
lexicon.bonuses = A_NNS_VBZ;
lexicon.bonus = A_NN;
lexicon.books = A_NNS;
lexicon.booking = A_NN_VBG;
lexicon.book = A_NN_VB;
lexicon.bookings = A_NNS;
lexicon.booked = A_VBN_VBD;
lexicon.booms = A_NNS_VBZ;
lexicon.boom = A_NN_VB;
lexicon.booming = A_JJ_VBG;
lexicon.boomed = A_VBD_VBN;
lexicon.boosted = A_VBD_VBN;
lexicon.boost = A_VB_NN_VBP;
lexicon.boosting = A_VBG;
lexicon.boosts = A_NNS_VBZ;
lexicon.booting = A_VBG;
lexicon.boots = A_NNS;
lexicon.booted = A_VBN_VBD_JJ;
lexicon.boot = A_NN_VB;
lexicon.booths = A_NNS;
lexicon.booth = A_NN;
lexicon.bordering = A_VBG;
lexicon.bordered = A_VBN;
lexicon.border = A_NN;
lexicon.borders = A_NNS_VBZ;
lexicon.boring = A_JJ_VBG_NN;
lexicon.bore = A_VBD_VBP_JJ_NN_VB;
lexicon.bores = A_NNS_VBZ;
lexicon.bored = A_VBN_JJ_VBD;
lexicon.boringly = A_RB;
lexicon.borne = A_VBN;
lexicon.born = A_VBN;
lexicon.borrows = A_VBZ;
lexicon.borrowed = A_VBN_VBD_JJ;
lexicon.borrower = A_NN;
lexicon.borrowers = A_NNS;
lexicon.borrow = A_VB_VBP;
lexicon.borrowing = A_NN_JJ_VBG;
lexicon.borrowings = A_NNS;
lexicon.boss = A_NN;
lexicon.bossed = A_VBN;
lexicon.bosses = A_NNS;
lexicon.bothers = A_VBZ;
lexicon.bother = A_VB_VBP;
lexicon.bothering = A_VBG;
lexicon.bothered = A_VBN_VBD;
lexicon.bottles = A_NNS_VBZ;
lexicon.bottled = A_JJ_VBD_VBN;
lexicon.bottling = A_NN_VBG;
lexicon.bottle = A_NN_VB;
lexicon.bottom = A_NN_JJ_VB;
lexicon.bottoming = A_VBG;
lexicon.bottoms = A_NNS;
lexicon.bottomed = A_VBN_VBD;
lexicon.bounce = A_VB_VBP_NN;
lexicon.bounces = A_VBZ_NNS;
lexicon.bounced = A_VBD_VBN;
lexicon.bouncing = A_VBG_NN;
lexicon.boundaries = A_NNS;
lexicon.boundary = A_NN;
lexicon.bow = A_NN_VB_VBP;
lexicon.bowed = A_VBD_VBN_JJ;
lexicon.bowing = A_VBG;
lexicon.bows = A_NNS_VBZ;
lexicon.bowls = A_NNS_VBZ;
lexicon.bowling = A_NN_VBG;
lexicon.bowl = A_NN_VBP;
lexicon.bowled = A_VBN;
lexicon.box = A_NN_VB;
lexicon.boxed = A_VBN;
lexicon.boxes = A_NNS;
lexicon.boxing = A_NN;
lexicon.boy = A_NN_UH;
lexicon.boys = A_NNS;
lexicon.boyfriend = A_NN;
lexicon.boyfriends = A_NNS;
lexicon.brain = A_NN;
lexicon.brains = A_NNS;
lexicon.brakes = A_NNS_VBZ;
lexicon.brake = A_NN_VB;
lexicon.braking = A_VBG_NN;
lexicon.branching = A_VBG_NN;
lexicon.branches = A_NNS;
lexicon.branched = A_VBN_JJ_VBD;
lexicon.branch = A_NN_VB;
lexicon.branded = A_VBN_JJ;
lexicon.brands = A_NNS_VBZ;
lexicon.brand = A_NN_VBP_JJ_RB;
lexicon.bravely = A_RB;
lexicon.brave = A_JJ_VB;
lexicon.braving = A_VBG;
lexicon.braved = A_VBD_VBN;
lexicon.breaded = A_VBN;
lexicon.bread = A_NN;
lexicon.breaks = A_NNS_VBZ;
lexicon.breaking = A_VBG_JJ_NN;
lexicon.break = A_VB_NN_VBP;
lexicon.breakfast = A_NN;
lexicon.breakfasted = A_VBD;
lexicon.breakfasts = A_NNS;
lexicon.breast = A_NN;
lexicon.breasts = A_NNS;
lexicon.breath = A_NN_VB;
lexicon.breathe = A_VB_VBP;
lexicon.breathes = A_VBZ;
lexicon.breaths = A_NNS;
lexicon.breathing = A_NN_VBG;
lexicon.breathed = A_VBD_VBN;
lexicon.breezes = A_NNS;
lexicon.breeze = A_NN_VB;
lexicon.brick = A_NN;
lexicon.bricks = A_NNS;
lexicon.bride = A_NN;
lexicon.brides = A_NNS;
lexicon.bridge = A_NN_JJ_VB;
lexicon.bridging = A_VBG_JJ;
lexicon.bridges = A_NNS_VBZ;
lexicon.briefed = A_VBN_VBD;
lexicon.briefings = A_NNS;
lexicon.brief = A_JJ_NN_VB;
lexicon.briefing = A_NN_VBG;
lexicon.briefs = A_NNS;
lexicon.briefly = A_NN_RB;
lexicon.brightness = A_NN;
lexicon.brightly = A_RB;
lexicon.bright = A_JJ_RB;
lexicon.brilliant = A_JJ;
lexicon.brilliantly = A_RB;
lexicon.bringing = A_VBG_NN;
lexicon.bring = A_VB_VBP;
lexicon.brings = A_VBZ;
lexicon.broadly = A_RB;
lexicon.broad = A_JJ;
lexicon.broadcaster = A_NN;
lexicon.broadcasters = A_NNS;
lexicon.broadcast = A_NN_JJ_VB_VBD_VBN;
lexicon.broadcasting = A_NN_VBG;
lexicon.broadcastings = A_NNS;
lexicon.broadcasts = A_NNS_VBZ;
lexicon.broken = A_VBN_JJ;
lexicon.brokenly = A_RB;
lexicon.brokering = A_VBG_NN;
lexicon.broker = A_NN;
lexicon.brokered = A_JJ_VBD_VBN;
lexicon.brokers = A_NNS;
lexicon.bronzed = A_JJ;
lexicon.bronzes = A_NNS;
lexicon.bronze = A_NN_JJ;
lexicon.brotherly = A_JJ;
lexicon.brothers = A_NNS;
lexicon.brother = A_NN;
lexicon.brotherism = A_NN;
lexicon.brown = A_JJ_NN_VB;
lexicon.browned = A_VBN;
lexicon.browning = A_VBG;
lexicon.brush = A_NN_JJ_VB_VBP;
lexicon.brushed = A_VBD_VBN_JJ;
lexicon.brushes = A_NNS;
lexicon.brushing = A_VBG_NN;
lexicon.brutality = A_NN;
lexicon.brutalism = A_NN;
lexicon.brutally = A_RB;
lexicon.brutalities = A_NNS;
lexicon.brutalized = A_VBN_JJ;
lexicon.brutal = A_JJ;
lexicon.bubbly = A_JJ_NN;
lexicon.bubble = A_NN_VBP_VB;
lexicon.bubbling = A_VBG_NN;
lexicon.bubbled = A_VBN_VBD;
lexicon.bubbles = A_NNS_VBZ;
lexicon.bucks = A_NNS_VBZ;
lexicon.bucking = A_VBG;
lexicon.buck = A_NN_VBP_VB;
lexicon.bucked = A_VBD_VBN;
lexicon.bucket = A_NN;
lexicon.buckets = A_NNS;
lexicon.buddies = A_NNS;
lexicon.buddy = A_NN;
lexicon.budget = A_NN_VB;
lexicon.budgets = A_NNS;
lexicon.budgeted = A_VBN_VBD;
lexicon.budgeting = A_NN_VBG;
lexicon.budgeteers = A_NNS;
lexicon.bug = A_NN_VBP;
lexicon.bugged = A_VBN_VBD;
lexicon.bugs = A_NNS_VBZ;
lexicon.bugging = A_NN;
lexicon.building = A_NN_VBG;
lexicon.builds = A_VBZ;
lexicon.buildings = A_NNS;
lexicon.build = A_VB_VBN_VBP_NN;
lexicon.builders = A_NNS;
lexicon.builder = A_NN;
lexicon.bulb = A_NN;
lexicon.bulbs = A_NNS;
lexicon.bulking = A_VBG;
lexicon.bulks = A_VBZ;
lexicon.bulked = A_VBD;
lexicon.bulk = A_NN_JJ;
lexicon.bull = A_NN_VB;
lexicon.bulls = A_NNS;
lexicon.bullets = A_NNS;
lexicon.bullet = A_NN;
lexicon.bunching = A_VBG;
lexicon.bunches = A_NNS;
lexicon.bunch = A_NN;
lexicon.bunched = A_VBN_VBD;
lexicon.burdens = A_NNS_VBZ;
lexicon.burdening = A_VBG;
lexicon.burdened = A_VBN_VBD;
lexicon.burden = A_NN_VB_VBP;
lexicon.bureau = A_NN;
lexicon.burn = A_VB_VBP_NN;
lexicon.burning = A_VBG_JJ_NN;
lexicon.burne = A_VB;
lexicon.burns = A_NNS_VBZ;
lexicon.burned = A_VBN_JJ_VBD;
lexicon.burnings = A_NNS;
lexicon.bursting = A_VBG;
lexicon.burst = A_NN_VBD_VBN_VBP_VB;
lexicon.bursts = A_NNS_VBZ;
lexicon.bury = A_VB_VBP;
lexicon.burying = A_VBG;
lexicon.buried = A_VBN_JJ_VBD;
lexicon.bus = A_NN;
lexicon.bushes = A_NNS;
lexicon.bush = A_NN;
lexicon.busies = A_NNS;
lexicon.busy = A_JJ;
lexicon.business = A_NN_NNP;
lexicon.businesses = A_NNS;
lexicon.busied = A_VBD;
lexicon.businessman = A_NN;
lexicon.butting = A_VBG;
lexicon.but = A_CC_IN_JJ_RB;
lexicon.butted = A_VBN;
lexicon.buts = A_NNS;
lexicon.butts = A_NNS_VBZ;
lexicon.butt = A_NN_CC_VBP_VB;
lexicon.butter = A_NN;
lexicon.butterflies = A_NNS;
lexicon.butterfly = A_NN;
lexicon.buttons = A_NNS;
lexicon.buttoned = A_VBN;
lexicon.button = A_NN_VB;
lexicon.buying = A_VBG_NN_JJ;
lexicon.buy = A_VB_VBP_JJ_NN;
lexicon.buys = A_VBZ_NNS;
lexicon.buyings = A_NNS;
lexicon.buyer = A_NN;
lexicon.buyers = A_NNS;
lexicon.by = A_IN_RB_RP;
lexicon.cab = A_NN;
lexicon.cabs = A_NNS;
lexicon.cabins = A_NNS;
lexicon.cabin = A_NN;
lexicon.cabinets = A_NNS;
lexicon.cabinet = A_NN_JJ;
lexicon.cables = A_NNS;
lexicon.cable = A_NN_VBP_JJ;
lexicon.cabled = A_VBD;
lexicon.cage = A_NN;
lexicon.caged = A_VBN;
lexicon.cages = A_NNS;
lexicon.cakes = A_NNS;
lexicon.caked = A_VBN_VBD;
lexicon.cake = A_NN;
lexicon.calculations = A_NNS;
lexicon.calculates = A_VBZ;
lexicon.calculable = A_JJ;
lexicon.calculate = A_VB_VBP;
lexicon.calculation = A_NN;
lexicon.calculators = A_NNS;
lexicon.calculated = A_VBN_VBD_JJ;
lexicon.calculator = A_NN;
lexicon.calculating = A_VBG_JJ_NN;
lexicon.calendar = A_NN;
lexicon.calendars = A_NNS;
lexicon.call = A_VB_JJ_NN_VBP;
lexicon.calling = A_VBG_NN;
lexicon.calls = A_VBZ_NNS_NN;
lexicon.called = A_VBN_VBD_VB;
lexicon.calming = A_VBG_JJ;
lexicon.calmed = A_VBD_VBN;
lexicon.calm = A_JJ_NN_VB;
lexicon.calmly = A_RB;
lexicon.calmness = A_NN;
lexicon.camera = A_NN;
lexicon.cameras = A_NNS;
lexicon.camps = A_NNS;
lexicon.camp = A_NN_VB;
lexicon.camped = A_VBD_VBN;
lexicon.camping = A_NN_VBG;
lexicon.campaigns = A_NNS;
lexicon.campaigned = A_VBD_VBN;
lexicon.campaign = A_NN_VB;
lexicon.campaigners = A_NNS;
lexicon.campaigning = A_VBG_NN;
lexicon.campuses = A_NNS;
lexicon.campus = A_NN;
lexicon.cans = A_NNS_VBZ;
lexicon.can = A_MD_NN_VB;
lexicon.ca = A_MD;
lexicon.canned = A_JJ_VBN;
lexicon.cancelling = A_VBG;
lexicon.canceling = A_VBG;
lexicon.cancelled = A_VBN;
lexicon.cancel = A_VB_NN;
lexicon.canceled = A_VBN_VBD_JJ;
lexicon.cancels = A_VBZ;
lexicon.cancellation = A_NN;
lexicon.cancellations = A_NNS;
lexicon.cancers = A_NNS;
lexicon.cancerous = A_JJ;
lexicon.cancer = A_NN;
lexicon.candidly = A_RB;
lexicon.candidate = A_NN;
lexicon.candid = A_JJ;
lexicon.candidates = A_NNS;
lexicon.candles = A_NNS;
lexicon.candle = A_NN;
lexicon.candy = A_NN;
lexicon.candies = A_NNS;
lexicon.canvas = A_NN;
lexicon.capped = A_VBD_VBN_JJ;
lexicon.cap = A_NN_VBP_VB;
lexicon.caps = A_NNS_VBZ;
lexicon.capping = A_VBG_NN;
lexicon.capable = A_JJ;
lexicon.capably = A_RB;
lexicon.capability = A_NN;
lexicon.capabilities = A_NNS;
lexicon.capacities = A_NNS;
lexicon.capacity = A_NN;
lexicon.capitalizations = A_NNS;
lexicon.capitalize = A_VB;
lexicon.capitals = A_NNS;
lexicon.capitalized = A_VBN_JJ_VBD;
lexicon.capitalizes = A_VBZ;
lexicon.capitalizing = A_VBG;
lexicon.capitalization = A_NN;
lexicon.capital = A_NN_JJ;
lexicon.capitalism = A_NN;
lexicon.captains = A_NNS;
lexicon.captain = A_NN_VBP;
lexicon.capturing = A_VBG;
lexicon.capture = A_VB_VBP_NN;
lexicon.captures = A_VBZ_NNS;
lexicon.captured = A_VBN_VBD;
lexicon.car = A_NN;
lexicon.cars = A_NNS;
lexicon.carbohydrate = A_NN;
lexicon.carbon = A_NN;
lexicon.carbons = A_NNS;
lexicon.carbonates = A_NNS;
lexicon.cards = A_NNS;
lexicon.card = A_NN;
lexicon.carefulness = A_NN;
lexicon.caring = A_VBG_JJ_NN;
lexicon.care = A_NN_VB_VBP;
lexicon.careful = A_JJ;
lexicon.carefully = A_RB;
lexicon.cares = A_VBZ_NNS;
lexicon.cared = A_VBD_VBN;
lexicon.careerism = A_NN;
lexicon.career = A_NN_NNP;
lexicon.careers = A_NNS;
lexicon.cargoes = A_NNS;
lexicon.cargo = A_NN;
lexicon.carpets = A_NNS;
lexicon.carpeted = A_VBN_VBD;
lexicon.carpet = A_NN;
lexicon.carpeting = A_NN;
lexicon.carrier = A_NN;
lexicon.carriers = A_NNS;
lexicon.carrots = A_NNS;
lexicon.carrot = A_NN;
lexicon.carried = A_VBD_VBN;
lexicon.carrying = A_VBG_JJ_NN;
lexicon.carry = A_VB_NN_VBP;
lexicon.carries = A_VBZ_NNS;
lexicon.carts = A_NNS;
lexicon.carte = A_NN;
lexicon.carting = A_VBG;
lexicon.cart = A_NN_VBP_VB;
lexicon.carted = A_VBD_VBN;
lexicon.cartoon = A_NN;
lexicon.cartoons = A_NNS;
lexicon.carves = A_VBZ;
lexicon.carved = A_VBN_JJ_VBD;
lexicon.carving = A_VBG;
lexicon.carve = A_VB_VBP;
lexicon.carvings = A_NNS;
lexicon.cased = A_VBD;
lexicon.case = A_NN_VB;
lexicon.cases = A_NNS_VBZ;
lexicon.casings = A_NNS;
lexicon.cash = A_NN_VB;
lexicon.cashed = A_VBD_VBN;
lexicon.cashing = A_VBG;
lexicon.casinos = A_NNS_VBZ;
lexicon.casino = A_NN;
lexicon.cast = A_NN_JJ_VB_VBD_VBN_VBP;
lexicon.castings = A_NNS;
lexicon.casts = A_VBZ_NNS;
lexicon.caste = A_NN;
lexicon.casting = A_VBG_NN;
lexicon.casual = A_JJ_RB;
lexicon.casuals = A_NNS;
lexicon.casually = A_RB;
lexicon.casualty = A_NN;
lexicon.casualties = A_NNS;
lexicon.cat = A_NN;
lexicon.cats = A_NNS;
lexicon.cataloging = A_VBG;
lexicon.catalogs = A_NNS_VBZ;
lexicon.catalog = A_NN;
lexicon.catching = A_VBG_NN;
lexicon.catches = A_VBZ_NNS;
lexicon.catch = A_VB_VBP_NN;
lexicon.categories = A_NNS;
lexicon.category = A_NN;
lexicon.cattle = A_NNS_NN;
lexicon.caused = A_VBN_VBD;
lexicon.causes = A_NNS_VBZ;
lexicon.causing = A_VBG_NN;
lexicon.cause = A_NN_VB_VBG_VBP;
lexicon.cave = A_NN_VB;
lexicon.caving = A_NN;
lexicon.caved = A_VBD_VBN;
lexicon.caves = A_NNS;
lexicon.ceases = A_VBZ;
lexicon.ceased = A_VBD_VBN;
lexicon.cease = A_VB_VBP;
lexicon.ceasing = A_VBG;
lexicon.ceilings = A_NNS;
lexicon.ceiling = A_NN;
lexicon.celebrated = A_VBD_JJ_VBN;
lexicon.celebrates = A_VBZ;
lexicon.celebration = A_NN;
lexicon.celebrations = A_NNS;
lexicon.celebrators = A_NNS;
lexicon.celebrants = A_NNS;
lexicon.celebrate = A_VB_VBP;
lexicon.celebrities = A_NNS;
lexicon.celebrity = A_NN;
lexicon.celebrating = A_VBG;
lexicon.cell = A_NN;
lexicon.cells = A_NNS;
lexicon.cemeteries = A_NNS;
lexicon.cemetery = A_NN;
lexicon.center = A_NN_JJ_RB_VB_VBP;
lexicon.centering = A_VBG_NN;
lexicon.centers = A_NNS_VBZ;
lexicon.centered = A_VBN_VBD;
lexicon.centralizing = A_VBG_JJ;
lexicon.centrality = A_NN;
lexicon.centralization = A_NN;
lexicon.centralized = A_JJ_VBD_VBN;
lexicon.central = A_JJ_NN;
lexicon.centrally = A_RB;
lexicon.centralize = A_VB;
lexicon.century = A_NN;
lexicon.centuries = A_NNS;
lexicon.ceremony = A_NN;
lexicon.ceremonial = A_JJ;
lexicon.ceremoniously = A_RB;
lexicon.ceremonially = A_RB;
lexicon.ceremonies = A_NNS;
lexicon.certain = A_JJ_RB;
lexicon.certainly = A_RB;
lexicon.chain = A_NN_VBP;
lexicon.chained = A_VBD_VBN_JJ;
lexicon.chains = A_NNS;
lexicon.chair = A_NN_VB;
lexicon.chairs = A_NNS_VBZ;
lexicon.chairing = A_NN;
lexicon.chaired = A_VBN_JJ_VBD;
lexicon.chairman = A_NN;
lexicon.challengers = A_NNS;
lexicon.challenged = A_VBD_VBN;
lexicon.challenges = A_NNS_VBZ;
lexicon.challenger = A_NN;
lexicon.challenging = A_VBG_JJ;
lexicon.challenge = A_NN_VB_VBP;
lexicon.challengeable = A_JJ;
lexicon.chamber = A_NN;
lexicon.chambered = A_VBN;
lexicon.chambers = A_NNS;
lexicon.champions = A_NNS_VBZ;
lexicon.championed = A_VBN_VBD;
lexicon.champion = A_NN_JJ_VB_VBP;
lexicon.championing = A_VBG;
lexicon.championships = A_NNS;
lexicon.championship = A_NN;
lexicon.chance = A_NN_JJ_VB_VBP;
lexicon.chances = A_NNS;
lexicon.chanced = A_VBD_VBN;
lexicon.change = A_NN_VBP_VB;
lexicon.changing = A_VBG_JJ_NN;
lexicon.changed = A_VBN_VBD_JJ;
lexicon.changes = A_NNS_VBZ;
lexicon.channels = A_NNS;
lexicon.channeling = A_VBG;
lexicon.channelled = A_VBN;
lexicon.channel = A_NN_VB_VBP;
lexicon.channeled = A_VBN_VBD;
lexicon.chaos = A_NN;
lexicon.chapters = A_NNS;
lexicon.chapter = A_NN;
lexicon.character = A_NN;
lexicon.characters = A_NNS;
lexicon.characteristically = A_RB;
lexicon.characteristic = A_JJ_NN;
lexicon.characteristics = A_NNS;
lexicon.characterization = A_NN;
lexicon.characterizing = A_VBG;
lexicon.characterize = A_VB_VBP;
lexicon.characterizations = A_NNS;
lexicon.characterizes = A_VBZ;
lexicon.characterized = A_VBN_VBD_JJ;
lexicon.charging = A_VBG_NN;
lexicon.charge = A_NN_VBP_VB;
lexicon.charges = A_NNS_VBZ;
lexicon.charged = A_VBN_VBD_JJ;
lexicon.charities = A_NNS;
lexicon.charity = A_NN;
lexicon.charm = A_NN_VB;
lexicon.charmed = A_VBN_VBD;
lexicon.charms = A_NNS_VBZ;
lexicon.charming = A_JJ;
lexicon.charmingly = A_RB;
lexicon.chart = A_NN_VB_VBP;
lexicon.charting = A_NN_VBG;
lexicon.charted = A_VBN;
lexicon.chartings = A_NNS;
lexicon.charts = A_NNS_VBZ;
lexicon.charters = A_NNS_VBZ;
lexicon.charter = A_NN_JJ;
lexicon.chartered = A_JJ_VBD_VBN;
lexicon.chasing = A_VBG_NN;
lexicon.chase = A_NN_JJ_VB_VBP;
lexicon.chased = A_VBN_VBD;
lexicon.cheap = A_JJ_NN_RB;
lexicon.cheat = A_VB_VBP;
lexicon.cheated = A_VBN_JJ_VBD;
lexicon.cheating = A_NN_VBG;
lexicon.cheats = A_VBZ;
lexicon.checks = A_NNS_VBZ;
lexicon.checking = A_VBG_NN;
lexicon.checked = A_VBN_VBD_JJ;
lexicon.check = A_NN_VBP_VB;
lexicon.cheek = A_NN;
lexicon.cheeks = A_NNS;
lexicon.cheerfulness = A_NN;
lexicon.cheere = A_VBP;
lexicon.cheers = A_NNS_VBZ;
lexicon.cheered = A_VBD_VBN;
lexicon.cheering = A_VBG;
lexicon.cheer = A_NN_VB_VBP;
lexicon.cheerfully = A_RB;
lexicon.cheerful = A_JJ;
lexicon.cheeses = A_NNS;
lexicon.cheese = A_NN;
lexicon.chef = A_NN;
lexicon.chefs = A_NNS;
lexicon.chemical = A_NN_JJ;
lexicon.chemically = A_RB;
lexicon.chemicals = A_NNS;
lexicon.chemistries = A_NNS;
lexicon.chemistry = A_NN;
lexicon.chests = A_NNS;
lexicon.chest = A_NN;
lexicon.chewing = A_VBG_JJ_NN;
lexicon.chewed = A_VBD_VBN;
lexicon.chews = A_NNS;
lexicon.chew = A_VB_VBP;
lexicon.chicken = A_NN;
lexicon.chickens = A_NNS;
lexicon.chief = A_JJ_NN;
lexicon.chiefs = A_NNS;
lexicon.child = A_NN;
lexicon.childhood = A_NN;
lexicon.chill = A_NN_JJ_VB;
lexicon.chills = A_NNS_VBZ;
lexicon.chilled = A_VBN_JJ_VBD;
lexicon.chilling = A_VBG_JJ;
lexicon.chillingly = A_RB;
lexicon.chin = A_NN_VB;
lexicon.chins = A_NNS;
lexicon.chinning = A_NN;
lexicon.chipping = A_VBG_NN;
lexicon.chipped = A_VBN_VBD_JJ;
lexicon.chips = A_NNS;
lexicon.chip = A_NN;
lexicon.chocolate = A_NN_JJ;
lexicon.chocolates = A_NNS;
lexicon.choices = A_NNS;
lexicon.choice = A_NN_JJ;
lexicon.cholesterol = A_NN;
lexicon.choose = A_VB_VBP;
lexicon.choosing = A_VBG_NN;
lexicon.chooses = A_VBZ;
lexicon.chopping = A_VBG_NN;
lexicon.chop = A_VB_NN;
lexicon.chops = A_NNS;
lexicon.chopped = A_JJ_VBD_VBN;
lexicon.chronically = A_RB;
lexicon.chronic = A_JJ_NN;
lexicon.chunk = A_NN;
lexicon.chunks = A_NNS;
lexicon.churches = A_NNS;
lexicon.church = A_NN_NNP;
lexicon.churchly = A_JJ;
lexicon.cigarette = A_NN;
lexicon.cigarettes = A_NNS;
lexicon.circling = A_VBG;
lexicon.circles = A_NNS_VBZ;
lexicon.circled = A_VBD;
lexicon.circle = A_NN_VB;
lexicon.circuitous = A_JJ;
lexicon.circuits = A_NNS_VBZ;
lexicon.circuit = A_NN;
lexicon.circumstances = A_NNS;
lexicon.circumstance = A_NN;
lexicon.cited = A_VBD_VBN;
lexicon.cite = A_VBP_VB;
lexicon.citing = A_VBG;
lexicon.cites = A_VBZ;
lexicon.citizen = A_NN;
lexicon.citizens = A_NNS;
lexicon.citizenship = A_NN;
lexicon.city = A_NN;
lexicon.cities = A_NNS;
lexicon.civics = A_NNS;
lexicon.civic = A_JJ;
lexicon.civilizations = A_NNS;
lexicon.civilize = A_VB;
lexicon.civilized = A_JJ_VBN;
lexicon.civilizing = A_VBG;
lexicon.civil = A_JJ;
lexicon.civility = A_NN;
lexicon.civilian = A_JJ_NN;
lexicon.civilians = A_NNS;
lexicon.claims = A_NNS_VBZ;
lexicon.claiming = A_VBG;
lexicon.claim = A_NN_VBP_VB;
lexicon.claimed = A_VBD_VBN;
lexicon.classed = A_VBN;
lexicon.classes = A_NNS;
lexicon.class = A_NN;
lexicon.classicism = A_NN;
lexicon.classics = A_NNS;
lexicon.classic = A_JJ_NN;
lexicon.classically = A_RB;
lexicon.classical = A_JJ;
lexicon.classified = A_VBN_VBD_JJ;
lexicon.classify = A_VB_VBP;
lexicon.classifiers = A_NNS;
lexicon.classifying = A_VBG;
lexicon.classifies = A_VBZ;
lexicon.classrooms = A_NNS;
lexicon.classroom = A_NN;
lexicon.clay = A_NN;
lexicon.clays = A_NNS;
lexicon.clean = A_JJ_VBP_RB_VB;
lexicon.cleanly = A_RB;
lexicon.cleaning = A_NN_VBG;
lexicon.cleans = A_VBZ;
lexicon.cleaned = A_VBN_VBD;
lexicon.clearly = A_RB;
lexicon.clear = A_JJ_RB_VB_VBP;
lexicon.clearness = A_NN;
lexicon.clears = A_VBZ;
lexicon.cleared = A_VBN_VBD;
lexicon.clearing = A_VBG_JJ_NN;
lexicon.clerking = A_NN;
lexicon.clerk = A_NN;
lexicon.clerks = A_NNS;
lexicon.clicked = A_VBD_VBN;
lexicon.clicking = A_VBG_NN;
lexicon.click = A_NN;
lexicon.clicks = A_NNS_VBZ;
lexicon.client = A_NN;
lexicon.clients = A_NNS;
lexicon.cliff = A_NN;
lexicon.cliffs = A_NNS;
lexicon.climates = A_NNS;
lexicon.climate = A_NN;
lexicon.climatic = A_JJ;
lexicon.climbs = A_VBZ_NNS;
lexicon.climbing = A_VBG_NN;
lexicon.climbed = A_VBD_VBN;
lexicon.climb = A_VB_VBP_NN;
lexicon.cling = A_VBP_VB;
lexicon.clinging = A_VBG;
lexicon.clings = A_VBZ;
lexicon.clinics = A_NNS;
lexicon.clinical = A_JJ;
lexicon.clinically = A_RB;
lexicon.clinic = A_NN;
lexicon.clippings = A_NNS;
lexicon.clipped = A_VBN_VBD;
lexicon.clip = A_NN_VB;
lexicon.clipping = A_NN;
lexicon.clips = A_NNS;
lexicon.clocked = A_VBN;
lexicon.clock = A_NN_VBP;
lexicon.clocks = A_NNS_VBZ;
lexicon.clocking = A_NN;
lexicon.closing = A_VBG_JJ_NN;
lexicon.closings = A_NNS;
lexicon.close = A_VB_VBP_JJ_NN_RB;
lexicon.closeness = A_NN;
lexicon.closely = A_RB;
lexicon.closes = A_VBZ_NNS_NN;
lexicon.closed = A_VBD_VBN_JJ_NN_VB;
lexicon.closer = A_JJR_JJ_RB_RBR;
lexicon.closest = A_JJS;
lexicon.closets = A_NNS;
lexicon.closeted = A_JJ_VBD_VBN;
lexicon.closet = A_NN;
lexicon.clothed = A_VBN;
lexicon.clothes = A_NNS;
lexicon.clothing = A_NN;
lexicon.cloth = A_NN;
lexicon.clothe = A_VB;
lexicon.clouding = A_NN;
lexicon.cloud = A_NN_VB_VBP;
lexicon.clouds = A_NNS_VBZ;
lexicon.clouded = A_VBN_JJ_VBD;
lexicon.clubbed = A_JJ_VBD;
lexicon.clubs = A_NNS;
lexicon.club = A_NN;
lexicon.clues = A_NNS;
lexicon.clue = A_NN;
lexicon.clustering = A_VBG_NN;
lexicon.clusters = A_NNS_VBZ;
lexicon.clustered = A_VBN_VBD;
lexicon.cluster = A_NN_VBP;
lexicon.coach = A_NN;
lexicon.coaches = A_NNS;
lexicon.coaching = A_NN_VBG;
lexicon.coached = A_VBN;
lexicon.coal = A_NN;
lexicon.coals = A_NNS;
lexicon.coalitions = A_NNS;
lexicon.coalition = A_NN;
lexicon.coasted = A_VBD_VBN;
lexicon.coast = A_NN;
lexicon.coasts = A_NNS;
lexicon.coastal = A_JJ;
lexicon.coating = A_NN_VBG;
lexicon.coat = A_NN_VB;
lexicon.coats = A_NNS;
lexicon.coated = A_VBN_JJ;
lexicon.coatings = A_NNS;
lexicon.cocaine = A_NN;
lexicon.code = A_NN_VB;
lexicon.coding = A_NN;
lexicon.codes = A_NNS;
lexicon.coded = A_VBN_JJ;
lexicon.coffees = A_NNS;
lexicon.coffee = A_NN;
lexicon.cognitive = A_JJ;
lexicon.coins = A_NNS;
lexicon.coin = A_NN_VB;
lexicon.coined = A_VBN_VBD;
lexicon.cold = A_JJ_NN;
lexicon.coldly = A_RB;
lexicon.colds = A_NNS;
lexicon.colde = A_MD;
lexicon.coldness = A_NN;
lexicon.collaborators = A_NNS;
lexicon.collaborate = A_VB_VBP;
lexicon.collaborations = A_NNS;
lexicon.collaborative = A_JJ;
lexicon.collaboration = A_NN;
lexicon.collaborating = A_VBG;
lexicon.collaborates = A_VBZ;
lexicon.collaborated = A_VBD_VBN;
lexicon.collaborator = A_NN;
lexicon.collapse = A_NN_VB;
lexicon.collapses = A_VBZ_NNS;
lexicon.collapsible = A_JJ;
lexicon.collapsing = A_VBG;
lexicon.collapsed = A_VBD_JJ_VBN;
lexicon.collar = A_NN_VB;
lexicon.collared = A_VBN;
lexicon.collars = A_NNS;
lexicon.colleague = A_NN;
lexicon.colleagues = A_NNS;
lexicon.collectively = A_RB;
lexicon.collections = A_NNS;
lexicon.collectability = A_NN;
lexicon.collecting = A_VBG_NN;
lexicon.collection = A_NN;
lexicon.collectives = A_NNS;
lexicon.collects = A_VBZ;
lexicon.collect = A_VB_JJ_VBP;
lexicon.collective = A_JJ_NN;
lexicon.collected = A_VBN_VBD;
lexicon.collectibles = A_NNS;
lexicon.collectible = A_JJ;
lexicon.collectors = A_NNS;
lexicon.collector = A_NN;
lexicon.college = A_NN;
lexicon.colleges = A_NNS;
lexicon.colonials = A_NNS;
lexicon.colonies = A_NNS;
lexicon.colonial = A_JJ_NN;
lexicon.colony = A_NN;
lexicon.colonialism = A_NN;
lexicon.coloring = A_NN;
lexicon.colorization = A_NN;
lexicon.color = A_NN_JJ_VB_VBP;
lexicon.colorful = A_JJ;
lexicon.colors = A_NNS_VBZ;
lexicon.colored = A_JJ_VBN;
lexicon.coloration = A_NN;
lexicon.coloreds = A_NNS;
lexicon.columns = A_NNS;
lexicon.column = A_NN;
lexicon.columnists = A_NNS;
lexicon.columnist = A_NN;
lexicon.combatant = A_JJ_NN;
lexicon.combative = A_JJ;
lexicon.combating = A_VBG;
lexicon.combatted = A_VBN;
lexicon.combatants = A_NNS;
lexicon.combat = A_NN_FW_VB;
lexicon.combination = A_NN;
lexicon.combinable = A_JJ;
lexicon.combines = A_VBZ_NNS;
lexicon.combined = A_VBN_JJ_VBD;
lexicon.combinations = A_NNS;
lexicon.combining = A_VBG;
lexicon.combine = A_VB_NN_VBP;
lexicon.comely = A_JJ;
lexicon.comings = A_NNS;
lexicon.coming = A_VBG_JJ_NN;
lexicon.comes = A_VBZ_NNS;
lexicon.come = A_VB_VBD_VBN_VBP_VBZ_JJ;
lexicon.comedy = A_NN;
lexicon.comedies = A_NNS;
lexicon.comedie = A_NN;
lexicon.comfort = A_NN_VB;
lexicon.comforted = A_VBN;
lexicon.comfortable = A_JJ_NN;
lexicon.comfortably = A_RB;
lexicon.comforting = A_VBG_JJ;
lexicon.comforts = A_NNS;
lexicon.commandant = A_NN;
lexicon.commands = A_NNS_VBZ;
lexicon.commander = A_NN;
lexicon.commandments = A_NNS;
lexicon.commandeering = A_VBG;
lexicon.command = A_NN_VBP_VB;
lexicon.commanded = A_VBD_VBN;
lexicon.commanding = A_VBG_JJ_NN;
lexicon.commanders = A_NNS;
lexicon.commandeered = A_VBN;
lexicon.commandment = A_NN;
lexicon.commentators = A_NNS;
lexicon.commentator = A_NN;
lexicon.commented = A_VBD_VBN;
lexicon.comment = A_VB_VBP_NN;
lexicon.commenting = A_VBG;
lexicon.comments = A_NNS_VBZ;
lexicon.commercial = A_JJ_NN;
lexicon.commercializing = A_VBG;
lexicon.commercialism = A_NN;
lexicon.commercialization = A_NN;
lexicon.commercials = A_NNS;
lexicon.commercialize = A_VB;
lexicon.commercially = A_RB;
lexicon.commercialized = A_VBN;
lexicon.commissioned = A_VBN_VBD;
lexicon.commission = A_NN_VB;
lexicon.commissions = A_NNS_VBZ_NN;
lexicon.commissioning = A_NN_VBG;
lexicon.commissioner = A_NN;
lexicon.commissioners = A_NNS;
lexicon.commitments = A_NNS;
lexicon.committed = A_VBN_JJ_VB_VBD;
lexicon.commit = A_VB_JJ_VBP;
lexicon.commits = A_VBZ;
lexicon.committing = A_VBG;
lexicon.commitment = A_NN;
lexicon.committee = A_NN;
lexicon.committees = A_NNS_VBZ;
lexicon.commodities = A_NNS;
lexicon.commodity = A_NN;
lexicon.commonality = A_NN;
lexicon.common = A_JJ_NN;
lexicon.commonly = A_RB;
lexicon.commoner = A_JJR;
lexicon.commoners = A_NNS;
lexicon.commons = A_NN;
lexicon.commonness = A_NN;
lexicon.communicate = A_VB_VBP;
lexicon.communicating = A_VBG_NN;
lexicon.communicators = A_NNS;
lexicon.communicational = A_JJ;
lexicon.communications = A_NNS_NN;
lexicon.communication = A_NN;
lexicon.communicative = A_JJ;
lexicon.communicator = A_NN;
lexicon.communicated = A_VBN_VBD;
lexicon.communicable = A_JJ;
lexicon.community = A_NN;
lexicon.communities = A_NNS;
lexicon.companions = A_NNS;
lexicon.companion = A_NN_JJ;
lexicon.companionable = A_JJ;
lexicon.company = A_NN;
lexicon.companies = A_NNS;
lexicon.comparative = A_JJ_NN;
lexicon.compared = A_VBN_VBD;
lexicon.compare = A_VB_VBP_NN;
lexicon.comparable = A_JJ;
lexicon.comparably = A_RB;
lexicon.comparing = A_VBG;
lexicon.compares = A_VBZ_NNS;
lexicon.comparatively = A_RB;
lexicon.comparability = A_NN;
lexicon.comparisons = A_NNS;
lexicon.comparison = A_NN;
lexicon.compellingly = A_RB;
lexicon.compelling = A_JJ_VBG;
lexicon.compels = A_VBZ;
lexicon.compel = A_VB;
lexicon.compelled = A_VBN_VBD_JJ;
lexicon.compensated = A_VBN_VBD;
lexicon.compensates = A_VBZ;
lexicon.compensations = A_NNS;
lexicon.compensating = A_VBG;
lexicon.compensate = A_VB_VBP;
lexicon.compensation = A_NN;
lexicon.compete = A_VB_VBP;
lexicon.competing = A_VBG_JJ;
lexicon.competently = A_RB;
lexicon.competes = A_VBZ;
lexicon.competed = A_VBD_VBN;
lexicon.competency = A_NN;
lexicon.competent = A_JJ;
lexicon.competence = A_NN;
lexicon.competitions = A_NNS;
lexicon.competitive = A_JJ;
lexicon.competitiveness = A_NN;
lexicon.competitively = A_RB;
lexicon.competition = A_NN;
lexicon.competitors = A_NNS;
lexicon.competitor = A_NN;
lexicon.complaining = A_VBG;
lexicon.complainant = A_NN;
lexicon.complain = A_VBP_VB;
lexicon.complains = A_VBZ;
lexicon.complained = A_VBD_VBN;
lexicon.complaint = A_NN;
lexicon.complaints = A_NNS;
lexicon.completes = A_VBZ;
lexicon.completely = A_RB;
lexicon.completed = A_VBN_JJ_VBD;
lexicon.complete = A_JJ_VB_VBP;
lexicon.completing = A_VBG;
lexicon.completions = A_NNS;
lexicon.completeness = A_NN;
lexicon.completion = A_NN;
lexicon.complexity = A_NN;
lexicon.complex = A_JJ_NN;
lexicon.complexities = A_NNS;
lexicon.complexes = A_NNS;
lexicon.compliance = A_NN;
lexicon.complications = A_NNS;
lexicon.complicate = A_VB_VBP;
lexicon.complicates = A_VBZ;
lexicon.complicated = A_VBN_JJ_VBD;
lexicon.complicating = A_VBG;
lexicon.complicity = A_NN;
lexicon.complication = A_NN;
lexicon.comply = A_VB_VBP;
lexicon.complies = A_VBZ;
lexicon.complied = A_VBN_VBD;
lexicon.complying = A_VBG;
lexicon.component = A_NN;
lexicon.components = A_NNS;
lexicon.composers = A_NNS;
lexicon.composing = A_VBG;
lexicon.compose = A_VB_VBP;
lexicon.composed = A_VBN_VBD_JJ;
lexicon.composer = A_NN;
lexicon.composes = A_VBZ;
lexicon.composition = A_NN;
lexicon.compositional = A_JJ;
lexicon.composite = A_JJ_NN;
lexicon.compositions = A_NNS;
lexicon.composites = A_NNS;
lexicon.compound = A_NN_JJ_VB_VBP;
lexicon.compounding = A_VBG_NN;
lexicon.compounds = A_NNS_VBZ;
lexicon.compounded = A_VBN_JJ_VBD;
lexicon.comprehensively = A_RB;
lexicon.comprehensiveness = A_NN;
lexicon.comprehension = A_NN;
lexicon.comprehensive = A_JJ;
lexicon.comprising = A_VBG;
lexicon.comprised = A_VBN_VBD;
lexicon.comprises = A_VBZ;
lexicon.comprise = A_VBP_VB;
lexicon.compromising = A_VBG_JJ;
lexicon.compromise = A_NN_JJ_VB;
lexicon.compromises = A_NNS_VBZ;
lexicon.compromiser = A_NN;
lexicon.compromised = A_VBN_VBD;
lexicon.computational = A_JJ;
lexicon.compute = A_VB;
lexicon.computes = A_VBZ;
lexicon.computation = A_NN;
lexicon.computations = A_NNS;
lexicon.computer = A_NN;
lexicon.computing = A_VBG_NN;
lexicon.computers = A_NNS;
lexicon.computed = A_VBN_JJ;
lexicon.concede = A_VBP_VB;
lexicon.concedes = A_VBZ;
lexicon.conceded = A_VBD_VBN;
lexicon.conceding = A_VBG;
lexicon.concededly = A_RB;
lexicon.conceiving = A_VBG;
lexicon.conceive = A_VB_VBP;
lexicon.conceived = A_VBN_VBD_JJ;
lexicon.conceives = A_VBZ;
lexicon.conceiver = A_NN;
lexicon.conceivably = A_RB;
lexicon.conceivable = A_JJ;
lexicon.concentrating = A_VBG;
lexicon.concentric = A_JJ;
lexicon.concentrate = A_VB_VBP_NN;
lexicon.concentrations = A_NNS;
lexicon.concentrated = A_VBN_JJ_VBD;
lexicon.concentrates = A_VBZ_NNS;
lexicon.concentration = A_NN;
lexicon.concept = A_NN;
lexicon.conception = A_NN;
lexicon.conceptions = A_NNS;
lexicon.concepts = A_NNS;
lexicon.concerning = A_VBG;
lexicon.concerns = A_NNS_VBZ;
lexicon.concern = A_NN_VBP_VB;
lexicon.concerned = A_VBN_JJ_VB_VBD;
lexicon.concerted = A_JJ_VBN;
lexicon.concerts = A_NNS;
lexicon.concert = A_NN;
lexicon.concluded = A_VBD_VBN;
lexicon.conclude = A_VB_VBP;
lexicon.concluding = A_VBG_JJ;
lexicon.concludes = A_VBZ;
lexicon.conclusion = A_NN;
lexicon.conclusively = A_RB;
lexicon.conclusions = A_NNS;
lexicon.conclusive = A_JJ;
lexicon.concrete = A_JJ_NN;
lexicon.concretely = A_RB;
lexicon.condemned = A_VBN_JJ_VBD;
lexicon.condemning = A_VBG;
lexicon.condemn = A_VB_VBP;
lexicon.condemns = A_VBZ;
lexicon.condemnation = A_NN;
lexicon.conditioned = A_VBN_VBD_JJ;
lexicon.conditional = A_JJ_NN;
lexicon.conditioning = A_NN_VBG;
lexicon.conditionally = A_RB;
lexicon.conditions = A_NNS;
lexicon.condition = A_NN_VBP_VB;
lexicon.conducts = A_VBZ;
lexicon.conductivity = A_NN;
lexicon.conduct = A_NN_VBP_VB;
lexicon.conducted = A_VBN_VBD;
lexicon.conducting = A_VBG_NN;
lexicon.conduction = A_NN;
lexicon.conferred = A_VBN_VBD;
lexicon.conference = A_NN;
lexicon.conferring = A_VBG;
lexicon.confers = A_VBZ;
lexicon.confer = A_VB_VBP;
lexicon.conferences = A_NNS;
lexicon.confessions = A_NNS;
lexicon.confess = A_VB_VBP;
lexicon.confessing = A_VBG;
lexicon.confesses = A_VBZ;
lexicon.confession = A_NN;
lexicon.confessed = A_VBD_VBN;
lexicon.confidently = A_RB;
lexicon.confided = A_VBD_VBN;
lexicon.confides = A_VBZ;
lexicon.confidence = A_NN;
lexicon.confidences = A_NNS;
lexicon.confiding = A_VBG_JJ;
lexicon.confidants = A_NNS;
lexicon.confide = A_VB_VBP;
lexicon.confident = A_JJ;
lexicon.confidant = A_NN;
lexicon.confirmed = A_VBD_VBN_JJ;
lexicon.confirming = A_VBG;
lexicon.confirmation = A_NN;
lexicon.confirms = A_VBZ;
lexicon.confirmations = A_NNS;
lexicon.confirm = A_VB_VBP;
lexicon.conflicted = A_VBD_VBN;
lexicon.conflicts = A_NNS_VBZ;
lexicon.conflict = A_NN_VB_VBP;
lexicon.conflicting = A_VBG_JJ;
lexicon.confronts = A_VBZ;
lexicon.confront = A_VB_VBP;
lexicon.confrontational = A_JJ;
lexicon.confrontations = A_NNS;
lexicon.confrontation = A_NN;
lexicon.confronted = A_VBN_VBD;
lexicon.confronting = A_VBG;
lexicon.confusions = A_NNS;
lexicon.confuse = A_VB_VBP;
lexicon.confused = A_VBN_JJ_VBD;
lexicon.confuses = A_VBZ;
lexicon.confusing = A_JJ_VBG;
lexicon.confusion = A_NN;
lexicon.congressional = A_JJ;
lexicon.congressionally = A_RB;
lexicon.connecting = A_VBG_JJ;
lexicon.connects = A_VBZ;
lexicon.connect = A_VB_VBP;
lexicon.connection = A_NN;
lexicon.connections = A_NNS;
lexicon.connective = A_JJ;
lexicon.connected = A_VBN_JJ_VBD;
lexicon.consciences = A_NNS;
lexicon.conscience = A_NN;
lexicon.conscious = A_JJ_NN;
lexicon.consciously = A_RB;
lexicon.consciousness = A_NN;
lexicon.consecutive = A_JJ;
lexicon.consensus = A_NN;
lexicon.consenting = A_VBG_JJ;
lexicon.consents = A_NNS_VBZ;
lexicon.consent = A_NN_VB;
lexicon.consented = A_VBD_VBN;
lexicon.consequences = A_NNS;
lexicon.consequently = A_RB;
lexicon.consequence = A_NN;
lexicon.consequent = A_JJ;
lexicon.conservative = A_JJ_NN;
lexicon.conservatives = A_NNS;
lexicon.conservancy = A_NN;
lexicon.conserving = A_VBG;
lexicon.conserve = A_VB;
lexicon.conservation = A_NN;
lexicon.conservatively = A_RB;
lexicon.conservator = A_NN;
lexicon.conserves = A_VBZ;
lexicon.conserved = A_VBN;
lexicon.conservators = A_NNS;
lexicon.considering = A_VBG;
lexicon.considered = A_VBN_VBD_JJ;
lexicon.consider = A_VB_VBP;
lexicon.considers = A_VBZ;
lexicon.considerate = A_JJ;
lexicon.considerably = A_RB;
lexicon.considerable = A_JJ;
lexicon.considerately = A_RB;
lexicon.consideration = A_NN;
lexicon.considerations = A_NNS;
lexicon.consisted = A_VBD_VBN;
lexicon.consistently = A_RB;
lexicon.consist = A_VB_VBP;
lexicon.consists = A_VBZ;
lexicon.consistence = A_NN;
lexicon.consistency = A_NN;
lexicon.consistent = A_JJ;
lexicon.consisting = A_VBG;
lexicon.conspiracy = A_NN;
lexicon.conspiracies = A_NNS;
lexicon.constant = A_JJ_NN_RB;
lexicon.constants = A_NNS;
lexicon.constantly = A_RB;
lexicon.constitute = A_VBP_VB;
lexicon.constitutionality = A_NN;
lexicon.constitution = A_NN;
lexicon.constituted = A_VBD_VBN;
lexicon.constitutional = A_JJ;
lexicon.constituting = A_VBG;
lexicon.constitutes = A_VBZ;
lexicon.constitutionally = A_RB;
lexicon.constitutions = A_NNS;
lexicon.constraint = A_NN;
lexicon.constraints = A_NNS;
lexicon.constructional = A_JJ;
lexicon.constructive = A_JJ;
lexicon.constructed = A_VBN_VBD;
lexicon.constructs = A_VBZ;
lexicon.construct = A_VB_VBP;
lexicon.constructively = A_RB;
lexicon.constructions = A_NNS;
lexicon.constructing = A_VBG;
lexicon.construction = A_NN;
lexicon.consultancy = A_NN;
lexicon.consult = A_VB;
lexicon.consultants = A_NNS;
lexicon.consultations = A_NNS;
lexicon.consultative = A_JJ;
lexicon.consulting = A_NN_JJ_VBG;
lexicon.consulted = A_VBN_VBD;
lexicon.consultation = A_NN;
lexicon.consultant = A_NN;
lexicon.consumer = A_NN;
lexicon.consumes = A_VBZ;
lexicon.consumables = A_NNS;
lexicon.consumers = A_NNS;
lexicon.consuming = A_VBG_NN;
lexicon.consumed = A_VBN_VBD;
lexicon.consume = A_VBP_VB;
lexicon.consumptive = A_JJ;
lexicon.consumption = A_NN;
lexicon.contact = A_NN_JJ_VB;
lexicon.contacts = A_NNS_VBZ;
lexicon.contacted = A_VBN_VBD;
lexicon.contacting = A_VBG;
lexicon.containment = A_NN;
lexicon.containing = A_VBG;
lexicon.contain = A_VB_VBP;
lexicon.containers = A_NNS;
lexicon.contains = A_VBZ;
lexicon.container = A_NN;
lexicon.contained = A_VBD_VBN_JJ;
lexicon.containable = A_JJ;
lexicon.contemplation = A_NN;
lexicon.contemplating = A_VBG;
lexicon.contemplative = A_JJ;
lexicon.contemplated = A_VBN_JJ_VBD;
lexicon.contemplates = A_VBZ;
lexicon.contemplate = A_VB_VBP;
lexicon.contemporaries = A_NNS;
lexicon.contemporary = A_JJ_NN;
lexicon.contending = A_VBG;
lexicon.contender = A_NN;
lexicon.contended = A_VBD_VBN;
lexicon.contend = A_VBP_VB;
lexicon.contenders = A_NNS;
lexicon.contends = A_VBZ;
lexicon.contents = A_NNS;
lexicon.contented = A_VBN_JJ;
lexicon.contentions = A_NNS;
lexicon.contentment = A_NN;
lexicon.contention = A_NN;
lexicon.content = A_NN_JJ_VB;
lexicon.contentedly = A_RB;
lexicon.contenting = A_VBG;
lexicon.contested = A_VBN_JJ_VBD;
lexicon.contestant = A_NN;
lexicon.contests = A_NNS;
lexicon.contestants = A_NNS;
lexicon.contesting = A_VBG;
lexicon.contest = A_NN_VB;
lexicon.contexts = A_NNS;
lexicon.context = A_NN;
lexicon.continously = A_RB;
lexicon.continents = A_NNS;
lexicon.continent = A_NN;
lexicon.continence = A_NN;
lexicon.continuingly = A_RB;
lexicon.continue = A_VB_VBP;
lexicon.continuously = A_RB;
lexicon.continues = A_VBZ;
lexicon.continued = A_VBD_JJ_VBN;
lexicon.continually = A_RB;
lexicon.continual = A_JJ;
lexicon.continuous = A_JJ;
lexicon.continuities = A_NNS;
lexicon.continuation = A_NN;
lexicon.continuity = A_NN;
lexicon.continuance = A_NN;
lexicon.continuing = A_VBG_JJ;
lexicon.contracting = A_NN_VBG;
lexicon.contractions = A_NNS;
lexicon.contracted = A_VBD_VBN;
lexicon.contraction = A_NN;
lexicon.contract = A_NN_VB_VBP;
lexicon.contracts = A_NNS_NN_VBZ;
lexicon.contractor = A_NN;
lexicon.contractors = A_NNS;
lexicon.contrasts = A_NNS_VBZ;
lexicon.contrasting = A_VBG_JJ;
lexicon.contrast = A_NN_VB_VBP;
lexicon.contrasted = A_VBN_VBD;
lexicon.contribution = A_NN;
lexicon.contribute = A_VB_VBP;
lexicon.contributed = A_VBD_VBN;
lexicon.contributes = A_VBZ;
lexicon.contributing = A_VBG_JJ;
lexicon.contributions = A_NNS;
lexicon.contributor = A_NN;
lexicon.contributors = A_NNS;
lexicon.controllers = A_NNS;
lexicon.controlled = A_VBN_JJ_VBD;
lexicon.controller = A_NN;
lexicon.controlling = A_VBG_JJ_NN;
lexicon.controllable = A_JJ;
lexicon.controls = A_NNS_VBZ;
lexicon.control = A_NN_JJ_VB_VBP;
lexicon.controversy = A_NN;
lexicon.controversies = A_NNS;
lexicon.controversial = A_JJ;
lexicon.convenient = A_JJ;
lexicon.conveniently = A_RB;
lexicon.convenience = A_NN;
lexicon.conveniences = A_NNS;
lexicon.convention = A_NN;
lexicon.convent = A_NN;
lexicon.conventionally = A_RB;
lexicon.conventional = A_JJ;
lexicon.conventions = A_NNS;
lexicon.conventionality = A_NN;
lexicon.converse = A_VB_NN;
lexicon.conversing = A_VBG;
lexicon.conversations = A_NNS;
lexicon.conversational = A_JJ;
lexicon.conversant = A_NN;
lexicon.conversely = A_RB;
lexicon.conversion = A_NN;
lexicon.conversation = A_NN;
lexicon.conversions = A_NNS;
lexicon.convertibles = A_NNS;
lexicon.converters = A_NNS;
lexicon.convertible = A_JJ_NN;
lexicon.convertibility = A_NN;
lexicon.converting = A_VBG;
lexicon.convert = A_VB_VBP_NN;
lexicon.converts = A_NNS_VBZ;
lexicon.converter = A_NN;
lexicon.converted = A_VBN_JJ_VBD;
lexicon.conveying = A_VBG;
lexicon.convey = A_VB_VBP;
lexicon.conveys = A_VBZ;
lexicon.conveyed = A_VBD_VBN;
lexicon.conveyance = A_NN;
lexicon.convicts = A_NNS;
lexicon.convicting = A_VBG;
lexicon.convicted = A_VBN_VBD;
lexicon.conviction = A_NN;
lexicon.convictions = A_NNS;
lexicon.convict = A_NN_VB;
lexicon.convincingly = A_RB;
lexicon.convincing = A_JJ_VBG_NN;
lexicon.convince = A_VB_VBP;
lexicon.convinces = A_VBZ;
lexicon.convinced = A_VBN_VBD_JJ;
lexicon.cooked = A_VBN_VBD;
lexicon.cook = A_NN_VB_VBP;
lexicon.cooking = A_NN_VBG_JJ;
lexicon.cooks = A_NNS;
lexicon.cookies = A_NNS;
lexicon.cookie = A_NN;
lexicon.cool = A_JJ_NN_RB_VB_VBP;
lexicon.cooled = A_VBN_JJ_VBD;
lexicon.coolness = A_NN;
lexicon.cools = A_VBZ;
lexicon.cooling = A_NN_VBG;
lexicon.coolnesses = A_NNS;
lexicon.cooperation = A_NN;
lexicon.cooperates = A_VBZ;
lexicon.cooperated = A_VBN_VBD;
lexicon.cooperative = A_JJ_NN;
lexicon.cooperating = A_VBG;
lexicon.cooperatively = A_RB;
lexicon.cooperatives = A_NNS;
lexicon.cooperate = A_VB_VBP;
lexicon.coordinator = A_NN;
lexicon.coordinating = A_VBG_NN;
lexicon.coordinated = A_VBN_VBD_JJ;
lexicon.coordinates = A_NNS_VBZ;
lexicon.coordinators = A_NNS;
lexicon.coordinate = A_VB_JJ_NN_VBP;
lexicon.coordination = A_NN;
lexicon.cops = A_NNS;
lexicon.cop = A_NN;
lexicon.copes = A_VBZ;
lexicon.cope = A_VB_NN;
lexicon.coping = A_VBG_NN;
lexicon.copings = A_NNS;
lexicon.copy = A_NN_VBP_VB;
lexicon.copying = A_NN_VBG;
lexicon.copies = A_NNS;
lexicon.copied = A_VBN_VBD;
lexicon.cords = A_NNS;
lexicon.corded = A_VBN;
lexicon.cord = A_NN;
lexicon.cores = A_NNS;
lexicon.core = A_NN_JJ;
lexicon.corne = A_NN;
lexicon.corns = A_NNS;
lexicon.corn = A_NN;
lexicon.corners = A_NNS;
lexicon.cornering = A_VBG;
lexicon.corner = A_NN_JJ_VB;
lexicon.cornered = A_VBN_VBD_JJ;
lexicon.corporate = A_JJ;
lexicon.corporates = A_NNS;
lexicon.corporation = A_NN;
lexicon.corporeality = A_NN;
lexicon.corporations = A_NNS;
lexicon.corporal = A_NN;
lexicon.corporeal = A_JJ;
lexicon.corrected = A_VBN_VBD_JJ;
lexicon.correction = A_NN;
lexicon.correctional = A_JJ;
lexicon.corrective = A_JJ;
lexicon.corrects = A_VBZ;
lexicon.correctly = A_RB;
lexicon.correct = A_JJ_VBP_VB;
lexicon.correctness = A_NN;
lexicon.corrections = A_NNS;
lexicon.correcting = A_VBG_NN;
lexicon.correlated = A_JJ_VBD_VBN;
lexicon.correlations = A_NNS;
lexicon.correlating = A_VBG;
lexicon.correlate = A_VB_VBP;
lexicon.correlation = A_NN;
lexicon.correspondence = A_NN;
lexicon.correspondents = A_NNS;
lexicon.correspondent = A_NN;
lexicon.correspondingly = A_RB;
lexicon.corresponds = A_VBZ;
lexicon.correspond = A_VB_VBP;
lexicon.corresponded = A_VBD;
lexicon.corresponding = A_JJ_VBG;
lexicon.corridors = A_NNS;
lexicon.corridor = A_NN;
lexicon.corrupted = A_VBN;
lexicon.corrupter = A_NN;
lexicon.corrupt = A_JJ_VB;
lexicon.corruptions = A_NNS;
lexicon.corruption = A_NN;
lexicon.corruptible = A_JJ;
lexicon.corrupts = A_VBZ;
lexicon.corrupting = A_VBG_JJ_NN;
lexicon.coste = A_VB;
lexicon.costing = A_VBG_NN;
lexicon.cost = A_NN_VBD_VBN_VBP_VB;
lexicon.costly = A_JJ_RB;
lexicon.costs = A_NNS_VBZ;
lexicon.costuming = A_NN;
lexicon.costume = A_NN_JJ;
lexicon.costumes = A_NNS;
lexicon.costumed = A_VBN;
lexicon.cottages = A_NNS;
lexicon.cottage = A_NN;
lexicon.cotton = A_NN;
lexicon.couching = A_VBG;
lexicon.couch = A_NN;
lexicon.couches = A_NNS;
lexicon.couched = A_VBN_VBD;
lexicon.could = A_MD;
lexicon.councils = A_NNS;
lexicon.council = A_NN;
lexicon.counsel = A_NN_VB_VBP;
lexicon.counseling = A_NN_VBG;
lexicon.counsels = A_VBZ;
lexicon.counseled = A_VBN_VBD;
lexicon.counselors = A_NNS;
lexicon.counselor = A_NN;
lexicon.counting = A_VBG_NN;
lexicon.count = A_NN_VB_VBP;
lexicon.counts = A_NNS_VBZ;
lexicon.counted = A_VBN_VBD;
lexicon.countering = A_VBG;
lexicon.countered = A_VBD_VBN;
lexicon.counters = A_NNS_VBZ;
lexicon.counter = A_NN_IN_JJ_RB_VB_VBP;
lexicon.counterparts = A_NNS;
lexicon.counterpart = A_NN_JJ;
lexicon.countries = A_NNS;
lexicon.country = A_NN;
lexicon.county = A_NN;
lexicon.counties = A_NNS;
lexicon.coupe = A_NN;
lexicon.coup = A_NN_FW;
lexicon.coupes = A_NNS;
lexicon.coups = A_NNS;
lexicon.couple = A_NN_JJ_VB;
lexicon.coupled = A_VBN_VBD;
lexicon.couples = A_NNS;
lexicon.coupling = A_VBG_NN;
lexicon.courageous = A_JJ;
lexicon.courageously = A_RB;
lexicon.courage = A_NN;
lexicon.courses = A_NNS;
lexicon.coursed = A_VBN;
lexicon.course = A_NN_RB;
lexicon.coursing = A_VBG;
lexicon.court = A_NN_VBP_VB;
lexicon.courtly = A_JJ;
lexicon.courts = A_NNS_VBZ;
lexicon.courting = A_VBG_NN;
lexicon.courted = A_VBN_VBD;
lexicon.courtroom = A_NN;
lexicon.courtrooms = A_NNS;
lexicon.cousin = A_NN;
lexicon.cousins = A_NNS;
lexicon.cover = A_VB_NN_VBP;
lexicon.covering = A_VBG_NN;
lexicon.covered = A_VBN_JJ_VBD;
lexicon.coverings = A_NNS;
lexicon.covers = A_VBZ_NNS;
lexicon.coverages = A_NNS;
lexicon.coverage = A_NN;
lexicon.cowed = A_VBN;
lexicon.cows = A_NNS;
lexicon.cow = A_NN_VB;
lexicon.crack = A_NN_JJ_VB_VBP;
lexicon.cracks = A_NNS_VBZ;
lexicon.cracking = A_VBG_JJ_NN;
lexicon.cracked = A_VBD_VBN_JJ;
lexicon.crafts = A_NNS;
lexicon.craft = A_NN_VB;
lexicon.crafted = A_VBN_VBD;
lexicon.crafting = A_VBG;
lexicon.crashed = A_VBD_JJ_VBN;
lexicon.crashes = A_NNS_VBZ;
lexicon.crashing = A_VBG;
lexicon.crash = A_NN_VBP_JJ_VB;
lexicon.crawl = A_VB_NN;
lexicon.crawled = A_VBD_VBN;
lexicon.crawls = A_NNS_VBZ;
lexicon.crawling = A_VBG;
lexicon.crazies = A_NNS;
lexicon.craziness = A_NN;
lexicon.crazy = A_JJ;
lexicon.cream = A_NN_JJ;
lexicon.creamed = A_VBN;
lexicon.creams = A_NNS;
lexicon.create = A_VB_VBP;
lexicon.created = A_VBN_VBD_JJ;
lexicon.creates = A_VBZ;
lexicon.creating = A_VBG;
lexicon.creation = A_NN;
lexicon.creations = A_NNS;
lexicon.creationism = A_NN;
lexicon.creativity = A_NN;
lexicon.creative = A_JJ;
lexicon.creativeness = A_NN;
lexicon.creatively = A_RB;
lexicon.creatures = A_NNS;
lexicon.creature = A_NN;
lexicon.credibility = A_NN;
lexicon.credible = A_JJ;
lexicon.credibly = A_RB;
lexicon.credits = A_NNS_VBZ;
lexicon.credit = A_NN_VB_VBP;
lexicon.credited = A_VBN_VBD;
lexicon.creditably = A_RB;
lexicon.creditable = A_JJ;
lexicon.crediting = A_NN_VBG;
lexicon.crews = A_NNS;
lexicon.crew = A_NN;
lexicon.crime = A_NN;
lexicon.crimes = A_NNS;
lexicon.criminality = A_NN;
lexicon.criminals = A_NNS;
lexicon.criminalizing = A_VBG;
lexicon.criminally = A_RB;
lexicon.criminal = A_JJ_NN;
lexicon.criminalized = A_JJ;
lexicon.criminalization = A_NN;
lexicon.criminalize = A_VB;
lexicon.crisis = A_NN;
lexicon.criteria = A_NNS;
lexicon.criticize = A_VB_VBP;
lexicon.criticisms = A_NNS;
lexicon.criticizes = A_VBZ;
lexicon.criticized = A_VBN_VBD;
lexicon.criticizing = A_VBG;
lexicon.critics = A_NNS;
lexicon.critical = A_JJ;
lexicon.critic = A_NN;
lexicon.critically = A_RB;
lexicon.criticism = A_NN;
lexicon.criticality = A_NN;
lexicon.cropping = A_VBG;
lexicon.crop = A_NN_RP_VB_VBP;
lexicon.crops = A_NNS_VBZ;
lexicon.cropped = A_VBD_VBN;
lexicon.crossings = A_NNS;
lexicon.crosses = A_VBZ_NNS;
lexicon.cross = A_VB_JJ_NN_RB_VBP;
lexicon.crossing = A_VBG_NN;
lexicon.crossed = A_VBD_VBN;
lexicon.crowd = A_NN_VBP_VB;
lexicon.crowds = A_NNS_VBP_VBZ;
lexicon.crowding = A_VBG;
lexicon.crowded = A_VBN_VBD_JJ;
lexicon.crucial = A_JJ;
lexicon.crucially = A_RB;
lexicon.cruel = A_JJ;
lexicon.cruises = A_NNS;
lexicon.cruising = A_VBG_NN;
lexicon.cruise = A_NN_VBP;
lexicon.crush = A_NN_VB;
lexicon.crushes = A_VBZ;
lexicon.crushing = A_VBG_JJ_NN;
lexicon.crushed = A_VBN_JJ_VBD;
lexicon.cried = A_VBD_VBN;
lexicon.cries = A_NNS_VBZ;
lexicon.cry = A_NN_VB_VBP;
lexicon.crying = A_VBG_NN;
lexicon.crystallized = A_VBD_VBN;
lexicon.crystals = A_NNS;
lexicon.crystallizing = A_VBG;
lexicon.crystallize = A_VB;
lexicon.crystal = A_NN_JJ;
lexicon.crystallization = A_NN;
lexicon.cues = A_NNS;
lexicon.cue = A_NN;
lexicon.cultured = A_JJ_VBN;
lexicon.cultures = A_NNS;
lexicon.culturally = A_RB;
lexicon.culture = A_NN;
lexicon.cultural = A_JJ;
lexicon.cupful = A_JJ;
lexicon.cupped = A_VBD_JJ;
lexicon.cups = A_NNS;
lexicon.cup = A_NN_VB;
lexicon.cure = A_NN_VBP_VB;
lexicon.cured = A_VBN_VBD;
lexicon.cures = A_NNS_VBZ;
lexicon.curing = A_VBG_NN;
lexicon.curiosity = A_NN;
lexicon.curiosities = A_NNS;
lexicon.curious = A_JJ;
lexicon.curiously = A_RB;
lexicon.currencies = A_NNS;
lexicon.currency = A_NN;
lexicon.current = A_JJ_NN;
lexicon.currently = A_RB_JJ;
lexicon.currents = A_NNS;
lexicon.curriculum = A_NN;
lexicon.curriculums = A_NNS;
lexicon.curtain = A_NN;
lexicon.curtained = A_JJ;
lexicon.curtains = A_NNS;
lexicon.curves = A_NNS;
lexicon.curved = A_JJ_VBN;
lexicon.curve = A_NN;
lexicon.curving = A_VBG;
lexicon.custodial = A_JJ;
lexicon.custody = A_NN;
lexicon.customer = A_NN;
lexicon.customized = A_VBN_JJ;
lexicon.custom = A_NN_JJ_RB;
lexicon.customs = A_NNS;
lexicon.customers = A_NNS;
lexicon.customization = A_NN;
lexicon.cuts = A_NNS_VBZ_NN;
lexicon.cutting = A_VBG_JJ_NN;
lexicon.cut = A_VB_VBD_VBN_VBP_JJ_NN;
lexicon.cuttings = A_NNS;
lexicon.cute = A_JJ;
lexicon.cuteness = A_NN;
lexicon.cycled = A_VBN;
lexicon.cycles = A_NNS_VBZ;
lexicon.cycling = A_NN_VBG;
lexicon.cycle = A_NN_VB;
lexicon.dad = A_NN;
lexicon.dailies = A_NNS;
lexicon.daily = A_JJ_NN_RB;
lexicon.dammed = A_VBD;
lexicon.dams = A_NNS;
lexicon.dam = A_NN_JJ_UH;
lexicon.damage = A_NN_VBP_VB;
lexicon.damaged = A_VBN_JJ_VBD;
lexicon.damages = A_NNS_VBZ;
lexicon.damaging = A_JJ_VBG;
lexicon.damning = A_VBG;
lexicon.damned = A_JJ_VBN_RB;
lexicon.damn = A_JJ_NN_RB_VB_UH;
lexicon.dances = A_NNS_VBZ;
lexicon.dance = A_NN_VB_VBP;
lexicon.dancing = A_NN_VBG;
lexicon.danced = A_VBD_VBN;
lexicon.dancer = A_NN;
lexicon.dancers = A_NNS;
lexicon.dangers = A_NNS;
lexicon.danger = A_NN;
lexicon.dangerously = A_RB;
lexicon.dangerous = A_JJ;
lexicon.dares = A_VBZ;
lexicon.dared = A_VBD_VBN;
lexicon.daring = A_JJ_NN_VBG;
lexicon.dare = A_VB_VBP_MD_NN;
lexicon.darkly = A_RB;
lexicon.darkness = A_NN;
lexicon.dark = A_JJ_NN_RB;
lexicon.data = A_NNS_NN;
lexicon.databases = A_NNS;
lexicon.database = A_NN;
lexicon.date = A_NN_VBP_VB;
lexicon.dates = A_NNS_VBZ;
lexicon.dated = A_VBN_JJ_VBD;
lexicon.dating = A_VBG_NN;
lexicon.daughters = A_NNS;
lexicon.daughter = A_NN;
lexicon.dawned = A_VBD;
lexicon.dawning = A_VBG_NN;
lexicon.dawn = A_NN_VB;
lexicon.dawns = A_VBZ;
lexicon.days = A_NNS;
lexicon.day = A_NN;
lexicon.dead = A_JJ_NN_RB_VBN;
lexicon.deadly = A_JJ_RB;
lexicon.deadness = A_NN;
lexicon.deadlines = A_NNS;
lexicon.deadline = A_NN;
lexicon.deal = A_NN_VB_VBP;
lexicon.dealing = A_VBG_NN;
lexicon.deals = A_NNS_VBZ;
lexicon.dealings = A_NNS;
lexicon.dealers = A_NNS;
lexicon.dealer = A_NN;
lexicon.dearly = A_RB;
lexicon.dear = A_JJ_NN_RB_UH;
lexicon.deathly = A_JJ;
lexicon.death = A_NN;
lexicon.deaths = A_NNS;
lexicon.debatable = A_JJ;
lexicon.debates = A_NNS_VBZ;
lexicon.debated = A_VBN_VBD;
lexicon.debate = A_NN_VB_VBP;
lexicon.debating = A_VBG_JJ;
lexicon.debris = A_NN;
lexicon.debts = A_NNS;
lexicon.debt = A_NN;
lexicon.debuting = A_VBG;
lexicon.debuts = A_VBZ;
lexicon.debuted = A_VBD;
lexicon.debut = A_NN_VB_VBP;
lexicon.decades = A_NNS;
lexicon.decade = A_NN;
lexicon.decadence = A_NN;
lexicon.decadent = A_JJ;
lexicon.decent = A_JJ;
lexicon.decently = A_RB;
lexicon.decide = A_VB_VBP;
lexicon.decidely = A_RB;
lexicon.decides = A_VBZ;
lexicon.decided = A_VBD_VBN_JJ;
lexicon.decidedly = A_RB;
lexicon.deciding = A_VBG_JJ;
lexicon.decisions = A_NNS;
lexicon.decisiveness = A_NN;
lexicon.decisively = A_RB;
lexicon.decision = A_NN;
lexicon.decisive = A_JJ;
lexicon.decking = A_NN_VBG;
lexicon.deck = A_NN_VB;
lexicon.decked = A_VBN;
lexicon.decks = A_NNS;
lexicon.declared = A_VBD_VBN_JJ;
lexicon.declares = A_VBZ;
lexicon.declaring = A_VBG;
lexicon.declare = A_VB_VBP;
lexicon.declaration = A_NN;
lexicon.declarative = A_JJ_NN;
lexicon.declarations = A_NNS;
lexicon.declines = A_NNS_VBZ;
lexicon.declined = A_VBD_VBN;
lexicon.decliners = A_NNS;
lexicon.decline = A_NN_VB_VBP;
lexicon.declining = A_VBG_JJ_NN;
lexicon.decorous = A_JJ;
lexicon.decor = A_NN;
lexicon.decoration = A_NN;
lexicon.decorated = A_VBN_VBD_JJ;
lexicon.decorations = A_NNS;
lexicon.decorator = A_NN;
lexicon.decorative = A_JJ;
lexicon.decorativeness = A_NN;
lexicon.decorate = A_VBP_VB;
lexicon.decorators = A_NNS;
lexicon.decorating = A_NN_VBG;
lexicon.decrease = A_NN_VB_VBP;
lexicon.decreasing = A_VBG;
lexicon.decreases = A_NNS_VBP_VBZ;
lexicon.decreased = A_VBD_VBN;
lexicon.dedicates = A_VBZ;
lexicon.dedicated = A_VBN_JJ_VBD;
lexicon.dedicate = A_VB;
lexicon.dedication = A_NN;
lexicon.deems = A_VBZ;
lexicon.deeming = A_VBG;
lexicon.deemed = A_VBN_VBD;
lexicon.deem = A_VBP_VB;
lexicon.deep = A_JJ_RB;
lexicon.deeps = A_NNS;
lexicon.deeply = A_RB;
lexicon.deer = A_NN_NNS;
lexicon.defeats = A_NNS_VBZ;
lexicon.defeated = A_VBN_VBD;
lexicon.defeat = A_NN_VB_VBP;
lexicon.defeatism = A_NN;
lexicon.defeating = A_VBG;
lexicon.defend = A_VB_VBP;
lexicon.defending = A_VBG_JJ;
lexicon.defends = A_VBZ;
lexicon.defendant = A_NN;
lexicon.defenders = A_NNS;
lexicon.defendants = A_NNS;
lexicon.defended = A_VBD_VBN;
lexicon.defender = A_NN;
lexicon.defenses = A_NNS;
lexicon.defensively = A_RB;
lexicon.defensive = A_JJ_NN;
lexicon.defensible = A_JJ;
lexicon.defense = A_NN;
lexicon.defensiveness = A_NN;
lexicon.deficit = A_NN;
lexicon.deficits = A_NNS;
lexicon.definable = A_JJ;
lexicon.defining = A_VBG;
lexicon.defined = A_VBN_JJ_VBD;
lexicon.defines = A_VBZ;
lexicon.define = A_VB_VBP;
lexicon.definitions = A_NNS;
lexicon.definitive = A_JJ;
lexicon.definite = A_JJ;
lexicon.definitively = A_RB;
lexicon.definition = A_NN;
lexicon.definitely = A_RB;
lexicon.definitional = A_JJ;
lexicon.degree = A_NN;
lexicon.degrees = A_NNS;
lexicon.delaying = A_VBG_JJ;
lexicon.delay = A_NN_VB_VBP;
lexicon.delays = A_NNS_VBZ;
lexicon.delayed = A_VBN_JJ_VBD;
lexicon.deliberating = A_VBG;
lexicon.deliberation = A_NN;
lexicon.deliberations = A_NNS;
lexicon.deliberated = A_VBD;
lexicon.deliberate = A_JJ_VB;
lexicon.deliberately = A_RB;
lexicon.delicately = A_RB;
lexicon.delicate = A_JJ;
lexicon.delighted = A_VBN_JJ_VBD;
lexicon.delights = A_VBZ_NNS;
lexicon.delighting = A_VBG;
lexicon.delightfully = A_RB;
lexicon.delightful = A_JJ;
lexicon.delight = A_NN_VB_VBP;
lexicon.delivers = A_VBZ;
lexicon.deliver = A_VB_VBP;
lexicon.delivering = A_VBG;
lexicon.delivered = A_VBN_VBD;
lexicon.deliveries = A_NNS_NN;
lexicon.delivery = A_NN;
lexicon.demanded = A_VBD_VBN;
lexicon.demander = A_NN;
lexicon.demand = A_NN_VB_VBP;
lexicon.demands = A_NNS_VBZ;
lexicon.demanding = A_VBG_JJ;
lexicon.demandingly = A_RB;
lexicon.democracies = A_NNS;
lexicon.democracy = A_NN;
lexicon.democrats = A_NNS;
lexicon.democratization = A_NN;
lexicon.democratizing = A_VBG;
lexicon.democratic = A_JJ;
lexicon.democratized = A_VBN;
lexicon.democratize = A_VB;
lexicon.democrat = A_NN;
lexicon.democratically = A_RB;
lexicon.demographic = A_JJ;
lexicon.demographically = A_RB;
lexicon.demographics = A_NNS;
lexicon.demonstrated = A_VBN_VBD_JJ;
lexicon.demonstratives = A_NNS;
lexicon.demonstrating = A_VBG;
lexicon.demonstrate = A_VB_VBP;
lexicon.demonstrable = A_JJ;
lexicon.demonstrably = A_RB;
lexicon.demonstrativeness = A_NN;
lexicon.demonstrators = A_NNS;
lexicon.demonstrates = A_VBZ;
lexicon.demonstratively = A_RB;
lexicon.demonstration = A_NN;
lexicon.demonstrations = A_NNS;
lexicon.denials = A_NNS;
lexicon.denial = A_NN;
lexicon.dense = A_JJ;
lexicon.densely = A_RB;
lexicon.density = A_NN;
lexicon.densities = A_NNS;
lexicon.denying = A_VBG_NN;
lexicon.denies = A_VBZ;
lexicon.denied = A_VBN_VBD;
lexicon.deny = A_VB_VBP;
lexicon.depart = A_VB_VBP;
lexicon.department = A_NN;
lexicon.departments = A_NNS;
lexicon.departs = A_VBZ;
lexicon.departed = A_VBD_JJ_VBN;
lexicon.departing = A_VBG;
lexicon.departures = A_NNS;
lexicon.departure = A_NN;
lexicon.depending = A_VBG;
lexicon.dependable = A_JJ;
lexicon.depends = A_VBZ;
lexicon.depend = A_VB_VBP;
lexicon.dependents = A_NNS;
lexicon.dependent = A_JJ_NN;
lexicon.depended = A_VBD_VBN;
lexicon.dependence = A_NN;
lexicon.dependency = A_NN;
lexicon.depict = A_VB_VBP;
lexicon.depiction = A_NN;
lexicon.depictions = A_NNS;
lexicon.depicting = A_VBG;
lexicon.depicts = A_VBZ;
lexicon.depicted = A_VBN_VBD;
lexicon.deployment = A_NN;
lexicon.deployed = A_VBN_VBD;
lexicon.deployments = A_NNS;
lexicon.deploy = A_VB_VBP;
lexicon.deploying = A_VBG;
lexicon.deployable = A_JJ;
lexicon.deposits = A_NNS_VBZ;
lexicon.depositing = A_VBG;
lexicon.depositions = A_NNS;
lexicon.deposit = A_NN_VB_VBP;
lexicon.deposition = A_NN;
lexicon.deposited = A_VBN_VBD;
lexicon.depressant = A_NN;
lexicon.depressants = A_NNS;
lexicon.depressingly = A_RB;
lexicon.depressed = A_JJ_VBD_VBN;
lexicon.depresses = A_VBZ;
lexicon.depressing = A_JJ_VBG;
lexicon.depress = A_VB_VBP;
lexicon.depressions = A_NNS;
lexicon.depression = A_NN;
lexicon.depths = A_NNS;
lexicon.depth = A_NN;
lexicon.deputy = A_NN_JJ;
lexicon.deputies = A_NNS;
lexicon.derivative = A_JJ_NN;
lexicon.deriving = A_VBG;
lexicon.derivatives = A_NNS;
lexicon.derivations = A_NNS;
lexicon.derivation = A_NN;
lexicon.derived = A_VBN_VBD;
lexicon.derives = A_VBZ;
lexicon.derive = A_VBP_VB;
lexicon.descendants = A_NNS;
lexicon.descending = A_VBG;
lexicon.descendents = A_NNS;
lexicon.descends = A_VBZ;
lexicon.descendant = A_NN;
lexicon.descended = A_VBD_VBN;
lexicon.descendent = A_NN;
lexicon.descend = A_VB_VBP;
lexicon.described = A_VBN_VBD;
lexicon.describes = A_VBZ;
lexicon.describe = A_VB_VBP;
lexicon.describing = A_VBG;
lexicon.description = A_NN;
lexicon.descriptions = A_NNS;
lexicon.descriptive = A_JJ;
lexicon.desertion = A_NN;
lexicon.desert = A_NN_JJ_VB_VBP;
lexicon.deserts = A_NNS_VBZ;
lexicon.deserted = A_VBN_VBD_JJ;
lexicon.deserve = A_VBP_VB;
lexicon.deserves = A_VBZ;
lexicon.deserved = A_VBD_VBN;
lexicon.deserving = A_JJ_NN;
lexicon.designing = A_VBG;
lexicon.designers = A_NNS;
lexicon.designating = A_VBG;
lexicon.designer = A_NN;
lexicon.designed = A_VBN_VBD;
lexicon.designated = A_VBN_VBD_JJ;
lexicon.designates = A_VBZ;
lexicon.designations = A_NNS;
lexicon.designs = A_NNS_VBZ;
lexicon.designate = A_VB_JJ_NN;
lexicon.design = A_NN_VB_VBP;
lexicon.designation = A_NN;
lexicon.desiring = A_VBG;
lexicon.desirous = A_JJ;
lexicon.desirable = A_JJ;
lexicon.desirability = A_NN;
lexicon.desires = A_NNS_VBZ;
lexicon.desired = A_VBN_VBD_JJ;
lexicon.desire = A_NN_VBP_VB;
lexicon.desks = A_NNS;
lexicon.desk = A_NN;
lexicon.desperately = A_RB;
lexicon.desperation = A_NN;
lexicon.desperate = A_JJ;
lexicon.despite = A_IN;
lexicon.dessert = A_NN;
lexicon.desserts = A_NNS;
lexicon.destination = A_NN;
lexicon.destined = A_VBN;
lexicon.destinations = A_NNS;
lexicon.destroyer = A_NN;
lexicon.destroyed = A_VBN_VBD_JJ;
lexicon.destroys = A_VBZ;
lexicon.destroyers = A_NNS;
lexicon.destroy = A_VB_VBP;
lexicon.destroying = A_VBG;
lexicon.destruction = A_NN;
lexicon.destructive = A_JJ;
lexicon.details = A_NNS_VBZ;
lexicon.detailed = A_VBN_JJ_VBD;
lexicon.detail = A_NN_VB;
lexicon.detailing = A_VBG;
lexicon.detectives = A_NNS;
lexicon.detective = A_NN;
lexicon.detection = A_NN;
lexicon.detects = A_VBZ;
lexicon.detectable = A_JJ;
lexicon.detected = A_VBN_VBD;
lexicon.detecting = A_VBG_NN;
lexicon.detect = A_VB_VBP;
lexicon.determinations = A_NNS;
lexicon.determinate = A_JJ;
lexicon.determinant = A_NN;
lexicon.determinative = A_JJ;
lexicon.determination = A_NN;
lexicon.determinedly = A_RB;
lexicon.determinants = A_NNS;
lexicon.determined = A_VBN_VBD_JJ;
lexicon.determinism = A_NN;
lexicon.determinable = A_JJ;
lexicon.determines = A_VBZ;
lexicon.determinability = A_NN;
lexicon.determining = A_VBG_JJ_NN;
lexicon.determine = A_VB_VBP;
lexicon.devastation = A_NN;
lexicon.devastatingly = A_RB;
lexicon.devastate = A_VB;
lexicon.devastating = A_JJ_VBG;
lexicon.devastated = A_VBN_VBD_JJ;
lexicon.develop = A_VB_VBP;
lexicon.develops = A_VBZ;
lexicon.development = A_NN;
lexicon.developers = A_NNS;
lexicon.developed = A_VBN_JJ_VBD;
lexicon.developer = A_NN;
lexicon.developing = A_VBG_JJ_NN;
lexicon.developments = A_NNS;
lexicon.developmental = A_JJ;
lexicon.devices = A_NNS;
lexicon.device = A_NN;
lexicon.devil = A_NN;
lexicon.devils = A_NNS_VBZ;
lexicon.devoting = A_VBG;
lexicon.devotions = A_NNS;
lexicon.devotion = A_NN;
lexicon.devotional = A_JJ;
lexicon.devotedly = A_RB;
lexicon.devote = A_VB_VBP;
lexicon.devoted = A_VBN_VBD_JJ;
lexicon.devotes = A_VBZ;
lexicon.diabetes = A_NN;
lexicon.diabetic = A_JJ_NN;
lexicon.diabetics = A_NNS;
lexicon.diagnoses = A_NNS_VBZ;
lexicon.diagnosed = A_VBN_VBD;
lexicon.diagnose = A_VB_VBP;
lexicon.diagnosable = A_JJ;
lexicon.diagnosing = A_VBG_NN;
lexicon.diagnosis = A_NN;
lexicon.dialogues = A_NNS;
lexicon.dialogue = A_NN;
lexicon.diamonds = A_NNS;
lexicon.diamond = A_NN;
lexicon.diaries = A_NNS;
lexicon.diary = A_NN;
lexicon.dictator = A_NN;
lexicon.dictators = A_NNS;
lexicon.dictate = A_VB_VBP;
lexicon.dictating = A_VBG_NN;
lexicon.dictates = A_NNS_VBZ;
lexicon.dictated = A_VBN_VBD;
lexicon.dictation = A_NN;
lexicon.dies = A_VBZ_NNS;
lexicon.died = A_VBD_VBN;
lexicon.dying = A_VBG_JJ_NN;
lexicon.die = A_VB_VBP_FW_NN;
lexicon.diets = A_NNS;
lexicon.diet = A_NN_VB;
lexicon.dieting = A_NN_VBG;
lexicon.differed = A_VBD_VBN;
lexicon.differs = A_VBZ;
lexicon.differing = A_VBG_JJ;
lexicon.different = A_JJ;
lexicon.differences = A_NNS;
lexicon.difference = A_NN;
lexicon.differ = A_VBP_VB;
lexicon.differently = A_RB;
lexicon.difficult = A_JJ;
lexicon.difficulty = A_NN;
lexicon.difficulties = A_NNS;
lexicon.digging = A_VBG_NN;
lexicon.dig = A_VB_FW_NN_VBP;
lexicon.digs = A_VBZ_NNS;
lexicon.digitizes = A_VBZ;
lexicon.digitalization = A_NN;
lexicon.digit = A_NN;
lexicon.digital = A_JJ;
lexicon.digitalized = A_JJ;
lexicon.digits = A_NNS;
lexicon.dignity = A_NN;
lexicon.dilemmas = A_NN_NNS;
lexicon.dilemma = A_NN;
lexicon.dimensioning = A_JJ_VBG;
lexicon.dimensions = A_NNS;
lexicon.dimension = A_NN_VB;
lexicon.diminishing = A_VBG;
lexicon.diminish = A_VB_VBP;
lexicon.diminished = A_VBN_JJ_VBD;
lexicon.diminishes = A_VBZ;
lexicon.dines = A_VBZ;
lexicon.dined = A_VBD_VBN;
lexicon.dine = A_VB;
lexicon.dining = A_NN_JJ_VBG;
lexicon.dinner = A_NN;
lexicon.dinners = A_NNS;
lexicon.dipped = A_VBD_VBN;
lexicon.dipping = A_VBG;
lexicon.dips = A_NNS;
lexicon.dip = A_NN_VBP_VB;
lexicon.diplomatically = A_RB;
lexicon.diplomats = A_NNS;
lexicon.diplomatic = A_JJ;
lexicon.diplomat = A_NN;
lexicon.direct = A_JJ_VBP_RB_VB;
lexicon.direction = A_NN;
lexicon.directing = A_VBG_NN;
lexicon.directives = A_NNS;
lexicon.directivity = A_NN;
lexicon.directed = A_VBN_VBD_JJ;
lexicon.directs = A_VBZ;
lexicon.directional = A_JJ;
lexicon.directionally = A_RB;
lexicon.directive = A_NN;
lexicon.directions = A_NNS;
lexicon.directly = A_RB;
lexicon.directness = A_NN;
lexicon.directors = A_NNS;
lexicon.directorate = A_NN;
lexicon.director = A_NN;
lexicon.dirt = A_NN_JJ;
lexicon.dirty = A_JJ_VB;
lexicon.disable = A_VB;
lexicon.disabled = A_JJ_NN_VBN;
lexicon.disability = A_NN;
lexicon.disabilities = A_NNS;
lexicon.disabling = A_VBG;
lexicon.disagree = A_VBP_VB;
lexicon.disagreed = A_VBD_VBN;
lexicon.disagrees = A_VBZ;
lexicon.disagreeable = A_JJ;
lexicon.disappearance = A_NN;
lexicon.disappeared = A_VBD_VBN;
lexicon.disappear = A_VB_VBP;
lexicon.disappearing = A_VBG;
lexicon.disappearances = A_NNS;
lexicon.disappears = A_VBZ;
lexicon.disappointment = A_NN;
lexicon.disappoint = A_VB;
lexicon.disappointing = A_JJ;
lexicon.disappointingly = A_RB;
lexicon.disappoints = A_VBZ;
lexicon.disappointments = A_NNS;
lexicon.disappointed = A_VBN_JJ_VBD;
lexicon.disasters = A_NNS;
lexicon.disaster = A_NN;
lexicon.discs = A_NNS;
lexicon.disc = A_NN;
lexicon.disciplining = A_VBG;
lexicon.discipline = A_NN_VB_VBP;
lexicon.disciplines = A_NNS;
lexicon.disciplined = A_VBN_VBD_JJ;
lexicon.discloses = A_VBZ;
lexicon.disclosed = A_VBN_JJ_VBD;
lexicon.disclosing = A_VBG;
lexicon.disclose = A_VB_VBP;
lexicon.discounting = A_NN_VBG;
lexicon.discounters = A_NNS;
lexicon.discounted = A_VBN_JJ_VBD;
lexicon.discounts = A_NNS_VBZ;
lexicon.discount = A_NN_VBP_JJ_VB;
lexicon.discounter = A_NN;
lexicon.discouraged = A_VBN_VBD_JJ;
lexicon.discouragement = A_NN;
lexicon.discourage = A_VB_VBP;
lexicon.discouraging = A_VBG_JJ;
lexicon.discourages = A_VBZ;
lexicon.discourses = A_NNS;
lexicon.discourse = A_NN_VB;
lexicon.discovering = A_VBG;
lexicon.discovered = A_VBN_JJ_VBD;
lexicon.discovers = A_VBZ;
lexicon.discover = A_VB_VBP;
lexicon.discoveries = A_NNS;
lexicon.discovery = A_NN;
lexicon.discrimination = A_NN;
lexicon.discriminating = A_VBG_JJ;
lexicon.discriminates = A_NNS_VBZ;
lexicon.discriminated = A_VBD_JJ_NN_VB;
lexicon.discriminate = A_VB_VBP_JJ;
lexicon.discussion = A_NN;
lexicon.discussions = A_NNS;
lexicon.discussant = A_NN;
lexicon.discussed = A_VBN_VBD;
lexicon.discusses = A_VBZ;
lexicon.discussing = A_VBG;
lexicon.discuss = A_VB_VBP;
lexicon.disease = A_NN;
lexicon.diseases = A_NNS;
lexicon.diseased = A_JJ;
lexicon.dished = A_VBD;
lexicon.dishes = A_NNS_VBZ;
lexicon.dishing = A_VBG;
lexicon.dish = A_NN_VB;
lexicon.disk = A_NN;
lexicon.disking = A_VBG;
lexicon.disks = A_NNS;
lexicon.dismissed = A_VBD_VBN;
lexicon.dismisses = A_VBZ;
lexicon.dismissal = A_NN;
lexicon.dismiss = A_VB_VBP;
lexicon.dismissing = A_VBG;
lexicon.disorderly = A_JJ;
lexicon.disorders = A_NNS;
lexicon.disordered = A_JJ_VBN;
lexicon.disorder = A_NN_VB;
lexicon.displaying = A_VBG;
lexicon.displays = A_NNS_VBZ;
lexicon.display = A_NN_VBP_VB;
lexicon.displayed = A_VBN_VBD;
lexicon.disputed = A_VBN_VBD_JJ;
lexicon.disputes = A_NNS_VBZ;
lexicon.disputable = A_JJ;
lexicon.dispute = A_NN_VBP_VB;
lexicon.dissolves = A_VBZ;
lexicon.dissolved = A_VBN_VBD;
lexicon.dissolve = A_VB_VBP_NN;
lexicon.dissolving = A_VBG_JJ;
lexicon.distances = A_NNS_VBZ;
lexicon.distance = A_NN_VB;
lexicon.distancing = A_VBG_NN;
lexicon.distant = A_JJ;
lexicon.distantly = A_RB;
lexicon.distinction = A_NN;
lexicon.distinctly = A_RB;
lexicon.distinctive = A_JJ;
lexicon.distinctively = A_RB;
lexicon.distinctions = A_NNS;
lexicon.distinctiveness = A_NN;
lexicon.distinct = A_JJ;
lexicon.distinguishes = A_VBZ;
lexicon.distinguished = A_VBN_JJ_VBD;
lexicon.distinguishing = A_VBG_JJ;
lexicon.distinguishable = A_JJ;
lexicon.distinguish = A_VB_VBP;
lexicon.distraction = A_NN;
lexicon.distracted = A_VBN_VBD;
lexicon.distractedly = A_RB;
lexicon.distract = A_VB;
lexicon.distractions = A_NNS;
lexicon.distracting = A_VBG_JJ;
lexicon.distributive = A_JJ;
lexicon.distributions = A_NNS;
lexicon.distributing = A_VBG_NN;
lexicon.distribution = A_NN;
lexicon.distributable = A_JJ;
lexicon.distributed = A_VBN_VBD_JJ;
lexicon.distributer = A_NN;
lexicon.distributes = A_VBZ;
lexicon.distribute = A_VB_VBP;
lexicon.districts = A_NNS;
lexicon.district = A_NN_JJ;
lexicon.districting = A_NN;
lexicon.disturber = A_NN;
lexicon.disturbed = A_VBN_VBD_JJ;
lexicon.disturbingly = A_RB;
lexicon.disturbances = A_NNS;
lexicon.disturbs = A_VBZ;
lexicon.disturbing = A_JJ_VBG;
lexicon.disturb = A_VB_VBP;
lexicon.disturbance = A_NN;
lexicon.diuretic = A_NN_JJ;
lexicon.diuretics = A_NNS;
lexicon.diversions = A_NNS;
lexicon.diversities = A_NNS;
lexicon.diverse = A_JJ;
lexicon.diversion = A_NN;
lexicon.diversity = A_NN;
lexicon.divides = A_VBZ;
lexicon.divide = A_VB_NN_VBP;
lexicon.divided = A_VBN_VBD_JJ;
lexicon.divider = A_NN;
lexicon.dividing = A_VBG;
lexicon.divinities = A_NNS;
lexicon.divinity = A_NN;
lexicon.divinely = A_RB;
lexicon.divine = A_JJ_NN;
lexicon.divining = A_VBG;
lexicon.divination = A_NN;
lexicon.divisions = A_NNS;
lexicon.divisible = A_JJ;
lexicon.divisiveness = A_NN;
lexicon.divisive = A_JJ;
lexicon.division = A_NN;
lexicon.divorced = A_VBN_JJ_VBD;
lexicon.divorces = A_NNS;
lexicon.divorce = A_NN_VB_VBP;
lexicon.does = A_VBZ;
lexicon.doing = A_VBG;
lexicon.do = A_VBP_FW_NN_VB_NNS_VBZ;
lexicon.doings = A_NNS;
lexicon.dock = A_NN_VB;
lexicon.docked = A_VBN;
lexicon.docks = A_NNS;
lexicon.doctored = A_VBN;
lexicon.doctorates = A_NNS;
lexicon.doctor = A_NN_VB;
lexicon.doctorate = A_NN;
lexicon.doctoring = A_NN;
lexicon.doctors = A_NNS;
lexicon.doctoral = A_JJ;
lexicon.doctrine = A_NN;
lexicon.doctrinal = A_JJ;
lexicon.doctrinally = A_RB;
lexicon.doctrines = A_NNS;
lexicon.documents = A_NNS_VBZ;
lexicon.documenting = A_VBG;
lexicon.document = A_NN_VB_VBP;
lexicon.documentation = A_NN;
lexicon.documented = A_VBN_VBD;
lexicon.documentaries = A_NNS;
lexicon.documentary = A_NN_JJ;
lexicon.dogs = A_NNS_VBZ;
lexicon.dogging = A_VBG;
lexicon.dogged = A_VBN_JJ_VBD;
lexicon.doggedly = A_RB;
lexicon.dog = A_NN_VBP;
lexicon.doll = A_NN;
lexicon.dolls = A_NNS;
lexicon.domains = A_NNS;
lexicon.domain = A_NN;
lexicon.domesticity = A_NN;
lexicon.domestic = A_JJ_NN;
lexicon.domesticates = A_VBZ;
lexicon.domestically = A_RB;
lexicon.dominates = A_VBZ;
lexicon.dominating = A_VBG_JJ;
lexicon.domineering = A_VBG_JJ;
lexicon.dominantly = A_RB;
lexicon.domination = A_NN;
lexicon.dominance = A_NN;
lexicon.dominated = A_VBN_VBD;
lexicon.dominant = A_JJ;
lexicon.dominate = A_VB_VBP;
lexicon.donating = A_VBG;
lexicon.donates = A_VBZ;
lexicon.donated = A_VBN_VBD;
lexicon.donation = A_NN;
lexicon.donations = A_NNS;
lexicon.donate = A_VB_VBP;
lexicon.donors = A_NNS;
lexicon.donor = A_NN;
lexicon.doors = A_NNS;
lexicon.door = A_NN_RB;
lexicon.doorway = A_NN;
lexicon.doorways = A_NNS;
lexicon.dosed = A_VBN_VBD;
lexicon.doses = A_NNS;
lexicon.dose = A_NN;
lexicon.dotted = A_VBN_VBD_JJ;
lexicon.dots = A_NNS;
lexicon.dotting = A_VBG_NN;
lexicon.dot = A_NN_VBP_VB;
lexicon.doubled = A_VBD_VBN;
lexicon.doubles = A_NNS_VBZ;
lexicon.doubling = A_VBG_NN;
lexicon.double = A_JJ_VBP_NN_RB_VB;
lexicon.doubte = A_NN;
lexicon.doubts = A_NNS_VBZ;
lexicon.doubting = A_VBG_JJ;
lexicon.doubtfully = A_RB;
lexicon.doubtful = A_JJ;
lexicon.doubtingly = A_RB;
lexicon.doubt = A_NN_VBP_RB_VB;
lexicon.doubted = A_VBD_VBN;
lexicon.dough = A_NN;
lexicon.down = A_RB_RBR_VBP_IN_JJ_NN_RP_VB;
lexicon.downs = A_NNS;
lexicon.downing = A_VBG;
lexicon.downed = A_VBD_VBN;
lexicon.downtown = A_NN_JJ_RB;
lexicon.dozens = A_NNS;
lexicon.drafted = A_VBN_VBD;
lexicon.drafts = A_NNS;
lexicon.drafting = A_VBG_NN;
lexicon.draft = A_NN_JJ_VB_VBP;
lexicon.drags = A_VBZ;
lexicon.dragged = A_VBN_VBD;
lexicon.drag = A_NN_VBP_VB;
lexicon.dragging = A_VBG_NN;
lexicon.draining = A_VBG_NN;
lexicon.drain = A_NN_VBP_VB;
lexicon.drained = A_VBN_VBD;
lexicon.drains = A_NNS_VBZ;
lexicon.dramas = A_NN;
lexicon.drama = A_NN;
lexicon.dramatical = A_JJ;
lexicon.dramatics = A_NNS;
lexicon.dramatically = A_RB;
lexicon.dramatization = A_NN;
lexicon.dramatic = A_JJ;
lexicon.dramatizations = A_NNS;
lexicon.dramatized = A_VBN;
lexicon.dramatizes = A_VBZ;
lexicon.dramatizing = A_VBG;
lexicon.dramatize = A_VB_VBP;
lexicon.draws = A_VBZ_NNS;
lexicon.drawing = A_VBG_JJ_NN;
lexicon.draw = A_VB_VBP_NN;
lexicon.drawings = A_NNS;
lexicon.drawers = A_NNS;
lexicon.drawer = A_NN;
lexicon.dreaming = A_VBG_NN;
lexicon.dreamed = A_VBD_VBN;
lexicon.dream = A_NN_VB_VBP;
lexicon.dreams = A_NNS_VBZ;
lexicon.dressed = A_VBN_JJ_VBD;
lexicon.dresses = A_NNS_VBZ;
lexicon.dressing = A_NN_VBG_JJ;
lexicon.dress = A_NN_VBP_VB;
lexicon.dressings = A_NNS;
lexicon.dries = A_NNS_VBZ;
lexicon.drying = A_VBG_NN;
lexicon.dried = A_VBN_VBD_JJ;
lexicon.dry = A_JJ_RB_VB_VBP;
lexicon.drifting = A_VBG_JJ_NN;
lexicon.drifted = A_VBD_VBN;
lexicon.drifts = A_VBZ_NNS;
lexicon.drift = A_NN_VBP_VB;
lexicon.drilled = A_VBN_VBD;
lexicon.drilling = A_NN_JJ_VBG;
lexicon.drill = A_NN_VB;
lexicon.drills = A_NNS_VBZ;
lexicon.drinking = A_NN_JJ_VBG;
lexicon.drinks = A_NNS_VBZ;
lexicon.drink = A_NN_VBP_VB;
lexicon.drives = A_NNS_VBZ;
lexicon.drive = A_NN_VBP_VB;
lexicon.driving = A_VBG_JJ_NN;
lexicon.drivers = A_NNS;
lexicon.driver = A_NN;
lexicon.driveway = A_NN;
lexicon.driveways = A_NNS;
lexicon.drop = A_NN_JJ_VB_VBP;
lexicon.drops = A_VBZ_NNS;
lexicon.dropping = A_VBG_NN;
lexicon.droppings = A_NNS;
lexicon.dropped = A_VBD_VBN;
lexicon.drowned = A_VBN_JJ_VBD;
lexicon.drownings = A_NNS;
lexicon.drown = A_VB_VBP;
lexicon.drowns = A_VBZ;
lexicon.drowning = A_VBG;
lexicon.drug = A_NN;
lexicon.drugging = A_VBG;
lexicon.drugged = A_VBN_JJ;
lexicon.drugs = A_NNS;
lexicon.drummed = A_VBD_VBN;
lexicon.drum = A_VB_NN;
lexicon.drums = A_NNS;
lexicon.drumming = A_VBG;
lexicon.drunk = A_JJ_NN_VBN;
lexicon.drunks = A_NNS;
lexicon.ducking = A_VBG;
lexicon.ducked = A_VBD;
lexicon.ducks = A_NNS_VBZ;
lexicon.duck = A_NN_VB;
lexicon.dues = A_NNS;
lexicon.due = A_JJ_IN_NN_RB_NNS;
lexicon.dumb = A_JJ;
lexicon.dumping = A_VBG_NN;
lexicon.dumps = A_VBZ_NNS;
lexicon.dumped = A_VBD_VBN;
lexicon.dump = A_VB_VBP_NN;
lexicon.during = A_IN;
lexicon.dusting = A_VBG_NN;
lexicon.dusted = A_VBN_VBD;
lexicon.dust = A_NN_VB_VBP;
lexicon.dusts = A_NNS;
lexicon.dutiful = A_JJ;
lexicon.duty = A_NN;
lexicon.dutifully = A_RB;
lexicon.duties = A_NNS;
lexicon.dynamics = A_NNS;
lexicon.dynamism = A_NN;
lexicon.dynamically = A_RB;
lexicon.dynamic = A_JJ_NN;
lexicon.dynamical = A_JJ;
lexicon.each = A_DT;
lexicon.eagerly = A_RB;
lexicon.eager = A_JJ;
lexicon.eagerness = A_NN;
lexicon.earful = A_NN;
lexicon.ears = A_NNS;
lexicon.eared = A_JJ;
lexicon.ear = A_NN;
lexicon.early = A_JJ_RB;
lexicon.earns = A_VBZ;
lexicon.earnings = A_NNS_NN;
lexicon.earned = A_VBD_JJ_VBN;
lexicon.earning = A_VBG_NN;
lexicon.earn = A_VB_VBP;
lexicon.earthly = A_JJ;
lexicon.earth = A_NN;
lexicon.earthquake = A_NN;
lexicon.earthquakes = A_NNS;
lexicon.easing = A_VBG_JJ_NN;
lexicon.ease = A_VB_NN_VBP;
lexicon.eased = A_VBD_VBN;
lexicon.eases = A_VBZ;
lexicon.easily = A_RB;
lexicon.east = A_JJ_NN_RB;
lexicon.eastern = A_JJ;
lexicon.easy = A_JJ_RB;
lexicon.eating = A_VBG_JJ_NN;
lexicon.eats = A_VBZ;
lexicon.eatings = A_NNS;
lexicon.eat = A_VB_VBP;
lexicon.eaten = A_VBN;
lexicon.echoing = A_VBG;
lexicon.echo = A_NN_VBP_VB;
lexicon.echoed = A_VBD_VBN;
lexicon.echoes = A_NNS_VBZ;
lexicon.ecologically = A_RB;
lexicon.ecology = A_NN;
lexicon.ecological = A_JJ;
lexicon.economics = A_NNS_NN;
lexicon.economical = A_JJ;
lexicon.economic = A_JJ;
lexicon.economically = A_RB;
lexicon.economizing = A_VBG;
lexicon.economize = A_VB;
lexicon.economist = A_NN;
lexicon.economists = A_NNS;
lexicon.economy = A_NN;
lexicon.economies = A_NNS;
lexicon.edged = A_VBD_JJ_VBN;
lexicon.edging = A_VBG_NN;
lexicon.edge = A_NN_VB;
lexicon.edges = A_NNS;
lexicon.edit = A_VB;
lexicon.edition = A_NN;
lexicon.editions = A_NNS;
lexicon.edited = A_VBN_VBD;
lexicon.editing = A_NN_VBG;
lexicon.edits = A_VBZ;
lexicon.editor = A_NN;
lexicon.editors = A_NNS;
lexicon.education = A_NN;
lexicon.educators = A_NNS;
lexicon.educational = A_JJ;
lexicon.educations = A_NNS;
lexicon.educator = A_NN;
lexicon.educate = A_VB;
lexicon.educated = A_VBN_JJ;
lexicon.educating = A_VBG_NN;
lexicon.effecte = A_VB;
lexicon.effects = A_NNS_VBZ;
lexicon.effecting = A_VBG;
lexicon.effectively = A_RB;
lexicon.effectiveness = A_NN;
lexicon.effect = A_NN_JJ_VB_VBP;
lexicon.effected = A_VBN_VBD;
lexicon.effective = A_JJ_VBN_NN;
lexicon.efficiently = A_RB;
lexicon.efficient = A_JJ;
lexicon.efficiencies = A_NNS;
lexicon.efficiency = A_NN;
lexicon.effortful = A_JJ;
lexicon.efforts = A_NNS;
lexicon.effort = A_NN;
lexicon.eggs = A_NNS;
lexicon.egg = A_NN;
lexicon.egos = A_NNS;
lexicon.ego = A_NN;
lexicon.eighth = A_JJ_NN;
lexicon.either = A_DT_CC_IN_RB_RBR;
lexicon.elaborately = A_RB;
lexicon.elaborated = A_VBN;
lexicon.elaborates = A_VBZ;
lexicon.elaborating = A_VBG;
lexicon.elaborate = A_VB_JJ;
lexicon.elaboration = A_NN;
lexicon.elbow = A_NN;
lexicon.elbows = A_NNS;
lexicon.elbowing = A_VBG;
lexicon.elders = A_NNS;
lexicon.elderly = A_JJ_NN;
lexicon.elder = A_JJR_JJ_NN;
lexicon.election = A_NN;
lexicon.electing = A_VBG;
lexicon.elect = A_VB_VBP;
lexicon.electives = A_NNS;
lexicon.elections = A_NNS;
lexicon.elective = A_JJ;
lexicon.elected = A_VBN_JJ_VBD;
lexicon.elects = A_VBZ;
lexicon.electricals = A_NNS;
lexicon.electrical = A_JJ;
lexicon.electrically = A_RB;
lexicon.electric = A_JJ_NN;
lexicon.electricity = A_NN;
lexicon.electronics = A_NNS_NN;
lexicon.electron = A_NN;
lexicon.electronic = A_JJ;
lexicon.electronically = A_RB;
lexicon.electrons = A_NNS;
lexicon.elegant = A_JJ;
lexicon.elegance = A_NN;
lexicon.elegances = A_NNS;
lexicon.elegantly = A_RB;
lexicon.elements = A_NNS;
lexicon.element = A_NN;
lexicon.elemental = A_JJ_NN;
lexicon.elementary = A_JJ;
lexicon.elephants = A_NNS;
lexicon.elephant = A_NN;
lexicon.elevator = A_NN;
lexicon.elevators = A_NNS;
lexicon.elevate = A_VB_VBP;
lexicon.elevations = A_NNS;
lexicon.elevated = A_VBN_VBD_JJ;
lexicon.elevates = A_VBZ;
lexicon.elevation = A_NN;
lexicon.elevating = A_VBG;
lexicon.eligibility = A_NN;
lexicon.eligible = A_JJ_NN;
lexicon.eliminations = A_NNS;
lexicon.eliminates = A_VBZ;
lexicon.eliminated = A_VBN_VBD;
lexicon.eliminating = A_VBG;
lexicon.eliminate = A_VB_VBP;
lexicon.elimination = A_NN;
lexicon.elites = A_NNS;
lexicon.elite = A_NN_NNS_JJ;
lexicon.else = A_RB_JJ_NN;
lexicon.elsewhere = A_RB_NN;
lexicon.embarrassed = A_VBN_VBD_JJ;
lexicon.embarrassment = A_NN;
lexicon.embarrassingly = A_RB;
lexicon.embarrass = A_VB;
lexicon.embarrassing = A_JJ_VBG;
lexicon.embarrassments = A_NNS;
lexicon.embrace = A_VB_VBP_NN;
lexicon.embraces = A_VBZ_NNS;
lexicon.embraced = A_VBN_VBD;
lexicon.embracing = A_VBG;
lexicon.emerge = A_VB_VBP;
lexicon.emergencies = A_NNS;
lexicon.emerging = A_VBG;
lexicon.emergent = A_JJ;
lexicon.emergency = A_NN_JJ;
lexicon.emergence = A_NN;
lexicon.emerges = A_VBZ;
lexicon.emerged = A_VBD_VBN;
lexicon.emission = A_NN;
lexicon.emissions = A_NNS;
lexicon.emotionalism = A_NN;
lexicon.emotions = A_NNS;
lexicon.emoted = A_VBD;
lexicon.emotion = A_NN;
lexicon.emotionally = A_RB;
lexicon.emotional = A_JJ;
lexicon.emotionality = A_NN;
lexicon.emote = A_VB;
lexicon.emphasis = A_NN;
lexicon.emphases = A_NNS;
lexicon.emphasizes = A_VBZ;
lexicon.emphasized = A_VBD_VBN;
lexicon.emphasize = A_VB_VBP;
lexicon.emphasizing = A_VBG;
lexicon.empirically = A_RB;
lexicon.empires = A_NNS;
lexicon.empirical = A_JJ;
lexicon.empire = A_NN;
lexicon.employing = A_VBG;
lexicon.employes = A_NNS_VBZ;
lexicon.employer = A_NN;
lexicon.employed = A_VBN_VBD;
lexicon.employe = A_NN;
lexicon.employs = A_VBZ;
lexicon.employ = A_VB_NN_VBP;
lexicon.employment = A_NN;
lexicon.employers = A_NNS;
lexicon.employments = A_NNS;
lexicon.employee = A_NN;
lexicon.employees = A_NNS_VBZ;
lexicon.empty = A_JJ_NN_RB_VB_VBP;
lexicon.emptied = A_VBN_VBD;
lexicon.empties = A_VBZ;
lexicon.emptiness = A_NN;
lexicon.emptying = A_VBG;
lexicon.enable = A_VB_VBP;
lexicon.enabled = A_VBD_VBN;
lexicon.enabling = A_VBG;
lexicon.enables = A_VBZ;
lexicon.enactments = A_NNS;
lexicon.enact = A_VB;
lexicon.enacts = A_VBZ;
lexicon.enacted = A_VBN_VBD;
lexicon.enacting = A_VBG;
lexicon.enactment = A_NN;
lexicon.encounters = A_NNS_VBZ;
lexicon.encounter = A_NN_VB_VBP;
lexicon.encountered = A_VBN_VBD;
lexicon.encountering = A_VBG;
lexicon.encouraging = A_VBG_JJ;
lexicon.encourage = A_VB_VBP;
lexicon.encouragement = A_NN;
lexicon.encouragingly = A_RB;
lexicon.encourages = A_VBZ;
lexicon.encouraged = A_VBN_VBD_JJ;
lexicon.end = A_NN_VBP_JJ_RB_VB;
lexicon.ended = A_VBD_JJ_VB_VBN;
lexicon.ends = A_NNS_VBZ;
lexicon.endings = A_NNS;
lexicon.ending = A_VBG_JJ_NN_VBN;
lexicon.endlessly = A_RB;
lexicon.endless = A_JJ;
lexicon.endorse = A_VB_VBP;
lexicon.endorses = A_VBZ;
lexicon.endorsed = A_VBN_VBD;
lexicon.endorsements = A_NNS;
lexicon.endorsing = A_VBG_NN;
lexicon.endorsers = A_NNS;
lexicon.endorsement = A_NN;
lexicon.endure = A_VB_VBP;
lexicon.enduring = A_VBG_JJ;
lexicon.endures = A_VBZ;
lexicon.endured = A_VBD_VBN;
lexicon.endurable = A_JJ;
lexicon.enduringly = A_RB;
lexicon.endurance = A_NN;
lexicon.enemies = A_NNS;
lexicon.enemy = A_NN;
lexicon.energies = A_NNS;
lexicon.energy = A_NN;
lexicon.enforcement = A_NN;
lexicon.enforce = A_VB_VBP;
lexicon.enforced = A_VBN_VBD_JJ;
lexicon.enforcer = A_NN;
lexicon.enforces = A_VBZ;
lexicon.enforcers = A_NNS;
lexicon.enforcing = A_VBG;
lexicon.enforceable = A_JJ;
lexicon.engaged = A_VBN_JJ_VBD;
lexicon.engaging = A_VBG_JJ;
lexicon.engage = A_VB_VBP;
lexicon.engages = A_NNS_VBN_VBZ;
lexicon.engagingly = A_RB;
lexicon.engagement = A_NN;
lexicon.engagements = A_NNS;
lexicon.engine = A_NN;
lexicon.engines = A_NNS;
lexicon.engineers = A_NNS;
lexicon.engineered = A_VBN_VBD_JJ;
lexicon.engineering = A_NN_VBG;
lexicon.engineer = A_NN_VB;
lexicon.enhance = A_VB_VBP;
lexicon.enhancing = A_VBG;
lexicon.enhancement = A_NN;
lexicon.enhances = A_VBZ;
lexicon.enhanced = A_VBN_VBD_JJ;
lexicon.enhancements = A_NNS;
lexicon.enjoys = A_VBZ;
lexicon.enjoying = A_VBG;
lexicon.enjoy = A_VB_VBP;
lexicon.enjoyable = A_JJ;
lexicon.enjoyed = A_VBD_VBN;
lexicon.enjoyment = A_NN;
lexicon.enormity = A_NN;
lexicon.enormous = A_JJ;
lexicon.enormously = A_RB;
lexicon.enough = A_RB_JJ_NN;
lexicon.enrollments = A_NNS;
lexicon.enroll = A_VB_VBP;
lexicon.enrolling = A_NN;
lexicon.enrollment = A_NN;
lexicon.enrolled = A_VBN_VBD_JJ;
lexicon.ensures = A_VBZ;
lexicon.ensured = A_VBD;
lexicon.ensure = A_VB_VBP;
lexicon.ensuring = A_VBG;
lexicon.entering = A_VBG;
lexicon.entered = A_VBD_VBN;
lexicon.enter = A_VB_VBN_VBP;
lexicon.enters = A_VBZ;
lexicon.enterprise = A_NN;
lexicon.enterprising = A_JJ;
lexicon.enterprisingly = A_RB;
lexicon.enterprises = A_NNS;
lexicon.entertainment = A_NN;
lexicon.entertaining = A_VBG_JJ_NN;
lexicon.entertain = A_VB;
lexicon.entertainers = A_NNS;
lexicon.entertained = A_VBN_VBD;
lexicon.entertainer = A_NN;
lexicon.entertainments = A_NNS;
lexicon.entertains = A_VBZ;
lexicon.enthusiasm = A_NN;
lexicon.enthusiasms = A_NNS;
lexicon.entire = A_JJ_NN;
lexicon.entirely = A_RB;
lexicon.entitle = A_VB_VBP;
lexicon.entitles = A_VBZ;
lexicon.entitlement = A_NN_JJ;
lexicon.entitlements = A_NNS;
lexicon.entitled = A_VBN_VBD;
lexicon.entitling = A_VBG;
lexicon.entities = A_NNS;
lexicon.entity = A_NN;
lexicon.entrances = A_NNS;
lexicon.entranced = A_VBN;
lexicon.entrance = A_NN;
lexicon.entrepreneurs = A_NNS;
lexicon.entrepreneurism = A_NN;
lexicon.entrepreneur = A_NN;
lexicon.entries = A_NNS;
lexicon.entry = A_NN;
lexicon.enveloped = A_VBN;
lexicon.envelopes = A_NNS;
lexicon.envelope = A_NN;
lexicon.enveloping = A_VBG;
lexicon.environment = A_NN;
lexicon.environing = A_VBG;
lexicon.environments = A_NNS;
lexicon.environs = A_NNS;
lexicon.environmental = A_JJ;
lexicon.environmentalism = A_NN;
lexicon.environmentally = A_RB;
lexicon.envision = A_VBP_VB;
lexicon.envisions = A_VBZ;
lexicon.envisioned = A_VBD_VBN;
lexicon.envisioning = A_VBG;
lexicon.epidemic = A_NN_JJ;
lexicon.epidemics = A_NNS;
lexicon.episodic = A_JJ;
lexicon.episodes = A_NNS;
lexicon.episode = A_NN;
lexicon.equals = A_VBZ_NNS;
lexicon.equal = A_JJ_NN_VB_VBP;
lexicon.equaled = A_VBD_VBN;
lexicon.equalled = A_VBN;
lexicon.equalizing = A_NN;
lexicon.equalization = A_NN;
lexicon.equalize = A_VB;
lexicon.equaling = A_VBG;
lexicon.equalizers = A_NNS;
lexicon.equality = A_NN;
lexicon.equally = A_RB;
lexicon.equalizer = A_NN;
lexicon.equating = A_VBG;
lexicon.equations = A_NNS;
lexicon.equated = A_VBN_VBD;
lexicon.equation = A_NN;
lexicon.equate = A_VB_VBP;
lexicon.equator = A_NN;
lexicon.equates = A_VBZ;
lexicon.equips = A_VBZ;
lexicon.equipping = A_VBG_NN;
lexicon.equipment = A_NN;
lexicon.equip = A_VB_VBP;
lexicon.equipped = A_VBN_JJ_VBD;
lexicon.equities = A_NNS;
lexicon.equity = A_NN;
lexicon.equivalence = A_NN;
lexicon.equivalents = A_NNS;
lexicon.equivalent = A_NN_JJ;
lexicon.era = A_NN;
lexicon.eras = A_NNS;
lexicon.errors = A_NNS;
lexicon.error = A_NN;
lexicon.escapes = A_NNS_VBZ;
lexicon.escaped = A_VBD_VBN;
lexicon.escape = A_VB_NN_VBP;
lexicon.escaping = A_VBG;
lexicon.especially = A_RB;
lexicon.essays = A_NNS;
lexicon.essay = A_NN;
lexicon.essayed = A_VBD_VBN;
lexicon.essence = A_NN;
lexicon.essences = A_NNS;
lexicon.essentially = A_RB;
lexicon.essentials = A_NNS;
lexicon.essential = A_JJ_NN;
lexicon.established = A_VBN_JJ_VBD;
lexicon.establish = A_VB_VBP;
lexicon.establishing = A_VBG;
lexicon.establishment = A_NN;
lexicon.establishes = A_VBZ;
lexicon.establishments = A_NNS;
lexicon.estate = A_NN;
lexicon.estates = A_NNS;
lexicon.estimate = A_NN_VB_VBP;
lexicon.estimates = A_NNS_VBZ;
lexicon.estimated = A_VBN_JJ_VBD;
lexicon.estimating = A_VBG_NN;
lexicon.estimable = A_JJ;
lexicon.estimation = A_NN;
lexicon.estimators = A_NNS;
lexicon.etc = A_FW_NN;
lexicon.ethical = A_JJ;
lexicon.ethics = A_NNS_NN;
lexicon.ethically = A_RB;
lexicon.ethic = A_NN;
lexicon.ethnic = A_JJ;
lexicon.ethnically = A_RB;
lexicon.ethnicity = A_NN;
lexicon.evaluation = A_NN;
lexicon.evaluated = A_VBN_VBD;
lexicon.evaluates = A_VBZ;
lexicon.evaluative = A_JJ;
lexicon.evaluations = A_NNS;
lexicon.evaluate = A_VB_VBP;
lexicon.evaluating = A_VBG;
lexicon.evening = A_NN_VBG;
lexicon.evenly = A_RB;
lexicon.even = A_RB_JJ_VB;
lexicon.evened = A_VBN;
lexicon.evens = A_VBZ;
lexicon.evenings = A_NNS;
lexicon.eventful = A_JJ;
lexicon.events = A_NNS;
lexicon.eventfully = A_RB;
lexicon.event = A_NN;
lexicon.eventuality = A_NN;
lexicon.eventual = A_JJ;
lexicon.eventualities = A_NNS;
lexicon.eventuate = A_VBP;
lexicon.eventually = A_RB;
lexicon.ever = A_RB_RBR_RP;
lexicon.every = A_DT;
lexicon.everybody = A_NN;
lexicon.everyday = A_JJ;
lexicon.everyone = A_NN;
lexicon.everything = A_NN;
lexicon.everywhere = A_RB;
lexicon.evident = A_JJ;
lexicon.evidently = A_RB;
lexicon.evidence = A_NN_VBP;
lexicon.evidences = A_NNS;
lexicon.evils = A_NNS;
lexicon.evil = A_JJ_NN;
lexicon.evolution = A_NN;
lexicon.evolve = A_VB_VBP;
lexicon.evolves = A_VBZ;
lexicon.evolved = A_VBN_JJ_VBD;
lexicon.evolving = A_VBG;
lexicon.exact = A_JJ_VB;
lexicon.exacts = A_VBZ;
lexicon.exacted = A_VBD;
lexicon.exacting = A_JJ;
lexicon.exactly = A_RB;
lexicon.exams = A_NNS;
lexicon.exam = A_NN;
lexicon.examines = A_VBZ;
lexicon.examiner = A_NN;
lexicon.examined = A_VBD_VBN;
lexicon.examine = A_VB_VBP;
lexicon.examining = A_VBG_NN;
lexicon.examinations = A_NNS;
lexicon.examiners = A_NNS;
lexicon.examination = A_NN;
lexicon.examples = A_NNS;
lexicon.example = A_NN;
lexicon.exceedingly = A_RB;
lexicon.exceed = A_VB_VBP;
lexicon.exceeding = A_VBG_JJ;
lexicon.exceeded = A_VBD_VBN;
lexicon.exceeds = A_VBZ;
lexicon.excellent = A_JJ;
lexicon.excellences = A_NNS;
lexicon.excellence = A_NN_FW;
lexicon.excels = A_VBZ;
lexicon.excelled = A_VBD_VBN;
lexicon.excellently = A_RB;
lexicon.excelling = A_VBG;
lexicon.excel = A_VBP_VB;
lexicon.exceptions = A_NNS;
lexicon.except = A_IN_VB;
lexicon.exception = A_NN;
lexicon.excepting = A_VBG;
lexicon.exceptionally = A_RB;
lexicon.exceptional = A_JJ;
lexicon.excess = A_JJ_NN;
lexicon.excesses = A_NNS;
lexicon.excessive = A_JJ;
lexicon.excessively = A_RB;
lexicon.exchangeable = A_JJ;
lexicon.exchanging = A_VBG;
lexicon.exchangers = A_NNS;
lexicon.exchanged = A_VBN_VBD;
lexicon.exchanger = A_NN;
lexicon.exchanges = A_NNS_VBZ;
lexicon.exchange = A_NN_VB_VBP;
lexicon.excitement = A_NN;
lexicon.excite = A_VB;
lexicon.excites = A_VBZ;
lexicon.exciter = A_NN;
lexicon.excited = A_VBN_JJ_VBD;
lexicon.exciting = A_JJ_VBG;
lexicon.excitedly = A_RB;
lexicon.excitability = A_NN;
lexicon.excitements = A_NNS;
lexicon.exclude = A_VB_VBP;
lexicon.excluding = A_VBG;
lexicon.excludes = A_VBZ;
lexicon.excluded = A_VBN_VBD;
lexicon.exclusions = A_NNS;
lexicon.exclusion = A_NN;
lexicon.exclusively = A_RB;
lexicon.exclusiveness = A_NN;
lexicon.exclusivity = A_NN;
lexicon.exclusive = A_JJ_NN;
lexicon.excused = A_VBN_VBD;
lexicon.excuse = A_NN_VBP_VB;
lexicon.excuses = A_NNS_VBZ;
lexicon.excusable = A_JJ;
lexicon.executives = A_NNS;
lexicon.executed = A_VBN_JJ_VBD;
lexicon.executes = A_VBZ;
lexicon.executing = A_VBG;
lexicon.execution = A_NN;
lexicon.execute = A_VB_VBP;
lexicon.executions = A_NNS;
lexicon.executive = A_NN_JJ;
lexicon.exercised = A_VBN_VBD_JJ;
lexicon.exercises = A_NNS_VBZ;
lexicon.exercisable = A_JJ;
lexicon.exercising = A_VBG_NN;
lexicon.exercise = A_NN_VBP_VB;
lexicon.exhaustion = A_NN;
lexicon.exhausted = A_VBN_VBD;
lexicon.exhaustive = A_JJ;
lexicon.exhaust = A_NN_VB_VBP;
lexicon.exhaustively = A_RB;
lexicon.exhaustingly = A_RB;
lexicon.exhausts = A_NNS_VBZ;
lexicon.exhaustible = A_JJ;
lexicon.exhausting = A_VBG_JJ;
lexicon.exhibit = A_NN_VBP_VB;
lexicon.exhibition = A_NN;
lexicon.exhibited = A_VBN_VBD;
lexicon.exhibitions = A_NNS;
lexicon.exhibiting = A_VBG;
lexicon.exhibits = A_NNS_VBZ;
lexicon.exist = A_VB_VBP_NNP;
lexicon.existence = A_NN;
lexicon.existance = A_NN;
lexicon.existed = A_VBD_VBN;
lexicon.exists = A_VBZ;
lexicon.existent = A_JJ_NN;
lexicon.existing = A_VBG_JJ;
lexicon.exited = A_VBD_VBN;
lexicon.exit = A_NN_VB;
lexicon.exits = A_NNS_VBZ;
lexicon.exiting = A_VBG;
lexicon.exotic = A_JJ;
lexicon.expanding = A_VBG_JJ;
lexicon.expanded = A_VBN_VBD_JJ;
lexicon.expand = A_VB_VBP;
lexicon.expandable = A_JJ;
lexicon.expands = A_VBZ;
lexicon.expansively = A_RB;
lexicon.expansion = A_NN_JJ;
lexicon.expansions = A_NNS;
lexicon.expanse = A_NN_JJ;
lexicon.expansiveness = A_NN;
lexicon.expansive = A_JJ;
lexicon.expectations = A_NNS;
lexicon.expectantly = A_RB;
lexicon.expectable = A_JJ;
lexicon.expect = A_VBP_VB_IN;
lexicon.expecting = A_VBG;
lexicon.expectant = A_JJ;
lexicon.expectation = A_NN;
lexicon.expectancies = A_NNS;
lexicon.expectancy = A_NN;
lexicon.expected = A_VBN_VBD_JJ_VB;
lexicon.expectedly = A_RB;
lexicon.expects = A_VBZ;
lexicon.expeditions = A_NNS;
lexicon.expedited = A_VBN_VBD_JJ;
lexicon.expedition = A_NN;
lexicon.expediting = A_VBG;
lexicon.expedite = A_VB;
lexicon.expense = A_NN;
lexicon.expenses = A_NNS;
lexicon.expensive = A_JJ_RB;
lexicon.experimenting = A_VBG;
lexicon.experiments = A_NNS;
lexicon.experiences = A_NNS_VBZ;
lexicon.experience = A_NN_VBP_VB;
lexicon.experiment = A_NN_VBP_VB;
lexicon.experimented = A_VBD_VBN;
lexicon.experienced = A_VBN_JJ_VBD;
lexicon.experiencing = A_VBG;
lexicon.experimentations = A_NNS;
lexicon.experimentation = A_NN;
lexicon.experimenters = A_NNS;
lexicon.experimental = A_JJ;
lexicon.experimentalism = A_NN;
lexicon.experimenter = A_NN;
lexicon.experimentally = A_RB;
lexicon.experts = A_NNS;
lexicon.expert = A_NN_JJ;
lexicon.expertly = A_RB;
lexicon.expertise = A_NN;
lexicon.explained = A_VBD_VBN;
lexicon.explaining = A_VBG;
lexicon.explain = A_VB_VBP;
lexicon.explains = A_VBZ;
lexicon.explanation = A_NN;
lexicon.explanations = A_NNS;
lexicon.explicitness = A_NN;
lexicon.explicit = A_JJ;
lexicon.explicitly = A_RB;
lexicon.exploding = A_VBG;
lexicon.explode = A_VB_VBP;
lexicon.exploded = A_VBD_VBN;
lexicon.explodes = A_VBZ;
lexicon.exploit = A_VB_NN_VBP;
lexicon.exploitation = A_NN;
lexicon.exploited = A_VBN_VBD;
lexicon.exploiter = A_NN;
lexicon.exploiting = A_VBG;
lexicon.exploits = A_NNS_VBZ;
lexicon.exploiters = A_NNS;
lexicon.exploitative = A_JJ;
lexicon.explore = A_VB_VBP;
lexicon.explorers = A_NNS;
lexicon.explores = A_VBZ;
lexicon.explorer = A_NN;
lexicon.explored = A_VBN_VBD;
lexicon.exploring = A_VBG;
lexicon.exploration = A_NN;
lexicon.explorations = A_NNS;
lexicon.explosions = A_NNS;
lexicon.explosion = A_NN;
lexicon.explosive = A_JJ_NN;
lexicon.explosively = A_RB;
lexicon.explosives = A_NNS;
lexicon.exporting = A_VBG;
lexicon.export = A_NN_VBP_JJ_VB;
lexicon.exporters = A_NNS;
lexicon.exporter = A_NN;
lexicon.exported = A_VBN_VBD;
lexicon.exports = A_NNS_VBZ;
lexicon.exposed = A_VBN_JJ_VBD;
lexicon.exposes = A_VBZ;
lexicon.expose = A_VB_NN_VBP;
lexicon.exposing = A_VBG_JJ;
lexicon.exposure = A_NN;
lexicon.exposures = A_NNS;
lexicon.expression = A_NN;
lexicon.expressive = A_JJ;
lexicon.expressions = A_NNS;
lexicon.express = A_VB_VBP_JJ_NN;
lexicon.expressible = A_JJ;
lexicon.expressed = A_VBN_VBD_JJ;
lexicon.expresses = A_VBZ;
lexicon.expressiveness = A_NN;
lexicon.expressing = A_VBG;
lexicon.extend = A_VB_VBP_VBZ;
lexicon.extended = A_VBN_VBD_JJ;
lexicon.extendible = A_JJ;
lexicon.extends = A_VBZ;
lexicon.extendibles = A_NNS;
lexicon.extending = A_VBG;
lexicon.extension = A_NN;
lexicon.extensively = A_RB;
lexicon.extensions = A_NNS;
lexicon.extensive = A_JJ;
lexicon.extent = A_NN;
lexicon.externally = A_RB;
lexicon.extern = A_NN;
lexicon.external = A_JJ;
lexicon.externalization = A_NN;
lexicon.extra = A_JJ_NN_RB;
lexicon.extras = A_NNS;
lexicon.extraordinary = A_JJ_NN;
lexicon.extremely = A_RB;
lexicon.extreme = A_JJ_NN;
lexicon.extremity = A_NN;
lexicon.extremities = A_NNS;
lexicon.extremes = A_NNS;
lexicon.eyeful = A_NN;
lexicon.eying = A_VBG;
lexicon.eyeing = A_VBG;
lexicon.eyes = A_NNS;
lexicon.eyed = A_VBD;
lexicon.eye = A_NN;
lexicon.eyebrow = A_NN;
lexicon.eyebrows = A_NNS;
lexicon.fabric = A_NN;
lexicon.fabricating = A_VBG_NN;
lexicon.fabrications = A_NNS;
lexicon.fabrication = A_NN;
lexicon.fabricated = A_VBN_VBD_JJ;
lexicon.fabrics = A_NNS;
lexicon.fabricates = A_VBZ;
lexicon.fabricator = A_NN;
lexicon.fabricators = A_NNS;
lexicon.fabricate = A_VB_VBP;
lexicon.facing = A_VBG_JJ;
lexicon.face = A_NN_VBP_JJ_RB_VB;
lexicon.faced = A_VBN_VBD;
lexicon.faces = A_VBZ_NNS;
lexicon.facings = A_NNS;
lexicon.facilitators = A_NNS;
lexicon.facilitate = A_VB_VBP;
lexicon.facilitated = A_VBN;
lexicon.facilitates = A_VBZ;
lexicon.facilitating = A_VBG;
lexicon.facilites = A_NNS;
lexicon.facility = A_NN;
lexicon.facile = A_JJ;
lexicon.facilities = A_NNS;
lexicon.facts = A_NNS;
lexicon.fact = A_NN;
lexicon.factoring = A_NN_VBG;
lexicon.factored = A_VBN_JJ;
lexicon.factors = A_NNS_VBZ;
lexicon.factor = A_NN_VB_VBP;
lexicon.factory = A_NN_JJ;
lexicon.factories = A_NNS;
lexicon.faculty = A_NN;
lexicon.faculties = A_NNS;
lexicon.fade = A_VB_VBP_NN;
lexicon.fading = A_VBG_JJ_NN;
lexicon.fades = A_NNS_VBZ;
lexicon.faded = A_VBN_VBD_JJ;
lexicon.failing = A_VBG_NN;
lexicon.fails = A_VBZ_NNS;
lexicon.failings = A_NNS;
lexicon.failed = A_VBD_VBN_JJ;
lexicon.fail = A_VB_VBP_NN;
lexicon.failures = A_NNS;
lexicon.failure = A_NN;
lexicon.fainting = A_NN_VBG;
lexicon.faintly = A_RB;
lexicon.fainted = A_VBD_VBN;
lexicon.faint = A_JJ_NN_VB;
lexicon.fairness = A_NN;
lexicon.fairs = A_NNS;
lexicon.fairing = A_NN;
lexicon.fair = A_JJ_NN_RB;
lexicon.fairly = A_RB;
lexicon.faires = A_NNS;
lexicon.faiths = A_NNS;
lexicon.faithfully = A_RB;
lexicon.faith = A_NN;
lexicon.faithful = A_JJ_NN;
lexicon.fall = A_NN_VBP_VB;
lexicon.falling = A_VBG_JJ_NN;
lexicon.falls = A_VBZ_NNS;
lexicon.false = A_JJ_RB;
lexicon.falsely = A_RB;
lexicon.falseness = A_NN;
lexicon.famed = A_JJ_VBN;
lexicon.fames = A_NNS;
lexicon.fame = A_NN_VB;
lexicon.familiarness = A_NN;
lexicon.familiarity = A_NN;
lexicon.familiarize = A_VB;
lexicon.familiarly = A_RB;
lexicon.familiarization = A_NN;
lexicon.familiar = A_JJ_NN;
lexicon.families = A_NNS;
lexicon.family = A_NN;
lexicon.familial = A_JJ;
lexicon.famously = A_RB;
lexicon.famous = A_JJ_NNS;
lexicon.fanned = A_VBD_VBN;
lexicon.fanning = A_VBG_NN;
lexicon.fans = A_NNS_VBZ;
lexicon.fan = A_NN_VBP_VB;
lexicon.fantastically = A_RB;
lexicon.fantastic = A_JJ;
lexicon.fantasies = A_NNS;
lexicon.fantasy = A_NN;
lexicon.far = A_RB_IN_JJ;
lexicon.fares = A_NNS_NN_VBZ;
lexicon.fared = A_VBD_VBN;
lexicon.faring = A_VBG;
lexicon.fare = A_NN_VBP_VB;
lexicon.farmed = A_VBD_JJ;
lexicon.farm = A_NN_VB;
lexicon.farming = A_NN_VBG;
lexicon.farms = A_NNS_VBZ;
lexicon.farmer = A_NN;
lexicon.farmers = A_NNS;
lexicon.fascinatingly = A_RB;
lexicon.fascination = A_NN;
lexicon.fascinate = A_VB_VBP;
lexicon.fascinates = A_VBZ;
lexicon.fascinated = A_VBN_JJ_VBD;
lexicon.fascinating = A_JJ;
lexicon.fashionable = A_JJ_NN;
lexicon.fashioned = A_VBN_VBD;
lexicon.fashion = A_NN_VB;
lexicon.fashioning = A_VBG;
lexicon.fashions = A_NNS_VBZ;
lexicon.fast = A_RB_JJ_NN_RP;
lexicon.fastness = A_NN;
lexicon.faster = A_RBR_JJR_RB;
lexicon.fat = A_JJ_NN;
lexicon.fats = A_NNS;
lexicon.fatalities = A_NNS;
lexicon.fatality = A_NN;
lexicon.fatal = A_JJ;
lexicon.fatally = A_RB;
lexicon.fate = A_NN;
lexicon.fates = A_NNS;
lexicon.fateful = A_JJ;
lexicon.father = A_NN_VB;
lexicon.fathered = A_VBD;
lexicon.fatherly = A_JJ;
lexicon.fathers = A_NNS;
lexicon.fatigue = A_NN_VBP;
lexicon.fatigues = A_NNS;
lexicon.fatigued = A_VBN_JJ;
lexicon.fault = A_NN_VB_VBP;
lexicon.faulted = A_VBN_VBD;
lexicon.faults = A_NNS_VBZ;
lexicon.faulting = A_VBG;
lexicon.favors = A_VBZ_NNS;
lexicon.favore = A_FW;
lexicon.favoring = A_VBG;
lexicon.favorer = A_NN;
lexicon.favorably = A_RB;
lexicon.favorable = A_JJ;
lexicon.favored = A_VBN_VBD_JJ;
lexicon.favorableness = A_NN;
lexicon.favor = A_NN_VBP_VB;
lexicon.favorite = A_JJ_NN;
lexicon.favorites = A_NNS;
lexicon.favoritism = A_NN;
lexicon.fears = A_NNS_VBZ;
lexicon.feare = A_NN;
lexicon.fear = A_NN_VB_VBP;
lexicon.fearful = A_JJ;
lexicon.feared = A_VBD_VBN_JJ;
lexicon.fearing = A_VBG;
lexicon.fearfully = A_RB;
lexicon.feather = A_NN_VB;
lexicon.feathers = A_NNS;
lexicon.feathered = A_JJ_VBN;
lexicon.features = A_NNS_VBZ;
lexicon.featuring = A_VBG;
lexicon.feature = A_NN_VBP_JJ_VB;
lexicon.featured = A_VBN_VBD_JJ;
lexicon.federalize = A_VB;
lexicon.federal = A_JJ;
lexicon.federalism = A_NN_JJ;
lexicon.federalized = A_JJ;
lexicon.federally = A_RB;
lexicon.federation = A_NN;
lexicon.fees = A_NNS;
lexicon.fee = A_NN;
lexicon.feeds = A_VBZ_NNS;
lexicon.feedings = A_NNS;
lexicon.feed = A_NN_VB_VBD_VBP;
lexicon.feeding = A_VBG_NN;
lexicon.feedback = A_NN;
lexicon.feeling = A_NN_VBG;
lexicon.feels = A_VBZ_NNS;
lexicon.feel = A_VB_VBP_NN;
lexicon.feelings = A_NNS;
lexicon.fellows = A_NNS;
lexicon.fellow = A_NN_JJ;
lexicon.females = A_NNS;
lexicon.female = A_JJ_NN;
lexicon.feminist = A_JJ_NN;
lexicon.feminists = A_NNS;
lexicon.fence = A_NN;
lexicon.fencing = A_NN;
lexicon.fenced = A_JJ_VBN;
lexicon.fences = A_NNS;
lexicon.festive = A_JJ;
lexicon.festivity = A_NN;
lexicon.festivities = A_NNS;
lexicon.festival = A_NN;
lexicon.festivals = A_NNS;
lexicon.fevered = A_JJ;
lexicon.fever = A_NN;
lexicon.fevers = A_NNS;
lexicon.few = A_JJ_NN_RB_NNS;
lexicon.fewer = A_JJR_RB_RBR;
lexicon.fibers = A_NNS;
lexicon.fiber = A_NN;
lexicon.fictionalized = A_VBN;
lexicon.fictions = A_NNS;
lexicon.fiction = A_NN;
lexicon.fictional = A_JJ;
lexicon.field = A_NN_JJ_VB_VBP;
lexicon.fielded = A_VBD_VBN;
lexicon.fielding = A_NN_VBG;
lexicon.fields = A_NNS_VBZ;
lexicon.fierceness = A_NN;
lexicon.fierce = A_JJ;
lexicon.fiercely = A_RB;
lexicon.fifth = A_JJ_NN_RB;
lexicon.fights = A_NNS_VBZ;
lexicon.fight = A_NN_VB_VBP;
lexicon.fighting = A_VBG_JJ_NN;
lexicon.fighters = A_NNS;
lexicon.fighter = A_NN;
lexicon.figure = A_NN_VB_VBP_VBZ;
lexicon.figuratively = A_RB;
lexicon.figurative = A_JJ;
lexicon.figured = A_VBD_JJ_VBN;
lexicon.figuring = A_VBG;
lexicon.figural = A_JJ;
lexicon.figures = A_NNS_VBZ;
lexicon.filed = A_VBN_VBD;
lexicon.filing = A_NN_VBG;
lexicon.files = A_NNS_VBZ;
lexicon.file = A_VB_NN_VBP;
lexicon.filings = A_NNS;
lexicon.fillings = A_NNS;
lexicon.fills = A_VBZ;
lexicon.fille = A_FW;
lexicon.filling = A_VBG_NN;
lexicon.filled = A_VBN_JJ_VBD;
lexicon.filles = A_FW;
lexicon.fill = A_VB_VBP_NN;
lexicon.filmed = A_VBN_VBD_JJ;
lexicon.films = A_NNS;
lexicon.filming = A_VBG;
lexicon.film = A_NN_VB;
lexicon.filters = A_NNS_VBZ;
lexicon.filter = A_NN_VB;
lexicon.filtering = A_VBG_NN;
lexicon.filtered = A_VBN_JJ;
lexicon.finale = A_NN;
lexicon.finals = A_NNS;
lexicon.finalized = A_VBN_VBD;
lexicon.final = A_JJ;
lexicon.finally = A_RB;
lexicon.finality = A_NN;
lexicon.finalizing = A_VBG;
lexicon.financings = A_NNS;
lexicon.financeer = A_NN;
lexicon.finance = A_NN_VBP_VB;
lexicon.financing = A_NN_JJ_VBG;
lexicon.financed = A_VBN_JJ_VBD;
lexicon.financer = A_NN;
lexicon.finances = A_NNS_VBZ;
lexicon.financial = A_JJ;
lexicon.financier = A_NN;
lexicon.financiers = A_NNS;
lexicon.financially = A_RB;
lexicon.find = A_VB_VBP_NN;
lexicon.finding = A_VBG_NN;
lexicon.findings = A_NNS;
lexicon.finds = A_VBZ_NNS;
lexicon.fines = A_NNS_NN;
lexicon.fined = A_VBN_VBD;
lexicon.fine = A_JJ_NN_RB_VB;
lexicon.fining = A_VBG;
lexicon.fineness = A_NN;
lexicon.finely = A_RB;
lexicon.fingered = A_VBD_VBN;
lexicon.fingers = A_NNS;
lexicon.fingering = A_VBG_NN;
lexicon.fingerings = A_NNS;
lexicon.finger = A_NN_VB;
lexicon.finishes = A_VBZ_NNS;
lexicon.finish = A_VB_NN_VBP;
lexicon.finishing = A_VBG_JJ_NN;
lexicon.finisher = A_NN;
lexicon.finished = A_VBD_JJ_VB_VBN;
lexicon.firings = A_NNS;
lexicon.fire = A_NN_VB;
lexicon.fires = A_NNS_VBZ;
lexicon.firing = A_VBG_JJ_NN;
lexicon.fired = A_VBN_VBD;
lexicon.firms = A_NNS_VBZ;
lexicon.firmly = A_RB;
lexicon.firming = A_VBG_NN;
lexicon.firmed = A_VBD_VBN;
lexicon.firm = A_NN_JJ_VB;
lexicon.firmness = A_NN;
lexicon.firsts = A_NNS;
lexicon.fiscally = A_RB;
lexicon.fiscal = A_JJ_IN_NN;
lexicon.fished = A_VBN;
lexicon.fishing = A_NN_VBG_JJ;
lexicon.fishes = A_NNS_VBZ;
lexicon.fish = A_NN_RB_VB_NNS;
lexicon.fisherman = A_NN;
lexicon.fists = A_NNS;
lexicon.fisted = A_VBD;
lexicon.fist = A_NN_RB;
lexicon.fit = A_VB_VBN_VBP_JJ_NN_RB_VBD;
lexicon.fitness = A_NN;
lexicon.fits = A_VBZ_NNS;
lexicon.fitful = A_JJ;
lexicon.fitting = A_JJ_NN_VBG;
lexicon.fitfully = A_RB;
lexicon.fittings = A_NNS;
lexicon.fitted = A_VBN_VBD_JJ;
lexicon.fix = A_VB_VBP_NN;
lexicon.fixing = A_VBG_NN;
lexicon.fixes = A_NNS;
lexicon.fixed = A_VBN_JJ_VBD;
lexicon.flagging = A_JJ_VBG;
lexicon.flags = A_NNS_VBZ;
lexicon.flag = A_NN_VB;
lexicon.flagged = A_VBD;
lexicon.flaming = A_JJ_VBG;
lexicon.flame = A_NN_VBP_VB;
lexicon.flames = A_NNS;
lexicon.flamed = A_VBD_VBN;
lexicon.flash = A_NN_VBP_JJ_VB;
lexicon.flashing = A_VBG_NN;
lexicon.flashed = A_VBD_VBN;
lexicon.flashes = A_NNS_VBZ;
lexicon.flatnesses = A_NNS;
lexicon.flats = A_NNS;
lexicon.flat = A_JJ_NN_RB;
lexicon.flatness = A_NN;
lexicon.flatly = A_RB;
lexicon.flavor = A_NN;
lexicon.flavorful = A_JJ;
lexicon.flavoring = A_NN_VBG;
lexicon.flavorings = A_NNS;
lexicon.flavored = A_JJ_VBN;
lexicon.flavors = A_NNS;
lexicon.fleeing = A_VBG;
lexicon.flee = A_VB;
lexicon.flees = A_VBZ;
lexicon.fleeting = A_JJ;
lexicon.fleets = A_NNS_VBZ;
lexicon.fleet = A_NN_JJ;
lexicon.flesh = A_NN_VB;
lexicon.flexibility = A_NN;
lexicon.flexible = A_JJ;
lexicon.flight = A_NN;
lexicon.flights = A_NNS;
lexicon.flipping = A_VBG_JJ_RB;
lexicon.flip = A_JJ_VB;
lexicon.flips = A_VBZ_NNS;
lexicon.flipped = A_VBD;
lexicon.floated = A_VBD_VBN;
lexicon.floats = A_VBZ;
lexicon.floating = A_VBG_JJ;
lexicon.float = A_VB_NN_VBP;
lexicon.flooded = A_VBN_VBD;
lexicon.floods = A_NNS;
lexicon.flood = A_NN_VB_VBP;
lexicon.flooding = A_VBG_NN;
lexicon.floor = A_NN;
lexicon.floors = A_NNS;
lexicon.flooring = A_NN;
lexicon.floured = A_VBN;
lexicon.flour = A_NN;
lexicon.flowing = A_VBG_JJ;
lexicon.flowed = A_VBD_VBN;
lexicon.flow = A_NN_VBP_VB;
lexicon.flows = A_NNS_VBZ;
lexicon.flowering = A_NN_VBG;
lexicon.flowered = A_JJ_VBD_VBN;
lexicon.flower = A_NN_VBP;
lexicon.flowers = A_NNS;
lexicon.fluid = A_NN_JJ;
lexicon.fluids = A_NNS;
lexicon.flying = A_VBG_JJ_NN;
lexicon.fly = A_VB_NN_VBP;
lexicon.flies = A_VBZ_NNS;
lexicon.flied = A_VBD;
lexicon.focused = A_VBN_JJ_VBD;
lexicon.focusing = A_VBG_NN;
lexicon.focus = A_NN_VBP_VB;
lexicon.focuses = A_VBZ_NNS;
lexicon.fogged = A_JJ;
lexicon.fog = A_NN_VB;
lexicon.folded = A_VBN_VBD_JJ;
lexicon.fold = A_VB_NN_VBP;
lexicon.folds = A_NNS_VBZ;
lexicon.folding = A_VBG_JJ_NN;
lexicon.folk = A_NN_NNS;
lexicon.folks = A_NNS;
lexicon.following = A_VBG_JJ_NN;
lexicon.follower = A_NN;
lexicon.followings = A_NNS;
lexicon.followers = A_NNS;
lexicon.follow = A_VB_VBP;
lexicon.follows = A_VBZ;
lexicon.followed = A_VBD_JJ_VBN;
lexicon.food = A_NN;
lexicon.foods = A_NNS;
lexicon.fools = A_NNS;
lexicon.fooling = A_VBG_NN;
lexicon.fool = A_NN_JJ_VB;
lexicon.fooled = A_VBN;
lexicon.foot = A_NN_VBP_JJ_VB;
lexicon.footing = A_NN_VBG;
lexicon.football = A_NN;
lexicon.footballs = A_NNS;
lexicon.footballer = A_NN;
lexicon.for = A_IN_NNP_CC_JJ_RB_RP;
lexicon.forbid = A_VB_VBP_UH;
lexicon.forbidding = A_VBG_JJ;
lexicon.forbids = A_VBZ;
lexicon.forcefully = A_RB;
lexicon.forcing = A_VBG;
lexicon.forcefulness = A_NN;
lexicon.forceful = A_JJ;
lexicon.forced = A_VBN_JJ_VBD;
lexicon.forces = A_NNS_VBZ;
lexicon.force = A_NN_FW_VB_NNP_VBP;
lexicon.foreheads = A_NNS;
lexicon.forehead = A_NN;
lexicon.foreigner = A_NN;
lexicon.foreign = A_JJ;
lexicon.foreigners = A_NNS;
lexicon.forest = A_NN;
lexicon.forests = A_NNS;
lexicon.forever = A_RB;
lexicon.forgets = A_VBZ;
lexicon.forgetful = A_JJ;
lexicon.forgetfulness = A_NN;
lexicon.forgetting = A_VBG;
lexicon.forget = A_VB_VBP;
lexicon.forgiveness = A_NN;
lexicon.forgive = A_VB_VBP;
lexicon.forgiving = A_VBG_JJ;
lexicon.forking = A_VBG;
lexicon.forks = A_NNS;
lexicon.fork = A_NN_VB;
lexicon.forked = A_JJ_VBD_VBN;
lexicon.forming = A_VBG_NN;
lexicon.formed = A_VBN_VBD_JJ;
lexicon.form = A_NN_VBP_JJ_VB;
lexicon.forms = A_NNS_VBZ;
lexicon.formalism = A_NN;
lexicon.formalities = A_NNS;
lexicon.formally = A_RB;
lexicon.formalizes = A_VBZ;
lexicon.formalized = A_JJ_VBN;
lexicon.formality = A_NN;
lexicon.formal = A_JJ;
lexicon.formalize = A_VB;
lexicon.formative = A_JJ_NN;
lexicon.formation = A_NN;
lexicon.formations = A_NNS;
lexicon.format = A_NN;
lexicon.formats = A_NNS;
lexicon.formerly = A_RB;
lexicon.former = A_JJ_NN;
lexicon.formula = A_NN;
lexicon.formulas = A_NNS;
lexicon.formulae = A_NNS;
lexicon.formulaic = A_JJ;
lexicon.forth = A_RB_RP;
lexicon.fortune = A_NN;
lexicon.fortunately = A_RB;
lexicon.fortunes = A_NNS;
lexicon.fortunate = A_JJ;
lexicon.forum = A_NN;
lexicon.forums = A_NNS;
lexicon.forwarding = A_NN_VBG;
lexicon.forward = A_RB_JJ_NN_VB;
lexicon.forwarders = A_NNS;
lexicon.forwards = A_RB;
lexicon.forwarded = A_VBN;
lexicon.fostered = A_VBN_VBD;
lexicon.fosters = A_VBZ;
lexicon.foster = A_VB_JJ;
lexicon.fostering = A_VBG_NN;
lexicon.founding = A_NN_VBG_JJ;
lexicon.found = A_VBD_VBN_VB;
lexicon.founded = A_VBN_VBD;
lexicon.founds = A_VBZ;
lexicon.foundation = A_NN;
lexicon.foundations = A_NNS;
lexicon.foundering = A_VBG_JJ;
lexicon.founders = A_NNS;
lexicon.founder = A_NN_VB;
lexicon.foundered = A_VBD;
lexicon.fours = A_NNS;
lexicon.fourth = A_JJ_RB;
lexicon.fraction = A_NN;
lexicon.fractionally = A_RB;
lexicon.fractionated = A_VBN_VBD;
lexicon.fractioning = A_VBG;
lexicon.fractionation = A_NN;
lexicon.fractions = A_NNS;
lexicon.fractional = A_JJ;
lexicon.fragile = A_JJ;
lexicon.fragility = A_NN;
lexicon.fragmented = A_JJ_VBN;
lexicon.fragmentation = A_NN;
lexicon.fragment = A_NN;
lexicon.fragments = A_NNS_VBZ;
lexicon.fragmentations = A_NNS;
lexicon.frames = A_NNS;
lexicon.frame = A_NN_VBP_VB;
lexicon.framing = A_NN_VBG;
lexicon.framed = A_VBN_VBD_JJ;
lexicon.framework = A_NN;
lexicon.franchises = A_NNS_VBZ;
lexicon.franchised = A_VBN_JJ;
lexicon.franchise = A_NN_VB;
lexicon.franchiser = A_NN;
lexicon.franchising = A_NN_VBG;
lexicon.franchisers = A_NNS;
lexicon.frankly = A_RB;
lexicon.frank = A_JJ_NN;
lexicon.franked = A_JJ_VBN;
lexicon.franks = A_NNS;
lexicon.frankness = A_NN;
lexicon.franking = A_NN_VBG;
lexicon.frauds = A_NNS;
lexicon.fraud = A_NN;
lexicon.freeing = A_VBG_NN;
lexicon.frees = A_VBZ;
lexicon.free = A_JJ_RB_VB_VBP;
lexicon.freedoms = A_NNS;
lexicon.freedom = A_NN;
lexicon.freely = A_RB;
lexicon.freezing = A_VBG_JJ_NN;
lexicon.freezes = A_VBZ_NNS;
lexicon.freeze = A_NN_VB_VBP;
lexicon.frequencies = A_NNS;
lexicon.frequency = A_NN;
lexicon.frequent = A_JJ_VBP_VB;
lexicon.frequented = A_VBD_VBN;
lexicon.frequents = A_VBZ;
lexicon.frequently = A_RB;
lexicon.fresh = A_JJ;
lexicon.freshness = A_NN;
lexicon.freshly = A_RB;
lexicon.freshman = A_NN;
lexicon.friendly = A_JJ;
lexicon.friend = A_NN;
lexicon.friends = A_NNS;
lexicon.friendships = A_NNS;
lexicon.friendship = A_NN;
lexicon.from = A_IN_RB_RP;
lexicon.fronts = A_NNS;
lexicon.fronted = A_VBD;
lexicon.front = A_NN_JJ_RB;
lexicon.fronting = A_VBG_NN;
lexicon.frontier = A_NN;
lexicon.frontiers = A_NNS;
lexicon.frowns = A_VBZ;
lexicon.frowning = A_VBG;
lexicon.frowningly = A_RB;
lexicon.frown = A_VBP;
lexicon.frowned = A_VBD_VBN;
lexicon.frozen = A_VBN_JJ;
lexicon.fruits = A_NNS;
lexicon.fruitful = A_JJ;
lexicon.fruitfulness = A_NN;
lexicon.fruitfully = A_RB;
lexicon.fruit = A_NN;
lexicon.frustrating = A_JJ_VBG;
lexicon.frustratingly = A_RB;
lexicon.frustrates = A_VBZ;
lexicon.frustrated = A_VBN_JJ_VBD;
lexicon.frustrations = A_NNS;
lexicon.frustrate = A_VB;
lexicon.frustration = A_NN;
lexicon.fuck = A_VB;
lexicon.fucks = A_NNS;
lexicon.fueled = A_VBN_VBD;
lexicon.fuel = A_NN_VBP_VB;
lexicon.fuels = A_NNS_VBZ;
lexicon.fueling = A_VBG_NN;
lexicon.full = A_JJ_RB;
lexicon.fullness = A_NN;
lexicon.fully = A_RB;
lexicon.fun = A_NN_JJ;
lexicon.functioned = A_VBD_VBN;
lexicon.functioning = A_VBG_NN;
lexicon.functionally = A_RB;
lexicon.functions = A_NNS_VBZ;
lexicon.functional = A_JJ_NN;
lexicon.functionalism = A_NN;
lexicon.function = A_NN_VB_VBP;
lexicon.fund = A_NN_VBP_VB;
lexicon.funds = A_NNS_VBZ;
lexicon.funded = A_VBN_VBD_JJ;
lexicon.funding = A_NN_VBG;
lexicon.fundamentalism = A_NN;
lexicon.fundamentally = A_RB;
lexicon.fundamental = A_JJ;
lexicon.fundamentals = A_NNS;
lexicon.funeral = A_NN_JJ;
lexicon.funerals = A_NNS;
lexicon.funny = A_JJ;
lexicon.fur = A_NN;
lexicon.furs = A_NNS;
lexicon.furniture = A_NN;
lexicon.furthermore = A_RB;
lexicon.future = A_NN_JJ;
lexicon.futures = A_NNS;
lexicon.gain = A_NN_VBP_VB;
lexicon.gained = A_VBD_VBN_VB;
lexicon.gaining = A_VBG;
lexicon.gainful = A_JJ;
lexicon.gains = A_NNS_NN_VBZ;
lexicon.galaxies = A_NNS;
lexicon.galaxy = A_NN;
lexicon.gallery = A_NN;
lexicon.galleries = A_NNS;
lexicon.gaming = A_NN;
lexicon.game = A_NN;
lexicon.games = A_NNS;
lexicon.gangs = A_NNS;
lexicon.ganging = A_VBG;
lexicon.gang = A_NN_VB;
lexicon.gap = A_NN;
lexicon.gapped = A_VBD;
lexicon.gaps = A_NNS;
lexicon.garaged = A_VBN;
lexicon.garages = A_NNS;
lexicon.garage = A_NN_VBP;
lexicon.garbage = A_NN;
lexicon.gardeners = A_NNS;
lexicon.gardening = A_NN_VBG;
lexicon.gardens = A_NNS_VBZ;
lexicon.gardened = A_VBD;
lexicon.gardener = A_NN;
lexicon.garden = A_NN_VB;
lexicon.garlic = A_NN;
lexicon.gas = A_NN_VB;
lexicon.gasolines = A_NNS;
lexicon.gasoline = A_NN;
lexicon.gate = A_NN;
lexicon.gates = A_NNS_VBZ;
lexicon.gathers = A_VBZ;
lexicon.gathered = A_VBD_VBN;
lexicon.gathering = A_NN_VBG;
lexicon.gatherings = A_NNS;
lexicon.gather = A_VB_VBP;
lexicon.gays = A_NNS;
lexicon.gay = A_JJ;
lexicon.gaze = A_NN_VB_VBP;
lexicon.gazing = A_VBG;
lexicon.gazes = A_VBZ;
lexicon.gazed = A_VBD;
lexicon.gears = A_NNS_VBZ;
lexicon.geared = A_VBN_VBD;
lexicon.gearing = A_VBG;
lexicon.gear = A_NN_VB_VBP;
lexicon.genders = A_NNS;
lexicon.gender = A_NN_VB;
lexicon.gene = A_NN;
lexicon.genes = A_NNS;
lexicon.generalizations = A_NNS;
lexicon.generalize = A_VB_VBP;
lexicon.generals = A_NNS;
lexicon.generally = A_RB;
lexicon.generality = A_NN;
lexicon.generalized = A_JJ_VBN;
lexicon.generalization = A_NN;
lexicon.generalities = A_NNS;
lexicon.general = A_JJ_NN;
lexicon.generator = A_NN;
lexicon.generators = A_NNS;
lexicon.generational = A_JJ;
lexicon.generate = A_VB_VBP;
lexicon.generating = A_VBG_NN;
lexicon.generates = A_VBZ;
lexicon.generated = A_VBN_VBD_VBG;
lexicon.generation = A_NN;
lexicon.generations = A_NNS;
lexicon.generously = A_RB;
lexicon.generous = A_JJ;
lexicon.genetic = A_JJ;
lexicon.genetically = A_RB;
lexicon.genetics = A_NNS;
lexicon.geniuses = A_NNS;
lexicon.genius = A_NN;
lexicon.genre = A_NN;
lexicon.genres = A_NNS;
lexicon.gently = A_RB;
lexicon.gentle = A_JJ_VB;
lexicon.gentleness = A_NN;
lexicon.gentlemanly = A_JJ;
lexicon.gentleman = A_NN;
lexicon.genuine = A_JJ;
lexicon.genuinely = A_RB;
lexicon.gestures = A_NNS_VBZ;
lexicon.gesture = A_NN;
lexicon.gestured = A_VBD;
lexicon.gesturing = A_VBG;
lexicon.gets = A_VBZ;
lexicon.get = A_VB_VBP;
lexicon.getting = A_VBG;
lexicon.ghosts = A_NNS;
lexicon.ghosted = A_VBD;
lexicon.ghost = A_NN;
lexicon.ghostly = A_JJ;
lexicon.giants = A_NNS;
lexicon.giant = A_NN_JJ;
lexicon.gift = A_NN;
lexicon.gifts = A_NNS;
lexicon.gifted = A_JJ_VBN;
lexicon.girl = A_NN;
lexicon.girls = A_NNS;
lexicon.girlfriend = A_NN;
lexicon.girlfriends = A_NNS;
lexicon.give = A_VB_NN_VBP;
lexicon.giving = A_VBG_NN;
lexicon.gives = A_VBZ;
lexicon.givenness = A_NN;
lexicon.given = A_VBN_JJ;
lexicon.gladly = A_RB;
lexicon.gladness = A_NN;
lexicon.glad = A_JJ;
lexicon.glancing = A_VBG_JJ;
lexicon.glances = A_NNS_VBZ;
lexicon.glanced = A_VBD;
lexicon.glance = A_NN_VB;
lexicon.glasses = A_NNS;
lexicon.glass = A_NN;
lexicon.glimpse = A_NN;
lexicon.glimpsed = A_VBN_VBD;
lexicon.glimpses = A_NNS;
lexicon.globally = A_RB;
lexicon.global = A_JJ;
lexicon.globalizing = A_VBG;
lexicon.globalism = A_NN;
lexicon.globalization = A_NN;
lexicon.globalized = A_JJ;
lexicon.globes = A_NNS;
lexicon.globe = A_NN;
lexicon.glories = A_NNS_VBZ;
lexicon.glory = A_NN;
lexicon.glorying = A_VBG;
lexicon.gloved = A_VBN_JJ;
lexicon.gloves = A_NNS;
lexicon.glove = A_NN;
lexicon.go = A_VB_JJ_NN_RP_VBP;
lexicon.going = A_VBG_JJ_NN;
lexicon.goings = A_NNS;
lexicon.goal = A_NN;
lexicon.goals = A_NNS;
lexicon.goats = A_NNS;
lexicon.goat = A_NN;
lexicon.golds = A_NNS;
lexicon.gold = A_NN_JJ;
lexicon.golden = A_JJ;
lexicon.golfs = A_NNS;
lexicon.golfing = A_NN_VBG;
lexicon.golfed = A_VBN;
lexicon.golf = A_NN;
lexicon.goodness = A_NN;
lexicon.goods = A_NNS;
lexicon.good = A_JJ_NN_RB;
lexicon.governed = A_VBN_JJ_VBD;
lexicon.governing = A_VBG_JJ_NN;
lexicon.governs = A_VBZ;
lexicon.governance = A_NN;
lexicon.government = A_NN;
lexicon.govern = A_VB_VBP;
lexicon.governments = A_NNS;
lexicon.governor = A_NN;
lexicon.governors = A_NNS;
lexicon.grabbing = A_VBG_NN;
lexicon.grab = A_VB_JJ_NN_VBP;
lexicon.grabs = A_NNS_VBZ;
lexicon.grabbed = A_VBD_VBN;
lexicon.graced = A_VBD_VBN;
lexicon.graces = A_NNS;
lexicon.gracefully = A_RB;
lexicon.gracefulness = A_NN;
lexicon.graceful = A_JJ;
lexicon.grace = A_NN_VB_VBP;
lexicon.grades = A_NNS;
lexicon.graded = A_VBN;
lexicon.grade = A_NN_VB;
lexicon.grading = A_VBG_NN;
lexicon.gradualism = A_NN;
lexicon.gradual = A_JJ_RB;
lexicon.gradually = A_RB;
lexicon.graduates = A_NNS_VBZ;
lexicon.graduating = A_VBG_NN;
lexicon.graduation = A_NN;
lexicon.graduate = A_NN_JJ_VB_VBP;
lexicon.graduated = A_VBN_VBD_JJ;
lexicon.graining = A_NN;
lexicon.grain = A_NN;
lexicon.grains = A_NNS;
lexicon.grained = A_JJ;
lexicon.grand = A_JJ;
lexicon.grandly = A_RB;
lexicon.grandchild = A_NN;
lexicon.grandfathers = A_NNS;
lexicon.grandfather = A_NN_VB;
lexicon.grandmotherly = A_JJ;
lexicon.grandmothers = A_NNS;
lexicon.grandmother = A_NN;
lexicon.grandparents = A_NNS;
lexicon.grant = A_NN_VBP_VB;
lexicon.granting = A_VBG_NN;
lexicon.granted = A_VBN_JJ_VBD;
lexicon.grants = A_NNS_VBZ;
lexicon.grape = A_NN;
lexicon.grapes = A_NNS;
lexicon.grasping = A_VBG;
lexicon.grasped = A_VBN_VBD;
lexicon.grasp = A_VB_VBP_NN;
lexicon.grasses = A_NNS;
lexicon.grassed = A_VBN;
lexicon.grass = A_NN;
lexicon.grated = A_VBD_JJ;
lexicon.gratings = A_NNS;
lexicon.gratefully = A_RB;
lexicon.grating = A_NN;
lexicon.gratingly = A_RB;
lexicon.grateful = A_JJ;
lexicon.grate = A_NN;
lexicon.grates = A_NNS;
lexicon.gravely = A_RB;
lexicon.grave = A_JJ_NN;
lexicon.graves = A_NNS;
lexicon.gravity = A_NN;
lexicon.grayed = A_JJ;
lexicon.graying = A_VBG_NN;
lexicon.grays = A_NNS;
lexicon.gray = A_JJ_NN;
lexicon.greatly = A_RB;
lexicon.great = A_JJ_RB;
lexicon.greatness = A_NN;
lexicon.greats = A_NNS;
lexicon.greate = A_NN;
lexicon.greatest = A_JJS;
lexicon.greenness = A_NN;
lexicon.greenly = A_RB;
lexicon.greening = A_JJ_NN_VBG;
lexicon.green = A_JJ_NN_VB;
lexicon.greens = A_NNS;
lexicon.greetings = A_NNS;
lexicon.greeting = A_NN_VBG_JJ;
lexicon.greeted = A_VBD_VBN;
lexicon.greet = A_VB_VBP;
lexicon.greets = A_VBZ;
lexicon.grief = A_NN;
lexicon.grinned = A_VBD;
lexicon.grinning = A_VBG_JJ;
lexicon.grins = A_NNS;
lexicon.grin = A_NN_VB;
lexicon.grips = A_NNS;
lexicon.grip = A_NN_VBP;
lexicon.gripping = A_VBG_JJ;
lexicon.gripped = A_VBD_VBN;
lexicon.groceries = A_NNS;
lexicon.grocery = A_NN;
lexicon.gross = A_JJ_NN_VB;
lexicon.grossing = A_VBG;
lexicon.grosses = A_VBZ;
lexicon.grossed = A_VBD;
lexicon.grounding = A_VBG_NN;
lexicon.grounds = A_NNS_VBZ;
lexicon.grounded = A_VBN_VBD_JJ;
lexicon.ground = A_NN_JJ_VB_VBD_VBN;
lexicon.groups = A_NNS;
lexicon.grouped = A_VBN;
lexicon.group = A_NN_VB_VBP;
lexicon.grouping = A_NN_VBG;
lexicon.groupings = A_NNS;
lexicon.growing = A_VBG_JJ_NN;
lexicon.grows = A_VBZ;
lexicon.grow = A_VB_VBP;
lexicon.growths = A_NNS;
lexicon.growth = A_NN_JJ_VB;
lexicon.guaranteed = A_VBN_JJ_VBD;
lexicon.guarantees = A_NNS_VBZ;
lexicon.guarantee = A_NN_VB_VBP;
lexicon.guaranteeing = A_VBG_NN;
lexicon.guarding = A_VBG;
lexicon.guard = A_NN_JJ_VB_VBP;
lexicon.guarded = A_VBN_JJ_VBD;
lexicon.guards = A_NNS_VBZ;
lexicon.guardedly = A_RB;
lexicon.guessing = A_VBG_NN;
lexicon.guesses = A_NNS_VBZ;
lexicon.guessed = A_VBD_VBN;
lexicon.guess = A_VBP_NN_VB;
lexicon.guest = A_NN_JJ;
lexicon.guests = A_NNS;
lexicon.guidance = A_NN;
lexicon.guided = A_VBN_VBD_JJ;
lexicon.guides = A_NNS_VBZ;
lexicon.guide = A_NN_VBP_VB;
lexicon.guiding = A_VBG_JJ;
lexicon.guideline = A_NN;
lexicon.guidelines = A_NNS;
lexicon.guilt = A_NN;
lexicon.guiltiness = A_NN;
lexicon.guilty = A_JJ_RB;
lexicon.guitar = A_NN;
lexicon.guitars = A_NNS;
lexicon.gun = A_NN_VB;
lexicon.guns = A_NNS_VBZ;
lexicon.gunning = A_VBG_NN;
lexicon.gunned = A_VBN_VBD;
lexicon.guts = A_NNS;
lexicon.gut = A_NN_VB;
lexicon.gutted = A_VBN_VBD;
lexicon.guy = A_NN;
lexicon.guys = A_NNS;
lexicon.gyms = A_NNS;
lexicon.gym = A_NN;
lexicon.ha = A_UH;
lexicon.habits = A_NNS;
lexicon.habit = A_NN;
lexicon.habitants = A_NNS;
lexicon.habitable = A_JJ;
lexicon.habitat = A_NN;
lexicon.habitats = A_NNS;
lexicon.hair = A_NN;
lexicon.hairs = A_NNS;
lexicon.halfway = A_RB_JJ;
lexicon.halfways = A_RB;
lexicon.hall = A_NN;
lexicon.halls = A_NNS;
lexicon.hallway = A_NN;
lexicon.hallways = A_NNS;
lexicon.handful = A_NN;
lexicon.hand = A_NN_RB_VB_VBP_JJ;
lexicon.handing = A_VBG;
lexicon.handed = A_VBD_VBN;
lexicon.handfuls = A_NNS;
lexicon.hande = A_NN;
lexicon.hands = A_NNS_VBZ;
lexicon.handled = A_VBN_VBD;
lexicon.handles = A_VBZ_NNS;
lexicon.handling = A_NN_VBG;
lexicon.handle = A_VB_NN_VBP;
lexicon.handsome = A_JJ;
lexicon.handsomely = A_RB;
lexicon.handsomer = A_JJR;
lexicon.hanging = A_VBG_JJ_NN;
lexicon.hangs = A_VBZ;
lexicon.hanged = A_VBN_VBD;
lexicon.hang = A_VB_JJ_VBP_NN;
lexicon.happen = A_VB_VBP;
lexicon.happenings = A_NNS;
lexicon.happening = A_VBG_NN;
lexicon.happens = A_VBZ;
lexicon.happened = A_VBD_VBN;
lexicon.happily = A_RB;
lexicon.happy = A_JJ;
lexicon.happiness = A_NN;
lexicon.harassing = A_VBG;
lexicon.harassed = A_VBD_VBN;
lexicon.harassment = A_NN;
lexicon.harass = A_VB_VBP;
lexicon.hardly = A_RB;
lexicon.hardness = A_NN;
lexicon.hard = A_JJ_RB;
lexicon.hardware = A_NN;
lexicon.harmful = A_JJ;
lexicon.harming = A_VBG;
lexicon.harmed = A_VBN_VBD;
lexicon.harms = A_VBZ_NNS;
lexicon.harm = A_NN_VB_VBP;
lexicon.harmonies = A_NNS;
lexicon.harmoniously = A_RB;
lexicon.harmonious = A_JJ;
lexicon.harmony = A_NN;
lexicon.harshness = A_NN;
lexicon.harshly = A_RB;
lexicon.harsh = A_JJ;
lexicon.harvests = A_NNS;
lexicon.harvested = A_VBN;
lexicon.harvesting = A_NN_VBG;
lexicon.harvest = A_NN_VB_VBP;
lexicon.has = A_VBZ_VBN;
lexicon.hat = A_NN;
lexicon.hatted = A_VBN;
lexicon.hats = A_NNS;
lexicon.hateful = A_JJ;
lexicon.hating = A_VBG;
lexicon.hates = A_VBZ_NNS;
lexicon.hate = A_VBP_NN_VB;
lexicon.hated = A_VBD_JJ_VBN;
lexicon.hauling = A_VBG_NN;
lexicon.haul = A_NN_VB;
lexicon.hauls = A_NNS_VBZ;
lexicon.hauled = A_VBD_VBN;
lexicon.have = A_VBP_JJ_NN_VB_VBN;
lexicon.having = A_VBG;
lexicon.haves = A_NNS;
lexicon.hazards = A_NNS;
lexicon.hazard = A_NN_VB;
lexicon.hazardous = A_JJ;
lexicon.he = A_PRP_VB;
lexicon.head = A_NN_JJ_RB_VB_VBP;
lexicon.headed = A_VBN_VBD;
lexicon.heads = A_NNS_VBZ;
lexicon.heade = A_NN;
lexicon.heading = A_VBG_NN;
lexicon.headings = A_NNS;
lexicon.headache = A_NN;
lexicon.headaches = A_NNS;
lexicon.headlines = A_NNS;
lexicon.headlined = A_VBN_VBD;
lexicon.headline = A_NN;
lexicon.headlining = A_VBG;
lexicon.headquarters = A_NN_NNS;
lexicon.headquarter = A_JJ;
lexicon.headquartered = A_VBN;
lexicon.healing = A_NN_JJ_VBG;
lexicon.heal = A_VB;
lexicon.healed = A_VBN_VBD;
lexicon.healthful = A_JJ;
lexicon.health = A_NN;
lexicon.healthy = A_JJ;
lexicon.hear = A_VB_VBP;
lexicon.hearings = A_NNS;
lexicon.hearing = A_NN_VBG;
lexicon.hears = A_VBZ;
lexicon.heare = A_VBP_VB;
lexicon.heart = A_NN_RB_VB;
lexicon.hearts = A_NNS;
lexicon.heated = A_VBN_JJ_VBD;
lexicon.heat = A_NN_VB_VBP;
lexicon.heatedly = A_RB;
lexicon.heating = A_NN_VBG;
lexicon.heats = A_VBZ;
lexicon.heavens = A_NNS_UH;
lexicon.heavenly = A_JJ;
lexicon.heaven = A_NN;
lexicon.heavily = A_RB;
lexicon.heaviness = A_NN;
lexicon.heavy = A_JJ_NN_RB;
lexicon.heavies = A_NNS;
lexicon.heels = A_NNS;
lexicon.heel = A_NN;
lexicon.heights = A_NNS;
lexicon.height = A_NN;
lexicon.helicopters = A_NNS;
lexicon.helicopter = A_NN;
lexicon.hells = A_NNS;
lexicon.hell = A_NN_UH;
lexicon.hello = A_UH_NN;
lexicon.helmets = A_NNS;
lexicon.helmet = A_NN;
lexicon.helmeted = A_JJ;
lexicon.helpings = A_NNS;
lexicon.helpful = A_JJ;
lexicon.help = A_VB_NN_VBP;
lexicon.helping = A_VBG_NN;
lexicon.helpfulness = A_NN;
lexicon.helps = A_VBZ_VBP_NNS;
lexicon.helpfully = A_RB;
lexicon.helped = A_VBD_VBN_VBP;
lexicon.hence = A_RB;
lexicon.hers = A_PRP_JJ;
lexicon.her = A_PRP$_PRP;
lexicon.herbs = A_NNS;
lexicon.herb = A_NN;
lexicon.here = A_RB;
lexicon.heritage = A_NN;
lexicon.heritages = A_NNS;
lexicon.hero = A_NN;
lexicon.heroes = A_NNS;
lexicon.herself = A_PRP;
lexicon.hesitating = A_VBG;
lexicon.hesitantly = A_RB;
lexicon.hesitatingly = A_RB;
lexicon.hesitate = A_VB_VBP;
lexicon.hesitance = A_NN;
lexicon.hesitancy = A_NN;
lexicon.hesitation = A_NN;
lexicon.hesitates = A_VBZ;
lexicon.hesitated = A_VBD_VBN;
lexicon.hesitant = A_JJ;
lexicon.hey = A_UH;
lexicon.hidden = A_VBN_JJ;
lexicon.hides = A_NNS_VBZ;
lexicon.hide = A_VB_VBP_NN;
lexicon.hiding = A_VBG_NN;
lexicon.highs = A_NNS;
lexicon.highness = A_NN;
lexicon.highly = A_RB;
lexicon.high = A_JJ_NN_RB_RP;
lexicon.highlighted = A_VBN_VBD;
lexicon.highlights = A_VBZ_NNS;
lexicon.highlight = A_VB_VBP_NN;
lexicon.highlighting = A_VBG;
lexicon.highways = A_NNS_JJ;
lexicon.highway = A_NN;
lexicon.hike = A_NN_VB;
lexicon.hiking = A_VBG_NN;
lexicon.hiked = A_VBD_VBN;
lexicon.hikes = A_NNS;
lexicon.hill = A_NN;
lexicon.hills = A_NNS;
lexicon.him = A_PRP;
lexicon.himself = A_PRP;
lexicon.himselfe = A_NN;
lexicon.hinting = A_VBG;
lexicon.hint = A_NN_VBP_VB;
lexicon.hinted = A_VBD_VBN;
lexicon.hints = A_NNS_VBZ;
lexicon.hips = A_NNS;
lexicon.hip = A_NN_JJ;
lexicon.hires = A_VBZ_NNS;
lexicon.hired = A_VBN_JJ_VBD;
lexicon.hiring = A_VBG_NN;
lexicon.hire = A_VB_VBP_NN;
lexicon.his = A_PRP$_PRP;
lexicon.historians = A_NNS;
lexicon.historian = A_NN;
lexicon.historic = A_JJ;
lexicon.historical = A_JJ;
lexicon.historicity = A_NN;
lexicon.historically = A_RB;
lexicon.histories = A_NNS;
lexicon.history = A_NN;
lexicon.hits = A_NNS_VBZ;
lexicon.hitting = A_VBG_NN;
lexicon.hit = A_VBD_JJ_NN_VB_VBN_VBP;
lexicon.hockey = A_NN;
lexicon.hold = A_VB_NN_RB_VBP;
lexicon.holds = A_VBZ_NNS;
lexicon.holdings = A_NNS;
lexicon.holding = A_VBG_JJ_NN;
lexicon.holes = A_NNS;
lexicon.holed = A_VBN_VBD;
lexicon.hole = A_NN_VBP_VB;
lexicon.holidays = A_NNS_VBZ;
lexicon.holiday = A_NN;
lexicon.holy = A_JJ;
lexicon.holies = A_NNS;
lexicon.homes = A_NNS;
lexicon.homing = A_JJ_VBG;
lexicon.home = A_NN_VBP_RB_VB;
lexicon.homely = A_JJ;
lexicon.homelands = A_NNS;
lexicon.homeland = A_NN;
lexicon.homeless = A_JJ_NN;
lexicon.homelessness = A_NN;
lexicon.homework = A_NN;
lexicon.honest = A_JJ;
lexicon.honestly = A_RB;
lexicon.honey = A_NN_VB_UH_JJ;
lexicon.honorably = A_RB;
lexicon.honored = A_VBN_JJ_VBD;
lexicon.honor = A_NN_VBP_VB;
lexicon.honoring = A_VBG;
lexicon.honorable = A_JJ_NN;
lexicon.honors = A_NNS_VBZ_JJ;
lexicon.hook = A_NN_VB;
lexicon.hooks = A_NNS_VBZ;
lexicon.hooking = A_VBG;
lexicon.hooked = A_VBN_JJ_VBD;
lexicon.hopefully = A_RB;
lexicon.hopefuls = A_NNS;
lexicon.hoping = A_VBG;
lexicon.hopes = A_VBZ_NNS;
lexicon.hopeful = A_JJ_NN;
lexicon.hope = A_NN_VB_VBD_VBP;
lexicon.hoped = A_VBD_VBN;
lexicon.horizon = A_NN;
lexicon.horizons = A_NNS;
lexicon.hormonal = A_JJ;
lexicon.hormone = A_NN;
lexicon.hormones = A_NNS;
lexicon.horned = A_JJ;
lexicon.horn = A_NN_VB;
lexicon.horns = A_NNS;
lexicon.horribly = A_RB;
lexicon.horrible = A_JJ_NN;
lexicon.horribles = A_NNS;
lexicon.horror = A_NN;
lexicon.horrors = A_NNS;
lexicon.horses = A_NNS;
lexicon.horse = A_NN;
lexicon.hospitalization = A_NN;
lexicon.hospitalized = A_VBN_JJ;
lexicon.hospital = A_NN;
lexicon.hospitals = A_NNS;
lexicon.hospitable = A_JJ;
lexicon.hospitality = A_NN;
lexicon.hospitalizations = A_NNS;
lexicon.hosts = A_NNS_VBZ;
lexicon.hosting = A_VBG;
lexicon.hoste = A_NN;
lexicon.hosted = A_VBN_JJ_VBD;
lexicon.host = A_NN_VB;
lexicon.hostage = A_NN;
lexicon.hostages = A_NNS;
lexicon.hostilities = A_NNS;
lexicon.hostile = A_JJ_NN;
lexicon.hostility = A_NN;
lexicon.hot = A_JJ;
lexicon.hotly = A_RB;
lexicon.hotels = A_NNS;
lexicon.hotel = A_NN;
lexicon.hour = A_NN;
lexicon.hourly = A_JJ;
lexicon.hours = A_NNS_VBZ;
lexicon.houseful = A_NN;
lexicon.housing = A_NN_VBG_JJ;
lexicon.house = A_NN_VBP_VB;
lexicon.housed = A_VBN_VBD;
lexicon.houses = A_NNS_VBZ;
lexicon.housings = A_NNS;
lexicon.household = A_NN_JJ;
lexicon.householder = A_NN;
lexicon.households = A_NNS;
lexicon.householders = A_NNS;
lexicon.how = A_WRB;
lexicon.howe = A_WRB;
lexicon.however = A_RB_RBR_WRB;
lexicon.hugs = A_NNS;
lexicon.hugged = A_VBD;
lexicon.hug = A_NN_VB_VBP;
lexicon.hugging = A_VBG_NN;
lexicon.huggings = A_NNS;
lexicon.huge = A_JJ;
lexicon.hugely = A_RB;
lexicon.huh = A_UH;
lexicon.humanize = A_VB;
lexicon.humanness = A_NN;
lexicon.humanity = A_NN;
lexicon.humans = A_NNS;
lexicon.humanism = A_NN;
lexicon.humaneness = A_NN;
lexicon.humanly = A_RB;
lexicon.humane = A_JJ;
lexicon.human = A_JJ_NN;
lexicon.humanities = A_NNS;
lexicon.humanizing = A_VBG;
lexicon.humanely = A_RB;
lexicon.humors = A_NNS;
lexicon.humorous = A_JJ;
lexicon.humor = A_NN_VB;
lexicon.hunger = A_NN;
lexicon.hungry = A_JJ;
lexicon.hunt = A_NN_VB_VBP;
lexicon.hunted = A_VBN_VBD_JJ;
lexicon.hunts = A_VBZ_NNS;
lexicon.hunting = A_NN_VBG;
lexicon.hunters = A_NNS;
lexicon.hunter = A_NN;
lexicon.hurricane = A_NN;
lexicon.hurricanes = A_NNS;
lexicon.hurrying = A_VBG_JJ;
lexicon.hurriedly = A_RB;
lexicon.hurried = A_VBD_VBN_JJ;
lexicon.hurries = A_VBZ;
lexicon.hurry = A_NN_VBP_VB;
lexicon.hurt = A_VBN_JJ_NN_VB_VBD_VBP;
lexicon.hurts = A_VBZ;
lexicon.hurting = A_VBG;
lexicon.husbands = A_NNS;
lexicon.husband = A_NN;
lexicon.hypothesis = A_NN;
lexicon.i = A_PRP;
lexicon.icing = A_NN;
lexicon.ice = A_NN_JJ;
lexicon.iced = A_JJ;
lexicon.icon = A_NN;
lexicon.icons = A_NNS;
lexicon.idea = A_NN;
lexicon.ideas = A_NNS;
lexicon.idealized = A_VBN_JJ;
lexicon.ideals = A_NNS;
lexicon.ideal = A_JJ_NN;
lexicon.idealism = A_NN;
lexicon.idealization = A_NN;
lexicon.ideally = A_RB;
lexicon.idealisms = A_NNS;
lexicon.identities = A_NNS;
lexicon.identically = A_RB;
lexicon.identical = A_JJ;
lexicon.identity = A_NN;
lexicon.identifications = A_NNS;
lexicon.identification = A_NN;
lexicon.identifiers = A_NNS;
lexicon.identify = A_VB_VBP;
lexicon.identifying = A_VBG;
lexicon.identified = A_VBN_JJ_VBD;
lexicon.identifies = A_VBZ;
lexicon.identifier = A_NN;
lexicon.identifiable = A_JJ;
lexicon.ideologically = A_RB;
lexicon.ideological = A_JJ;
lexicon.ideology = A_NN;
lexicon.ideologies = A_NNS;
lexicon.if = A_IN;
lexicon.ifs = A_NNS;
lexicon.ignorance = A_NN;
lexicon.ignore = A_VB_VBP;
lexicon.ignorant = A_JJ;
lexicon.ignoring = A_VBG;
lexicon.ignored = A_VBN_VBD;
lexicon.ignores = A_VBZ;
lexicon.ills = A_NNS;
lexicon.ill = A_JJ_NNS_NN_RB;
lexicon.illness = A_NN;
lexicon.illnesses = A_NNS;
lexicon.illegally = A_RB;
lexicon.illegalities = A_NNS;
lexicon.illegality = A_NN;
lexicon.illegal = A_JJ;
lexicon.illusive = A_JJ;
lexicon.illusions = A_NNS_FW;
lexicon.illusiveness = A_NN;
lexicon.illusion = A_NN;
lexicon.illustrators = A_NNS;
lexicon.illustrate = A_VB_VBP;
lexicon.illustrator = A_NN;
lexicon.illustrated = A_VBN_JJ_VBD;
lexicon.illustrative = A_JJ;
lexicon.illustrating = A_VBG;
lexicon.illustration = A_NN;
lexicon.illustrations = A_NNS;
lexicon.illustrates = A_VBZ;
lexicon.imaged = A_VBN;
lexicon.images = A_NNS;
lexicon.image = A_NN_VB;
lexicon.imaging = A_NN_JJ;
lexicon.imagines = A_VBZ;
lexicon.imagined = A_VBN_VBD_JJ;
lexicon.imagine = A_VB_VBP;
lexicon.imaginatively = A_RB;
lexicon.imagination = A_NN;
lexicon.imaginable = A_JJ;
lexicon.imaginations = A_NNS;
lexicon.imaginative = A_JJ;
lexicon.imaginings = A_NNS;
lexicon.imagining = A_VBG;
lexicon.immediate = A_JJ;
lexicon.immediately = A_RB;
lexicon.immigration = A_NN;
lexicon.immigrant = A_NN_JJ;
lexicon.immigrated = A_VBD_VBN;
lexicon.immigrants = A_NNS;
lexicon.immunities = A_NNS;
lexicon.immunization = A_NN;
lexicon.immunity = A_NN;
lexicon.immune = A_JJ_NN;
lexicon.immunized = A_VBN;
lexicon.impacted = A_VBN_JJ;
lexicon.impacts = A_NNS;
lexicon.impaction = A_NN;
lexicon.impact = A_NN_VB;
lexicon.implement = A_VB_VBP;
lexicon.implementing = A_VBG;
lexicon.implements = A_NNS_VBZ;
lexicon.implementation = A_NN;
lexicon.implementer = A_NN;
lexicon.implemented = A_VBN_VBD;
lexicon.implications = A_NNS;
lexicon.implicated = A_VBN;
lexicon.implicate = A_VB;
lexicon.implication = A_NN;
lexicon.implying = A_VBG;
lexicon.implies = A_VBZ;
lexicon.implied = A_VBN_JJ_VBD;
lexicon.imply = A_VB_VBP;
lexicon.importation = A_NN;
lexicon.importantly = A_RB;
lexicon.imported = A_VBN_VBD_JJ;
lexicon.importer = A_NN;
lexicon.import = A_NN_VB_VBP;
lexicon.importing = A_VBG_NN;
lexicon.important = A_JJ;
lexicon.importance = A_NN;
lexicon.imports = A_NNS_VBZ;
lexicon.importers = A_NNS;
lexicon.imposes = A_VBZ;
lexicon.impose = A_VB_VBP;
lexicon.imposing = A_VBG_JJ;
lexicon.imposed = A_VBN_VBD_JJ;
lexicon.impossibly = A_RB;
lexicon.impossible = A_JJ;
lexicon.impossibility = A_NN;
lexicon.impressed = A_VBN_JJ_VBD;
lexicon.impresses = A_VBZ;
lexicon.impresser = A_NN;
lexicon.impressing = A_VBG;
lexicon.impressions = A_NNS;
lexicon.impress = A_VB_NN_VBP;
lexicon.impressive = A_JJ;
lexicon.impressively = A_RB;
lexicon.impression = A_NN;
lexicon.improve = A_VB_VBP;
lexicon.improves = A_VBZ;
lexicon.improving = A_VBG_NN;
lexicon.improved = A_VBN_JJ_VBD;
lexicon.improvement = A_NN;
lexicon.improvements = A_NNS;
lexicon.impulsively = A_RB;
lexicon.impulse = A_NN_JJ;
lexicon.impulsive = A_JJ;
lexicon.impulses = A_NNS;
lexicon.in = A_IN_FW_NN_RB_RP_NNP_RBR_VBD;
lexicon.incentives = A_NNS;
lexicon.incentive = A_NN_JJ;
lexicon.incidents = A_NNS;
lexicon.incidence = A_NN;
lexicon.incident = A_NN_JJ;
lexicon.include = A_VBP_VBN_VB;
lexicon.including = A_VBG;
lexicon.includes = A_VBZ;
lexicon.included = A_VBD_VBN_JJ;
lexicon.income = A_NN;
lexicon.incoming = A_JJ_VBG;
lexicon.incomes = A_NNS;
lexicon.incorporation = A_NN;
lexicon.incorporating = A_JJ_VBG;
lexicon.incorporates = A_VBZ;
lexicon.incorporated = A_VBN_JJ_VBD;
lexicon.incorporate = A_VB_VBP_JJ;
lexicon.increasingly = A_RB;
lexicon.increasing = A_VBG_JJ_NN;
lexicon.increase = A_NN_VB_VBP;
lexicon.increased = A_VBN_JJ_VB_VBD;
lexicon.increases = A_NNS_VBZ;
lexicon.incredibly = A_RB;
lexicon.incredible = A_JJ;
lexicon.indeed = A_RB_UH;
lexicon.independence = A_NN;
lexicon.independent = A_JJ_NN;
lexicon.independents = A_NNS;
lexicon.independently = A_RB;
lexicon.independant = A_JJ;
lexicon.indexers = A_NNS;
lexicon.indexing = A_NN_VBG;
lexicon.indexation = A_NN;
lexicon.index = A_NN_VB;
lexicon.indexer = A_NN;
lexicon.indexes = A_NNS;
lexicon.indexed = A_VBN_JJ;
lexicon.indicative = A_JJ;
lexicon.indicating = A_VBG;
lexicon.indications = A_NNS;
lexicon.indicators = A_NNS;
lexicon.indicated = A_VBD_JJ_VBN;
lexicon.indicates = A_VBZ;
lexicon.indicate = A_VB_VBP;
lexicon.indicator = A_NN;
lexicon.indices = A_NNS;
lexicon.indication = A_NN;
lexicon.indigenous = A_JJ;
lexicon.individual = A_JJ_NN;
lexicon.individualized = A_JJ_VBN;
lexicon.individualism = A_NN;
lexicon.individuals = A_NNS;
lexicon.individuation = A_NN;
lexicon.individually = A_RB;
lexicon.individuality = A_NN;
lexicon.individuate = A_VB;
lexicon.individualizing = A_VBG;
lexicon.industriously = A_RB;
lexicon.industrialize = A_VB;
lexicon.industrialization = A_NN;
lexicon.industrialism = A_NN;
lexicon.industrious = A_JJ;
lexicon.industry = A_NN;
lexicon.industries = A_NNS;
lexicon.industrialized = A_VBN_JJ;
lexicon.industrially = A_RB;
lexicon.industrials = A_NNS_VBZ;
lexicon.industrial = A_JJ;
lexicon.inevitable = A_JJ;
lexicon.inevitably = A_RB;
lexicon.inevitability = A_NN;
lexicon.inevitabilities = A_NNS;
lexicon.infant = A_NN_JJ;
lexicon.infants = A_NNS;
lexicon.infected = A_VBN_VBD_JJ;
lexicon.infecting = A_VBG;
lexicon.infect = A_VB;
lexicon.infection = A_NN;
lexicon.infections = A_NNS;
lexicon.infectious = A_JJ;
lexicon.inflates = A_VBZ;
lexicon.inflated = A_JJ_VBD_VBN;
lexicon.inflate = A_VB;
lexicon.inflating = A_VBG;
lexicon.inflations = A_NNS;
lexicon.inflation = A_NN;
lexicon.influence = A_NN_VB_VBP;
lexicon.influenced = A_VBN_VBD;
lexicon.influences = A_NNS_VBZ;
lexicon.influencing = A_VBG;
lexicon.influential = A_JJ;
lexicon.informal = A_JJ;
lexicon.informally = A_RB;
lexicon.informant = A_NN;
lexicon.informing = A_VBG;
lexicon.inform = A_VB_VBP;
lexicon.informs = A_VBZ;
lexicon.information = A_NN;
lexicon.informality = A_NN;
lexicon.informed = A_VBN_VBD_JJ;
lexicon.informer = A_JJ;
lexicon.informants = A_NNS;
lexicon.informational = A_JJ;
lexicon.informative = A_JJ;
lexicon.infrastructure = A_NN;
lexicon.infrastructural = A_JJ;
lexicon.infrastructures = A_NNS;
lexicon.ingredients = A_NNS;
lexicon.ingredient = A_NN;
lexicon.inherent = A_JJ;
lexicon.inheres = A_VBZ;
lexicon.inherently = A_RB;
lexicon.inherited = A_VBN_VBD_JJ;
lexicon.inheriting = A_VBG;
lexicon.inherits = A_VBZ;
lexicon.inheritance = A_NN;
lexicon.inheritable = A_JJ;
lexicon.inherit = A_VB_VBP;
lexicon.initiated = A_VBN_VBD;
lexicon.initiates = A_VBZ_NNS;
lexicon.initial = A_JJ_NN_VB;
lexicon.initiator = A_NN;
lexicon.initiatives = A_NNS_VBZ;
lexicon.initialing = A_VBG;
lexicon.initiative = A_NN;
lexicon.initially = A_RB;
lexicon.initiate = A_VB_NN_VBP;
lexicon.initialed = A_VBD_VBN;
lexicon.initiating = A_VBG;
lexicon.initiation = A_NN;
lexicon.initials = A_NNS;
lexicon.injure = A_VB_VBP;
lexicon.injuring = A_VBG;
lexicon.injured = A_VBN_VBD_JJ;
lexicon.injures = A_VBZ;
lexicon.injurious = A_JJ;
lexicon.injury = A_NN;
lexicon.injuries = A_NNS;
lexicon.inmate = A_NN;
lexicon.inmates = A_NNS;
lexicon.inner = A_JJ;
lexicon.innocent = A_JJ;
lexicon.innocence = A_NN;
lexicon.innocents = A_NNS;
lexicon.innocently = A_RB;
lexicon.innovate = A_VB;
lexicon.innovativeness = A_NN;
lexicon.innovative = A_JJ;
lexicon.innovator = A_NN;
lexicon.innovation = A_NN;
lexicon.innovated = A_VBD;
lexicon.innovations = A_NNS;
lexicon.innovators = A_NNS;
lexicon.input = A_NN;
lexicon.inputs = A_NNS;
lexicon.inquiries = A_NNS;
lexicon.inquiry = A_NN;
lexicon.insect = A_NN_JJ;
lexicon.insects = A_NNS;
lexicon.insertions = A_NNS;
lexicon.insert = A_VB_VBP_NN;
lexicon.insertion = A_NN;
lexicon.inserts = A_NNS;
lexicon.inserting = A_VBG;
lexicon.inserted = A_VBN_VBD;
lexicon.insiders = A_NNS;
lexicon.inside = A_IN_JJ_NN_RB;
lexicon.insides = A_NNS;
lexicon.insider = A_NN_JJ;
lexicon.insightful = A_JJ;
lexicon.insights = A_NNS;
lexicon.insight = A_NN;
lexicon.insistent = A_JJ;
lexicon.insist = A_VBP_VB;
lexicon.insists = A_VBZ;
lexicon.insistence = A_NN;
lexicon.insisted = A_VBD_VBN;
lexicon.insistently = A_RB;
lexicon.insisting = A_VBG;
lexicon.inspecting = A_VBG;
lexicon.inspection = A_NN;
lexicon.inspected = A_VBN_VBD;
lexicon.inspections = A_NNS;
lexicon.inspect = A_VB_VBP;
lexicon.inspector = A_NN;
lexicon.inspectors = A_NNS_VBZ;
lexicon.inspires = A_VBZ;
lexicon.inspirational = A_JJ;
lexicon.inspirationally = A_RB;
lexicon.inspired = A_VBN_JJ_VBD;
lexicon.inspiring = A_JJ_VBG;
lexicon.inspire = A_VB_VBP;
lexicon.inspirations = A_NNS;
lexicon.inspiration = A_NN;
lexicon.installing = A_VBG;
lexicon.installed = A_VBN_JJ_VBD;
lexicon.installer = A_NN;
lexicon.installations = A_NNS;
lexicon.installment = A_NN_JJ;
lexicon.installation = A_NN;
lexicon.install = A_VB_VBP;
lexicon.installments = A_NNS;
lexicon.instalments = A_NNS;
lexicon.instancy = A_NN;
lexicon.instance = A_NN;
lexicon.instances = A_NNS;
lexicon.instant = A_NN_JJ;
lexicon.instantly = A_RB;
lexicon.instead = A_RB;
lexicon.instinctively = A_RB;
lexicon.instincts = A_NNS;
lexicon.instinct = A_NN;
lexicon.instinctive = A_JJ;
lexicon.institutes = A_NN;
lexicon.institutionally = A_RB;
lexicon.instituting = A_VBG;
lexicon.institute = A_NN_VB;
lexicon.institution = A_NN;
lexicon.institutions = A_NNS;
lexicon.institutional = A_JJ;
lexicon.instituted = A_VBN_VBD;
lexicon.instructions = A_NNS;
lexicon.instructing = A_VBG;
lexicon.instructional = A_JJ;
lexicon.instruct = A_VB_VBP;
lexicon.instruction = A_NN;
lexicon.instructs = A_VBZ;
lexicon.instructed = A_VBN_VBD;
lexicon.instructive = A_JJ;
lexicon.instructor = A_NN;
lexicon.instructors = A_NNS;
lexicon.instrumental = A_JJ_NN;
lexicon.instrumentals = A_NNS;
lexicon.instrumented = A_JJ;
lexicon.instruments = A_NNS;
lexicon.instrumentally = A_RB;
lexicon.instrumentation = A_NN;
lexicon.instrument = A_NN;
lexicon.instrumentalities = A_NNS;
lexicon.insures = A_VBZ;
lexicon.insurer = A_NN;
lexicon.insured = A_VBN_VBD_JJ_NN;
lexicon.insurance = A_NN;
lexicon.insure = A_VB_VBP;
lexicon.insuring = A_VBG;
lexicon.insurability = A_NN;
lexicon.insurers = A_NNS;
lexicon.intactible = A_JJ;
lexicon.intact = A_JJ;
lexicon.integrating = A_VBG;
lexicon.integrity = A_NN;
lexicon.integrators = A_NNS;
lexicon.integrate = A_VB_VBP;
lexicon.integration = A_NN;
lexicon.integral = A_NN_JJ;
lexicon.integrative = A_JJ;
lexicon.integrates = A_VBZ;
lexicon.integrated = A_VBN_JJ;
lexicon.integrals = A_NNS;
lexicon.integrator = A_NN;
lexicon.intellectuals = A_NNS;
lexicon.intellectually = A_RB;
lexicon.intellectual = A_JJ_NN;
lexicon.intellectuality = A_NN;
lexicon.intelligible = A_JJ_NN;
lexicon.intelligence = A_NN;
lexicon.intelligently = A_RB;
lexicon.intelligent = A_JJ;
lexicon.intend = A_VBP_VB;
lexicon.intended = A_VBN_VBD_JJ;
lexicon.intendant = A_NN;
lexicon.intends = A_VBZ;
lexicon.intending = A_VBG;
lexicon.intendants = A_NNS;
lexicon.intensely = A_RB;
lexicon.intensities = A_NNS;
lexicon.intensity = A_NN;
lexicon.intensively = A_RB;
lexicon.intensive = A_JJ_NN;
lexicon.intense = A_JJ;
lexicon.intention = A_NN;
lexicon.intentionally = A_RB;
lexicon.intentional = A_JJ;
lexicon.intent = A_NN_JJ;
lexicon.intently = A_RB;
lexicon.intents = A_NNS;
lexicon.intentioned = A_JJ;
lexicon.intentions = A_NNS;
lexicon.interactions = A_NNS;
lexicon.interactive = A_JJ;
lexicon.interacts = A_VBZ;
lexicon.interaction = A_NN;
lexicon.interacting = A_VBG_NN;
lexicon.interact = A_VBP_VB;
lexicon.interests = A_NNS_VBZ;
lexicon.interestingly = A_RB;
lexicon.interest = A_NN_VBP_VB;
lexicon.interesting = A_JJ;
lexicon.interested = A_JJ_VBD_VBN;
lexicon.interferes = A_VBZ;
lexicon.interfere = A_VB_VBP;
lexicon.interference = A_NN;
lexicon.interior = A_JJ_NN;
lexicon.interiors = A_NNS;
lexicon.internationalism = A_NN;
lexicon.internationals = A_NNS;
lexicon.internment = A_NN;
lexicon.internationally = A_RB;
lexicon.intern = A_NN_VB;
lexicon.internalized = A_VBN;
lexicon.internally = A_RB;
lexicon.interned = A_VBN;
lexicon.international = A_JJ_NN;
lexicon.interning = A_VBG;
lexicon.internal = A_JJ;
lexicon.interns = A_NNS;
lexicon.interne = A_FW_NN;
lexicon.interpreted = A_VBN_VBD;
lexicon.interpreter = A_NN;
lexicon.interprets = A_VBZ;
lexicon.interpretation = A_NN;
lexicon.interpretable = A_JJ;
lexicon.interpreters = A_NNS;
lexicon.interpretive = A_JJ;
lexicon.interpretations = A_NNS;
lexicon.interpret = A_VB_VBP;
lexicon.interpretative = A_JJ;
lexicon.interpreting = A_VBG;
lexicon.interruptions = A_NNS;
lexicon.interrupts = A_VBZ;
lexicon.interrupted = A_VBN_JJ_VBD;
lexicon.interruption = A_NN;
lexicon.interrupt = A_VB_VBP;
lexicon.interrupting = A_VBG;
lexicon.intervals = A_NNS;
lexicon.interval = A_NN;
lexicon.intervention = A_NN;
lexicon.interventions = A_NNS;
lexicon.interviewing = A_VBG_NN;
lexicon.interview = A_NN_VB;
lexicon.interviewers = A_NNS;
lexicon.interviewed = A_VBN_VBD;
lexicon.interviewer = A_NN;
lexicon.interviews = A_NNS_VBZ;
lexicon.intimations = A_NNS;
lexicon.intimate = A_JJ_NN_VB;
lexicon.intimation = A_NN;
lexicon.intimated = A_VBD_VBN;
lexicon.intimal = A_JJ;
lexicon.intimately = A_RB;
lexicon.intimating = A_VBG;
lexicon.into = A_IN_RP;
lexicon.introduces = A_VBZ;
lexicon.introduced = A_VBN_VBD;
lexicon.introduce = A_VB_VBP;
lexicon.introducing = A_VBG;
lexicon.introductions = A_NNS;
lexicon.introduction = A_NN;
lexicon.invading = A_VBG;
lexicon.invade = A_VB_VBP;
lexicon.invaders = A_NNS;
lexicon.invader = A_NN;
lexicon.invades = A_VBZ;
lexicon.invaded = A_VBD_VBN;
lexicon.invasion = A_NN;
lexicon.invasions = A_NNS;
lexicon.invasive = A_JJ;
lexicon.inventively = A_RB;
lexicon.invents = A_VBZ;
lexicon.inventions = A_NNS;
lexicon.inventiveness = A_NN;
lexicon.inventing = A_VBG;
lexicon.invention = A_NN;
lexicon.invented = A_VBN_VBD;
lexicon.invent = A_VB_VBP;
lexicon.inventive = A_JJ;
lexicon.inventories = A_NNS;
lexicon.inventory = A_NN;
lexicon.invested = A_VBN_VBD;
lexicon.invests = A_VBZ;
lexicon.investment = A_NN_JJ;
lexicon.investing = A_VBG_JJ_NN;
lexicon.investments = A_NNS;
lexicon.investable = A_JJ;
lexicon.invest = A_VB_VBP;
lexicon.investigating = A_VBG_NN;
lexicon.investigator = A_NN;
lexicon.investigations = A_NNS;
lexicon.investigational = A_JJ;
lexicon.investigation = A_NN;
lexicon.investigated = A_VBN_VBD;
lexicon.investigates = A_VBZ;
lexicon.investigative = A_JJ;
lexicon.investigators = A_NNS;
lexicon.investigate = A_VB_VBP;
lexicon.investor = A_NN;
lexicon.investors = A_NNS_NNPS;
lexicon.invisibly = A_RB;
lexicon.invisible = A_JJ;
lexicon.invisibles = A_NNS;
lexicon.invited = A_VBN_VBD;
lexicon.invites = A_VBZ;
lexicon.invitations = A_NNS;
lexicon.invite = A_VB_VBP_NN;
lexicon.invitation = A_NN;
lexicon.invitational = A_JJ;
lexicon.inviting = A_VBG_JJ;
lexicon.involve = A_VB_VBP;
lexicon.involvements = A_NNS;
lexicon.involving = A_VBG;
lexicon.involved = A_VBN_VBD_JJ_VB;
lexicon.involves = A_VBZ;
lexicon.involvement = A_NN;
lexicon.ironic = A_JJ;
lexicon.ironically = A_RB;
lexicon.irons = A_NNS_VBZ;
lexicon.ironed = A_VBN;
lexicon.ironing = A_VBG_NN;
lexicon.ironical = A_JJ;
lexicon.iron = A_NN_VB;
lexicon.irony = A_NN;
lexicon.ironies = A_NNS;
lexicon.is = A_VBZ;
lexicon.islander = A_NN;
lexicon.islands = A_NNS_VBZ;
lexicon.island = A_NN;
lexicon.islanders = A_NNS;
lexicon.isolating = A_VBG_JJ;
lexicon.isolation = A_NN;
lexicon.isolate = A_VB_VBP;
lexicon.isolated = A_VBN_JJ_VBD;
lexicon.isolates = A_VBZ;
lexicon.issue = A_NN_VBP_VB;
lexicon.issued = A_VBN_VBD_JJ;
lexicon.issues = A_NNS_VBZ;
lexicon.issuing = A_VBG;
lexicon.it = A_PRP;
lexicon.its = A_PRP$;
lexicon.itemized = A_VBN;
lexicon.item = A_NN;
lexicon.itemizing = A_VBG;
lexicon.itemize = A_VB;
lexicon.itemization = A_NN;
lexicon.items = A_NNS_VBZ;
lexicon.itself = A_PRP;
lexicon.jacket = A_NN;
lexicon.jackets = A_NNS;
lexicon.jacketed = A_JJ_VBN;
lexicon.jailed = A_VBN_VBD_JJ;
lexicon.jails = A_NNS;
lexicon.jail = A_NN_VB;
lexicon.jailing = A_VBG;
lexicon.jarred = A_VBD_VBN;
lexicon.jar = A_NN;
lexicon.jars = A_NNS;
lexicon.jarring = A_VBG_JJ;
lexicon.jarringly = A_RB;
lexicon.jaw = A_NN;
lexicon.jaws = A_NNS;
lexicon.jazz = A_NN;
lexicon.jeans = A_NNS;
lexicon.jetting = A_VBG;
lexicon.jet = A_NN_VBP;
lexicon.jets = A_NNS;
lexicon.jewelry = A_NN;
lexicon.job = A_NN;
lexicon.jobs = A_NNS;
lexicon.joining = A_VBG_NN;
lexicon.join = A_VB_VBP;
lexicon.joined = A_VBD_VBN;
lexicon.joins = A_VBZ;
lexicon.jointly = A_RB;
lexicon.joint = A_JJ_NN;
lexicon.joints = A_NNS;
lexicon.joke = A_NN_VBP_VB;
lexicon.jokes = A_NNS_VBZ;
lexicon.joked = A_VBD;
lexicon.jokingly = A_RB;
lexicon.joking = A_VBG;
lexicon.journal = A_NN;
lexicon.journalism = A_NN;
lexicon.journals = A_NNS;
lexicon.journalistic = A_JJ;
lexicon.journalist = A_NN;
lexicon.journalists = A_NNS;
lexicon.journalistically = A_RB;
lexicon.journeys = A_NNS;
lexicon.journeying = A_VBG;
lexicon.journey = A_NN_VB;
lexicon.journeyed = A_VBD;
lexicon.joy = A_NN;
lexicon.joyfully = A_RB;
lexicon.joys = A_NNS;
lexicon.joyful = A_JJ;
lexicon.judging = A_VBG_NN;
lexicon.judges = A_NNS_VBZ;
lexicon.judged = A_VBN_VBD;
lexicon.judge = A_NN_VB_VBP;
lexicon.judgmental = A_JJ;
lexicon.judgments = A_NNS;
lexicon.judgment = A_NN;
lexicon.judiciously = A_RB;
lexicon.judicial = A_JJ;
lexicon.judicially = A_RB;
lexicon.judicious = A_JJ;
lexicon.juice = A_NN;
lexicon.juices = A_NNS;
lexicon.jump = A_NN_VBP_JJ_VB;
lexicon.jumps = A_NNS_VBZ;
lexicon.jumping = A_VBG_NN;
lexicon.jumped = A_VBD_VBN;
lexicon.jungle = A_NN;
lexicon.jungles = A_NNS;
lexicon.juniors = A_NNS;
lexicon.junior = A_JJ_NN;
lexicon.jurisdictional = A_JJ;
lexicon.jurisdictions = A_NNS;
lexicon.jurisdiction = A_NN;
lexicon.jurors = A_NNS;
lexicon.juror = A_NN;
lexicon.juries = A_NNS;
lexicon.jury = A_NN;
lexicon.justly = A_RB;
lexicon.justness = A_NN;
lexicon.juste = A_FW;
lexicon.just = A_RB_JJ_RP;
lexicon.justices = A_NNS;
lexicon.justice = A_NN;
lexicon.justify = A_VB_VBP;
lexicon.justifiable = A_JJ;
lexicon.justifiably = A_RB;
lexicon.justifying = A_VBG;
lexicon.justifies = A_VBZ;
lexicon.justified = A_VBN_VBD_JJ;
lexicon.keep = A_VB_NN_VBP;
lexicon.keeps = A_VBZ_NNS;
lexicon.keeping = A_VBG_NN;
lexicon.key = A_JJ_NN_VB;
lexicon.keying = A_VBG;
lexicon.keys = A_NNS;
lexicon.keyed = A_VBN_JJ;
lexicon.kicking = A_VBG_NN;
lexicon.kick = A_NN_VB_VBP;
lexicon.kicked = A_VBD_VBN;
lexicon.kicks = A_VBZ_NNS;
lexicon.kids = A_NNS_VBZ;
lexicon.kid = A_NN_VB;
lexicon.kidding = A_VBG;
lexicon.killed = A_VBN_VBD;
lexicon.killing = A_VBG_JJ_NN;
lexicon.killings = A_NNS;
lexicon.kills = A_VBZ_NNS;
lexicon.kill = A_VB_VBP_NN;
lexicon.killer = A_NN;
lexicon.killers = A_NNS;
lexicon.kind = A_NN_JJ_RB;
lexicon.kinds = A_NNS;
lexicon.kindnesses = A_NNS;
lexicon.kindness = A_NN;
lexicon.kindly = A_RB_JJ;
lexicon.king = A_NN;
lexicon.kings = A_NNS;
lexicon.kingdom = A_NN;
lexicon.kingdoms = A_NNS;
lexicon.kisses = A_NNS_VBZ;
lexicon.kissed = A_VBD_VBN;
lexicon.kissing = A_VBG;
lexicon.kissings = A_NNS;
lexicon.kiss = A_NN_VB_VBP;
lexicon.kit = A_NN;
lexicon.kits = A_NNS;
lexicon.kitchen = A_NN;
lexicon.kitchens = A_NNS;
lexicon.knee = A_NN;
lexicon.knees = A_NNS;
lexicon.kneels = A_VBZ;
lexicon.kneeled = A_VBD;
lexicon.kneel = A_VB;
lexicon.kneeling = A_VBG;
lexicon.knife = A_NN;
lexicon.knocked = A_VBD_VBN;
lexicon.knock = A_VB_VBP_NN;
lexicon.knocks = A_VBZ_NNS;
lexicon.knocking = A_VBG_NN;
lexicon.knowed = A_VBN;
lexicon.knowing = A_VBG_JJ_NN;
lexicon.knowingly = A_RB;
lexicon.knows = A_VBZ;
lexicon.know = A_VB_NN_VBP;
lexicon.knowledge = A_NN;
lexicon.knowledgeable = A_JJ;
lexicon.known = A_VBN_JJ;
lexicon.knowns = A_NNS;
lexicon.labs = A_NNS;
lexicon.lab = A_NN;
lexicon.label = A_NN_VB_VBP;
lexicon.labeling = A_VBG_NN;
lexicon.labels = A_NNS_VBZ;
lexicon.labeled = A_VBN_VBD;
lexicon.labelled = A_VBN_VBD;
lexicon.laborer = A_NN;
lexicon.labored = A_VBD_VBN_JJ;
lexicon.laborers = A_NNS;
lexicon.laboring = A_VBG;
lexicon.labors = A_NNS_VBZ;
lexicon.labor = A_NN_VBP_VB;
lexicon.laboratory = A_NN;
lexicon.laboratories = A_NNS;
lexicon.lacked = A_VBD_VBN;
lexicon.lack = A_NN_VB_VBP;
lexicon.lacks = A_VBZ;
lexicon.lacking = A_VBG_JJ;
lexicon.ladder = A_NN;
lexicon.laddered = A_JJ;
lexicon.ladies = A_NNS;
lexicon.lady = A_NN;
lexicon.lakes = A_NNS;
lexicon.lake = A_NN;
lexicon.lamps = A_NNS;
lexicon.lamp = A_NN;
lexicon.landing = A_NN_VBG;
lexicon.lands = A_NNS_VBZ;
lexicon.landed = A_VBD_VBN;
lexicon.land = A_NN_VBP_VB;
lexicon.landes = A_NNS;
lexicon.landings = A_NNS;
lexicon.landmarks = A_NNS;
lexicon.landmark = A_NN_JJ;
lexicon.landscape = A_NN;
lexicon.landscaped = A_VBN_JJ;
lexicon.landscapes = A_NNS;
lexicon.landscapers = A_NNS;
lexicon.landscaping = A_NN_VBG;
lexicon.lane = A_NN;
lexicon.lanes = A_NNS;
lexicon.languages = A_NNS_VBZ;
lexicon.language = A_NN;
lexicon.lapping = A_VBG;
lexicon.lap = A_NN_VBP;
lexicon.lapped = A_VBD_VBN;
lexicon.laps = A_NNS_VBZ;
lexicon.largely = A_RB_VBN;
lexicon.large = A_JJ_RB;
lexicon.laser = A_NN;
lexicon.lasers = A_NNS;
lexicon.lasting = A_VBG_JJ;
lexicon.lasts = A_VBZ;
lexicon.lastly = A_RB;
lexicon.last = A_JJ_NN_RB_VB_VBP;
lexicon.lasted = A_VBD_VBN;
lexicon.lately = A_RB;
lexicon.late = A_JJ_RB;
lexicon.later = A_RB_JJ_RP_JJR_RBR;
lexicon.lateral = A_JJ;
lexicon.latest = A_JJS_JJ;
lexicon.latter = A_NN_JJ;
lexicon.laugh = A_NN_VBP_VB;
lexicon.laughingly = A_RB;
lexicon.laughs = A_VBZ_NNS;
lexicon.laughing = A_VBG_JJ_NN;
lexicon.laughed = A_VBD_VBN;
lexicon.laughter = A_NN;
lexicon.launchings = A_NNS;
lexicon.launches = A_VBZ_NNS;
lexicon.launched = A_VBN_VBD_VB;
lexicon.launch = A_VB_NN;
lexicon.launching = A_VBG_NN;
lexicon.laundry = A_NN;
lexicon.laundries = A_NNS;
lexicon.lawful = A_JJ;
lexicon.laws = A_NNS;
lexicon.law = A_NN;
lexicon.lawfully = A_RB;
lexicon.lawmaking = A_JJ_NN;
lexicon.lawmakers = A_NNS;
lexicon.lawmaker = A_NN;
lexicon.lawn = A_NN;
lexicon.lawns = A_NNS;
lexicon.lawsuit = A_NN;
lexicon.lawsuits = A_NNS;
lexicon.lawyer = A_NN;
lexicon.lawyering = A_NN;
lexicon.lawyers = A_NNS;
lexicon.laying = A_VBG_NN;
lexicon.lays = A_VBZ_NNS;
lexicon.lay = A_VBD_VBP_JJ_VB;
lexicon.layered = A_VBN;
lexicon.layering = A_VBG_NN;
lexicon.layer = A_NN;
lexicon.layers = A_NNS;
lexicon.leading = A_VBG_JJ_NN;
lexicon.leads = A_VBZ_NNS;
lexicon.lead = A_VB_VBN_VBP_JJ_NN;
lexicon.leadings = A_NNS;
lexicon.leaded = A_JJ;
lexicon.leaders = A_NNS;
lexicon.leader = A_NN;
lexicon.leadership = A_NN;
lexicon.leafed = A_VBD;
lexicon.leafing = A_VBG;
lexicon.leaf = A_NN;
lexicon.league = A_NN;
lexicon.leagues = A_NNS;
lexicon.leagued = A_VBN;
lexicon.leans = A_VBZ;
lexicon.leaning = A_VBG;
lexicon.lean = A_JJ_VBP_VB;
lexicon.leaned = A_VBD_VBN;
lexicon.leaped = A_VBD_VBN;
lexicon.leaping = A_VBG;
lexicon.leap = A_NN_VBP_VB;
lexicon.leaps = A_NNS_VBZ;
lexicon.learn = A_VB_VBP;
lexicon.learns = A_VBZ;
lexicon.learning = A_VBG_NN;
lexicon.learned = A_VBD_VBN_JJ_NN;
lexicon.least = A_JJS_RBS_JJ;
lexicon.leather = A_NN_JJ;
lexicon.leathers = A_NNS;
lexicon.leathered = A_JJ;
lexicon.leaves = A_VBZ_JJ_NNS;
lexicon.leavings = A_NNS;
lexicon.leaving = A_VBG_NN;
lexicon.leave = A_VB_NN_VBP;
lexicon.lecturers = A_NNS;
lexicon.lecture = A_NN_VBP_VB;
lexicon.lecturer = A_NN;
lexicon.lectures = A_NNS_VBZ;
lexicon.lectured = A_VBD_VBN;
lexicon.lecturing = A_VBG_NN;
lexicon.left = A_VBN_JJ_NN_RB_VBD;
lexicon.legs = A_NNS;
lexicon.legged = A_JJ;
lexicon.leggings = A_NNS;
lexicon.leg = A_NN;
lexicon.legacy = A_NN;
lexicon.legacies = A_NNS;
lexicon.legalized = A_VBN;
lexicon.legalizing = A_VBG;
lexicon.legalize = A_VB_VBP;
lexicon.legalization = A_NN;
lexicon.legal = A_JJ;
lexicon.legality = A_NN;
lexicon.legally = A_RB;
lexicon.legends = A_NNS;
lexicon.legend = A_NN;
lexicon.legislative = A_JJ;
lexicon.legislated = A_VBN_VBD;
lexicon.legislates = A_VBZ;
lexicon.legislator = A_NN;
lexicon.legislation = A_NN;
lexicon.legislate = A_VB;
lexicon.legislating = A_VBG_NN;
lexicon.legislatively = A_RB;
lexicon.legislators = A_NNS;
lexicon.legislatures = A_NNS;
lexicon.legislature = A_NN;
lexicon.legitimately = A_RB;
lexicon.legitimize = A_VB;
lexicon.legitimating = A_VBG;
lexicon.legitimate = A_JJ;
lexicon.legitimizes = A_VBZ;
lexicon.legitimized = A_VBN;
lexicon.lemon = A_NN_JJ;
lexicon.lemons = A_NNS;
lexicon.lending = A_NN_VBG_JJ;
lexicon.lends = A_VBZ;
lexicon.lend = A_VB_VBP;
lexicon.length = A_NN;
lexicon.lengths = A_NNS;
lexicon.lens = A_NN;
lexicon.len = A_NN;
lexicon.less = A_JJR_JJS_CC_RB_RBR_RBS;
lexicon.lessons = A_NNS;
lexicon.lesson = A_NN;
lexicon.lets = A_VBZ;
lexicon.let = A_VB_VBD_VBN_VBP_NN;
lexicon.letting = A_VBG_NN;
lexicon.letters = A_NNS;
lexicon.lettering = A_NN;
lexicon.letter = A_NN;
lexicon.lettered = A_VBD;
lexicon.leveled = A_VBD_VBN;
lexicon.levels = A_NNS_VBZ;
lexicon.level = A_NN_VBP_JJ_VB;
lexicon.levelled = A_VBN;
lexicon.leveling = A_NN_VBG;
lexicon.liability = A_NN;
lexicon.liabilities = A_NNS;
lexicon.liberalizing = A_VBG;
lexicon.liberal = A_JJ_NN;
lexicon.liberalized = A_VBN_JJ_VBD;
lexicon.liberalize = A_VB_VBP;
lexicon.liberated = A_VBN_JJ_VBD;
lexicon.liberals = A_NNS;
lexicon.liberalization = A_NN;
lexicon.liberalism = A_NN;
lexicon.liberate = A_VB;
lexicon.liberally = A_RB;
lexicon.liberation = A_NN;
lexicon.liberalizations = A_NNS;
lexicon.liberality = A_NN;
lexicon.liberating = A_VBG_JJ;
lexicon.libertie = A_NN;
lexicon.liberty = A_NN;
lexicon.liberties = A_NNS;
lexicon.libraries = A_NNS;
lexicon.library = A_NN;
lexicon.license = A_NN_VBP_VB;
lexicon.licensed = A_VBN_VBD_JJ;
lexicon.licenses = A_NNS_VBZ;
lexicon.licensing = A_NN_VBG_JJ;
lexicon.lid = A_NN;
lexicon.lids = A_NNS;
lexicon.lying = A_VBG_NN;
lexicon.lie = A_VB_VBP_NN;
lexicon.lied = A_VBD;
lexicon.lies = A_VBZ_NNS;
lexicon.life = A_NN_RB;
lexicon.lifes = A_NNS;
lexicon.lifestyle = A_NN;
lexicon.lifestyles = A_NNS;
lexicon.lifetime = A_NN_JJ;
lexicon.lifts = A_VBZ_NNS;
lexicon.lift = A_VB_NN_VBP;
lexicon.lifted = A_VBD_VBN;
lexicon.lifting = A_VBG_JJ_NN;
lexicon.lightly = A_RB;
lexicon.lighting = A_NN_VBG;
lexicon.light = A_NN_JJ_RB_VB_VBP;
lexicon.lights = A_NNS_VBZ;
lexicon.lightness = A_NN;
lexicon.lighted = A_VBN_VBD_JJ;
lexicon.lightning = A_NN;
lexicon.liked = A_VBD_VBN;
lexicon.like = A_IN_JJ_NN_VB_VBP;
lexicon.likee = A_VB;
lexicon.likes = A_VBZ_NNS_NN;
lexicon.likely = A_JJ_RB;
lexicon.likeness = A_NN;
lexicon.liking = A_NN_VBG;
lexicon.likelihood = A_NN;
lexicon.likewise = A_RB;
lexicon.limb = A_NN;
lexicon.limbs = A_NNS;
lexicon.limits = A_NNS_VBP_VBZ;
lexicon.limitations = A_NNS;
lexicon.limit = A_NN_VB_VBP;
lexicon.limitation = A_NN;
lexicon.limited = A_JJ_VBD_VBN;
lexicon.limiting = A_VBG;
lexicon.lines = A_NNS_VBZ;
lexicon.lining = A_VBG_NN;
lexicon.line = A_NN_VBP_RB_VB;
lexicon.lined = A_VBN_VBD_JJ;
lexicon.links = A_NNS_VBZ_NN;
lexicon.linked = A_VBN_VBD_JJ;
lexicon.link = A_NN_VB_VBP;
lexicon.linking = A_VBG_NN;
lexicon.lion = A_NN;
lexicon.lions = A_NNS;
lexicon.lips = A_NNS;
lexicon.lip = A_NN_JJ;
lexicon.liquidating = A_VBG_JJ_NN;
lexicon.liquidations = A_NNS;
lexicon.liquidated = A_VBN_VBD;
lexicon.liquidator = A_NN;
lexicon.liquid = A_JJ_NN;
lexicon.liquidators = A_NNS;
lexicon.liquidate = A_VB;
lexicon.liquidities = A_NNS;
lexicon.liquids = A_NNS;
lexicon.liquidity = A_NN;
lexicon.liquidation = A_NN;
lexicon.listings = A_NNS;
lexicon.lists = A_NNS_VBZ;
lexicon.liste = A_FW;
lexicon.listed = A_VBN_VBD_JJ;
lexicon.list = A_NN_VBP_VB;
lexicon.listing = A_NN_VBG;
lexicon.listens = A_VBZ;
lexicon.listening = A_VBG_NN;
lexicon.listen = A_VB_VBP;
lexicon.listeners = A_NNS;
lexicon.listened = A_VBD_VBN;
lexicon.listener = A_NN;
lexicon.literal = A_JJ;
lexicon.literally = A_RB;
lexicon.liters = A_NNS;
lexicon.literalism = A_NN;
lexicon.literate = A_JJ;
lexicon.liter = A_NN;
lexicon.literalness = A_NN;
lexicon.literary = A_JJ_NN;
lexicon.literatures = A_NNS;
lexicon.literature = A_NN;
lexicon.little = A_JJ_RB;
lexicon.lively = A_JJ_RB;
lexicon.live = A_VB_RB_VBP_JJ;
lexicon.lives = A_NNS_VBZ;
lexicon.living = A_VBG_JJ_NN;
lexicon.lived = A_VBD_VBN_VB;
lexicon.liver = A_NN;
lexicon.livers = A_NNS;
lexicon.loaded = A_VBN_JJ_VBD;
lexicon.loading = A_NN_VBG;
lexicon.loads = A_NNS;
lexicon.load = A_NN_VB_VBP;
lexicon.loadings = A_NNS;
lexicon.loaned = A_VBN_VBD;
lexicon.loan = A_NN_VB;
lexicon.loans = A_NNS_VBZ;
lexicon.lobbying = A_VBG_JJ_NN;
lexicon.lobbied = A_VBD_VBN;
lexicon.lobby = A_NN_VB;
lexicon.lobbies = A_NNS;
lexicon.localized = A_JJ_VBN;
lexicon.locale = A_NN;
lexicon.locals = A_NNS;
lexicon.localize = A_VB;
lexicon.localisms = A_NNS;
lexicon.localities = A_NNS;
lexicon.locally = A_RB;
lexicon.localism = A_NN;
lexicon.locales = A_NNS;
lexicon.local = A_JJ_NN;
lexicon.localization = A_NN;
lexicon.locality = A_NN;
lexicon.location = A_NN;
lexicon.locate = A_VB_VBP;
lexicon.locations = A_NNS;
lexicon.located = A_VBN_JJ_VBD;
lexicon.locates = A_VBZ;
lexicon.locating = A_VBG;
lexicon.locked = A_VBN_JJ_VBD;
lexicon.locks = A_NNS_VBZ;
lexicon.lock = A_VB_VBP_JJ_NN;
lexicon.locking = A_JJ_VBG;
lexicon.logging = A_NN_VBG_JJ;
lexicon.logged = A_VBN_VBD;
lexicon.logs = A_NNS_VBZ;
lexicon.log = A_NN_VB_VBP;
lexicon.logical = A_JJ;
lexicon.logic = A_NN;
lexicon.logically = A_RB;
lexicon.lone = A_JJ;
lexicon.lonely = A_JJ;
lexicon.longs = A_VBZ;
lexicon.long = A_JJ_VBP_RB;
lexicon.longings = A_NNS;
lexicon.longed = A_VBD_VBN;
lexicon.longing = A_NN_VBG;
lexicon.longtime = A_JJ_NN;
lexicon.look = A_VB_NN_VBP;
lexicon.looks = A_VBZ_NNS_NN;
lexicon.looked = A_VBD_VBN;
lexicon.looking = A_VBG_JJ_NN;
lexicon.loops = A_NNS_VBZ;
lexicon.loop = A_NN;
lexicon.looped = A_VBD;
lexicon.loose = A_JJ_RB_VB;
lexicon.looseness = A_NN;
lexicon.loosely = A_RB;
lexicon.loses = A_VBZ_NNS;
lexicon.losing = A_VBG_JJ_NN;
lexicon.lose = A_VB_VBP;
lexicon.losses = A_NNS;
lexicon.loss = A_NN;
lexicon.lost = A_VBD_VBN_JJ;
lexicon.lots = A_NNS;
lexicon.lot = A_NN_RB_JJ;
lexicon.loudly = A_RB;
lexicon.loud = A_JJ_RB;
lexicon.lovely = A_JJ;
lexicon.lovelies = A_NNS;
lexicon.lovingly = A_RB;
lexicon.love = A_NN_NNP_VB_VBP;
lexicon.loving = A_JJ_VBG;
lexicon.loved = A_VBD_VBN_JJ;
lexicon.loves = A_VBZ_NNS;
lexicon.lovering = A_VBG;
lexicon.lovers = A_NNS;
lexicon.lover = A_NN;
lexicon.lows = A_NNS;
lexicon.low = A_JJ_NN_RB_RP;
lexicon.lower = A_JJR_RBR_VBP_JJ_RB_VB;
lexicon.lowered = A_VBD_VBN_JJ;
lexicon.lowering = A_VBG_NN;
lexicon.lowers = A_VBZ_NNS;
lexicon.loyal = A_JJ;
lexicon.loyalty = A_NN;
lexicon.loyalties = A_NNS;
lexicon.luck = A_NN;
lexicon.lucked = A_VBD;
lexicon.lucks = A_NNS;
lexicon.lucky = A_JJ;
lexicon.lunch = A_NN_VB;
lexicon.lunched = A_VBN;
lexicon.lunches = A_NNS;
lexicon.lunges = A_VBZ;
lexicon.lunged = A_VBD;
lexicon.lunging = A_VBG;
lexicon.lung = A_NN;
lexicon.lunge = A_VB;
lexicon.lungs = A_NNS;
lexicon.machines = A_NNS;
lexicon.machine = A_NN;
lexicon.machining = A_NN;
lexicon.machinations = A_NNS;
lexicon.madness = A_NN;
lexicon.madly = A_RB;
lexicon.mad = A_JJ;
lexicon.magazine = A_NN;
lexicon.magazines = A_NNS;
lexicon.magically = A_RB;
lexicon.magic = A_NN_JJ;
lexicon.magical = A_JJ;
lexicon.magnetic = A_JJ;
lexicon.magnetized = A_VBN;
lexicon.magnetisms = A_NNS;
lexicon.magnet = A_NN;
lexicon.magnets = A_NNS;
lexicon.magnetically = A_RB;
lexicon.magnetism = A_NN;
lexicon.magnetics = A_NNS;
lexicon.magnitudes = A_NNS;
lexicon.magnitude = A_NN;
lexicon.mailings = A_NNS;
lexicon.mail = A_NN_VB_VBP;
lexicon.mails = A_NNS;
lexicon.mailed = A_VBN_VBD_JJ;
lexicon.mailing = A_NN_VBG;
lexicon.mains = A_NNS;
lexicon.main = A_JJ_NN;
lexicon.mainly = A_RB;
lexicon.mainstream = A_NN_JJ_RB;
lexicon.maintaining = A_VBG;
lexicon.maintainence = A_NN;
lexicon.maintains = A_VBZ;
lexicon.maintain = A_VB_VBP;
lexicon.maintained = A_VBN_VBD;
lexicon.maintenance = A_NN;
lexicon.majors = A_NNS;
lexicon.majored = A_VBN;
lexicon.majority = A_NN_JJ;
lexicon.major = A_JJ_NN_VBP;
lexicon.majoring = A_VBG;
lexicon.majorities = A_NNS;
lexicon.makes = A_VBZ_NNS_NN;
lexicon.makings = A_NNS;
lexicon.making = A_VBG_NN;
lexicon.make = A_VB_NN_VBP;
lexicon.maker = A_NN;
lexicon.makers = A_NNS;
lexicon.makeup = A_NN;
lexicon.male = A_JJ_NN;
lexicon.males = A_NNS;
lexicon.maleness = A_NN;
lexicon.malls = A_NNS;
lexicon.mall = A_NN;
lexicon.manning = A_VBG;
lexicon.mans = A_VBZ;
lexicon.manly = A_JJ;
lexicon.manned = A_JJ_VBD_VBN;
lexicon.man = A_NN_JJ_VB_UH;
lexicon.manage = A_VB_VBP;
lexicon.managers = A_NNS;
lexicon.managements = A_NNS;
lexicon.manageability = A_NN;
lexicon.manageable = A_JJ;
lexicon.management = A_NN;
lexicon.managing = A_VBG_JJ_NN;
lexicon.managment = A_NN;
lexicon.managed = A_VBD_VBN_JJ;
lexicon.manager = A_NN;
lexicon.manages = A_VBZ;
lexicon.mandating = A_VBG;
lexicon.mandates = A_NNS_VBZ;
lexicon.mandate = A_NN_VB;
lexicon.mandated = A_VBN_VBD;
lexicon.manipulator = A_NN;
lexicon.manipulate = A_VB_VBP;
lexicon.manipulated = A_VBN_VBD;
lexicon.manipulative = A_JJ;
lexicon.manipulations = A_NNS;
lexicon.manipulation = A_NN;
lexicon.manipulators = A_NNS;
lexicon.manipulates = A_VBZ;
lexicon.manipulating = A_VBG;
lexicon.manners = A_NNS;
lexicon.mannerism = A_NN;
lexicon.manner = A_NN;
lexicon.mannerisms = A_NNS;
lexicon.mannered = A_JJ;
lexicon.mansions = A_NNS;
lexicon.mansion = A_NN;
lexicon.manuals = A_NNS;
lexicon.manual = A_JJ_NN;
lexicon.manually = A_RB;
lexicon.manufacture = A_VB_NN_VBP;
lexicon.manufacturing = A_NN_VBG;
lexicon.manufacturers = A_NNS;
lexicon.manufactures = A_VBZ_NNS;
lexicon.manufactured = A_VBN_VBD_JJ;
lexicon.manufacturer = A_NN;
lexicon.many = A_JJ_DT_NN_RB_VB_NNS_PDT;
lexicon.maps = A_NNS;
lexicon.map = A_NN_VBP_VB;
lexicon.mapped = A_VBN_VBD;
lexicon.mapping = A_NN_VBG;
lexicon.marble = A_NN;
lexicon.marbles = A_NNS;
lexicon.march = A_NN_VBP_VB;
lexicon.marches = A_NNS_VBZ;
lexicon.marched = A_VBD_VBN;
lexicon.marching = A_VBG_NN;
lexicon.marginality = A_NN;
lexicon.marginalizing = A_VBG;
lexicon.marginally = A_RB;
lexicon.marginal = A_JJ;
lexicon.margined = A_VBN;
lexicon.margining = A_VBG;
lexicon.margin = A_NN_JJ;
lexicon.margins = A_NNS;
lexicon.marinated = A_VBN;
lexicon.marine = A_NN_JJ;
lexicon.marines = A_NNS;
lexicon.mariner = A_NN;
lexicon.marinating = A_VBG;
lexicon.markings = A_NNS;
lexicon.mark = A_NN_VBP_VB;
lexicon.marking = A_VBG_NN;
lexicon.marks = A_NNS_VBZ;
lexicon.markedly = A_RB;
lexicon.marked = A_VBN_JJ_VBD_VBP;
lexicon.markers = A_NNS;
lexicon.marker = A_NN;
lexicon.marketable = A_JJ;
lexicon.marketed = A_VBN_VBD;
lexicon.marketer = A_NN;
lexicon.markets = A_NNS_VBZ;
lexicon.marketization = A_NN;
lexicon.marketability = A_NN;
lexicon.marketings = A_NNS;
lexicon.marketeers = A_NNS;
lexicon.marketers = A_NNS;
lexicon.marketing = A_NN_VBG_JJ;
lexicon.market = A_NN_VBP_VB;
lexicon.marketplace = A_NN;
lexicon.marketplaces = A_NNS;
lexicon.marriageables = A_NNS;
lexicon.marriages = A_NNS;
lexicon.marriage = A_NN;
lexicon.marrieds = A_NNS;
lexicon.marry = A_VB_VBP;
lexicon.marrying = A_VBG;
lexicon.marries = A_VBZ;
lexicon.married = A_VBN_VBD_JJ;
lexicon.masks = A_NNS;
lexicon.mask = A_NN_VBP_VB;
lexicon.masked = A_VBN_VBD_JJ;
lexicon.masking = A_VBG_NN;
lexicon.mass = A_NN_JJ_RB_VB;
lexicon.massing = A_VBG;
lexicon.masse = A_FW_NN_RB;
lexicon.masses = A_NNS;
lexicon.massed = A_VBD_VBN;
lexicon.massively = A_RB;
lexicon.massive = A_JJ;
lexicon.master = A_NN_JJ_VB_JJR;
lexicon.mastering = A_VBG;
lexicon.masterly = A_JJ;
lexicon.masters = A_NNS;
lexicon.mastered = A_VBN_VBD;
lexicon.masterfully = A_RB;
lexicon.masterful = A_JJ;
lexicon.matches = A_VBZ_NNS;
lexicon.matched = A_VBN_JJ_VBD;
lexicon.matching = A_VBG_JJ_NN;
lexicon.match = A_VB_VBP_NN;
lexicon.mate = A_NN_VBP_VB_UH;
lexicon.mates = A_NNS;
lexicon.mated = A_VBN;
lexicon.mating = A_NN_JJ_VBG;
lexicon.material = A_NN_JJ;
lexicon.materialism = A_NN;
lexicon.materialized = A_VBD_VBN;
lexicon.materializes = A_VBZ;
lexicon.materials = A_NNS;
lexicon.materially = A_RB;
lexicon.materialize = A_VB_VBP;
lexicon.math = A_NN;
lexicon.mathematical = A_JJ;
lexicon.mathematics = A_NNS_NN;
lexicon.mathematically = A_RB;
lexicon.mattered = A_VBD_VBN;
lexicon.matter = A_NN_VBP_VB;
lexicon.matters = A_NNS_VBZ;
lexicon.maximums = A_NNS;
lexicon.maximum = A_JJ_NN;
lexicon.maye = A_MD;
lexicon.may = A_MD_NNP;
lexicon.maybe = A_RB;
lexicon.mayor = A_NN;
lexicon.mayoral = A_JJ;
lexicon.mayors = A_NNS;
lexicon.me = A_PRP_FW;
lexicon.meal = A_NN;
lexicon.meals = A_NNS;
lexicon.meanes = A_NNS;
lexicon.means = A_VBZ_NNS_NN;
lexicon.mean = A_VB_VBP_JJ_NN;
lexicon.meanly = A_RB;
lexicon.meanness = A_NN;
lexicon.meaning = A_NN_VBG;
lexicon.meanings = A_NNS;
lexicon.meaningfulness = A_NN;
lexicon.meaningfully = A_RB;
lexicon.meaningful = A_JJ;
lexicon.meantime = A_NN_RB;
lexicon.meanwhile = A_RB_NN;
lexicon.measurable = A_JJ;
lexicon.measurably = A_RB;
lexicon.measures = A_NNS_VBZ;
lexicon.measured = A_VBN_VBD_JJ;
lexicon.measure = A_NN_VBP_VB;
lexicon.measuring = A_VBG_NN;
lexicon.measurements = A_NNS;
lexicon.measurement = A_NN;
lexicon.meats = A_NNS;
lexicon.meat = A_NN;
lexicon.mechanism = A_NN;
lexicon.mechanics = A_NNS;
lexicon.mechanical = A_JJ;
lexicon.mechanization = A_NN;
lexicon.mechanisms = A_NNS;
lexicon.mechanized = A_JJ_VBN;
lexicon.mechanically = A_RB;
lexicon.mechanic = A_NN;
lexicon.medal = A_NN;
lexicon.medals = A_NNS;
lexicon.media = A_NNS_NN;
lexicon.medically = A_RB;
lexicon.medication = A_NN;
lexicon.medics = A_NNS;
lexicon.medications = A_NNS;
lexicon.medical = A_JJ;
lexicon.medicinal = A_JJ_NN;
lexicon.medicine = A_NN;
lexicon.medicines = A_NNS;
lexicon.medium = A_NN_JJ;
lexicon.mediums = A_NNS;
lexicon.meet = A_VB_VBP_NN;
lexicon.meets = A_VBZ_NNS;
lexicon.meetings = A_NNS;
lexicon.meeting = A_NN_VBG;
lexicon.melting = A_VBG_JJ_NN;
lexicon.melts = A_VBZ;
lexicon.melted = A_VBN_JJ_VBD;
lexicon.melt = A_VB_VBP_NN;
lexicon.member = A_NN;
lexicon.members = A_NNS;
lexicon.membership = A_NN;
lexicon.memberships = A_NNS;
lexicon.memorial = A_NN_JJ;
lexicon.memories = A_NNS;
lexicon.memorialized = A_VBN;
lexicon.memorials = A_NNS;
lexicon.memory = A_NN;
lexicon.memorialization = A_NN;
lexicon.mentalities = A_NNS;
lexicon.mentality = A_NN;
lexicon.mental = A_JJ;
lexicon.mentally = A_RB_NN_JJ;
lexicon.mentioned = A_VBN_VBD;
lexicon.mention = A_VB_NN_VBP;
lexicon.mentions = A_VBZ_NNS;
lexicon.mentioning = A_VBG_NN;
lexicon.mentors = A_NNS;
lexicon.mentor = A_NN;
lexicon.menu = A_NN;
lexicon.merchants = A_NNS;
lexicon.merchant = A_NN_JJ;
lexicon.merely = A_RB;
lexicon.mere = A_JJ;
lexicon.merit = A_NN_VB_VBP;
lexicon.merits = A_NNS_VBZ;
lexicon.merited = A_VBD;
lexicon.messed = A_VBD_VBN;
lexicon.messes = A_NNS;
lexicon.messing = A_VBG;
lexicon.mess = A_NN_VBP_VB;
lexicon.message = A_NN;
lexicon.messaging = A_NN_VBG;
lexicon.messages = A_NNS;
lexicon.metallic = A_JJ;
lexicon.metal = A_NN;
lexicon.metalized = A_VBN;
lexicon.metals = A_NNS;
lexicon.metaphorical = A_JJ;
lexicon.metaphors = A_NNS;
lexicon.metaphor = A_NN;
lexicon.meters = A_NNS_NN;
lexicon.meter = A_NN;
lexicon.metered = A_VBN;
lexicon.metering = A_VBG;
lexicon.method = A_NN;
lexicon.methods = A_NNS;
lexicon.methode = A_NNP;
lexicon.methodically = A_RB;
lexicon.methodical = A_JJ;
lexicon.metropolitanization = A_NN;
lexicon.metropolitan = A_JJ_NN;
lexicon.middling = A_JJ;
lexicon.middle = A_NN_JJ;
lexicon.middles = A_NNS;
lexicon.midnight = A_NN_RB;
lexicon.midsts = A_NNS;
lexicon.midst = A_NN;
lexicon.might = A_MD_NN;
lexicon.migration = A_NN;
lexicon.migrated = A_VBN_VBD;
lexicon.migrates = A_VBZ;
lexicon.migrate = A_VB_VBP;
lexicon.migrations = A_NNS;
lexicon.migrating = A_VBG;
lexicon.mildness = A_NN;
lexicon.mildly = A_RB;
lexicon.mild = A_JJ;
lexicon.military = A_JJ_NN;
lexicon.milked = A_VBD_VBN;
lexicon.milks = A_VBZ_NNS;
lexicon.milking = A_VBG;
lexicon.milk = A_NN_VB;
lexicon.milled = A_JJ;
lexicon.mills = A_NNS;
lexicon.mill = A_NN;
lexicon.milling = A_NN_VBG;
lexicon.minded = A_VBD_VBN;
lexicon.mindful = A_JJ;
lexicon.minds = A_NNS;
lexicon.mind = A_NN_RB_VB;
lexicon.mines = A_NNS;
lexicon.mined = A_VBN_VBD;
lexicon.mine = A_NN_PRP$_JJ_VB_PRP_VBP;
lexicon.mining = A_NN_VBG;
lexicon.minerals = A_NNS;
lexicon.mineralized = A_JJ;
lexicon.miner = A_NN;
lexicon.miners = A_NNS;
lexicon.mineral = A_NN_JJ;
lexicon.minimalism = A_NN;
lexicon.minimal = A_JJ;
lexicon.minimized = A_VBN_VBD;
lexicon.minimizes = A_VBZ;
lexicon.minimizing = A_VBG;
lexicon.minimize = A_VB;
lexicon.minimally = A_RB;
lexicon.minimum = A_JJ_NN;
lexicon.minimums = A_NNS;
lexicon.ministers = A_NNS;
lexicon.ministered = A_VBD;
lexicon.minister = A_NN_NNP;
lexicon.ministering = A_VBG;
lexicon.ministries = A_NNS;
lexicon.ministry = A_NN;
lexicon.minorities = A_NNS;
lexicon.minority = A_NN_JJ;
lexicon.minor = A_JJ_NN;
lexicon.minors = A_NNS;
lexicon.minute = A_NN_JJ;
lexicon.minutes = A_NNS;
lexicon.minutely = A_RB;
lexicon.miracle = A_NN;
lexicon.miracles = A_NNS;
lexicon.mirroring = A_VBG_NN;
lexicon.mirror = A_NN_VBP_VB;
lexicon.mirrors = A_VBZ_NNS;
lexicon.mirrored = A_VBN_VBD;
lexicon.missed = A_VBD_VBN_JJ;
lexicon.missing = A_VBG_JJ_NN;
lexicon.miss = A_VB_VBP_NN;
lexicon.misses = A_VBZ_NNS;
lexicon.missile = A_NN;
lexicon.missiles = A_NNS;
lexicon.missions = A_NNS;
lexicon.mission = A_NN;
lexicon.missionaries = A_NNS;
lexicon.missionary = A_JJ_NN;
lexicon.mistaking = A_VBG_NN;
lexicon.mistake = A_NN_VB;
lexicon.mistakes = A_NNS_VBZ;
lexicon.mixing = A_VBG_NN;
lexicon.mixes = A_NNS_VBZ;
lexicon.mixed = A_VBN_VBD_JJ;
lexicon.mix = A_NN_VBP_VB;
lexicon.mixture = A_NN;
lexicon.mixtures = A_NNS;
lexicon.mobility = A_NN;
lexicon.mobilized = A_VBN_VBD;
lexicon.mobilize = A_VB;
lexicon.mobilization = A_NN;
lexicon.mobilizing = A_VBG_NN;
lexicon.mobile = A_JJ;
lexicon.mode = A_NN_FW;
lexicon.modes = A_NNS;
lexicon.modeling = A_NN_JJ_VBG;
lexicon.models = A_NNS;
lexicon.modeled = A_VBN_VBD_JJ;
lexicon.model = A_NN_JJ_VB_NNP;
lexicon.moderates = A_NNS_VBZ;
lexicon.moderated = A_VBN_VBD;
lexicon.moderating = A_VBG_JJ;
lexicon.moderate = A_JJ_VBP_VB;
lexicon.moderately = A_RB;
lexicon.moderation = A_NN;
lexicon.moderator = A_NN;
lexicon.moderns = A_NNS;
lexicon.modernized = A_VBN_JJ_VBD;
lexicon.modernization = A_NN;
lexicon.modernize = A_VB;
lexicon.modernizing = A_VBG_NN;
lexicon.modernism = A_NN;
lexicon.modern = A_JJ_NN;
lexicon.modernity = A_NN;
lexicon.modest = A_JJ;
lexicon.modestly = A_RB;
lexicon.modify = A_VB_VBP;
lexicon.modifiers = A_NNS;
lexicon.modifying = A_VBG;
lexicon.modified = A_VBN_JJ_VBD;
lexicon.modifies = A_VBZ;
lexicon.modifier = A_NN;
lexicon.molecule = A_NN;
lexicon.molecules = A_NNS;
lexicon.mom = A_NN;
lexicon.moments = A_NNS;
lexicon.moment = A_NN;
lexicon.momentous = A_JJ;
lexicon.momentum = A_NN;
lexicon.moneys = A_NNS;
lexicon.moneyed = A_JJ;
lexicon.money = A_NN;
lexicon.monitors = A_NNS_VBZ;
lexicon.monitored = A_VBN_VBD_JJ;
lexicon.monitor = A_VB_NN_VBP;
lexicon.monitoring = A_NN_VBG;
lexicon.monkey = A_NN;
lexicon.monkeys = A_NNS;
lexicon.monster = A_NN;
lexicon.monsters = A_NNS;
lexicon.monthly = A_JJ_NN_RB;
lexicon.month = A_NN;
lexicon.months = A_NNS;
lexicon.monumentalism = A_NN;
lexicon.monumental = A_JJ;
lexicon.monumentally = A_RB;
lexicon.monuments = A_NNS;
lexicon.monument = A_NN;
lexicon.monumentality = A_NN;
lexicon.mood = A_NN;
lexicon.moods = A_NNS;
lexicon.moons = A_NNS;
lexicon.moon = A_NN_VB;
lexicon.morally = A_RB;
lexicon.moralities = A_NNS;
lexicon.morality = A_NN;
lexicon.moralizing = A_VBG_JJ;
lexicon.morals = A_NNS;
lexicon.morale = A_NN;
lexicon.moralism = A_NN;
lexicon.moralizers = A_NNS;
lexicon.moral = A_JJ_NN;
lexicon.more = A_JJR_JJ_NN_RB_RP_RBR;
lexicon.mores = A_NNS;
lexicon.moreover = A_RB;
lexicon.mornings = A_NNS;
lexicon.morning = A_NN;
lexicon.mortality = A_NN;
lexicon.mortal = A_JJ_NN;
lexicon.mortally = A_RB;
lexicon.mortals = A_NNS;
lexicon.mortgage = A_NN_VB;
lexicon.mortgages = A_NNS_VBZ;
lexicon.mortgaged = A_VBN;
lexicon.mostly = A_RB_JJ;
lexicon.most = A_RBS_JJ_NN_RB_JJS;
lexicon.mothers = A_NNS;
lexicon.mothered = A_VBN;
lexicon.motherly = A_JJ;
lexicon.mother = A_NN_VB;
lexicon.motional = A_JJ;
lexicon.motioning = A_VBG;
lexicon.motioned = A_VBD;
lexicon.motions = A_NNS_VBZ;
lexicon.motion = A_NN;
lexicon.motives = A_NNS;
lexicon.motivate = A_VB_VBP;
lexicon.motive = A_NN_JJ;
lexicon.motivated = A_VBN_VBD_JJ;
lexicon.motivation = A_NN;
lexicon.motivating = A_VBG_JJ;
lexicon.motivations = A_NNS;
lexicon.motivates = A_VBZ;
lexicon.motoring = A_VBG;
lexicon.motorized = A_VBN_JJ;
lexicon.motored = A_VBD;
lexicon.motors = A_NNS;
lexicon.motor = A_NN_JJ_VB;
lexicon.mounted = A_VBN_JJ_VBD;
lexicon.mount = A_VB_NN_VBP;
lexicon.mountings = A_NNS;
lexicon.mounting = A_VBG_JJ_NN;
lexicon.mounts = A_NNS_VBZ;
lexicon.mountaineering = A_NN;
lexicon.mountains = A_NNS;
lexicon.mountaineers = A_NNS;
lexicon.mountainously = A_RB;
lexicon.mountain = A_NN;
lexicon.mountainous = A_JJ;
lexicon.mouse = A_NN;
lexicon.mouth = A_NN;
lexicon.mouthed = A_VBD;
lexicon.mouthful = A_NN;
lexicon.mouths = A_NNS;
lexicon.mouthing = A_VBG;
lexicon.move = A_NN_VBP_VB;
lexicon.moved = A_VBD_VBN;
lexicon.moves = A_NNS_VBZ;
lexicon.movingly = A_RB;
lexicon.moving = A_VBG_JJ_NN;
lexicon.movements = A_NNS;
lexicon.movement = A_NN;
lexicon.movies = A_NNS;
lexicon.movie = A_NN;
lexicon.much = A_JJ_DT_NN_RB;
lexicon.mud = A_NN;
lexicon.multipled = A_VBD;
lexicon.multiplicity = A_NN;
lexicon.multiples = A_NNS;
lexicon.multiplication = A_NN;
lexicon.multiple = A_JJ_NN;
lexicon.municipal = A_JJ_NN;
lexicon.municipally = A_RB;
lexicon.municipals = A_NNS;
lexicon.municipality = A_NN;
lexicon.municipalities = A_NNS;
lexicon.murders = A_NNS_VBZ;
lexicon.murderer = A_NN;
lexicon.murdered = A_VBN_VBD_JJ;
lexicon.murderers = A_NNS;
lexicon.murdering = A_VBG_JJ;
lexicon.murderous = A_JJ;
lexicon.murder = A_NN_VB;
lexicon.muscle = A_NN_VB;
lexicon.muscling = A_VBG;
lexicon.muscles = A_NNS;
lexicon.muscled = A_VBD_VBN;
lexicon.museums = A_NNS;
lexicon.museum = A_NN;
lexicon.mushrooming = A_NN;
lexicon.mushrooms = A_NNS;
lexicon.mushroomed = A_VBN_VBD;
lexicon.mushroom = A_NN_VBP_VB;
lexicon.musicality = A_NN;
lexicon.musicals = A_NNS;
lexicon.musically = A_RB;
lexicon.music = A_NN;
lexicon.musical = A_JJ_NN;
lexicon.musicians = A_NNS;
lexicon.musician = A_NN;
lexicon.musts = A_NNS;
lexicon.must = A_MD_JJ_NN;
lexicon.mutterings = A_NNS;
lexicon.mutterers = A_NNS;
lexicon.muttered = A_VBD;
lexicon.muttering = A_VBG;
lexicon.mutter = A_VB;
lexicon.mutters = A_NNS_VBZ;
lexicon.mutuality = A_NN;
lexicon.mutual = A_JJ;
lexicon.mutually = A_RB;
lexicon.my = A_PRP$_UH_PRP_JJ;
lexicon.myself = A_PRP;
lexicon.mystery = A_NN;
lexicon.mysteries = A_NNS;
lexicon.mysteriously = A_RB;
lexicon.mysterious = A_JJ;
lexicon.myth = A_NN;
lexicon.myths = A_NNS;
lexicon.nail = A_NN_RB_VB;
lexicon.nailed = A_VBN_VBD;
lexicon.nailing = A_VBG;
lexicon.nails = A_NNS;
lexicon.nakedly = A_RB;
lexicon.naked = A_JJ;
lexicon.name = A_NN_VB_UH_VBP;
lexicon.namely = A_RB;
lexicon.naming = A_VBG_NN;
lexicon.named = A_VBN_VBD_JJ;
lexicon.names = A_NNS_VBZ;
lexicon.narrated = A_VBN;
lexicon.narrative = A_NN_JJ;
lexicon.narration = A_NN;
lexicon.narrator = A_NN;
lexicon.narratives = A_NNS;
lexicon.narrows = A_VBZ;
lexicon.narrower = A_JJR;
lexicon.narrowed = A_VBD_VBN;
lexicon.narrowing = A_VBG_NN;
lexicon.narrow = A_JJ_VB;
lexicon.narrowness = A_NN;
lexicon.nasty = A_JJ;
lexicon.national = A_JJ_NN_RB;
lexicon.nations = A_NNS;
lexicon.nationally = A_RB;
lexicon.nationalized = A_VBD_VBN_JJ;
lexicon.nationality = A_NN;
lexicon.nationalization = A_NN;
lexicon.nation = A_NN;
lexicon.nationals = A_NNS;
lexicon.nationalizing = A_VBG;
lexicon.nationalism = A_NN;
lexicon.nationalisms = A_NNS;
lexicon.nationalize = A_VB;
lexicon.nationalities = A_NNS;
lexicon.nationwide = A_JJ_RB;
lexicon.native = A_JJ_NN;
lexicon.natives = A_NNS;
lexicon.nature = A_NN_JJ;
lexicon.naturalism = A_NN;
lexicon.naturalness = A_NN;
lexicon.natures = A_NNS;
lexicon.naturally = A_RB;
lexicon.natured = A_JJ;
lexicon.natural = A_JJ_NN;
lexicon.naturalized = A_VBN_JJ;
lexicon.naval = A_JJ;
lexicon.near = A_IN_RB_VB_JJ;
lexicon.nearly = A_RB;
lexicon.nearness = A_NN;
lexicon.nears = A_VBZ_NNS;
lexicon.nearing = A_VBG;
lexicon.neared = A_VBD_VBN;
lexicon.nearby = A_JJ_RB;
lexicon.neat = A_JJ;
lexicon.neatly = A_RB;
lexicon.neatness = A_NN;
lexicon.necessarily = A_RB;
lexicon.necessaries = A_NNS;
lexicon.necessary = A_JJ;
lexicon.necessity = A_NN;
lexicon.necessities = A_NNS;
lexicon.necking = A_NN;
lexicon.neck = A_NN_RB_VB;
lexicon.necks = A_NNS;
lexicon.needed = A_VBN_JJ_VBD;
lexicon.needing = A_VBG;
lexicon.need = A_NN_VBP_MD_VB;
lexicon.needs = A_VBZ_NNS_VBP_VB;
lexicon.needled = A_VBD;
lexicon.needles = A_NNS;
lexicon.needle = A_NN_VB;
lexicon.negated = A_VBN_VBD;
lexicon.negative = A_JJ_NN;
lexicon.negatively = A_RB;
lexicon.negatives = A_NNS;
lexicon.negate = A_VB;
lexicon.negation = A_NN;
lexicon.negotiation = A_NN;
lexicon.negotiators = A_NNS_VBZ;
lexicon.negotiations = A_NNS;
lexicon.negotiating = A_VBG_JJ_NN;
lexicon.negotiable = A_JJ;
lexicon.negotiate = A_VB_VBP;
lexicon.negotiator = A_NN;
lexicon.negotiates = A_VBZ;
lexicon.negotiated = A_VBN_JJ_VBD;
lexicon.neighborly = A_JJ;
lexicon.neighboring = A_VBG_JJ;
lexicon.neighbors = A_NNS;
lexicon.neighbor = A_NN;
lexicon.neighborhoods = A_NNS;
lexicon.neighborhood = A_NN;
lexicon.neither = A_DT_NN_RB_CC;
lexicon.nerves = A_NNS;
lexicon.nerve = A_NN;
lexicon.nervousness = A_NN;
lexicon.nervous = A_JJ;
lexicon.nervously = A_RB;
lexicon.nested = A_VBN_VBD;
lexicon.nests = A_NNS;
lexicon.nesting = A_VBG_JJ_NN;
lexicon.nest = A_NN_VBP;
lexicon.net = A_JJ_NN_VB;
lexicon.netting = A_VBG;
lexicon.netted = A_VBD_VBN;
lexicon.nets = A_NNS_VBZ;
lexicon.networking = A_NN_VBG;
lexicon.networks = A_NNS_VBZ;
lexicon.network = A_NN_VB;
lexicon.neutralism = A_NN;
lexicon.neutrality = A_NN;
lexicon.neutral = A_JJ;
lexicon.neutralized = A_VBN;
lexicon.neutralizes = A_VBZ;
lexicon.neutralization = A_NN;
lexicon.neutralize = A_VB;
lexicon.never = A_RB_RBR;
lexicon.nevertheless = A_RB;
lexicon.new = A_JJ;
lexicon.newly = A_RB_JJ;
lexicon.news = A_NN_NNS;
lexicon.newspaper = A_NN;
lexicon.newspapers = A_NNS;
lexicon.next = A_JJ_IN_RB;
lexicon.nicely = A_RB;
lexicon.nice = A_JJ;
lexicon.night = A_NN_RB;
lexicon.nightly = A_JJ_RB;
lexicon.nights = A_NNS;
lexicon.nighted = A_JJ;
lexicon.nightmares = A_NNS;
lexicon.nightmare = A_NN;
lexicon.no = A_DT_JJ_NN_RB_UH;
lexicon.nobody = A_NN;
lexicon.nods = A_VBZ_NNS;
lexicon.nodded = A_VBD_VBN;
lexicon.nod = A_NN_VB_VBP;
lexicon.nodding = A_VBG_JJ;
lexicon.noise = A_NN;
lexicon.noises = A_NNS;
lexicon.nominations = A_NNS;
lexicon.nominal = A_JJ_NN;
lexicon.nominating = A_VBG;
lexicon.nominally = A_RB;
lexicon.nominated = A_VBN_VBD;
lexicon.nominate = A_VB_VBP;
lexicon.nomination = A_NN;
lexicon.nominee = A_NN;
lexicon.nominees = A_NNS;
lexicon.none = A_NN;
lexicon.nonetheless = A_RB;
lexicon.nonprofit = A_JJ;
lexicon.noon = A_NN;
lexicon.nor = A_CC;
lexicon.norm = A_NN;
lexicon.norms = A_NNS;
lexicon.normalizing = A_VBG;
lexicon.normalize = A_VB;
lexicon.normals = A_NNS;
lexicon.normalized = A_VBN;
lexicon.normally = A_RB;
lexicon.normalization = A_NN;
lexicon.normal = A_JJ_RB;
lexicon.north = A_RB_JJ_NN;
lexicon.northeast = A_NN_JJ_RB;
lexicon.northerner = A_NN;
lexicon.northerners = A_NNS;
lexicon.northern = A_JJ;
lexicon.northwest = A_RB_NN_JJS_JJ;
lexicon.nose = A_NN_VB;
lexicon.noses = A_NNS;
lexicon.nosed = A_VBD;
lexicon.nosing = A_VBG;
lexicon.not = A_RB;
lexicon.noting = A_VBG;
lexicon.note = A_NN_JJ_VBP_VB;
lexicon.notes = A_NNS_VBZ;
lexicon.noted = A_VBD_JJ_VBN;
lexicon.notebook = A_NN;
lexicon.notebooks = A_NNS;
lexicon.nothing = A_NN;
lexicon.nothings = A_NNS;
lexicon.noticing = A_VBG;
lexicon.notice = A_NN_VB_VBP;
lexicon.noticed = A_VBD_VBN_JJ;
lexicon.notices = A_NNS_VBZ;
lexicon.noticeable = A_JJ;
lexicon.noticeably = A_RB;
lexicon.notion = A_NN;
lexicon.notions = A_NNS;
lexicon.novelized = A_JJ;
lexicon.novels = A_NNS;
lexicon.novel = A_NN_JJ;
lexicon.now = A_RB_JJ_NN_UH;
lexicon.nowhere = A_RB_NN;
lexicon.nuclear = A_JJ;
lexicon.numbering = A_VBG_NN;
lexicon.numbers = A_NNS_VBZ;
lexicon.number = A_NN_VB_VBP;
lexicon.numbered = A_VBN_VBD;
lexicon.numeral = A_NN;
lexicon.numerator = A_NN;
lexicon.numerically = A_RB;
lexicon.numerous = A_JJ;
lexicon.numerical = A_JJ;
lexicon.numerals = A_NNS;
lexicon.nurses = A_NNS;
lexicon.nursed = A_VBD;
lexicon.nursing = A_NN_VBG;
lexicon.nurse = A_NN;
lexicon.nuts = A_NNS_JJ;
lexicon.nut = A_NN;
lexicon.nutrient = A_JJ;
lexicon.nutrients = A_NNS;
lexicon.oaks = A_NNS;
lexicon.oak = A_NN;
lexicon.objective = A_NN_JJ;
lexicon.objected = A_VBD_VBN;
lexicon.objectively = A_RB;
lexicon.objectiveness = A_NN;
lexicon.object = A_NN_VBP_VB;
lexicon.objectives = A_NNS;
lexicon.objecting = A_VBG;
lexicon.objectivity = A_NN;
lexicon.objects = A_NNS_VBZ;
lexicon.objections = A_NNS;
lexicon.objection = A_NN;
lexicon.obligates = A_VBZ;
lexicon.obligated = A_VBN_VBD_JJ;
lexicon.obligations = A_NNS;
lexicon.oblige = A_VB_NN;
lexicon.obliged = A_VBN_JJ_VBD;
lexicon.obliges = A_VBZ;
lexicon.obliging = A_JJ;
lexicon.obligational = A_JJ;
lexicon.obligating = A_VBG;
lexicon.obligation = A_NN;
lexicon.obligingly = A_RB;
lexicon.observers = A_NNS;
lexicon.observable = A_JJ;
lexicon.observations = A_NNS;
lexicon.observant = A_JJ;
lexicon.observes = A_VBZ;
lexicon.observed = A_VBN_JJ_VBD;
lexicon.observer = A_NN;
lexicon.observances = A_NNS;
lexicon.observation = A_NN;
lexicon.observational = A_JJ;
lexicon.observe = A_VB_VBP;
lexicon.observance = A_NN;
lexicon.observing = A_VBG;
lexicon.obstacle = A_NN;
lexicon.obstacles = A_NNS;
lexicon.obtainable = A_JJ;
lexicon.obtained = A_VBN_VBD_VBP;
lexicon.obtain = A_VB_VBP;
lexicon.obtaining = A_VBG;
lexicon.obtaine = A_VB;
lexicon.obviousness = A_NN;
lexicon.obviously = A_RB;
lexicon.obvious = A_JJ;
lexicon.occasion = A_NN_VB;
lexicon.occasioned = A_VBN;
lexicon.occasions = A_NNS_VBZ;
lexicon.occasionally = A_RB;
lexicon.occasional = A_JJ;
lexicon.occupation = A_NN;
lexicon.occupational = A_JJ;
lexicon.occupants = A_NNS;
lexicon.occupations = A_NNS;
lexicon.occupancies = A_NNS;
lexicon.occupancy = A_NN;
lexicon.occupant = A_NN;
lexicon.occupy = A_VB_VBP;
lexicon.occupying = A_VBG_JJ;
lexicon.occupies = A_VBZ;
lexicon.occupied = A_VBN_JJ_VBD;
lexicon.occurs = A_VBZ;
lexicon.occurring = A_VBG;
lexicon.occuring = A_VBG;
lexicon.occur = A_VB_VBP;
lexicon.occured = A_VBD;
lexicon.occurred = A_VBD_VBN;
lexicon.ocean = A_NN;
lexicon.oceans = A_NNS;
lexicon.odds = A_NNS;
lexicon.odd = A_JJ;
lexicon.oddly = A_RB;
lexicon.of = A_IN_RB_RP_NNP;
lexicon.offing = A_NN;
lexicon.off = A_IN_JJ_NN_RB_RP;
lexicon.offended = A_VBN_JJ_VBD;
lexicon.offenders = A_NNS;
lexicon.offending = A_VBG;
lexicon.offender = A_NN;
lexicon.offends = A_VBZ;
lexicon.offend = A_VB;
lexicon.offensively = A_RB;
lexicon.offenses = A_NNS;
lexicon.offensives = A_NNS;
lexicon.offense = A_NN;
lexicon.offensive = A_JJ_NN;
lexicon.offer = A_NN_VB_VBP;
lexicon.offering = A_NN_VBG;
lexicon.offered = A_VBN_JJ_VBD;
lexicon.offerings = A_NNS;
lexicon.offers = A_VBZ_NNS_NN;
lexicon.officers = A_NNS;
lexicon.offices = A_NNS;
lexicon.office = A_NN;
lexicon.officered = A_VBN;
lexicon.officals = A_NNS;
lexicon.officer = A_NN;
lexicon.offical = A_JJ;
lexicon.officiate = A_VB;
lexicon.official = A_NN_JJ;
lexicon.officiating = A_VBG;
lexicon.officials = A_NNS;
lexicon.officiated = A_VBD;
lexicon.officious = A_JJ;
lexicon.officially = A_RB;
lexicon.oftener = A_RBR;
lexicon.often = A_RB;
lexicon.oh = A_UH;
lexicon.oil = A_NN;
lexicon.oiled = A_JJ;
lexicon.oils = A_NNS;
lexicon.oks = A_VBZ;
lexicon.okay = A_JJ_RB_VB_UH;
lexicon.olds = A_NNS;
lexicon.old = A_JJ;
lexicon.on = A_IN_NNP_RBR_JJ_RB_RP;
lexicon.once = A_RB_IN;
lexicon.ones = A_NNS;
lexicon.oneness = A_NN;
lexicon.ongoing = A_JJ;
lexicon.onion = A_NN;
lexicon.onions = A_NNS;
lexicon.online = A_JJ;
lexicon.only = A_RB_IN_JJ;
lexicon.onto = A_IN;
lexicon.openings = A_NNS;
lexicon.opens = A_VBZ;
lexicon.opened = A_VBD_VBN;
lexicon.opener = A_NN;
lexicon.openness = A_NN;
lexicon.open = A_JJ_VBP_NN_RB_RP_VB;
lexicon.openers = A_NNS;
lexicon.opening = A_NN_VBG_JJ;
lexicon.openly = A_RB;
lexicon.opera = A_NN;
lexicon.operas = A_NNS;
lexicon.operationally = A_RB;
lexicon.operative = A_JJ_NN;
lexicon.operations = A_NNS;
lexicon.operators = A_NNS;
lexicon.operational = A_JJ;
lexicon.operation = A_NN;
lexicon.operates = A_VBZ;
lexicon.operated = A_VBN_VBD_JJ;
lexicon.operate = A_VB_VBP;
lexicon.operator = A_NN;
lexicon.operating = A_VBG_JJ_NN;
lexicon.operable = A_JJ;
lexicon.operatives = A_NNS;
lexicon.opinionated = A_JJ;
lexicon.opinion = A_NN;
lexicon.opinions = A_NNS;
lexicon.opponents = A_NNS;
lexicon.opponent = A_NN;
lexicon.opportunism = A_NN;
lexicon.opportuning = A_NN;
lexicon.opportunities = A_NNS;
lexicon.opportune = A_JJ;
lexicon.opportunity = A_NN;
lexicon.opposes = A_VBZ;
lexicon.opposed = A_VBN_JJ_VBD;
lexicon.oppose = A_VB_NNPS_VBP;
lexicon.opposing = A_VBG_JJ;
lexicon.opposite = A_JJ_IN_NN;
lexicon.opposition = A_NN;
lexicon.opts = A_VBZ;
lexicon.opted = A_VBD_VBN;
lexicon.opting = A_VBG;
lexicon.opt = A_VB_VBP;
lexicon.optimistic = A_JJ;
lexicon.optimistically = A_RB;
lexicon.optimists = A_NNS;
lexicon.optimist = A_NN;
lexicon.optional = A_JJ;
lexicon.option = A_NN_VBP;
lexicon.options = A_NNS;
lexicon.optioned = A_VBN;
lexicon.or = A_CC_NNP;
lexicon.orally = A_RB;
lexicon.oral = A_JJ;
lexicon.orange = A_JJ_NN;
lexicon.oranges = A_NNS;
lexicon.orbital = A_JJ_NN;
lexicon.orbiting = A_VBG;
lexicon.orbited = A_VBD;
lexicon.orbits = A_NNS;
lexicon.orbit = A_NN_VB;
lexicon.orderings = A_NNS;
lexicon.ordered = A_VBD_VBN_JJ;
lexicon.ordering = A_VBG_NN;
lexicon.order = A_NN_VBP_IN_VB;
lexicon.orderly = A_JJ_NN_RB;
lexicon.ordere = A_VBN;
lexicon.orders = A_NNS_VBZ;
lexicon.ordinary = A_JJ_NN;
lexicon.organs = A_NNS;
lexicon.organically = A_RB;
lexicon.organic = A_JJ;
lexicon.organizers = A_NNS;
lexicon.organ = A_NN;
lexicon.organizes = A_VBZ;
lexicon.organizations = A_NNS;
lexicon.organisms = A_NNS;
lexicon.organized = A_VBN_VBD_JJ;
lexicon.organizer = A_NN;
lexicon.organize = A_VB_VBP;
lexicon.organization = A_NN;
lexicon.organics = A_NNS;
lexicon.organizing = A_VBG_NN;
lexicon.organism = A_NN;
lexicon.organizational = A_JJ;
lexicon.organizationally = A_RB;
lexicon.orientations = A_NNS;
lexicon.oriental = A_JJ;
lexicon.orienting = A_VBG;
lexicon.oriented = A_VBN_VBD_JJ;
lexicon.orientation = A_NN;
lexicon.origins = A_NNS;
lexicon.originate = A_VB_VBP;
lexicon.originations = A_NNS;
lexicon.originality = A_NN;
lexicon.originally = A_RB;
lexicon.originators = A_NNS;
lexicon.origination = A_NN;
lexicon.original = A_JJ_NN;
lexicon.origin = A_NN;
lexicon.originating = A_VBG;
lexicon.originator = A_NN;
lexicon.originates = A_VBZ;
lexicon.originals = A_NNS;
lexicon.originated = A_VBD_JJ_VBN_VBP;
lexicon.other = A_JJ_NN;
lexicon.others = A_NNS;
lexicon.otherwise = A_RB_JJ;
lexicon.ought = A_MD;
lexicon.our = A_PRP$;
lexicon.ours = A_PRP_JJ_PRP$;
lexicon.ourselves = A_PRP;
lexicon.outs = A_NNS;
lexicon.out = A_IN_JJ_NN_RB_RP;
lexicon.outlying = A_JJ;
lexicon.outcomes = A_NNS;
lexicon.outcome = A_NN;
lexicon.outdoor = A_JJ;
lexicon.outdoors = A_RB_NN;
lexicon.outer = A_JJ;
lexicon.outfit = A_NN_VB_VBP;
lexicon.outfits = A_NN_NNS;
lexicon.outfitted = A_VBD_VBN;
lexicon.outfitting = A_VBG;
lexicon.outlets = A_NNS;
lexicon.outlet = A_NN;
lexicon.outlined = A_VBN_VBD_JJ;
lexicon.outlines = A_NNS_VBZ;
lexicon.outlining = A_VBG;
lexicon.outline = A_NN_VB_VBP;
lexicon.output = A_NN_VB;
lexicon.outputs = A_NNS;
lexicon.outputting = A_VBG;
lexicon.outsiders = A_NNS;
lexicon.outsider = A_NN;
lexicon.outside = A_IN_JJ_NN_RB;
lexicon.outstandingly = A_RB;
lexicon.outstanding = A_JJ;
lexicon.ovens = A_NNS;
lexicon.oven = A_NN;
lexicon.overeating = A_NN_VBG;
lexicon.over = A_IN_RP_JJ_RB;
lexicon.overly = A_RB;
lexicon.overlying = A_JJ;
lexicon.overalls = A_NNS;
lexicon.overall = A_JJ_NN_RB;
lexicon.overcoming = A_VBG;
lexicon.overcomes = A_VBZ;
lexicon.overcome = A_VB_VBN_VBP;
lexicon.overlooked = A_VBN_VBD;
lexicon.overlooking = A_VBG;
lexicon.overlooks = A_VBZ;
lexicon.overlook = A_VB_VBP;
lexicon.overnight = A_JJ_NN_RB;
lexicon.overnighters = A_NNS;
lexicon.oversee = A_VB;
lexicon.oversees = A_VBZ;
lexicon.overseeing = A_VBG;
lexicon.overwhelmed = A_VBN_VBD_JJ;
lexicon.overwhelm = A_VB_VBP;
lexicon.overwhelming = A_JJ_VBG;
lexicon.overwhelmingly = A_RB;
lexicon.owed = A_VBN_VBD;
lexicon.owes = A_VBZ;
lexicon.owe = A_VBP_VB;
lexicon.owing = A_JJ_VBG;
lexicon.owned = A_VBN_VBD_JJ;
lexicon.owne = A_JJ;
lexicon.owns = A_VBZ;
lexicon.own = A_JJ_VBN_VBP_VB;
lexicon.owning = A_VBG_NN;
lexicon.owner = A_NN;
lexicon.owners = A_NNS;
lexicon.ownerships = A_NNS;
lexicon.ownership = A_NN;
lexicon.oxygen = A_NN;
lexicon.oxygens = A_NNS;
lexicon.pace = A_NN_VB_VBP;
lexicon.pacing = A_VBG_JJ_NN;
lexicon.paces = A_NNS;
lexicon.paced = A_VBD_VBN;
lexicon.packing = A_VBG_NN;
lexicon.packed = A_VBN_JJ_VBD;
lexicon.pack = A_NN_VB_VBP;
lexicon.packs = A_NNS_VBZ;
lexicon.packaging = A_NN_VBG;
lexicon.packages = A_NNS_VBZ;
lexicon.package = A_NN_VB;
lexicon.packaged = A_VBN_JJ;
lexicon.padded = A_JJ_VBN;
lexicon.padding = A_NN_VBG;
lexicon.pads = A_NNS;
lexicon.pad = A_NN_VB;
lexicon.paging = A_NN;
lexicon.page = A_NN_VB;
lexicon.pages = A_NNS;
lexicon.painful = A_JJ;
lexicon.pains = A_NNS;
lexicon.pain = A_NN;
lexicon.painfully = A_RB;
lexicon.pained = A_JJ_VBD_VBN;
lexicon.paints = A_NNS_VBZ;
lexicon.painting = A_NN_VBG;
lexicon.painted = A_VBN_VBD_JJ;
lexicon.paint = A_NN_VB_VBP;
lexicon.paintings = A_NNS;
lexicon.painter = A_NN;
lexicon.painters = A_NNS;
lexicon.paired = A_VBN_JJ_VBD;
lexicon.pairing = A_NN_VBG;
lexicon.pairings = A_NNS;
lexicon.pairs = A_NNS;
lexicon.pair = A_NN_FW_VB;
lexicon.palace = A_NN;
lexicon.palaces = A_NNS;
lexicon.paleness = A_NN;
lexicon.palely = A_RB;
lexicon.paled = A_VBD_VB_VBN;
lexicon.pales = A_VBZ_NNS;
lexicon.pale = A_JJ_VBP_NN;
lexicon.paling = A_VBG;
lexicon.palms = A_NNS;
lexicon.palmed = A_VBD;
lexicon.palm = A_NN_VB;
lexicon.pans = A_NNS_VBZ;
lexicon.panned = A_VBN_VBD;
lexicon.pan = A_NN_VB;
lexicon.panning = A_VBG;
lexicon.paneled = A_JJ;
lexicon.panels = A_NNS;
lexicon.panel = A_NN;
lexicon.paneling = A_NN;
lexicon.panelization = A_NN;
lexicon.panelized = A_VBN;
lexicon.panics = A_NNS;
lexicon.panic = A_NN_VB_VBP;
lexicon.paper = A_NN_VB;
lexicon.papering = A_VBG;
lexicon.papers = A_NNS;
lexicon.parading = A_VBG;
lexicon.paraded = A_VBN_VBD;
lexicon.parades = A_NNS_VBZ;
lexicon.parade = A_NN_VBP;
lexicon.parents = A_NNS;
lexicon.parental = A_JJ;
lexicon.parenting = A_NN;
lexicon.parent = A_NN_JJ;
lexicon.parish = A_NN;
lexicon.parishes = A_NNS;
lexicon.parked = A_VBN_JJ_VBD;
lexicon.parks = A_NNS;
lexicon.parking = A_NN_JJ_VBG;
lexicon.park = A_NN_VB;
lexicon.part = A_NN_JJ_RB_VB;
lexicon.parted = A_VBD_VBN_JJ;
lexicon.parting = A_NN_VBG;
lexicon.parte = A_NN;
lexicon.parts = A_NNS;
lexicon.partly = A_RB;
lexicon.partings = A_NNS;
lexicon.partial = A_JJ_NN;
lexicon.partially = A_RB;
lexicon.participant = A_NN;
lexicon.participative = A_JJ;
lexicon.participants = A_NNS;
lexicon.participate = A_VB_VBP;
lexicon.participation = A_NN;
lexicon.participating = A_VBG_JJ;
lexicon.participations = A_NNS;
lexicon.participates = A_VBZ;
lexicon.participated = A_VBD_VBN;
lexicon.particle = A_NN;
lexicon.particles = A_NNS;
lexicon.particulars = A_NNS;
lexicon.particularity = A_NN;
lexicon.particularly = A_RB;
lexicon.particular = A_JJ_NN_RB;
lexicon.partnered = A_VBN;
lexicon.partner = A_NN;
lexicon.partners = A_NNS;
lexicon.partnership = A_NN;
lexicon.partnerships = A_NNS;
lexicon.parties = A_NNS_VBZ;
lexicon.partying = A_VBG;
lexicon.party = A_NN;
lexicon.passing = A_VBG_JJ_NN;
lexicon.passe = A_JJ;
lexicon.passes = A_VBZ_NNS;
lexicon.passed = A_VBN_VBD;
lexicon.pass = A_VB_VBP_NN;
lexicon.passages = A_NNS;
lexicon.passage = A_NN;
lexicon.passenger = A_NN_JJ;
lexicon.passengers = A_NNS;
lexicon.passion = A_NN;
lexicon.passionate = A_JJ;
lexicon.passionately = A_RB;
lexicon.passions = A_NNS;
lexicon.pasted = A_VBN_VBD;
lexicon.pastes = A_NNS;
lexicon.paste = A_NN_VB;
lexicon.past = A_JJ_VBN_IN_NN_RB;
lexicon.pastness = A_NN;
lexicon.pasting = A_VBG_NN;
lexicon.pasta = A_NN;
lexicon.pastors = A_NNS;
lexicon.pastoral = A_JJ;
lexicon.pastor = A_NN;
lexicon.patting = A_VBG;
lexicon.pats = A_NNS;
lexicon.patted = A_VBD;
lexicon.pat = A_JJ_NN_VB;
lexicon.patch = A_NN_VB;
lexicon.patches = A_NNS;
lexicon.patched = A_VBN_JJ;
lexicon.patently = A_RB;
lexicon.patents = A_NNS;
lexicon.patent = A_NN_JJ;
lexicon.patented = A_VBN_VBD_JJ;
lexicon.patenting = A_NN;
lexicon.path = A_NN;
lexicon.paths = A_NNS;
lexicon.patience = A_NN;
lexicon.patiently = A_RB;
lexicon.patients = A_NNS;
lexicon.patient = A_NN_JJ;
lexicon.patrolled = A_VBN_VBD;
lexicon.patrolling = A_VBG_NN;
lexicon.patrols = A_NNS;
lexicon.patrol = A_NN_VBP_VB;
lexicon.patronizing = A_VBG_JJ;
lexicon.patronize = A_VB;
lexicon.patronized = A_VBN_VBD;
lexicon.patron = A_NN;
lexicon.patrons = A_NNS;
lexicon.pattern = A_NN;
lexicon.patterns = A_NNS;
lexicon.patterned = A_VBN_JJ;
lexicon.paused = A_VBD_VBN;
lexicon.pauses = A_VBZ_NNS;
lexicon.pause = A_NN_VBP_VB;
lexicon.pausing = A_VBG;
lexicon.paying = A_VBG_JJ;
lexicon.pays = A_VBZ;
lexicon.pay = A_VB_VBD_VBP_NN;
lexicon.payments = A_NNS;
lexicon.payment = A_NN;
lexicon.peaceful = A_JJ;
lexicon.peacefully = A_RB;
lexicon.peace = A_NN;
lexicon.peaks = A_NNS_VBZ;
lexicon.peaking = A_VBG_NN;
lexicon.peaked = A_VBD_JJ_VBN;
lexicon.peak = A_NN_VBP_JJ_VB;
lexicon.peanut = A_NN_JJ;
lexicon.peanuts = A_NNS;
lexicon.peasant = A_NN_JJ;
lexicon.peasants = A_NNS;
lexicon.peels = A_VBZ;
lexicon.peeling = A_VBG_NN;
lexicon.peeled = A_VBN_VBD;
lexicon.peel = A_VB;
lexicon.peers = A_NNS_VBZ;
lexicon.peer = A_NN_VBP_JJR_VB;
lexicon.peered = A_VBD_VBN;
lexicon.peering = A_VBG;
lexicon.pen = A_NN_VB;
lexicon.penned = A_VBN_VBD;
lexicon.pens = A_NNS;
lexicon.penning = A_VBG;
lexicon.penalty = A_NN;
lexicon.penalties = A_NNS;
lexicon.penciled = A_VBN;
lexicon.pencils = A_NNS_VBZ;
lexicon.pencil = A_NN;
lexicon.pensions = A_NNS;
lexicon.pension = A_NN;
lexicon.pensioner = A_NN;
lexicon.pensioners = A_NNS;
lexicon.people = A_NNS_NN;
lexicon.peopled = A_VBN;
lexicon.peoples = A_NNS;
lexicon.peppers = A_NNS;
lexicon.peppered = A_VBD_VBN_JJ;
lexicon.pepper = A_NN_VB;
lexicon.peppering = A_VBG;
lexicon.per = A_IN_FW_RP_NNP;
lexicon.perceived = A_VBN_VBD_JJ;
lexicon.perceives = A_VBZ;
lexicon.perceiving = A_VBG;
lexicon.perceive = A_VB_VBP;
lexicon.percentages = A_NNS;
lexicon.percentage = A_NN;
lexicon.perceptiveness = A_NN;
lexicon.perceptive = A_JJ;
lexicon.perceptions = A_NNS;
lexicon.perceptible = A_JJ;
lexicon.perception = A_NN;
lexicon.perfecting = A_VBG;
lexicon.perfectibility = A_NN;
lexicon.perfected = A_VBN;
lexicon.perfect = A_JJ;
lexicon.perfection = A_NN;
lexicon.perfectability = A_NN;
lexicon.perfectly = A_RB;
lexicon.performing = A_VBG_JJ_NN;
lexicon.performance = A_NN;
lexicon.performers = A_NNS;
lexicon.performer = A_NN_JJ;
lexicon.performed = A_VBN_VBD;
lexicon.performs = A_VBZ;
lexicon.perform = A_VB_VBP;
lexicon.performances = A_NNS;
lexicon.perhaps = A_RB;
lexicon.periodical = A_NN;
lexicon.periodic = A_JJ;
lexicon.periodicals = A_NNS;
lexicon.period = A_NN;
lexicon.periodicity = A_NN;
lexicon.periods = A_NNS;
lexicon.periodically = A_RB;
lexicon.permanence = A_NN;
lexicon.permanant = A_JJ;
lexicon.permanent = A_JJ;
lexicon.permanently = A_RB;
lexicon.permission = A_NN;
lexicon.permissibility = A_NN;
lexicon.permissible = A_JJ_NN;
lexicon.permissive = A_JJ;
lexicon.permit = A_VB_VBP_NN;
lexicon.permits = A_VBZ_NNS;
lexicon.permitted = A_VBN_JJ_VBD;
lexicon.permitting = A_VBG;
lexicon.persistently = A_RB;
lexicon.persists = A_VBZ;
lexicon.persisting = A_VBG_JJ;
lexicon.persistent = A_JJ_NN;
lexicon.persisted = A_VBD_VBN;
lexicon.persist = A_VB_VBP;
lexicon.persistency = A_NN;
lexicon.persistence = A_NN_JJ;
lexicon.personal = A_JJ_NN_NNP;
lexicon.personalized = A_VBN_JJ;
lexicon.persons = A_NNS;
lexicon.personality = A_NN;
lexicon.person = A_NN;
lexicon.personally = A_RB;
lexicon.personalize = A_VB;
lexicon.personalities = A_NNS;
lexicon.personnel = A_NNS_JJ_NN;
lexicon.perspective = A_NN_JJ;
lexicon.perspectives = A_NNS;
lexicon.persuade = A_VB_VBP;
lexicon.persuading = A_VBG_NN;
lexicon.persuades = A_VBZ;
lexicon.persuaders = A_NNS;
lexicon.persuaded = A_VBN_VBD;
lexicon.pet = A_NN_VB_JJ;
lexicon.petted = A_VBN;
lexicon.pets = A_NNS;
lexicon.petting = A_NN;
lexicon.phasing = A_VBG;
lexicon.phase = A_NN_VB;
lexicon.phased = A_VBN_VBD;
lexicon.phases = A_NNS_VBZ;
lexicon.phenomenon = A_NN;
lexicon.philosophically = A_RB;
lexicon.philosophizing = A_VBG_NN;
lexicon.philosophers = A_NNS;
lexicon.philosophic = A_JJ;
lexicon.philosopher = A_NN;
lexicon.philosophized = A_VBD;
lexicon.philosophical = A_JJ;
lexicon.philosophies = A_NNS;
lexicon.philosophy = A_NN;
lexicon.phones = A_NNS_VBZ;
lexicon.phoned = A_VBD_VBN;
lexicon.phone = A_NN_VB_VBP;
lexicon.phoning = A_VBG;
lexicon.photos = A_NNS;
lexicon.photo = A_NN_JJ;
lexicon.photographing = A_VBG_NN;
lexicon.photographer = A_NN;
lexicon.photographed = A_VBN_VBD;
lexicon.photographs = A_NNS_VBZ;
lexicon.photographic = A_JJ;
lexicon.photograph = A_NN_VB;
lexicon.photographers = A_NNS;
lexicon.photographically = A_RB;
lexicon.photography = A_NN;
lexicon.phrases = A_NNS;
lexicon.phrasing = A_NN;
lexicon.phrase = A_NN;
lexicon.phrasings = A_NNS;
lexicon.phrased = A_VBN_VBD;
lexicon.physics = A_NN_NNS;
lexicon.physically = A_RB;
lexicon.physicalness = A_NN;
lexicon.physicals = A_NNS;
lexicon.physical = A_JJ_NN;
lexicon.physicians = A_NNS;
lexicon.physician = A_NN;
lexicon.pianos = A_NNS;
lexicon.piano = A_NN;
lexicon.picking = A_VBG_NN;
lexicon.pick = A_VB_VBP_NN;
lexicon.picked = A_VBD_VB_VBN;
lexicon.pickings = A_NNS_NN;
lexicon.picks = A_VBZ_NNS;
lexicon.pickups = A_NNS;
lexicon.pickup = A_NN_JJ;
lexicon.picturing = A_VBG_NN;
lexicon.pictures = A_NNS_VBZ;
lexicon.pictured = A_VBN_VBD;
lexicon.picture = A_NN_VB_VBP;
lexicon.pies = A_NNS;
lexicon.pie = A_NN_RP;
lexicon.pieces = A_NNS;
lexicon.pieced = A_VBN;
lexicon.piece = A_NN_FW_VB;
lexicon.pigs = A_NNS_VBZ;
lexicon.pig = A_NN;
lexicon.pilings = A_NNS;
lexicon.piles = A_NNS_NN_VBZ;
lexicon.piled = A_VBD_VBN_JJ;
lexicon.pile = A_NN_VBP_VB;
lexicon.piling = A_VBG_NN;
lexicon.pills = A_NNS;
lexicon.pill = A_NN;
lexicon.pillow = A_NN;
lexicon.pillows = A_NNS;
lexicon.piloting = A_NN_VBG;
lexicon.pilote = A_FW;
lexicon.pilots = A_NNS;
lexicon.pilot = A_NN_JJ_VB;
lexicon.pins = A_NNS_VBZ;
lexicon.pinned = A_VBN_VBD;
lexicon.pin = A_NN_VBP_VB;
lexicon.pinning = A_VBG_NN;
lexicon.pinnings = A_NNS;
lexicon.pines = A_NNS;
lexicon.pine = A_NN_VBP;
lexicon.pink = A_JJ_NN;
lexicon.pinks = A_NNS;
lexicon.pinkly = A_RB;
lexicon.pioneers = A_NNS;
lexicon.pioneer = A_NN_VB;
lexicon.pioneered = A_VBD_VBN;
lexicon.pioneering = A_VBG_JJ;
lexicon.pipe = A_NN;
lexicon.pipes = A_NNS;
lexicon.piped = A_VBD_VBN;
lexicon.piping = A_NN;
lexicon.pistoleers = A_NNS;
lexicon.pistol = A_NN;
lexicon.pistols = A_NNS;
lexicon.pits = A_NNS_VBZ;
lexicon.pit = A_NN_VBP_VB;
lexicon.pitting = A_VBG;
lexicon.pitted = A_VBN_VBD;
lexicon.pitches = A_NNS_VBZ;
lexicon.pitched = A_VBD_JJ_VBN;
lexicon.pitch = A_NN_JJ_VB_VBP;
lexicon.pitching = A_VBG_NN;
lexicon.pitcher = A_NN;
lexicon.pitchers = A_NNS;
lexicon.pizzas = A_NNS;
lexicon.pizza = A_NN;
lexicon.placing = A_VBG_NN;
lexicon.place = A_NN_VBP_RB_VB;
lexicon.places = A_NNS_VBZ;
lexicon.placed = A_VBN_VBD;
lexicon.placement = A_NN;
lexicon.placements = A_NNS;
lexicon.plains = A_NNS;
lexicon.plainly = A_RB;
lexicon.plain = A_JJ_NN_RB;
lexicon.plaintiffs = A_NNS;
lexicon.plaintiff = A_NN;
lexicon.planned = A_VBN_JJ_VBD;
lexicon.plans = A_NNS_VBP_VBZ;
lexicon.planning = A_NN_VBG;
lexicon.plan = A_NN_VB_VBN_VBP;
lexicon.planes = A_NNS;
lexicon.planed = A_VBN;
lexicon.plane = A_NN_VB;
lexicon.planet = A_NN;
lexicon.planets = A_NNS;
lexicon.planner = A_NN;
lexicon.planners = A_NNS;
lexicon.planted = A_VBN_JJ_VBD;
lexicon.plants = A_NNS_VBZ;
lexicon.plantings = A_NNS;
lexicon.plant = A_NN_VBP_VB;
lexicon.planting = A_VBG_NN;
lexicon.plastics = A_NNS;
lexicon.plastic = A_NN_JJ;
lexicon.plasticity = A_NN;
lexicon.plastically = A_RB;
lexicon.plate = A_NN;
lexicon.plateful = A_JJ;
lexicon.plated = A_VBN;
lexicon.plates = A_NNS;
lexicon.platforms = A_NNS;
lexicon.platform = A_NN;
lexicon.played = A_VBD_VBN;
lexicon.playfulness = A_NN;
lexicon.play = A_VB_NN_VBP;
lexicon.playful = A_JJ;
lexicon.playfully = A_RB;
lexicon.plays = A_VBZ_NNS_VBP;
lexicon.playing = A_VBG_JJ_NN;
lexicon.player = A_NN;
lexicon.players = A_NNS;
lexicon.playoff = A_NN;
lexicon.playoffs = A_NNS;
lexicon.plea = A_NN_VB;
lexicon.pleas = A_NNS;
lexicon.pleadings = A_NNS;
lexicon.plead = A_VB_VBP;
lexicon.pleads = A_VBZ;
lexicon.pleadingly = A_RB;
lexicon.pleading = A_VBG_JJ_NN;
lexicon.pleaded = A_VBD_VBN;
lexicon.pleasantness = A_NN;
lexicon.pleasantly = A_RB;
lexicon.pleasant = A_JJ;
lexicon.pleasing = A_JJ_NN_VBG;
lexicon.pleases = A_VBZ;
lexicon.pleased = A_VBN_JJ_VBD;
lexicon.pleasingly = A_RB;
lexicon.please = A_VB_UH_VBP;
lexicon.pleasures = A_NNS;
lexicon.pleasure = A_NN_JJ_VB;
lexicon.pleasurable = A_JJ;
lexicon.plentiful = A_JJ;
lexicon.plenty = A_NN_JJ_RB;
lexicon.plotted = A_VBN_VBD;
lexicon.plots = A_NNS_VBZ;
lexicon.plot = A_NN_VB_VBP;
lexicon.plotting = A_VBG_NN;
lexicon.plunge = A_NN_VBP_VB;
lexicon.plunged = A_VBD_VBN;
lexicon.plunges = A_NNS_VBZ;
lexicon.plunging = A_VBG_NN;
lexicon.plus = A_CC_IN_JJ_NN_RB;
lexicon.pocketful = A_NN;
lexicon.pocketing = A_VBG;
lexicon.pockets = A_NNS_VBZ;
lexicon.pocket = A_NN_VB;
lexicon.pocketed = A_VBD_VBN;
lexicon.poems = A_NNS;
lexicon.poem = A_NN;
lexicon.poet = A_NN;
lexicon.poets = A_NNS;
lexicon.poetry = A_NN;
lexicon.pointing = A_VBG_NN;
lexicon.pointedly = A_RB;
lexicon.point = A_NN_VBP_RB_VB;
lexicon.pointe = A_FW;
lexicon.points = A_NNS_VBZ;
lexicon.pointed = A_VBD_VBN_JJ;
lexicon.poke = A_NN_VB;
lexicon.poked = A_VBD_VBN;
lexicon.poking = A_VBG;
lexicon.pokes = A_VBZ;
lexicon.pole = A_NN;
lexicon.poling = A_VBG;
lexicon.poles = A_NNS;
lexicon.police = A_NN_VB_NNS;
lexicon.policed = A_VBN;
lexicon.polices = A_NNS;
lexicon.policing = A_VBG_NN;
lexicon.policeman = A_NN;
lexicon.policy = A_NN;
lexicon.policies = A_NNS;
lexicon.politics = A_NNS_NN;
lexicon.politic = A_JJ_NN;
lexicon.politically = A_RB;
lexicon.politeness = A_NN;
lexicon.polite = A_JJ;
lexicon.politely = A_RB;
lexicon.political = A_JJ;
lexicon.politician = A_NN;
lexicon.politicians = A_NNS;
lexicon.pollings = A_NNS;
lexicon.poll = A_NN_JJ_VB;
lexicon.polls = A_NNS_VBZ;
lexicon.polled = A_VBN_VBD;
lexicon.polling = A_NN_JJ_VBG;
lexicon.pollutant = A_NN;
lexicon.pollute = A_VB;
lexicon.polluted = A_JJ_VBD_VBN;
lexicon.polluter = A_NN;
lexicon.polluting = A_VBG_JJ;
lexicon.polluters = A_NNS;
lexicon.pollutants = A_NNS;
lexicon.pollution = A_NN;
lexicon.ponds = A_NNS;
lexicon.pond = A_NN;
lexicon.pools = A_NNS_VBZ;
lexicon.pool = A_NN_VBP_VB;
lexicon.pooled = A_VBN_JJ;
lexicon.pooling = A_VBG_NN;
lexicon.poor = A_JJ_NN_NNP;
lexicon.poorly = A_RB;
lexicon.pop = A_NN_JJ_VB_VBP;
lexicon.popping = A_VBG;
lexicon.popped = A_VBD_VBN;
lexicon.pops = A_VBZ;
lexicon.popularly = A_RB;
lexicon.popularizing = A_VBG;
lexicon.popularity = A_NN;
lexicon.popularized = A_VBN_VBD;
lexicon.popular = A_JJ;
lexicon.popularize = A_VB;
lexicon.populations = A_NNS;
lexicon.populating = A_VBG;
lexicon.populated = A_VBN_JJ_VBD;
lexicon.populous = A_JJ;
lexicon.populate = A_VB_VBP;
lexicon.population = A_NN;
lexicon.populism = A_NN;
lexicon.porches = A_NNS;
lexicon.porch = A_NN;
lexicon.pork = A_NN;
lexicon.port = A_NN_JJ;
lexicon.portly = A_JJ;
lexicon.ports = A_NNS;
lexicon.portfolios = A_NNS;
lexicon.portfolio = A_NN;
lexicon.portions = A_NNS;
lexicon.portion = A_NN;
lexicon.portrait = A_NN;
lexicon.portraits = A_NNS;
lexicon.portraying = A_VBG;
lexicon.portrays = A_VBZ;
lexicon.portray = A_VB_VBP;
lexicon.portrayed = A_VBN_VBD;
lexicon.portrayal = A_NN;
lexicon.portrayals = A_NNS;
lexicon.posed = A_VBN_VBD;
lexicon.poses = A_VBZ;
lexicon.pose = A_VB_VBP_NN;
lexicon.posing = A_VBG;
lexicon.positively = A_RB;
lexicon.positional = A_JJ;
lexicon.positioning = A_VBG_NN;
lexicon.positioned = A_VBN_VBD_JJ;
lexicon.positions = A_NNS_VBZ;
lexicon.positive = A_JJ_NN;
lexicon.position = A_NN_VBP_VB;
lexicon.possessive = A_JJ;
lexicon.possess = A_VBP_VB;
lexicon.possessed = A_VBD_VBN;
lexicon.possesses = A_VBZ;
lexicon.possessing = A_VBG;
lexicon.possession = A_NN;
lexicon.possessions = A_NNS;
lexicon.possibility = A_NN;
lexicon.possiblities = A_NNS;
lexicon.possiblity = A_NN;
lexicon.possible = A_JJ_RB;
lexicon.possibilities = A_NNS;
lexicon.possibly = A_RB;
lexicon.postings = A_NNS;
lexicon.posts = A_NNS_VBZ;
lexicon.posted = A_VBD_VBN_JJ;
lexicon.posting = A_VBG_NN;
lexicon.post = A_NN_FW_IN_JJ_VB_VBD_VBP;
lexicon.posterity = A_NN;
lexicon.posters = A_NNS;
lexicon.poster = A_NN;
lexicon.pots = A_NNS;
lexicon.pot = A_NN_VB;
lexicon.potted = A_JJ_VBN;
lexicon.potting = A_VBG_NN;
lexicon.potatoes = A_NNS;
lexicon.potato = A_NN;
lexicon.potentials = A_NNS;
lexicon.potentially = A_RB;
lexicon.potentialities = A_NNS;
lexicon.potential = A_JJ_NN;
lexicon.potentiality = A_NN;
lexicon.pound = A_NN_VB_VBP;
lexicon.pounds = A_NNS_VBZ;
lexicon.pounding = A_VBG_NN;
lexicon.pounded = A_VBD_VBN;
lexicon.pours = A_VBZ;
lexicon.poured = A_VBD_VBN;
lexicon.pouring = A_VBG;
lexicon.pour = A_VB_FW_IN_VBP;
lexicon.poverty = A_NN;
lexicon.powder = A_NN;
lexicon.powdered = A_JJ_VBN;
lexicon.powders = A_NNS;
lexicon.powerfully = A_RB;
lexicon.power = A_NN_VBP_VB;
lexicon.powered = A_VBN_JJ;
lexicon.powers = A_NNS_VBZ;
lexicon.powering = A_VBG;
lexicon.powerful = A_JJ;
lexicon.powerfulness = A_NN;
lexicon.practiced = A_VBN_VBD_JJ;
lexicon.practices = A_NNS_VBZ;
lexicon.practicability = A_NN;
lexicon.practical = A_JJ_NN;
lexicon.practicality = A_NN;
lexicon.practically = A_RB;
lexicon.practicable = A_JJ;
lexicon.practicing = A_VBG_NN;
lexicon.practice = A_NN_VB_VBP;
lexicon.practitioner = A_NN;
lexicon.practitioners = A_NNS;
lexicon.praising = A_VBG;
lexicon.praises = A_VBZ_NNS;
lexicon.praised = A_VBD_JJ_VBN;
lexicon.praise = A_NN_VBP_VB;
lexicon.praying = A_VBG_NN;
lexicon.prays = A_VBZ;
lexicon.pray = A_VB_VBP;
lexicon.prayed = A_VBD_VBN;
lexicon.prayers = A_NNS;
lexicon.prayerful = A_JJ;
lexicon.prayerfully = A_RB;
lexicon.prayer = A_NN;
lexicon.preach = A_VB_VBP;
lexicon.preaching = A_NN_VBG;
lexicon.preached = A_VBD_VBN;
lexicon.preaches = A_VBZ;
lexicon.precious = A_JJ_RB;
lexicon.precision = A_NN_JJ;
lexicon.precisely = A_RB;
lexicon.precise = A_JJ;
lexicon.predators = A_NNS;
lexicon.predator = A_NN;
lexicon.predates = A_VBZ;
lexicon.predicting = A_VBG_NN;
lexicon.predicted = A_VBD_JJ_VBN;
lexicon.predictions = A_NNS;
lexicon.predictability = A_NN;
lexicon.predict = A_VBP_VB;
lexicon.predictive = A_JJ;
lexicon.predictably = A_RB;
lexicon.predictable = A_JJ;
lexicon.prediction = A_NN;
lexicon.predicts = A_VBZ;
lexicon.preference = A_NN;
lexicon.preferably = A_RB;
lexicon.preferable = A_JJ;
lexicon.preferences = A_NNS;
lexicon.prefers = A_VBZ;
lexicon.prefer = A_VBP_VB;
lexicon.preferring = A_VBG;
lexicon.preferred = A_JJ_VBD_VBG_VBN;
lexicon.preferment = A_NN;
lexicon.pregnancies = A_NNS;
lexicon.pregnancy = A_NN;
lexicon.pregnant = A_JJ;
lexicon.preliminaries = A_NNS;
lexicon.preliminary = A_JJ_NN;
lexicon.premise = A_NN;
lexicon.premises = A_NNS_NN;
lexicon.premium = A_NN_JJ;
lexicon.premiums = A_NNS;
lexicon.preparatives = A_NNS;
lexicon.preparer = A_NN;
lexicon.prepare = A_VB_VBP;
lexicon.preparers = A_NNS;
lexicon.preparations = A_NNS;
lexicon.preparation = A_NN;
lexicon.preparative = A_JJ;
lexicon.prepared = A_VBN_VBD_JJ;
lexicon.prepares = A_VBZ;
lexicon.preparing = A_VBG;
lexicon.prescriptions = A_NNS;
lexicon.prescription = A_NN;
lexicon.prescriptive = A_JJ;
lexicon.presence = A_NN;
lexicon.presences = A_NNS;
lexicon.presently = A_RB;
lexicon.presentable = A_JJ;
lexicon.presentation = A_NN;
lexicon.presentness = A_NN;
lexicon.presente = A_JJ;
lexicon.presents = A_VBZ_NNS;
lexicon.presentational = A_JJ;
lexicon.presenting = A_VBG;
lexicon.presenters = A_NNS;
lexicon.presented = A_VBN_VBD;
lexicon.presenter = A_NN;
lexicon.presentations = A_NNS;
lexicon.present = A_JJ_VBP_NN_RB_VB;
lexicon.presentments = A_NNS;
lexicon.preservation = A_NN;
lexicon.preservative = A_JJ;
lexicon.preserved = A_VBN_JJ_VBD;
lexicon.preserving = A_VBG;
lexicon.preserves = A_VBZ_NNS;
lexicon.preserve = A_VB_VBP_NN;
lexicon.president = A_NN_NNP;
lexicon.presiding = A_VBG;
lexicon.presidency = A_NN;
lexicon.preside = A_VB;
lexicon.presided = A_VBD_VBN;
lexicon.presides = A_VBZ;
lexicon.presidents = A_NNS;
lexicon.presidential = A_JJ;
lexicon.presses = A_NNS_VBZ;
lexicon.pressed = A_VBN_VBD;
lexicon.press = A_NN_VBP_VB;
lexicon.pressing = A_VBG_JJ;
lexicon.pressured = A_VBN_JJ_NN_VB_VBD;
lexicon.pressures = A_NNS;
lexicon.pressuring = A_VBG;
lexicon.pressurized = A_VBN;
lexicon.pressure = A_NN_VB_VBP;
lexicon.presuming = A_VBG;
lexicon.presumably = A_RB;
lexicon.presumes = A_VBZ;
lexicon.presumed = A_VBN_JJ_VBD;
lexicon.presume = A_VB_VBP;
lexicon.pretend = A_VB_JJ;
lexicon.pretending = A_VBG;
lexicon.pretended = A_VBD_VBN;
lexicon.pretends = A_VBZ;
lexicon.pretty = A_RB_JJ;
lexicon.prettiness = A_NN;
lexicon.prevailed = A_VBD_VBN;
lexicon.prevail = A_VB_VBP;
lexicon.prevailing = A_VBG_JJ;
lexicon.prevails = A_VBZ;
lexicon.prevaile = A_VB;
lexicon.preventable = A_JJ;
lexicon.prevention = A_NN;
lexicon.preventative = A_JJ;
lexicon.preventatives = A_NNS;
lexicon.prevents = A_VBZ;
lexicon.preventive = A_JJ_NN;
lexicon.prevent = A_VB_VBP;
lexicon.prevented = A_VBN_VBD;
lexicon.preventing = A_VBG;
lexicon.previous = A_JJ;
lexicon.previously = A_RB;
lexicon.prices = A_NNS_VBZ;
lexicon.price = A_NN_VBP_VB;
lexicon.pricings = A_NNS;
lexicon.pricing = A_NN_VBG;
lexicon.priced = A_VBN_JJ_VBD;
lexicon.prides = A_VBZ;
lexicon.prided = A_VBD_VBN;
lexicon.pride = A_NN_VBP;
lexicon.priest = A_NN;
lexicon.priestly = A_JJ;
lexicon.priests = A_NNS;
lexicon.primarily = A_RB;
lexicon.primary = A_JJ_NN;
lexicon.primaries = A_NNS;
lexicon.priming = A_VBG_NN;
lexicon.primed = A_VBN_JJ_VBD;
lexicon.primes = A_NNS;
lexicon.prime = A_JJ_NN;
lexicon.principals = A_NNS;
lexicon.principal = A_JJ_NN;
lexicon.principally = A_RB;
lexicon.principled = A_JJ;
lexicon.principle = A_NN;
lexicon.principles = A_NNS;
lexicon.prints = A_NNS_VBZ;
lexicon.print = A_NN_VB_VBP;
lexicon.printed = A_VBN_VBD_JJ;
lexicon.printing = A_NN_VBG;
lexicon.prior = A_RB_NN_JJ;
lexicon.priorities = A_NNS;
lexicon.priority = A_NN_JJ;
lexicon.prisoner = A_NN;
lexicon.prison = A_NN_VB;
lexicon.prisoners = A_NNS;
lexicon.prisons = A_NNS;
lexicon.privacy = A_NN;
lexicon.privation = A_NN;
lexicon.privatize = A_VB;
lexicon.privatized = A_VBN_VBD_JJ;
lexicon.private = A_JJ_NN_RB;
lexicon.privatizations = A_NNS;
lexicon.privations = A_NNS;
lexicon.privately = A_RB;
lexicon.privatizing = A_VBG;
lexicon.privatization = A_NN;
lexicon.privilege = A_NN;
lexicon.privileges = A_NNS_VBZ;
lexicon.privileged = A_JJ;
lexicon.privileging = A_VBG;
lexicon.prized = A_VBN_JJ;
lexicon.prizes = A_NNS_VBZ;
lexicon.prize = A_NN_JJ_VBP;
lexicon.pro = A_FW_IN_JJ_NN;
lexicon.probabilities = A_NNS;
lexicon.probability = A_NN;
lexicon.probable = A_JJ;
lexicon.probably = A_RB;
lexicon.problem = A_NN;
lexicon.problems = A_NNS;
lexicon.procedurally = A_RB;
lexicon.procedural = A_JJ;
lexicon.procedure = A_NN;
lexicon.procedures = A_NNS_VBZ;
lexicon.proceedings = A_NNS;
lexicon.proceeded = A_VBD_VBN;
lexicon.proceeding = A_NN_VBG;
lexicon.proceed = A_VB_VBP;
lexicon.proceeds = A_NNS_VBZ;
lexicon.processing = A_NN_VBG;
lexicon.process = A_NN_VBP_VB;
lexicon.processes = A_NNS_VBZ;
lexicon.processed = A_VBN_VBD_JJ;
lexicon.procession = A_NN;
lexicon.processors = A_NNS;
lexicon.processor = A_NN;
lexicon.proclaims = A_VBZ;
lexicon.proclaim = A_VB_VBP;
lexicon.proclaiming = A_VBG;
lexicon.proclaimed = A_VBD_JJ_VBN;
lexicon.producers = A_NNS;
lexicon.producer = A_NN;
lexicon.produces = A_VBZ;
lexicon.produced = A_VBN_VBD;
lexicon.produce = A_VB_VBP_NN;
lexicon.producing = A_VBG_JJ_NN;
lexicon.production = A_NN;
lexicon.products = A_NNS;
lexicon.product = A_NN;
lexicon.productions = A_NNS;
lexicon.productive = A_JJ;
lexicon.productivity = A_NN;
lexicon.profession = A_NN;
lexicon.professions = A_NNS;
lexicon.profess = A_VBP_VB;
lexicon.professedly = A_RB;
lexicon.professes = A_VBZ;
lexicon.professed = A_VBD_VBN_JJ;
lexicon.professing = A_VBG;
lexicon.professionally = A_RB;
lexicon.professionals = A_NNS;
lexicon.professional = A_JJ_NN;
lexicon.professionalism = A_NN;
lexicon.professors = A_NNS;
lexicon.professor = A_NN;
lexicon.profile = A_NN_JJ_VB;
lexicon.profiles = A_NNS_VBZ;
lexicon.profiled = A_VBN;
lexicon.profiling = A_VBG;
lexicon.profitably = A_RB;
lexicon.profited = A_VBD_VBN;
lexicon.profitable = A_JJ;
lexicon.profiteering = A_VBG_NN;
lexicon.profits = A_NNS_VBZ;
lexicon.profitting = A_VBG;
lexicon.profit = A_NN_VBP_VB;
lexicon.profiting = A_VBG;
lexicon.profitability = A_NN;
lexicon.profiteers = A_NNS;
lexicon.profound = A_JJ;
lexicon.profoundly = A_RB;
lexicon.profoundity = A_NN;
lexicon.programmed = A_VBN_JJ;
lexicon.program = A_NN_VBP_VB;
lexicon.programming = A_NN_VBG;
lexicon.programs = A_NNS;
lexicon.programed = A_VBN;
lexicon.programing = A_NN_VBG;
lexicon.progression = A_NN;
lexicon.progressing = A_VBG;
lexicon.progressed = A_VBD_VBN;
lexicon.progresses = A_VBZ;
lexicon.progressives = A_NNS;
lexicon.progressivity = A_NN;
lexicon.progress = A_NN_VB;
lexicon.progressively = A_RB;
lexicon.progressive = A_JJ_NN;
lexicon.progressions = A_NNS;
lexicon.prohibitive = A_JJ;
lexicon.prohibition = A_NN;
lexicon.prohibitions = A_NNS;
lexicon.prohibitively = A_RB;
lexicon.prohibited = A_VBN_VBD;
lexicon.prohibit = A_VB_VBP;
lexicon.prohibiting = A_VBG;
lexicon.prohibits = A_VBZ;
lexicon.projection = A_NN;
lexicon.projecting = A_VBG;
lexicon.project = A_NN_VB_VBP;
lexicon.projects = A_NNS_VBZ;
lexicon.projective = A_JJ;
lexicon.projected = A_VBN_JJ_VBD;
lexicon.projections = A_NNS;
lexicon.prominence = A_NN;
lexicon.prominant = A_JJ;
lexicon.prominently = A_RB;
lexicon.prominent = A_JJ;
lexicon.promising = A_JJ_VBG;
lexicon.promise = A_NN_VB_VBP;
lexicon.promises = A_VBZ_NNS;
lexicon.promised = A_VBD_JJ_VBN;
lexicon.promotional = A_JJ;
lexicon.promoters = A_NNS;
lexicon.promotions = A_NNS;
lexicon.promotion = A_NN;
lexicon.promotes = A_VBZ;
lexicon.promoting = A_VBG;
lexicon.promote = A_VB_VBP;
lexicon.promoter = A_NN;
lexicon.promoted = A_VBN_VBD;
lexicon.promptings = A_NNS;
lexicon.promptly = A_RB;
lexicon.prompt = A_VB_JJ_VBP;
lexicon.prompts = A_VBZ;
lexicon.prompted = A_VBD_VBN;
lexicon.prompting = A_VBG_NN;
lexicon.proof = A_NN_JJ;
lexicon.properly = A_RB;
lexicon.proper = A_JJ;
lexicon.property = A_NN;
lexicon.properties = A_NNS;
lexicon.proportioned = A_JJ;
lexicon.proportion = A_NN;
lexicon.proportionality = A_NN;
lexicon.proportionally = A_RB;
lexicon.proportions = A_NNS;
lexicon.proportional = A_JJ_NN;
lexicon.proposals = A_NNS;
lexicon.proposing = A_VBG;
lexicon.proposal = A_NN;
lexicon.proposed = A_VBN_VBD_VBP_JJ;
lexicon.proposes = A_VBZ;
lexicon.propose = A_VB_VBP;
lexicon.prosecution = A_NN;
lexicon.prosecuting = A_VBG_NN;
lexicon.prosecuted = A_VBN_VBD;
lexicon.prosecute = A_VB;
lexicon.prosecutions = A_NNS;
lexicon.prosecutors = A_NNS;
lexicon.prosecutor = A_NN;
lexicon.prospect = A_NN;
lexicon.prospects = A_NNS;
lexicon.prospectively = A_RB;
lexicon.prospective = A_JJ;
lexicon.protective = A_JJ_NN;
lexicon.protecting = A_VBG;
lexicon.protect = A_VB_VBP;
lexicon.protections = A_NNS;
lexicon.protected = A_VBN_JJ_VBD;
lexicon.protects = A_VBZ;
lexicon.protection = A_NN;
lexicon.protectively = A_RB;
lexicon.protein = A_NN;
lexicon.proteins = A_NNS_VBZ;
lexicon.protesting = A_VBG;
lexicon.protest = A_NN_VB_VBP;
lexicon.protestations = A_NNS;
lexicon.protested = A_VBD_VBN;
lexicon.protests = A_NNS_VBZ;
lexicon.protester = A_NN;
lexicon.protesters = A_NNS;
lexicon.protocols = A_NNS;
lexicon.protocol = A_NN;
lexicon.proud = A_JJ;
lexicon.proudly = A_RB;
lexicon.prove = A_VB_VBP;
lexicon.proving = A_VBG_NN;
lexicon.proved = A_VBD_JJ_VBN;
lexicon.proves = A_VBZ;
lexicon.provide = A_VB_VBP;
lexicon.provided = A_VBN_VBD;
lexicon.providing = A_VBG_IN;
lexicon.providers = A_NNS;
lexicon.provides = A_VBZ;
lexicon.provider = A_NN;
lexicon.providence = A_NN;
lexicon.province = A_NN;
lexicon.provinces = A_NNS;
lexicon.provisions = A_NNS;
lexicon.provisioned = A_VBN;
lexicon.provision = A_NN;
lexicon.provisioning = A_VBG_NN;
lexicon.provoking = A_VBG_JJ;
lexicon.provokes = A_VBZ;
lexicon.provoked = A_VBD_JJ_VBN;
lexicon.provoke = A_VB_VBP;
lexicon.psychologically = A_RB;
lexicon.psychology = A_NN;
lexicon.psychological = A_JJ;
lexicon.psychologists = A_NNS;
lexicon.psychologist = A_NN;
lexicon.publicize = A_VB;
lexicon.publicity = A_NN;
lexicon.publication = A_NN;
lexicon.publically = A_RB;
lexicon.publications = A_NNS;
lexicon.publicly = A_RB;
lexicon.public = A_JJ_NN_RB;
lexicon.publicized = A_VBN_JJ;
lexicon.publicizing = A_VBG;
lexicon.publishers = A_NNS;
lexicon.publishing = A_NN_JJ_VBG;
lexicon.publishes = A_VBZ;
lexicon.published = A_VBN_JJ_VBD;
lexicon.publisher = A_NN;
lexicon.publish = A_VB_VBP;
lexicon.publishable = A_JJ;
lexicon.pulling = A_VBG;
lexicon.pulls = A_VBZ_NNS;
lexicon.pull = A_VB_VBP_NN;
lexicon.pulled = A_VBD_VBN;
lexicon.pulsed = A_VBN;
lexicon.pulses = A_NNS;
lexicon.pulse = A_NN_VB;
lexicon.pulsing = A_VBG;
lexicon.pumps = A_NNS;
lexicon.pumping = A_VBG;
lexicon.pump = A_VB_VBP_NN;
lexicon.pumped = A_VBN_VBD;
lexicon.punched = A_VBD_VBN;
lexicon.punches = A_NNS;
lexicon.punch = A_NN_VBP_VB;
lexicon.punching = A_VBG_NN;
lexicon.punishable = A_JJ;
lexicon.punishing = A_VBG_JJ;
lexicon.punishes = A_VBZ;
lexicon.punished = A_VBN;
lexicon.punishments = A_NNS;
lexicon.punishment = A_NN;
lexicon.punish = A_VB_VBP;
lexicon.purchasers = A_NNS;
lexicon.purchase = A_NN_VB_VBP;
lexicon.purchaser = A_NN;
lexicon.purchases = A_NNS_VBZ;
lexicon.purchased = A_VBN_JJ_VBD;
lexicon.purchasing = A_VBG_JJ_NN;
lexicon.pure = A_JJ;
lexicon.purely = A_RB;
lexicon.purpling = A_VBG;
lexicon.purple = A_JJ_NN;
lexicon.purpose = A_NN;
lexicon.purposes = A_NNS;
lexicon.purposively = A_RB;
lexicon.purposeful = A_JJ;
lexicon.purposive = A_JJ;
lexicon.purposed = A_VBN;
lexicon.purposefully = A_RB;
lexicon.purposely = A_RB;
lexicon.purses = A_NNS;
lexicon.pursed = A_VBD;
lexicon.purse = A_NN;
lexicon.pursuing = A_VBG_NN;
lexicon.pursues = A_VBZ;
lexicon.pursued = A_VBN_JJ_VBD;
lexicon.pursue = A_VB_VBP;
lexicon.pursuits = A_NNS;
lexicon.pursuit = A_NN;
lexicon.pushing = A_VBG_JJ_NN;
lexicon.pushes = A_VBZ_NNS;
lexicon.pushed = A_VBD_VBN;
lexicon.push = A_VB_VBP_NN;
lexicon.puts = A_VBZ_NNS;
lexicon.putted = A_VBD;
lexicon.put = A_VB_JJ_NN_VBD_VBN_VBP;
lexicon.putting = A_VBG;
lexicon.puzzling = A_JJ_VBG;
lexicon.puzzled = A_VBN_JJ_VBD;
lexicon.puzzles = A_NNS_VBZ;
lexicon.puzzle = A_NN_VB;
lexicon.qualify = A_VB_VBP;
lexicon.qualifying = A_VBG;
lexicon.qualifies = A_VBZ;
lexicon.qualified = A_VBN_JJ_VBD;
lexicon.qualities = A_NNS;
lexicon.quality = A_NN_JJ;
lexicon.quantities = A_NNS;
lexicon.quantity = A_NN;
lexicon.quarter = A_NN;
lexicon.quarters = A_NNS;
lexicon.quarterly = A_JJ_NN_RB;
lexicon.quarterback = A_NN;
lexicon.quarterbacks = A_NNS;
lexicon.queens = A_NNS;
lexicon.queen = A_NN;
lexicon.quests = A_NNS;
lexicon.quest = A_NN;
lexicon.questioned = A_VBD_VBN;
lexicon.questioner = A_NN;
lexicon.questionable = A_JJ;
lexicon.questionably = A_RB;
lexicon.questioning = A_VBG_JJ_NN;
lexicon.question = A_NN_VB_VBP;
lexicon.questions = A_NNS_VBZ;
lexicon.questioningly = A_RB;
lexicon.questioners = A_NNS;
lexicon.questionnaires = A_NNS;
lexicon.questionnaire = A_NN;
lexicon.quickness = A_NN;
lexicon.quick = A_JJ_NN_RB;
lexicon.quickly = A_RB;
lexicon.quieting = A_VBG;
lexicon.quiet = A_JJ_NN_VB;
lexicon.quieted = A_VBD_VBN;
lexicon.quietness = A_NN;
lexicon.quietly = A_RB;
lexicon.quitting = A_VBG;
lexicon.quit = A_VB_VBD_VBN_VBP_NN;
lexicon.quite = A_RB_PDT;
lexicon.quits = A_VBZ_NNS;
lexicon.quoting = A_VBG;
lexicon.quote = A_VB_VBP_NN;
lexicon.quoted = A_VBN_VBD;
lexicon.quotes = A_NNS_VBZ;
lexicon.rabbit = A_NN;
lexicon.rabbits = A_NNS;
lexicon.raced = A_VBD;
lexicon.races = A_NNS_VBZ;
lexicon.race = A_NN_VB;
lexicon.racing = A_VBG_JJ_NN;
lexicon.racially = A_RB;
lexicon.racial = A_JJ;
lexicon.racism = A_NN;
lexicon.racked = A_VBN_VBD;
lexicon.rack = A_NN_VB_VBP;
lexicon.racking = A_VBG;
lexicon.racks = A_NNS;
lexicon.radar = A_NN;
lexicon.radars = A_NNS;
lexicon.radiators = A_NNS;
lexicon.radiator = A_NN;
lexicon.radiates = A_VBZ;
lexicon.radiated = A_VBD_VBN_JJ;
lexicon.radiation = A_NN;
lexicon.radiate = A_VB_VBP;
lexicon.radiating = A_VBG;
lexicon.radiations = A_NNS;
lexicon.radicals = A_NNS;
lexicon.radicalized = A_VBN;
lexicon.radically = A_RB;
lexicon.radical = A_JJ_NN;
lexicon.radicalism = A_NN;
lexicon.radioing = A_VBG;
lexicon.radios = A_NNS;
lexicon.radio = A_NN_VB;
lexicon.radioed = A_JJ_VBD;
lexicon.rage = A_NN_VB;
lexicon.raged = A_VBD_VBN;
lexicon.rages = A_VBZ_NNS;
lexicon.raging = A_VBG_JJ;
lexicon.railed = A_VBD_VBN;
lexicon.rails = A_NNS_VBZ;
lexicon.railing = A_NN;
lexicon.railings = A_NNS;
lexicon.rail = A_NN_VB;
lexicon.railroads = A_NNS;
lexicon.railroading = A_VBG;
lexicon.railroader = A_NN;
lexicon.railroad = A_NN;
lexicon.rained = A_VBD_VBN;
lexicon.rain = A_NN_VB;
lexicon.raining = A_VBG;
lexicon.rains = A_NNS_VBZ;
lexicon.raises = A_VBZ_NNS;
lexicon.raise = A_VB_VBP_NN;
lexicon.raised = A_VBN_VBD_JJ;
lexicon.raising = A_VBG_NN_RP;
lexicon.rally = A_NN_VBP_VB;
lexicon.rallying = A_VBG_JJ_NN;
lexicon.rallied = A_VBD_VBN;
lexicon.rallies = A_NNS_VBZ;
lexicon.ranch = A_NN;
lexicon.ranches = A_NNS;
lexicon.randomness = A_NN;
lexicon.randomly = A_RB;
lexicon.randomization = A_NN;
lexicon.random = A_JJ_NN;
lexicon.rang = A_VBD;
lexicon.ranged = A_VBD_VBN;
lexicon.ranges = A_NNS_VBZ;
lexicon.range = A_NN_JJ_VB_VBP_VBZ;
lexicon.ranging = A_VBG;
lexicon.rankings = A_NNS;
lexicon.ranked = A_VBD_VBN_JJ;
lexicon.rank = A_NN_VBP_JJ_VB;
lexicon.ranking = A_JJ_VBG_NN;
lexicon.ranks = A_NNS_VBZ;
lexicon.raped = A_VBN_VBD_JJ;
lexicon.rapes = A_NNS_VBZ;
lexicon.rape = A_NN_VB_VBP;
lexicon.raping = A_VBG_NN;
lexicon.rapidement = A_FW;
lexicon.rapidly = A_RB;
lexicon.rapid = A_JJ;
lexicon.rapidity = A_NN;
lexicon.rare = A_JJ;
lexicon.raring = A_JJ;
lexicon.rarely = A_RB;
lexicon.rats = A_NNS;
lexicon.rat = A_NN_VB;
lexicon.rate = A_NN_VBP_VB;
lexicon.rating = A_NN_VBG;
lexicon.ratings = A_NNS;
lexicon.rated = A_VBN_JJ_VBD;
lexicon.rates = A_NNS_VBZ;
lexicon.rather = A_RB_IN;
lexicon.ratios = A_NNS;
lexicon.ratio = A_NN;
lexicon.rationed = A_VBN;
lexicon.rationally = A_RB;
lexicon.rationalism = A_NN;
lexicon.ration = A_NN;
lexicon.rationalizations = A_NNS;
lexicon.rational = A_JJ;
lexicon.rations = A_NNS;
lexicon.rationalize = A_VB_VBP;
lexicon.rationalized = A_JJ_VBN;
lexicon.rationalizing = A_VBG;
lexicon.rationing = A_NN;
lexicon.rationalization = A_NN;
lexicon.rationality = A_NN;
lexicon.raw = A_JJ;
lexicon.re = A_NN;
lexicon.reaches = A_VBZ_NNS;
lexicon.reached = A_VBN_VBD;
lexicon.reaching = A_VBG_NN;
lexicon.reach = A_VB_VBP_NN;
lexicon.reacting = A_VBG;
lexicon.reacted = A_VBD_VBN;
lexicon.reacts = A_VBZ;
lexicon.react = A_VB_VBP;
lexicon.reactions = A_NNS;
lexicon.reaction = A_NN;
lexicon.readings = A_NNS;
lexicon.read = A_VB_NN_VBD_VBN_VBP;
lexicon.reading = A_NN_VBG;
lexicon.reads = A_VBZ;
lexicon.readers = A_NNS;
lexicon.reader = A_NN;
lexicon.readily = A_RB;
lexicon.readiness = A_NN;
lexicon.readying = A_VBG;
lexicon.ready = A_JJ_RB_VB;
lexicon.readied = A_VBN_VBD;
lexicon.real = A_JJ_NN_RB;
lexicon.realness = A_NN;
lexicon.realists = A_NNS;
lexicon.realistically = A_RB;
lexicon.realist = A_NN;
lexicon.realistic = A_JJ;
lexicon.reality = A_NN;
lexicon.realities = A_NNS;
lexicon.realizing = A_VBG;
lexicon.realization = A_NN;
lexicon.realized = A_VBD_JJ_VBN;
lexicon.realizes = A_VBZ;
lexicon.realize = A_VB_VBP;
lexicon.really = A_RB;
lexicon.realms = A_NNS;
lexicon.realm = A_NN;
lexicon.rear = A_JJ_NN_VB;
lexicon.reared = A_VBD_VBN;
lexicon.rearing = A_VBG_NN;
lexicon.rears = A_VBZ;
lexicon.reasonably = A_RB;
lexicon.reasonable = A_JJ;
lexicon.reason = A_NN_VB_VBP;
lexicon.reasoned = A_VBD_JJ_VBN;
lexicon.reasoning = A_NN_VBG;
lexicon.reasons = A_NNS_VBZ;
lexicon.rebelled = A_VBD_VBN;
lexicon.rebels = A_NNS_VBZ;
lexicon.rebelling = A_VBG;
lexicon.rebel = A_NN_VBP_JJ_VB;
lexicon.rebuild = A_VB;
lexicon.rebuilder = A_NN;
lexicon.rebuilds = A_VBZ;
lexicon.rebuilding = A_VBG_NN;
lexicon.recall = A_VB_NN_VBP;
lexicon.recalls = A_VBZ_NNS;
lexicon.recalled = A_VBD_VBN;
lexicon.recalling = A_VBG_NN;
lexicon.receivers = A_NNS;
lexicon.receive = A_VB_VBP;
lexicon.received = A_VBD_VBN_JJ;
lexicon.receives = A_VBZ;
lexicon.receiver = A_NN;
lexicon.receivables = A_NN_NNS;
lexicon.receiving = A_VBG_NN;
lexicon.receivable = A_JJ_NN;
lexicon.recent = A_JJ;
lexicon.recently = A_RB;
lexicon.receptions = A_NNS;
lexicon.reception = A_NN;
lexicon.receptive = A_JJ;
lexicon.receptivity = A_NN;
lexicon.recess = A_NN;
lexicon.recession = A_NN;
lexicon.recessions = A_NNS;
lexicon.recessed = A_VBN;
lexicon.recipes = A_NNS;
lexicon.recipe = A_NN;
lexicon.recipients = A_NNS;
lexicon.recipient = A_JJ_NN;
lexicon.recognition = A_NN;
lexicon.recognitions = A_NNS;
lexicon.recognizing = A_VBG;
lexicon.recognize = A_VB_VBP;
lexicon.recognized = A_VBN_JJ_VBD;
lexicon.recognizes = A_VBZ;
lexicon.recommendation = A_NN;
lexicon.recommends = A_VBZ;
lexicon.recommended = A_VBD_VBN_JJ;
lexicon.recommending = A_VBG;
lexicon.recommend = A_VB_VBP;
lexicon.recommendations = A_NNS;
lexicon.records = A_NNS_VBZ;
lexicon.recorded = A_VBN_VBD_JJ;
lexicon.recorder = A_NN;
lexicon.recordings = A_NNS;
lexicon.recording = A_NN_VBG;
lexicon.recorders = A_NNS;
lexicon.record = A_NN_JJ_VB_VBP;
lexicon.recovered = A_VBD_VBN;
lexicon.recover = A_VB_VBP;
lexicon.recovers = A_VBZ;
lexicon.recovering = A_VBG;
lexicon.recovery = A_NN;
lexicon.recoveries = A_NNS;
lexicon.recruits = A_NNS_VBZ;
lexicon.recruiting = A_VBG_NN;
lexicon.recruit = A_VB_VBP_NN;
lexicon.recruitment = A_NN;
lexicon.recruiter = A_NN;
lexicon.recruited = A_VBN_VBD;
lexicon.red = A_JJ_NN;
lexicon.reds = A_NNS;
lexicon.reducing = A_VBG_NN;
lexicon.reduce = A_VB_VBP;
lexicon.reduces = A_VBZ;
lexicon.reducer = A_NN;
lexicon.reduced = A_VBN_VBD_JJ;
lexicon.reductions = A_NNS;
lexicon.reduction = A_NN;
lexicon.reference = A_NN;
lexicon.references = A_NNS;
lexicon.referent = A_NN;
lexicon.referring = A_VBG;
lexicon.refers = A_VBZ;
lexicon.refer = A_VB_VBP;
lexicon.referred = A_VBN_VBD;
lexicon.reflectance = A_NN;
lexicon.reflected = A_VBD_JJ_VBN;
lexicon.reflection = A_NN;
lexicon.reflecting = A_VBG_JJ;
lexicon.reflections = A_NNS;
lexicon.reflects = A_VBZ;
lexicon.reflective = A_JJ;
lexicon.reflect = A_VB_VBP;
lexicon.reformation = A_NN;
lexicon.reformer = A_JJ_NN;
lexicon.reformed = A_VBN_JJ_VBD;
lexicon.reforming = A_VBG;
lexicon.reformers = A_NNS;
lexicon.reform = A_NN_VB;
lexicon.reformism = A_NN;
lexicon.reforms = A_NNS;
lexicon.refrigerators = A_NNS;
lexicon.refrigeration = A_NN;
lexicon.refrigerator = A_NN;
lexicon.refrigerated = A_VBN_JJ;
lexicon.refrigerant = A_NN;
lexicon.refuge = A_NN;
lexicon.refugee = A_NN;
lexicon.refugees = A_NNS;
lexicon.refused = A_VBD_VBN;
lexicon.refuses = A_VBZ;
lexicon.refuse = A_VB_VBP_NN;
lexicon.refusers = A_NNS;
lexicon.refusal = A_NN;
lexicon.refusing = A_VBG_NN;
lexicon.regaining = A_VBG;
lexicon.regained = A_VBD_VBN;
lexicon.regains = A_VBZ;
lexicon.regain = A_VB_VBP;
lexicon.regard = A_NN_VB_VBP;
lexicon.regarded = A_VBN_JJ_VBD;
lexicon.regarding = A_VBG;
lexicon.regards = A_VBZ_NNS;
lexicon.regardless = A_RB;
lexicon.regime = A_NN;
lexicon.regimes = A_NNS;
lexicon.regions = A_NNS;
lexicon.regionalism = A_JJ;
lexicon.regionally = A_RB;
lexicon.region = A_NN;
lexicon.regional = A_JJ;
lexicon.regionals = A_NNS;
lexicon.registering = A_VBG;
lexicon.registered = A_VBN_VBD_JJ;
lexicon.register = A_VB_NN_VBP;
lexicon.registers = A_NNS_VBZ;
lexicon.regretted = A_VBD_VBN;
lexicon.regret = A_VBP_NN_VB;
lexicon.regrets = A_VBZ_NNS;
lexicon.regular = A_JJ;
lexicon.regulars = A_NNS;
lexicon.regularly = A_RB;
lexicon.regularity = A_NN;
lexicon.regulating = A_VBG_NN;
lexicon.regulations = A_NNS;
lexicon.regulation = A_NN_JJ;
lexicon.regulator = A_NN;
lexicon.regulates = A_VBZ;
lexicon.regulated = A_VBN_JJ_VBD;
lexicon.regulative = A_JJ;
lexicon.regulate = A_VB_VBP;
lexicon.regulators = A_NNS_VBZ;
lexicon.regulatory = A_JJ;
lexicon.rehabilitate = A_VB;
lexicon.rehabilitations = A_NNS;
lexicon.rehabilitation = A_NN;
lexicon.rehabilitated = A_VBN;
lexicon.rehabilitating = A_VBG;
lexicon.reinforcement = A_NN;
lexicon.reinforcing = A_VBG;
lexicon.reinforcements = A_NNS;
lexicon.reinforce = A_VB_VBP;
lexicon.reinforces = A_VBZ;
lexicon.reinforced = A_VBN_VBD_JJ;
lexicon.reject = A_VB_VBP;
lexicon.rejected = A_VBD_VBN;
lexicon.rejects = A_VBZ_NNS;
lexicon.rejection = A_NN;
lexicon.rejections = A_NNS;
lexicon.rejecting = A_VBG;
lexicon.relations = A_NNS;
lexicon.relatives = A_NNS;
lexicon.relatively = A_RB;
lexicon.related = A_VBN_JJ_VBD;
lexicon.relates = A_VBZ;
lexicon.relate = A_VBP_VB;
lexicon.relating = A_VBG;
lexicon.relative = A_JJ_NN;
lexicon.relation = A_NN;
lexicon.relativity = A_NN;
lexicon.relational = A_JJ;
lexicon.relationship = A_NN;
lexicon.relationships = A_NNS;
lexicon.relax = A_VB_VBP;
lexicon.relaxed = A_VBN_JJ_VBD;
lexicon.relaxes = A_VBZ;
lexicon.relaxer = A_NN;
lexicon.relaxing = A_VBG_JJ;
lexicon.relaxation = A_NN;
lexicon.releasing = A_VBG;
lexicon.release = A_NN_VBP_VB;
lexicon.releases = A_NNS_VBZ;
lexicon.released = A_VBN_VBD;
lexicon.relevancy = A_NN;
lexicon.relevance = A_NN;
lexicon.relevant = A_JJ;
lexicon.reliability = A_NN;
lexicon.reliable = A_JJ;
lexicon.reliably = A_RB;
lexicon.reliables = A_NNS;
lexicon.relief = A_NN;
lexicon.reliefs = A_NNS;
lexicon.relieving = A_VBG;
lexicon.relieve = A_VB;
lexicon.relieved = A_VBN_VBD_JJ;
lexicon.reliever = A_NN;
lexicon.relieves = A_VBZ;
lexicon.religions = A_NNS;
lexicon.religion = A_NN;
lexicon.religious = A_JJ_IN_NN;
lexicon.religiousness = A_NN;
lexicon.religiously = A_RB;
lexicon.reluctant = A_JJ;
lexicon.reluctance = A_NN;
lexicon.reluctantly = A_RB;
lexicon.relies = A_VBZ;
lexicon.relied = A_VBN_VB_VBD;
lexicon.rely = A_VB_VBP;
lexicon.relying = A_VBG;
lexicon.remain = A_VB_VBP;
lexicon.remains = A_VBZ_NNS;
lexicon.remaining = A_VBG_JJ;
lexicon.remained = A_VBD_VBN;
lexicon.remarked = A_VBD_VBN;
lexicon.remarking = A_VBG;
lexicon.remarks = A_NNS_VBZ;
lexicon.remark = A_NN_VB;
lexicon.remarkable = A_JJ;
lexicon.remarkably = A_RB;
lexicon.remember = A_VB_VBP;
lexicon.remembered = A_VBD_JJ_VBN;
lexicon.remembers = A_VBZ;
lexicon.remembering = A_VBG_NN;
lexicon.reminder = A_NN;
lexicon.reminders = A_NNS;
lexicon.remind = A_VB_VBP;
lexicon.reminded = A_VBD_VBN;
lexicon.reminds = A_VBZ;
lexicon.reminding = A_VBG;
lexicon.remoter = A_JJR;
lexicon.remote = A_JJ;
lexicon.remotely = A_RB;
lexicon.remoteness = A_NN;
lexicon.removable = A_JJ;
lexicon.removing = A_VBG;
lexicon.removal = A_NN;
lexicon.removes = A_VBZ;
lexicon.removed = A_VBN_JJ_VBD;
lexicon.remove = A_VB_VBP;
lexicon.rendering = A_VBG_NN;
lexicon.render = A_VB_VBP;
lexicon.rendered = A_VBN_VBD;
lexicon.renders = A_VBZ;
lexicon.renderings = A_NNS;
lexicon.rented = A_VBN_JJ_VBD;
lexicon.rent = A_NN_VB_VBN_VBP;
lexicon.rents = A_NNS_VBZ;
lexicon.renting = A_VBG_NN;
lexicon.rentals = A_NNS;
lexicon.rental = A_JJ_NN;
lexicon.repair = A_NN_VB_VBP;
lexicon.repaired = A_VBN_VBD;
lexicon.repairing = A_VBG_NN;
lexicon.repairs = A_NNS_VBZ;
lexicon.repeated = A_VBN_VBD_JJ;
lexicon.repeating = A_VBG_JJ;
lexicon.repeats = A_VBZ_NNS;
lexicon.repeatedly = A_RB;
lexicon.repeat = A_VB_JJ_NN_VBP;
lexicon.repeater = A_NN;
lexicon.repeaters = A_NNS;
lexicon.replaces = A_VBZ;
lexicon.replacements = A_NNS;
lexicon.replaced = A_VBN_VBD;
lexicon.replacement = A_NN_JJ;
lexicon.replace = A_VB_VBP;
lexicon.replacing = A_VBG;
lexicon.replying = A_VBG;
lexicon.reply = A_NN_VB_VBP;
lexicon.replied = A_VBD_VBN;
lexicon.replies = A_VBZ_NNS;
lexicon.report = A_NN_VBP_VB;
lexicon.reporter = A_NN;
lexicon.reported = A_VBD_JJ_VB_VBN_VBP;
lexicon.reportedly = A_RB;
lexicon.reporters = A_NNS;
lexicon.reporting = A_VBG_NN;
lexicon.reports = A_NNS_VBZ;
lexicon.represents = A_VBZ;
lexicon.represent = A_VB_VBP;
lexicon.representative = A_NN_JJ;
lexicon.represented = A_VBN_VBD;
lexicon.representatives = A_NNS;
lexicon.representing = A_VBG;
lexicon.representational = A_JJ_NN;
lexicon.representations = A_NNS;
lexicon.representation = A_NN;
lexicon.representives = A_NNS;
lexicon.republic = A_NN;
lexicon.republics = A_NNS;
lexicon.republican = A_JJ;
lexicon.reputations = A_NNS;
lexicon.repute = A_NN;
lexicon.reputable = A_JJ;
lexicon.reputed = A_VBN_JJ;
lexicon.reputedly = A_RB;
lexicon.reputation = A_NN;
lexicon.requesting = A_VBG;
lexicon.requests = A_NNS_VBZ;
lexicon.requested = A_VBD_VBN;
lexicon.requesters = A_NNS;
lexicon.request = A_NN_VB_VBP;
lexicon.required = A_VBN_VBD_JJ;
lexicon.requires = A_VBZ;
lexicon.requirements = A_NNS;
lexicon.requiring = A_VBG;
lexicon.requirement = A_NN;
lexicon.require = A_VB_VBP;
lexicon.rescue = A_NN_VB;
lexicon.rescuing = A_VBG;
lexicon.rescued = A_VBN_VBD;
lexicon.rescues = A_NNS_VBZ;
lexicon.research = A_NN_VB_VBP;
lexicon.researchable = A_JJ;
lexicon.researches = A_VBZ_NNS;
lexicon.researcher = A_NN;
lexicon.researched = A_VBN_VBD;
lexicon.researchers = A_NNS;
lexicon.researching = A_VBG;
lexicon.resemble = A_VB_VBP;
lexicon.resembled = A_VBD;
lexicon.resemblances = A_NNS;
lexicon.resembling = A_VBG;
lexicon.resemblance = A_NN;
lexicon.resembles = A_VBZ;
lexicon.reserves = A_NNS_VBZ;
lexicon.reserve = A_NN_JJ_VB_VBP;
lexicon.reserving = A_VBG;
lexicon.reservations = A_NNS;
lexicon.reservation = A_NN;
lexicon.reserved = A_VBN_VBD_JJ;
lexicon.residence = A_NN;
lexicon.residency = A_NN;
lexicon.residences = A_NNS;
lexicon.resides = A_VBZ;
lexicon.resided = A_VBD_VBN;
lexicon.reside = A_VBP_VB;
lexicon.residents = A_NNS;
lexicon.resident = A_NN_JJ;
lexicon.residing = A_VBG;
lexicon.residentially = A_RB;
lexicon.residential = A_JJ;
lexicon.resignation = A_NN;
lexicon.resignations = A_NNS;
lexicon.resigned = A_VBD_VBN_JJ;
lexicon.resign = A_VB_VBP;
lexicon.resigning = A_VBG_NN;
lexicon.resignedly = A_RB;
lexicon.resigns = A_VBZ;
lexicon.resistant = A_JJ_NN;
lexicon.resisted = A_VBN_VBD;
lexicon.resisting = A_VBG;
lexicon.resists = A_VBZ;
lexicon.resistive = A_JJ;
lexicon.resist = A_VB_VBP;
lexicon.resistances = A_NNS;
lexicon.resistance = A_NN_FW;
lexicon.resolutions = A_NNS;
lexicon.resolute = A_JJ;
lexicon.resolution = A_NN;
lexicon.resolutely = A_RB;
lexicon.resolving = A_VBG;
lexicon.resolved = A_VBN_VBD;
lexicon.resolves = A_VBZ;
lexicon.resolve = A_VB_NN;
lexicon.resorting = A_VBG;
lexicon.resorts = A_NNS_VBZ;
lexicon.resorted = A_VBN;
lexicon.resort = A_NN_VBP_VB;
lexicon.resource = A_NN;
lexicon.resourceful = A_JJ;
lexicon.resources = A_NNS;
lexicon.resourcefulness = A_NN;
lexicon.resourcefully = A_RB;
lexicon.respecting = A_VBG;
lexicon.respect = A_NN_VBP_VB;
lexicon.respectability = A_NN;
lexicon.respectively = A_RB;
lexicon.respects = A_NNS_VBZ;
lexicon.respective = A_JJ;
lexicon.respectful = A_JJ;
lexicon.respected = A_VBN_JJ_VBD;
lexicon.respectable = A_JJ;
lexicon.respectfully = A_RB;
lexicon.responds = A_VBZ;
lexicon.responding = A_VBG;
lexicon.respondents = A_NNS;
lexicon.respond = A_VB_NN_VBP;
lexicon.responded = A_VBD_VBN;
lexicon.respondent = A_NN;
lexicon.responsible = A_JJ;
lexicon.responsive = A_JJ;
lexicon.response = A_NN;
lexicon.responses = A_NNS;
lexicon.responsibilities = A_NNS;
lexicon.responsiveness = A_NN;
lexicon.responsibly = A_RB;
lexicon.responsively = A_RB;
lexicon.responsibility = A_NN;
lexicon.rests = A_VBZ_NNS;
lexicon.rested = A_VBD_VBN;
lexicon.rest = A_NN_VBP_RB_VB;
lexicon.resting = A_VBG;
lexicon.restful = A_JJ;
lexicon.restaurants = A_NNS;
lexicon.restaurant = A_NN;
lexicon.restorer = A_NN;
lexicon.restored = A_VBN_VBD;
lexicon.restoring = A_VBG_NN;
lexicon.restoration = A_NN;
lexicon.restore = A_VB_VBP;
lexicon.restorers = A_NNS;
lexicon.restorability = A_NN;
lexicon.restorative = A_JJ;
lexicon.restores = A_VBZ;
lexicon.restriction = A_NN;
lexicon.restrictive = A_JJ;
lexicon.restricted = A_VBN_JJ_VBD;
lexicon.restrictions = A_NNS;
lexicon.restricts = A_VBZ;
lexicon.restrict = A_VB_VBP;
lexicon.restricting = A_VBG_JJ;
lexicon.results = A_NNS_VBZ;
lexicon.resulting = A_VBG_JJ;
lexicon.resultant = A_JJ_NN;
lexicon.result = A_NN_VBP_VB;
lexicon.resultants = A_NNS;
lexicon.resulted = A_VBD_VBN;
lexicon.resumed = A_VBD_VBN;
lexicon.resumes = A_VBZ_NNS;
lexicon.resuming = A_VBG;
lexicon.resume = A_VB_NN_VBP;
lexicon.retailer = A_NN;
lexicon.retailed = A_VBN;
lexicon.retailers = A_NNS;
lexicon.retailing = A_NN_VBG;
lexicon.retail = A_JJ_NN_VB_VBP;
lexicon.retails = A_VBZ_NNS;
lexicon.retaining = A_VBG;
lexicon.retained = A_VBN_JJ_VBD;
lexicon.retainer = A_NN;
lexicon.retains = A_VBZ;
lexicon.retain = A_VB_VBP;
lexicon.retainers = A_NNS;
lexicon.retires = A_VBZ;
lexicon.retirements = A_NNS;
lexicon.retiring = A_VBG_JJ;
lexicon.retire = A_VB_VBP;
lexicon.retirement = A_NN;
lexicon.retired = A_VBN_JJ_VBD;
lexicon.retreating = A_VBG;
lexicon.retreat = A_NN_VB;
lexicon.retreats = A_NNS;
lexicon.retreated = A_VBD_VBN;
lexicon.returned = A_VBD_VBN;
lexicon.returns = A_NNS_VBZ;
lexicon.returning = A_VBG;
lexicon.return = A_NN_VBP_JJ_VB;
lexicon.revealed = A_VBD_JJ_VBN;
lexicon.reveal = A_VB_VBP;
lexicon.reveals = A_VBZ;
lexicon.revealing = A_VBG_JJ;
lexicon.revelling = A_VBG;
lexicon.revelers = A_NNS;
lexicon.revels = A_NNS;
lexicon.revellers = A_NNS;
lexicon.revel = A_VB_NN_VBP;
lexicon.revelation = A_NN;
lexicon.reveled = A_VBD;
lexicon.revelations = A_NNS;
lexicon.revellings = A_NNS;
lexicon.reveling = A_VBG;
lexicon.revenues = A_NNS;
lexicon.revenuers = A_NNS;
lexicon.revenue = A_NN;
lexicon.reversibility = A_NN;
lexicon.reversals = A_NNS;
lexicon.reversible = A_JJ;
lexicon.reverse = A_VB_JJ_NN_RB_VBP;
lexicon.reversing = A_VBG;
lexicon.reversed = A_VBD_JJ_VBN;
lexicon.reverses = A_VBZ_NNS;
lexicon.reversal = A_NN;
lexicon.reviewed = A_VBN_VBD;
lexicon.reviewer = A_NN;
lexicon.reviews = A_NNS_VBZ;
lexicon.reviewers = A_NNS;
lexicon.review = A_NN_VB_VBP;
lexicon.reviewing = A_VBG_NN;
lexicon.revolutions = A_NNS;
lexicon.revolution = A_NN;
lexicon.revolutionary = A_JJ_NN;
lexicon.revolutionaries = A_NNS;
lexicon.rewarded = A_VBN_VBD;
lexicon.reward = A_NN_VB_VBP;
lexicon.rewards = A_NNS_VBZ;
lexicon.rewarding = A_JJ_VBG;
lexicon.rhetorical = A_JJ;
lexicon.rhetoric = A_NN;
lexicon.rhythm = A_NN;
lexicon.rhythms = A_NNS;
lexicon.ribs = A_NNS;
lexicon.ribbed = A_JJ;
lexicon.ribbing = A_NN;
lexicon.rib = A_NN;
lexicon.ribbons = A_NNS;
lexicon.ribbon = A_NN;
lexicon.rice = A_NN;
lexicon.rich = A_JJ_NNS_NN;
lexicon.richness = A_NN;
lexicon.riches = A_NNS_FW_NN;
lexicon.riche = A_JJ;
lexicon.richly = A_RB;
lexicon.ridden = A_VBN;
lexicon.ridding = A_VBG;
lexicon.rid = A_JJ_VBD_VBN_RB_VB;
lexicon.riding = A_VBG_JJ_NN;
lexicon.ridings = A_NNS;
lexicon.ride = A_VB_NN_VBP;
lexicon.rides = A_NNS_VBZ;
lexicon.riders = A_NNS;
lexicon.rider = A_NN;
lexicon.ridge = A_NN;
lexicon.ridges = A_NNS;
lexicon.ridiculing = A_VBG;
lexicon.ridicules = A_VBZ;
lexicon.ridiculous = A_JJ;
lexicon.ridicule = A_NN_VB;
lexicon.ridiculed = A_VBN;
lexicon.ridiculously = A_RB;
lexicon.rifles = A_NNS;
lexicon.rifled = A_JJ;
lexicon.rifling = A_NN;
lexicon.rifle = A_NN;
lexicon.righted = A_VBN;
lexicon.rightfully = A_RB;
lexicon.rights = A_NNS;
lexicon.rightful = A_JJ;
lexicon.rightness = A_NN;
lexicon.rightly = A_RB;
lexicon.right = A_NN_RB_VB_IN_JJ;
lexicon.rims = A_NNS;
lexicon.rimmed = A_JJ_VBD;
lexicon.rim = A_NN_VBP;
lexicon.rings = A_NNS_VBZ;
lexicon.ring = A_NN_VB_VBP;
lexicon.ringed = A_JJ_VBN;
lexicon.ringing = A_VBG_NN;
lexicon.ringings = A_NNS;
lexicon.riots = A_NNS;
lexicon.rioting = A_NN;
lexicon.rioted = A_VBD;
lexicon.riot = A_NN;
lexicon.ripping = A_VBG;
lexicon.ripped = A_VBD_VBN;
lexicon.rip = A_VB_NN;
lexicon.rising = A_VBG_NN_JJ;
lexicon.rises = A_VBZ_NNS;
lexicon.rise = A_NN_VBP_VB;
lexicon.risking = A_VBG;
lexicon.risks = A_NNS_VBZ;
lexicon.risk = A_NN_VBP_VB;
lexicon.risked = A_VBD_VBN;
lexicon.riskiness = A_NN;
lexicon.risky = A_JJ;
lexicon.ritual = A_NN;
lexicon.ritualized = A_VBN;
lexicon.rituals = A_NNS;
lexicon.rivaled = A_VBD;
lexicon.rivals = A_NNS_VBZ;
lexicon.rivaling = A_VBG;
lexicon.rival = A_JJ_NN_VB_VBP;
lexicon.rivalled = A_VBD;
lexicon.rivers = A_NNS;
lexicon.river = A_NN;
lexicon.roads = A_NNS;
lexicon.road = A_NN;
lexicon.robotic = A_JJ;
lexicon.robotics = A_NNS;
lexicon.robot = A_NN;
lexicon.robotism = A_NN;
lexicon.robots = A_NNS;
lexicon.rocks = A_NNS_VBZ;
lexicon.rock = A_NN_JJ_VB_VBP;
lexicon.rocking = A_NN_JJ_VBG;
lexicon.rocked = A_VBD_VBN;
lexicon.rocketed = A_VBD_VBN;
lexicon.rocketing = A_VBG;
lexicon.rockets = A_NNS;
lexicon.rocket = A_NN;
lexicon.rod = A_NN;
lexicon.rods = A_NNS;
lexicon.rodding = A_NN;
lexicon.role = A_NN;
lexicon.roles = A_NNS;
lexicon.roll = A_NN_VB_VBP;
lexicon.rolls = A_NNS_VBZ;
lexicon.rolling = A_VBG_JJ_NN;
lexicon.rolled = A_VBD_VBN_JJ;
lexicon.romances = A_NNS;
lexicon.romancing = A_VBG_NN;
lexicon.romancers = A_NNS;
lexicon.romance = A_NN;
lexicon.romantic = A_JJ_NN;
lexicon.romantics = A_NNS;
lexicon.romantically = A_RB;
lexicon.roof = A_NN;
lexicon.roofs = A_NNS;
lexicon.roofing = A_NN;
lexicon.roofed = A_VBN;
lexicon.room = A_NN_NNP;
lexicon.roomed = A_VBD;
lexicon.rooming = A_VBG;
lexicon.rooms = A_NNS;
lexicon.roomful = A_NN;
lexicon.root = A_NN_VBP_VB;
lexicon.rooted = A_VBN_JJ;
lexicon.roots = A_NNS;
lexicon.rooting = A_VBG_NN;
lexicon.ropes = A_NNS;
lexicon.roped = A_VBD;
lexicon.rope = A_NN_VB;
lexicon.rose = A_VBD_VBP_JJ_NN;
lexicon.roses = A_NNS;
lexicon.roughed = A_VBD;
lexicon.roughness = A_NN;
lexicon.rough = A_JJ_RB;
lexicon.roughly = A_RB;
lexicon.roundness = A_NN;
lexicon.rounded = A_VBN_JJ_VBD;
lexicon.round = A_NN_IN_JJ_VBP_RB_VB;
lexicon.roundly = A_RB;
lexicon.rounding = A_VBG_NN;
lexicon.rounds = A_NNS_VBZ;
lexicon.rout = A_NN;
lexicon.routed = A_VBN_VBD;
lexicon.routes = A_NNS_VBZ;
lexicon.routings = A_NNS;
lexicon.route = A_NN_VBP_FW_IN_RB_VB;
lexicon.routing = A_VBG_NN;
lexicon.routines = A_NNS;
lexicon.routinely = A_RB;
lexicon.routine = A_JJ_NN;
lexicon.row = A_NN_VBP_VB;
lexicon.rowed = A_VBD;
lexicon.rows = A_NNS;
lexicon.rowing = A_NN;
lexicon.royal = A_JJ_NN;
lexicon.rub = A_NN_VB_VBP;
lexicon.rubbing = A_VBG_NN;
lexicon.rubs = A_NNS_VBZ;
lexicon.rubbed = A_VBD_VBN;
lexicon.rubber = A_NN;
lexicon.rubberized = A_VBN;
lexicon.ruin = A_NN_VBP_VB;
lexicon.ruining = A_VBG;
lexicon.ruins = A_NNS;
lexicon.ruined = A_VBN_JJ_VBD;
lexicon.rules = A_NNS_VBZ;
lexicon.rule = A_NN_VBP_VB;
lexicon.rulings = A_NNS;
lexicon.ruled = A_VBD_VBN;
lexicon.ruling = A_NN_VBG_JJ;
lexicon.rumored = A_VBN_VBD_JJ;
lexicon.rumors = A_NNS_VBZ;
lexicon.rumor = A_NN;
lexicon.runs = A_VBZ_NNS;
lexicon.run = A_VB_VBD_VBN_VBP_NN;
lexicon.running = A_VBG_JJ_NN_RB;
lexicon.runners = A_NNS;
lexicon.runner = A_NN;
lexicon.rural = A_JJ;
lexicon.rushed = A_VBD_VBN_JJ;
lexicon.rushes = A_VBZ_NNS;
lexicon.rush = A_NN_VB_VBP;
lexicon.rushing = A_VBG_NN;
lexicon.sackes = A_NNS;
lexicon.sackings = A_NNS;
lexicon.sacked = A_VBD_VBN;
lexicon.sack = A_NN_VB;
lexicon.sacks = A_NNS;
lexicon.sacking = A_VBG;
lexicon.sacred = A_JJ;
lexicon.sacrifices = A_NNS_VBZ;
lexicon.sacrifice = A_NN_VB;
lexicon.sadness = A_NN;
lexicon.sad = A_JJ;
lexicon.sadly = A_RB;
lexicon.safe = A_JJ_NN;
lexicon.safely = A_RB;
lexicon.safety = A_NN_VB;
lexicon.safeties = A_NNS;
lexicon.sailing = A_NN_VBG;
lexicon.sails = A_NNS_VBZ;
lexicon.sailed = A_VBD_VBN;
lexicon.sail = A_VB_VBP_NN;
lexicon.sake = A_NN_FW;
lexicon.salads = A_NNS;
lexicon.salad = A_NN;
lexicon.salaries = A_NNS;
lexicon.salaried = A_JJ;
lexicon.salary = A_NN;
lexicon.sales = A_NNS_JJ_VBZ;
lexicon.sale = A_NN;
lexicon.salmon = A_NN_NNS;
lexicon.salt = A_NN_JJ;
lexicon.salts = A_NNS;
lexicon.salted = A_VBN_VBD_JJ;
lexicon.salting = A_VBG_NN;
lexicon.same = A_JJ;
lexicon.sameness = A_NN;
lexicon.sampling = A_NN_VBG;
lexicon.sample = A_NN_JJ_VB_VBP;
lexicon.sampled = A_VBN_VBD;
lexicon.samples = A_NNS_VBZ;
lexicon.samplings = A_NNS;
lexicon.sands = A_NNS;
lexicon.sand = A_NN;
lexicon.sanding = A_NN_VBG;
lexicon.sandwich = A_NN;
lexicon.sandwiched = A_VBN_VBD;
lexicon.sandwiches = A_NNS;
lexicon.satellites = A_NNS;
lexicon.satellite = A_NN_JJ;
lexicon.satisfactions = A_NNS;
lexicon.satisfaction = A_NN;
lexicon.satisfying = A_JJ_VBG;
lexicon.satisfy = A_VB_VBP;
lexicon.satisfied = A_VBN_VBD_JJ;
lexicon.satisfies = A_VBZ_NNS;
lexicon.sauce = A_NN;
lexicon.sauces = A_NNS;
lexicon.savings = A_NNS_NN;
lexicon.saves = A_VBZ;
lexicon.saved = A_VBN_VBD;
lexicon.saving = A_VBG_JJ_NN;
lexicon.save = A_VB_IN_VBP;
lexicon.saying = A_VBG_NN;
lexicon.say = A_VBP_FW_NN_NNP_VB_UH;
lexicon.sayed = A_VBD;
lexicon.says = A_VBZ_NNS;
lexicon.sayings = A_NNS;
lexicon.scaling = A_VBG_NN;
lexicon.scales = A_NNS_VBZ;
lexicon.scaled = A_VBN_VBD;
lexicon.scale = A_NN_VB;
lexicon.scanned = A_VBD_VBN;
lexicon.scans = A_NNS_VBZ;
lexicon.scanning = A_NN_VBG;
lexicon.scan = A_NN_VBP_VB;
lexicon.scandalized = A_VBD_VBN;
lexicon.scandalizes = A_VBZ;
lexicon.scandalizing = A_JJ;
lexicon.scandal = A_NN;
lexicon.scandals = A_NNS;
lexicon.scandalous = A_JJ;
lexicon.scare = A_VB_NN_VBP;
lexicon.scaring = A_VBG;
lexicon.scared = A_VBN_JJ_RB_VBD;
lexicon.scares = A_NNS_VBZ;
lexicon.scary = A_JJ;
lexicon.scatter = A_NN_VB;
lexicon.scatters = A_VBZ;
lexicon.scattering = A_VBG;
lexicon.scattered = A_VBN_VBD_JJ;
lexicon.scenario = A_NN;
lexicon.scenarios = A_NNS;
lexicon.scenes = A_NNS;
lexicon.scene = A_NN;
lexicon.scents = A_NNS;
lexicon.scented = A_JJ_VBN;
lexicon.scent = A_NN;
lexicon.scheduled = A_VBN_VBD_JJ;
lexicon.schedules = A_NNS;
lexicon.schedule = A_NN_VB_VBP;
lexicon.scheduling = A_NN_VBG;
lexicon.schemes = A_NNS;
lexicon.scheme = A_NN;
lexicon.scheming = A_JJ_VBG;
lexicon.scholarly = A_JJ;
lexicon.scholars = A_NNS;
lexicon.scholar = A_NN;
lexicon.scholarships = A_NNS;
lexicon.scholarship = A_NN;
lexicon.schools = A_NNS;
lexicon.schooled = A_VBN;
lexicon.schooling = A_NN_VBG;
lexicon.school = A_NN_VB;
lexicon.sciences = A_NNS;
lexicon.science = A_NN_JJ;
lexicon.scientifically = A_RB;
lexicon.scientific = A_JJ;
lexicon.scientist = A_NN;
lexicon.scientists = A_NNS;
lexicon.scopes = A_NNS;
lexicon.scoped = A_NN;
lexicon.scope = A_NN;
lexicon.scored = A_VBD_JJ_VBN;
lexicon.scores = A_NNS_VBZ;
lexicon.scoring = A_VBG_NN;
lexicon.score = A_NN_VB_VBP;
lexicon.scramble = A_NN_VBP_VB;
lexicon.scrambling = A_VBG;
lexicon.scrambles = A_NNS;
lexicon.scrambled = A_VBD_JJ_VBN;
lexicon.scratched = A_VBD_VBN;
lexicon.scratches = A_NNS;
lexicon.scratching = A_VBG_NN;
lexicon.scratch = A_NN_VB_VBP;
lexicon.screaming = A_VBG_JJ_NN;
lexicon.scream = A_VB_VBP_NN;
lexicon.screams = A_NNS_VBZ;
lexicon.screamed = A_VBD_VBN;
lexicon.screened = A_VBN_VBD;
lexicon.screens = A_NNS_VBZ;
lexicon.screen = A_NN_VB_VBP;
lexicon.screenings = A_NNS;
lexicon.screening = A_NN_VBG;
lexicon.screws = A_NNS;
lexicon.screwed = A_VBN_VBD;
lexicon.screw = A_NN_VB;
lexicon.scripts = A_NNS;
lexicon.script = A_NN;
lexicon.sculptural = A_JJ;
lexicon.sculptures = A_NNS;
lexicon.sculptured = A_VBN_JJ;
lexicon.sculpture = A_NN;
lexicon.sea = A_NN_VB_VBP;
lexicon.seas = A_NNS;
lexicon.sealed = A_VBN_VBD_JJ;
lexicon.seal = A_NN_VB_VBP;
lexicon.sealing = A_NN_VBG;
lexicon.seals = A_NNS_VBZ;
lexicon.search = A_NN_VB_VBP;
lexicon.searchingly = A_RB;
lexicon.searching = A_VBG_NN;
lexicon.searches = A_NNS_VBZ;
lexicon.searched = A_VBD_VBN;
lexicon.searchings = A_NNS;
lexicon.seasonality = A_NN;
lexicon.seasonally = A_RB;
lexicon.seasonings = A_NNS;
lexicon.season = A_NN;
lexicon.seasoned = A_JJ_VBN;
lexicon.seasonal = A_JJ;
lexicon.seasoning = A_NN;
lexicon.seasons = A_NNS;
lexicon.seat = A_NN_VB_VBP;
lexicon.seating = A_NN_VBG;
lexicon.seats = A_NNS_VBZ;
lexicon.seated = A_VBN_VBD_JJ;
lexicon.secondly = A_RB;
lexicon.seconds = A_NNS;
lexicon.secondary = A_JJ;
lexicon.secreted = A_VBN;
lexicon.secretive = A_JJ;
lexicon.secrets = A_NNS;
lexicon.secretively = A_RB;
lexicon.secretly = A_RB;
lexicon.secret = A_JJ_NN;
lexicon.secretions = A_NNS;
lexicon.secretion = A_NN;
lexicon.secretaries = A_NNS;
lexicon.secretary = A_NN;
lexicon.secretarial = A_JJ;
lexicon.sectional = A_JJ;
lexicon.section = A_NN_NNP;
lexicon.sections = A_NNS;
lexicon.sectionalized = A_JJ;
lexicon.sectors = A_NNS;
lexicon.sector = A_NN;
lexicon.secular = A_JJ;
lexicon.secularism = A_NN;
lexicon.secularized = A_VBN;
lexicon.secure = A_VB_JJ_VBP;
lexicon.securities = A_NNS;
lexicon.secured = A_VBN_VBD_JJ;
lexicon.security = A_NN;
lexicon.securing = A_VBG;
lexicon.securely = A_RB;
lexicon.see = A_VB_UH_VBP;
lexicon.seeing = A_VBG;
lexicon.sees = A_VBZ;
lexicon.seeds = A_NNS;
lexicon.seed = A_NN_VBN;
lexicon.seeded = A_VBN;
lexicon.seekingly = A_RB;
lexicon.seeking = A_VBG;
lexicon.seek = A_VB_VBP;
lexicon.seeks = A_VBZ;
lexicon.seeming = A_JJ_VBG;
lexicon.seemed = A_VBD_VBN;
lexicon.seem = A_VB_VBP;
lexicon.seems = A_VBZ;
lexicon.seemingly = A_RB;
lexicon.segmented = A_JJ;
lexicon.segmentation = A_NN;
lexicon.segmenting = A_VBG;
lexicon.segment = A_NN_VBP;
lexicon.segmental = A_JJ;
lexicon.segments = A_NNS;
lexicon.seize = A_VB_VBP;
lexicon.seized = A_VBN_VBD;
lexicon.seizes = A_VBZ;
lexicon.seizing = A_VBG;
lexicon.seldom = A_RB;
lexicon.selective = A_JJ;
lexicon.selectiveness = A_NN;
lexicon.selectivity = A_NN;
lexicon.selectively = A_RB;
lexicon.selecting = A_VBG_NN;
lexicon.selects = A_VBZ;
lexicon.selections = A_NNS;
lexicon.select = A_VB_VBP_JJ;
lexicon.selected = A_VBN_JJ_VBD;
lexicon.selection = A_NN;
lexicon.self = A_NN_PRP;
lexicon.sell = A_VB_VBP_JJ_NN;
lexicon.selling = A_VBG_NN_JJ;
lexicon.sells = A_VBZ;
lexicon.selle = A_VB;
lexicon.sellers = A_NNS;
lexicon.seller = A_NN;
lexicon.seminar = A_NN;
lexicon.seminars = A_NNS;
lexicon.senate = A_NN;
lexicon.senator = A_NN;
lexicon.senators = A_NNS;
lexicon.send = A_VB_VBP;
lexicon.sends = A_VBZ;
lexicon.sending = A_VBG_NN;
lexicon.seniority = A_NN;
lexicon.senior = A_JJ_NN;
lexicon.seniors = A_NNS;
lexicon.sensational = A_JJ;
lexicon.sensations = A_NNS;
lexicon.sensation = A_NN;
lexicon.sensationalism = A_NN;
lexicon.senses = A_NNS_VBZ;
lexicon.sensing = A_VBG_NN;
lexicon.sense = A_NN_VBP_VB;
lexicon.sensed = A_VBD_VBN;
lexicon.sensitively = A_RB;
lexicon.sensitive = A_JJ_NN;
lexicon.sensitivity = A_NN;
lexicon.sensitivities = A_NNS;
lexicon.sensitives = A_NNS;
lexicon.sensitize = A_VB;
lexicon.sensitized = A_VBN;
lexicon.sensors = A_NNS;
lexicon.sensor = A_NN;
lexicon.sentencing = A_NN_VBG_JJ;
lexicon.sentence = A_NN;
lexicon.sentencings = A_NNS;
lexicon.sentenced = A_VBN_VBD;
lexicon.sentences = A_NNS;
lexicon.sentiments = A_NNS;
lexicon.sentimentality = A_NN;
lexicon.sentimental = A_JJ;
lexicon.sentiment = A_NN;
lexicon.sentimentalize = A_VB;
lexicon.separately = A_RB;
lexicon.separateness = A_NN;
lexicon.separated = A_VBN_JJ_VBD_VBP;
lexicon.separating = A_VBG;
lexicon.separate = A_JJ_VBP_VB;
lexicon.separates = A_VBZ;
lexicon.separable = A_JJ;
lexicon.separation = A_NN;
lexicon.separators = A_NNS;
lexicon.separations = A_NNS;
lexicon.sequenced = A_VBN;
lexicon.sequences = A_NNS;
lexicon.sequence = A_NN;
lexicon.series = A_NN_NNS;
lexicon.seriously = A_RB;
lexicon.seriousness = A_NN;
lexicon.serious = A_JJ;
lexicon.servants = A_NNS;
lexicon.servant = A_NN;
lexicon.serving = A_VBG_NN;
lexicon.serve = A_VB_VBP;
lexicon.serves = A_VBZ;
lexicon.served = A_VBN_VBD;
lexicon.servings = A_NNS;
lexicon.serviced = A_VBN_VBD;
lexicon.services = A_NNS_VBZ;
lexicon.servicing = A_NN_VBG;
lexicon.servicers = A_NNS;
lexicon.serviceable = A_JJ;
lexicon.service = A_NN_VB_VBP;
lexicon.sessions = A_NNS;
lexicon.session = A_NN;
lexicon.settings = A_NNS;
lexicon.setting = A_VBG_NN;
lexicon.set = A_VBN_VBD_VBP_JJ_NN_VB;
lexicon.sets = A_NNS_VBZ;
lexicon.settling = A_VBG_NN;
lexicon.settle = A_VB_VBP;
lexicon.settles = A_VBZ;
lexicon.settled = A_VBD_VBN_JJ_VB;
lexicon.settlements = A_NNS;
lexicon.settlement = A_NN;
lexicon.seventh = A_JJ;
lexicon.severally = A_RB;
lexicon.severity = A_NN;
lexicon.severing = A_VBG_NN;
lexicon.several = A_JJ_RB;
lexicon.severance = A_NN_JJ;
lexicon.severed = A_VBN_VBD;
lexicon.severely = A_RB;
lexicon.severable = A_JJ;
lexicon.severe = A_JJ;
lexicon.severly = A_RB;
lexicon.sever = A_VB_VBP;
lexicon.sex = A_NN_VB;
lexicon.sexes = A_NNS;
lexicon.sexual = A_JJ;
lexicon.sexually = A_RB;
lexicon.sexualized = A_JJ;
lexicon.sexuality = A_NN;
lexicon.sexy = A_JJ;
lexicon.shadings = A_NNS;
lexicon.shade = A_NN_VB;
lexicon.shades = A_NNS;
lexicon.shaded = A_VBN_VBD_JJ;
lexicon.shading = A_NN_VBG;
lexicon.shadowing = A_NN_VBG;
lexicon.shadow = A_NN_VB;
lexicon.shadowed = A_VBN_JJ;
lexicon.shadows = A_NNS;
lexicon.shakes = A_VBZ_NNS;
lexicon.shaking = A_VBG_NN;
lexicon.shake = A_VB_NN_VBP;
lexicon.shall = A_MD;
lexicon.sha = A_MD;
lexicon.shallow = A_JJ_NN;
lexicon.shallower = A_JJR;
lexicon.shallowness = A_NN;
lexicon.shameful = A_JJ;
lexicon.shames = A_NNS;
lexicon.shamed = A_VBN;
lexicon.shame = A_NN_VB;
lexicon.shaping = A_VBG_NN;
lexicon.shapely = A_JJ;
lexicon.shape = A_NN_VBP_VB;
lexicon.shaped = A_VBN_VBD_JJ;
lexicon.shapes = A_NNS_VBZ;
lexicon.shares = A_NNS_NN_VBZ;
lexicon.shared = A_VBN_JJ_VBD;
lexicon.sharing = A_VBG_NN;
lexicon.share = A_NN_VBP_JJ_VB;
lexicon.shareholdings = A_NNS;
lexicon.shareholding = A_NN;
lexicon.shareholders = A_NNS;
lexicon.shareholder = A_NN;
lexicon.sharks = A_NNS;
lexicon.shark = A_NN;
lexicon.sharpness = A_NN;
lexicon.sharp = A_JJ;
lexicon.sharply = A_RB;
lexicon.she = A_PRP;
lexicon.sheds = A_VBZ_NNS;
lexicon.shed = A_VB_VBD_VBN_VBP_NN;
lexicon.shedding = A_VBG_NN;
lexicon.sheep = A_NN_NNS;
lexicon.sheepe = A_NNS;
lexicon.sheer = A_JJ_NN;
lexicon.sheered = A_VBD;
lexicon.sheet = A_NN;
lexicon.sheeted = A_JJ;
lexicon.sheets = A_NNS;
lexicon.sheeting = A_NN;
lexicon.shelf = A_NN;
lexicon.shelling = A_VBG_NN;
lexicon.shelled = A_VBD_VBN_JJ;
lexicon.shells = A_NNS;
lexicon.shell = A_NN_JJ_VB;
lexicon.shelters = A_NNS;
lexicon.shelter = A_NN_VB;
lexicon.sheltered = A_VBN_JJ;
lexicon.sheltering = A_VBG;
lexicon.shifting = A_VBG_JJ_NN;
lexicon.shifted = A_VBD_VBN;
lexicon.shifts = A_NNS_VBZ;
lexicon.shift = A_NN_VB_VBP;
lexicon.shine = A_NN_VBP_VB;
lexicon.shiningly = A_RB;
lexicon.shining = A_VBG_JJ;
lexicon.shines = A_VBZ;
lexicon.shipped = A_VBN_JJ_VBD;
lexicon.shipping = A_VBG_NN;
lexicon.ship = A_NN_VBP_VB;
lexicon.ships = A_NNS_VBZ;
lexicon.shirt = A_NN;
lexicon.shirts = A_NNS;
lexicon.shit = A_NN;
lexicon.shocking = A_JJ_VBG;
lexicon.shocked = A_VBN_VBD_JJ;
lexicon.shock = A_NN_VB;
lexicon.shocks = A_NNS_VBZ;
lexicon.shockingly = A_RB;
lexicon.shoe = A_NN;
lexicon.shoes = A_NNS;
lexicon.shoots = A_VBZ_NNS;
lexicon.shoot = A_VB_NN_VBP;
lexicon.shootings = A_NNS;
lexicon.shooting = A_NN_VBG;
lexicon.shopped = A_VBN_VBD;
lexicon.shop = A_NN_VB_VBP;
lexicon.shopping = A_NN_JJ_VBG;
lexicon.shops = A_NNS_VBZ;
lexicon.shores = A_NNS;
lexicon.shored = A_VBN;
lexicon.shore = A_NN_JJ_RB_VB;
lexicon.shoring = A_VBG;
lexicon.shortly = A_RB;
lexicon.shorted = A_VBN_VBD;
lexicon.shorting = A_VBG_NN;
lexicon.short = A_JJ_NN_RB_VB;
lexicon.shortness = A_NN;
lexicon.shorts = A_NNS;
lexicon.shortage = A_NN;
lexicon.shortages = A_NNS;
lexicon.shot = A_NN_VBD_VBN;
lexicon.shots = A_NNS;
lexicon.should = A_MD;
lexicon.shoulders = A_NNS;
lexicon.shouldered = A_VBD_VBN;
lexicon.shouldering = A_VBG;
lexicon.shoulder = A_NN_VBP_RB_VB;
lexicon.shouting = A_VBG_NN;
lexicon.shouted = A_VBD_VBN;
lexicon.shout = A_VB_VBP_NN;
lexicon.shouts = A_VBZ_NNS;
lexicon.shove = A_VB_NN;
lexicon.shoved = A_VBD_VBN;
lexicon.shoves = A_VBZ;
lexicon.shoving = A_VBG;
lexicon.showed = A_VBD_VBN;
lexicon.showings = A_NNS;
lexicon.showing = A_VBG_NN;
lexicon.shows = A_VBZ_NNS;
lexicon.show = A_NN_VB_VBP;
lexicon.showered = A_VBN_VBD;
lexicon.shower = A_NN_VB_VBP;
lexicon.showers = A_NNS;
lexicon.showering = A_VBG;
lexicon.shrimping = A_NN;
lexicon.shrimp = A_NN;
lexicon.shrinks = A_VBZ;
lexicon.shrinking = A_VBG_NN;
lexicon.shrink = A_VB_NN;
lexicon.shrug = A_VB_NN_VBP;
lexicon.shrugging = A_VBG;
lexicon.shrugged = A_VBD;
lexicon.shrugs = A_VBZ_NNS;
lexicon.shuts = A_VBZ_NNS;
lexicon.shut = A_VBN_VBD_JJ_NN_VB;
lexicon.shutting = A_VBG;
lexicon.shuttle = A_NN_JJ;
lexicon.shuttled = A_VBD_VBN;
lexicon.shuttles = A_NNS_VBZ;
lexicon.shuttling = A_VBG;
lexicon.shy = A_JJ_NN_RB_VB_VBP;
lexicon.shied = A_VBD_VBN;
lexicon.shies = A_VBZ;
lexicon.shying = A_VBG;
lexicon.sibling = A_NN;
lexicon.siblings = A_NNS;
lexicon.sickness = A_NN;
lexicon.sickly = A_JJ;
lexicon.sick = A_JJ;
lexicon.sided = A_VBD_VBN;
lexicon.sides = A_NNS;
lexicon.sidings = A_NNS;
lexicon.siding = A_NN_VBG;
lexicon.side = A_NN_VBP_JJ_RB_VB;
lexicon.sidewalks = A_NNS;
lexicon.sidewalk = A_NN;
lexicon.sigh = A_NN_VBP;
lexicon.sighing = A_VBG;
lexicon.sighed = A_VBD;
lexicon.sighs = A_VBZ_NNS;
lexicon.sight = A_NN_VB;
lexicon.sighting = A_NN;
lexicon.sighted = A_VBN_VBD;
lexicon.sightings = A_NNS;
lexicon.sights = A_NNS;
lexicon.signs = A_NNS_VBZ;
lexicon.signing = A_VBG_NN;
lexicon.sign = A_NN_VBP_VB;
lexicon.signed = A_VBD_JJ_VBN;
lexicon.signaling = A_VBG_NN;
lexicon.signals = A_NNS_VBZ;
lexicon.signalling = A_VBG;
lexicon.signalizes = A_VBZ;
lexicon.signaled = A_VBD_VBN;
lexicon.signal = A_NN_VB_VBP;
lexicon.signalled = A_VBD;
lexicon.signatures = A_NNS;
lexicon.signature = A_NN;
lexicon.significance = A_NN;
lexicon.significantly = A_RB;
lexicon.significant = A_JJ;
lexicon.silence = A_NN_VB;
lexicon.silencing = A_VBG;
lexicon.silenced = A_VBN_VBD;
lexicon.silences = A_NNS;
lexicon.silent = A_JJ;
lexicon.silently = A_RB;
lexicon.silk = A_NN;
lexicon.silke = A_NN;
lexicon.silliness = A_NN;
lexicon.silly = A_JJ_NN_RB;
lexicon.silver = A_NN_JJ_JJR;
lexicon.similarities = A_NNS;
lexicon.similar = A_JJ;
lexicon.similarly = A_RB;
lexicon.similarity = A_NN;
lexicon.simples = A_NNS;
lexicon.simple = A_JJ_NN;
lexicon.simply = A_RB_JJ;
lexicon.simultaneous = A_JJ;
lexicon.simultaneously = A_RB;
lexicon.sinfulness = A_NN;
lexicon.sinning = A_NN;
lexicon.sinful = A_JJ;
lexicon.sin = A_NN_VBP_VB;
lexicon.sinned = A_VBN;
lexicon.sins = A_NNS;
lexicon.since = A_IN_RB;
lexicon.singing = A_VBG_JJ_NN;
lexicon.sings = A_VBZ;
lexicon.singed = A_VBD;
lexicon.sing = A_VB_VBP;
lexicon.singer = A_NN;
lexicon.singers = A_NNS;
lexicon.singles = A_NNS_VBZ;
lexicon.singled = A_VBD_VBN;
lexicon.singleness = A_NN;
lexicon.singling = A_VBG;
lexicon.singly = A_RB;
lexicon.single = A_JJ_VBP_NN_RB_VB;
lexicon.sinking = A_VBG_JJ_NN;
lexicon.sinks = A_VBZ;
lexicon.sink = A_VB_VBP_NN;
lexicon.sir = A_NN_UH;
lexicon.sisters = A_NNS;
lexicon.sister = A_NN_JJ;
lexicon.sit = A_VB_FW_VBP;
lexicon.sitting = A_VBG_NN;
lexicon.sits = A_VBZ_NNS;
lexicon.sittings = A_NNS;
lexicon.sites = A_NNS;
lexicon.site = A_NN;
lexicon.siting = A_NN;
lexicon.situations = A_NNS;
lexicon.situation = A_NN;
lexicon.situated = A_VBN;
lexicon.sixth = A_JJ_RB;
lexicon.sizes = A_NNS_VBZ;
lexicon.sized = A_VBD_JJ_VBN;
lexicon.size = A_NN_VBP_VB;
lexicon.sizing = A_NN;
lexicon.skis = A_NNS;
lexicon.skiing = A_NN_VBG;
lexicon.ski = A_NN_JJ_VB_VBP;
lexicon.skillfulness = A_NN;
lexicon.skillfully = A_RB;
lexicon.skilled = A_JJ_VBN;
lexicon.skillful = A_JJ;
lexicon.skill = A_NN;
lexicon.skills = A_NNS;
lexicon.skin = A_NN;
lexicon.skins = A_NNS;
lexicon.skinning = A_NN;
lexicon.skips = A_VBZ;
lexicon.skip = A_VB_VBP;
lexicon.skipping = A_VBG;
lexicon.skipped = A_VBD_VBN;
lexicon.skirt = A_NN_VB_VBP;
lexicon.skirted = A_VBN_VBD;
lexicon.skirting = A_VBG;
lexicon.skirts = A_NNS_VBZ;
lexicon.skull = A_NN;
lexicon.skulls = A_NNS;
lexicon.skies = A_NNS;
lexicon.sky = A_NN;
lexicon.slammed = A_VBD_VBN;
lexicon.slams = A_VBZ;
lexicon.slam = A_NN_VBP_VB;
lexicon.slamming = A_VBG;
lexicon.slapped = A_VBD_VBN;
lexicon.slapping = A_VBG_JJ_NN;
lexicon.slap = A_VB_NN;
lexicon.slaps = A_VBZ_NNS;
lexicon.slaves = A_NNS;
lexicon.slave = A_NN;
lexicon.slavery = A_NN;
lexicon.sleeping = A_VBG_NN;
lexicon.sleeps = A_VBZ;
lexicon.sleep = A_VB_NN_VBP;
lexicon.sleeves = A_NNS;
lexicon.sleeve = A_NN;
lexicon.sliced = A_VBN_VBD;
lexicon.slices = A_NNS_VBZ;
lexicon.slicing = A_VBG;
lexicon.slice = A_NN_VB_VBP;
lexicon.slide = A_NN_VBP_VB;
lexicon.sliding = A_VBG_JJ;
lexicon.slides = A_NNS_VBZ;
lexicon.slighted = A_JJ_VBN;
lexicon.slights = A_NNS;
lexicon.slighting = A_VBG;
lexicon.slightly = A_RB;
lexicon.slight = A_JJ_VBP_NN;
lexicon.slipping = A_VBG;
lexicon.slip = A_VB_NN_VBP;
lexicon.slips = A_NNS_VBZ;
lexicon.slipped = A_VBD_VBN;
lexicon.sloping = A_VBG_JJ;
lexicon.slopes = A_NNS_VBZ;
lexicon.slope = A_NN;
lexicon.slots = A_NNS;
lexicon.slot = A_NN;
lexicon.slotted = A_VBN;
lexicon.slow = A_JJ_VBP_RB_VB;
lexicon.slows = A_VBZ_NNS;
lexicon.slowness = A_NN;
lexicon.slowing = A_VBG_NN;
lexicon.slowed = A_VBD_VBN;
lexicon.slowly = A_RB;
lexicon.smallness = A_NN;
lexicon.small = A_JJ;
lexicon.smarting = A_VBG;
lexicon.smartly = A_RB;
lexicon.smarts = A_VBZ;
lexicon.smart = A_JJ_NN_RB;
lexicon.smarted = A_VBD;
lexicon.smelling = A_VBG;
lexicon.smell = A_NN_VB_VBP;
lexicon.smelled = A_VBD_VBN;
lexicon.smells = A_VBZ_NNS;
lexicon.smiles = A_NNS_VBZ;
lexicon.smiled = A_VBD_VBN;
lexicon.smilingly = A_RB;
lexicon.smile = A_NN_VB_VBP;
lexicon.smiling = A_VBG_JJ_NN;
lexicon.smoke = A_NN_VB_VBP;
lexicon.smokes = A_VBZ;
lexicon.smoked = A_VBD_JJ_VBN;
lexicon.smoking = A_NN_VBG;
lexicon.smoothly = A_RB;
lexicon.smoothing = A_VBG;
lexicon.smoothed = A_VBD_VBN;
lexicon.smooth = A_JJ_VB;
lexicon.smoothness = A_NN;
lexicon.snake = A_NN;
lexicon.snaking = A_VBG;
lexicon.snakes = A_NNS_VBZ;
lexicon.snaked = A_VBD;
lexicon.snaps = A_VBZ;
lexicon.snapped = A_VBD_VBN_JJ;
lexicon.snapping = A_VBG_NN;
lexicon.snap = A_VB_VBP_JJ_NN;
lexicon.sneak = A_VB_NN_VBP;
lexicon.sneaks = A_VBZ;
lexicon.sneaking = A_VBG;
lexicon.sneaked = A_VBD_VBN;
lexicon.snowed = A_VBD;
lexicon.snow = A_NN_VB;
lexicon.snowing = A_VBG;
lexicon.snows = A_NNS_VBZ;
lexicon.so = A_RB_CC_FW_IN;
lexicon.soak = A_VB;
lexicon.soaking = A_VBG_JJ_NN_RB;
lexicon.soaked = A_VBN_JJ_VBD;
lexicon.soap = A_NN;
lexicon.soaps = A_NNS;
lexicon.soaring = A_VBG_JJ;
lexicon.soared = A_VBD_VBN;
lexicon.soar = A_VB_VBP;
lexicon.soars = A_NNS;
lexicon.soccer = A_NN;
lexicon.sociality = A_NN;
lexicon.socialized = A_VBN_VBD;
lexicon.socializes = A_VBZ;
lexicon.social = A_JJ_NN;
lexicon.socialize = A_VB;
lexicon.socially = A_RB;
lexicon.socializing = A_VBG;
lexicon.socialization = A_NN;
lexicon.socialism = A_NN;
lexicon.societies = A_NNS;
lexicon.society = A_NN;
lexicon.socking = A_VBG;
lexicon.socks = A_NNS;
lexicon.socked = A_VBD;
lexicon.sock = A_NN_VB;
lexicon.sodium = A_NN;
lexicon.sofas = A_NNS;
lexicon.sofa = A_NN;
lexicon.softness = A_NN;
lexicon.softly = A_RB;
lexicon.soft = A_JJ_NNS_RB;
lexicon.softened = A_VBD_VBN_JJ;
lexicon.soften = A_VB;
lexicon.softener = A_NN;
lexicon.softens = A_VBZ;
lexicon.softening = A_VBG_JJ_NN;
lexicon.software = A_NN;
lexicon.soils = A_NNS;
lexicon.soiled = A_VBN_JJ_VBD;
lexicon.soil = A_NN_VB;
lexicon.solar = A_JJ;
lexicon.soldier = A_NN;
lexicon.soldiering = A_NN;
lexicon.soldiers = A_NNS;
lexicon.soldierly = A_RB;
lexicon.soles = A_NNS;
lexicon.solely = A_RB;
lexicon.sole = A_JJ_NN;
lexicon.solidly = A_RB;
lexicon.solid = A_JJ_NN_RB;
lexicon.solidity = A_NN;
lexicon.solids = A_NNS;
lexicon.solutions = A_NNS;
lexicon.solution = A_NN;
lexicon.solves = A_VBZ;
lexicon.solved = A_VBN_VBD;
lexicon.solve = A_VB_VBP;
lexicon.solving = A_VBG;
lexicon.some = A_DT_NN_RB;
lexicon.somebody = A_NN;
lexicon.someday = A_RB;
lexicon.somehow = A_RB_WRB;
lexicon.someone = A_NN;
lexicon.something = A_NN;
lexicon.sometime = A_RB_JJ;
lexicon.sometimes = A_RB;
lexicon.somewhat = A_RB;
lexicon.somewhere = A_RB_NN;
lexicon.somewheres = A_RB;
lexicon.son = A_NN;
lexicon.sons = A_NNS;
lexicon.songs = A_NNS;
lexicon.songful = A_JJ;
lexicon.song = A_NN;
lexicon.soon = A_RB;
lexicon.sophists = A_NNS;
lexicon.sophisticated = A_JJ;
lexicon.sophisticates = A_NNS;
lexicon.sophistication = A_NN;
lexicon.sophisticate = A_NN;
lexicon.sorry = A_JJ_RB_UH;
lexicon.sorted = A_VBN_VBD;
lexicon.sorts = A_NNS;
lexicon.sort = A_NN_RB_VB_VBP;
lexicon.sorting = A_VBG_NN;
lexicon.soulful = A_JJ;
lexicon.soul = A_NN;
lexicon.souled = A_JJ;
lexicon.soulfully = A_RB;
lexicon.souls = A_NNS;
lexicon.sounded = A_VBD_VBN;
lexicon.sounds = A_VBZ_NNS;
lexicon.soundings = A_NNS;
lexicon.sound = A_NN_JJ_RB_VB_VBP_VBZ;
lexicon.soundly = A_RB;
lexicon.soundness = A_NN;
lexicon.sounding = A_VBG_JJ_NN;
lexicon.soup = A_NN_VB;
lexicon.soups = A_NNS;
lexicon.source = A_NN;
lexicon.sourcing = A_NN_VBG;
lexicon.sources = A_NNS;
lexicon.south = A_RB_JJ_NN;
lexicon.southeast = A_RB_JJ_NN;
lexicon.southernisms = A_NNS;
lexicon.southern = A_JJ;
lexicon.southwest = A_RB_JJ_NN_JJS;
lexicon.sovereignty = A_NN;
lexicon.spaces = A_NNS;
lexicon.space = A_NN_VB;
lexicon.spacing = A_NN_JJ;
lexicon.spaced = A_VBN_JJ;
lexicon.spacings = A_NNS;
lexicon.spares = A_NNS_VBZ;
lexicon.spared = A_VBN_VBD;
lexicon.sparing = A_VBG_JJ;
lexicon.spare = A_JJ_VB_VBP;
lexicon.sparingly = A_RB;
lexicon.spark = A_VB_NN_VBP;
lexicon.sparks = A_VBZ_NNS;
lexicon.sparked = A_VBN_VBD;
lexicon.sparking = A_VBG;
lexicon.speaking = A_VBG_NN;
lexicon.speaks = A_VBZ;
lexicon.speak = A_VB_VBP;
lexicon.speakers = A_NNS;
lexicon.speaker = A_NN;
lexicon.special = A_JJ_NN;
lexicon.specialization = A_NN;
lexicon.specialize = A_VB_VBP;
lexicon.specializing = A_VBG;
lexicon.specials = A_NNS;
lexicon.specializes = A_VBZ;
lexicon.specialized = A_JJ_VBD_VBN;
lexicon.specially = A_RB;
lexicon.speciality = A_NN;
lexicon.specialist = A_NN_JJ;
lexicon.specialists = A_NNS;
lexicon.specialty = A_NN_JJ;
lexicon.specialties = A_NNS;
lexicon.specie = A_FW_NN;
lexicon.species = A_NN_NNS;
lexicon.specification = A_NN;
lexicon.specifics = A_NNS;
lexicon.specificity = A_NN;
lexicon.specifications = A_NNS;
lexicon.specific = A_JJ_NN;
lexicon.specifically = A_RB;
lexicon.specifies = A_VBZ;
lexicon.specified = A_VBN_JJ_VBD;
lexicon.specifying = A_VBG;
lexicon.specify = A_VB_VBP;
lexicon.spectacularly = A_RB;
lexicon.spectacular = A_JJ;
lexicon.spectrum = A_NN;
lexicon.speculate = A_VB_VBP;
lexicon.speculatively = A_RB;
lexicon.speculative = A_JJ;
lexicon.speculation = A_NN;
lexicon.speculators = A_NNS;
lexicon.speculator = A_NN;
lexicon.speculates = A_VBZ;
lexicon.speculated = A_VBD_VBN;
lexicon.speculations = A_NNS;
lexicon.speculating = A_VBG;
lexicon.speeches = A_NNS;
lexicon.speech = A_NN;
lexicon.speeds = A_NNS_VBZ;
lexicon.speeding = A_VBG_JJ_NN;
lexicon.speed = A_NN_VB;
lexicon.speeded = A_VBD_VBN;
lexicon.spells = A_VBZ_NNS;
lexicon.spell = A_VB_NN_VBP;
lexicon.spelling = A_NN_VBG;
lexicon.spelled = A_VBN_VBD;
lexicon.spending = A_NN_JJ_VBG;
lexicon.spend = A_VB_VBP;
lexicon.spends = A_VBZ;
lexicon.spheres = A_NNS;
lexicon.sphere = A_NN;
lexicon.spills = A_NNS_VBZ;
lexicon.spilled = A_VBD_VBN;
lexicon.spilling = A_VBG_NN;
lexicon.spill = A_NN_VB_VBP;
lexicon.spin = A_VB_NN;
lexicon.spins = A_VBZ;
lexicon.spinning = A_VBG_JJ;
lexicon.spine = A_NN;
lexicon.spirit = A_NN;
lexicon.spirits = A_NNS;
lexicon.spirited = A_JJ_VBN;
lexicon.spirituals = A_NNS;
lexicon.spirituality = A_NN;
lexicon.spiritual = A_JJ_NN;
lexicon.spiritually = A_RB;
lexicon.spit = A_VB_NN_VBD;
lexicon.spitting = A_VBG_NN;
lexicon.spits = A_VBZ;
lexicon.spite = A_NN_VB;
lexicon.splitting = A_NN_VBG_JJ;
lexicon.split = A_NN_JJ_VB_VBD_VBN_VBP;
lexicon.splits = A_NNS_VBZ;
lexicon.spokesman = A_NN;
lexicon.sponsoring = A_VBG;
lexicon.sponsored = A_VBN_VBD;
lexicon.sponsor = A_NN_VBP_VB;
lexicon.sponsors = A_NNS_VBZ;
lexicon.spoonfuls = A_NNS;
lexicon.spooned = A_VBD;
lexicon.spoon = A_NN;
lexicon.spoonful = A_NN;
lexicon.spoons = A_NNS;
lexicon.sporting = A_VBG_JJ_NN;
lexicon.sport = A_NN_JJ_VBP;
lexicon.sports = A_NNS_VBZ;
lexicon.sported = A_VBD;
lexicon.spotting = A_VBG;
lexicon.spotted = A_VBD_VBN_JJ;
lexicon.spot = A_NN_JJ_VB_VBP;
lexicon.spots = A_NNS_VBZ;
lexicon.spouses = A_NNS;
lexicon.spouse = A_NN;
lexicon.spraying = A_NN_VBG;
lexicon.sprays = A_NNS;
lexicon.sprayed = A_VBN_VBD;
lexicon.spray = A_NN_VB;
lexicon.spreads = A_VBZ_NNS;
lexicon.spreading = A_VBG;
lexicon.spread = A_NN_VBD_VBN_VBP_JJ_VB;
lexicon.spring = A_NN_VB_VBP;
lexicon.springs = A_NNS_VBZ;
lexicon.springing = A_VBG;
lexicon.sprinkle = A_VB_NN_VBP;
lexicon.sprinkling = A_NN_VBG;
lexicon.sprinkles = A_VBZ;
lexicon.sprinkled = A_VBD_VBN;
lexicon.spying = A_VBG_NN;
lexicon.spies = A_NNS_VBZ;
lexicon.spied = A_VBD_VBN;
lexicon.spy = A_NN_VB;
lexicon.squad = A_NN;
lexicon.squads = A_NNS;
lexicon.squarely = A_RB;
lexicon.squaring = A_VBG;
lexicon.squared = A_JJ_VBD_VBN;
lexicon.squares = A_NNS;
lexicon.square = A_NN_JJ_RB_VB_VBP;
lexicon.squeezes = A_VBZ_NNS;
lexicon.squeeze = A_NN_VBP_VB;
lexicon.squeezing = A_VBG;
lexicon.squeezed = A_VBN_VBD;
lexicon.stabilizers = A_NNS;
lexicon.stability = A_NN;
lexicon.stabilities = A_NNS;
lexicon.stabilizing = A_VBG;
lexicon.stabilize = A_VB_VBP;
lexicon.stabilized = A_VBN_VBD;
lexicon.stabilizes = A_VBZ;
lexicon.stabilizer = A_NN;
lexicon.stabilization = A_NN;
lexicon.stables = A_NNS;
lexicon.stabled = A_VBD;
lexicon.stable = A_JJ_NN;
lexicon.stack = A_NN_VB;
lexicon.stacked = A_VBN_VBD;
lexicon.stacking = A_VBG;
lexicon.stacks = A_NNS;
lexicon.stadium = A_NN;
lexicon.stadiums = A_NNS;
lexicon.staffs = A_NNS_VBZ;
lexicon.staff = A_NN_VBP_VB;
lexicon.staging = A_VBG_NN;
lexicon.staged = A_VBD_VBN;
lexicon.stages = A_NNS_VBZ;
lexicon.stage = A_NN_VBP_VB;
lexicon.stair = A_NN;
lexicon.stairs = A_NNS;
lexicon.staked = A_VBN_VBD;
lexicon.stakes = A_NNS_VBZ;
lexicon.stake = A_NN_VB_VBP;
lexicon.stance = A_NN;
lexicon.stances = A_NNS;
lexicon.stand = A_VB_NN_VBP;
lexicon.stands = A_VBZ_NNS_NN;
lexicon.standing = A_VBG_JJ_NN;
lexicon.standardized = A_JJ_VBN;
lexicon.standardize = A_VB;
lexicon.standards = A_NNS;
lexicon.standardizing = A_VBG;
lexicon.standard = A_JJ_NN;
lexicon.starring = A_VBG_JJ;
lexicon.stars = A_NNS_VBZ;
lexicon.star = A_NN_JJ_VB;
lexicon.starred = A_VBD_VBN;
lexicon.staring = A_VBG;
lexicon.stared = A_VBD_VBN;
lexicon.stares = A_NNS;
lexicon.stare = A_VB_VBP_FW_NN;
lexicon.starting = A_VBG_JJ_NN;
lexicon.started = A_VBD_JJ_VBN_VB;
lexicon.starts = A_VBZ_NNS_VBP;
lexicon.start = A_VB_VBP_NN_RP;
lexicon.starter = A_NN_JJ;
lexicon.starters = A_NNS;
lexicon.stated = A_VBN_JJ_VBD;
lexicon.stating = A_VBG;
lexicon.state = A_NN_JJ_VB_VBP;
lexicon.stately = A_JJ;
lexicon.states = A_NNS_VBZ;
lexicon.statements = A_NNS;
lexicon.statement = A_NN;
lexicon.stationing = A_VBG;
lexicon.station = A_NN;
lexicon.stations = A_NNS;
lexicon.stationed = A_VBN;
lexicon.statist = A_JJ;
lexicon.statistical = A_JJ;
lexicon.statistically = A_RB;
lexicon.statistics = A_NNS;
lexicon.statistic = A_NN;
lexicon.statues = A_NNS;
lexicon.statue = A_NN;
lexicon.statu = A_FW;
lexicon.statuses = A_NNS;
lexicon.status = A_NN_FW;
lexicon.statutes = A_NNS;
lexicon.statute = A_NN;
lexicon.stayed = A_VBD_JJ_VBN;
lexicon.stays = A_VBZ_NNS;
lexicon.stay = A_VB_VBP_NN;
lexicon.staying = A_VBG_JJ_NN;
lexicon.steadily = A_RB;
lexicon.steadiness = A_NN;
lexicon.steadying = A_JJ;
lexicon.steady = A_JJ_RB;
lexicon.steadied = A_VBD_VBN;
lexicon.steaks = A_NNS;
lexicon.steak = A_NN;
lexicon.steals = A_VBZ;
lexicon.steal = A_VB_VBP;
lexicon.stealing = A_VBG_JJ_NN;
lexicon.steams = A_VBZ;
lexicon.steam = A_NN;
lexicon.steamed = A_VBN_VBD;
lexicon.steaming = A_VBG;
lexicon.steel = A_NN_JJ;
lexicon.steeled = A_VBN;
lexicon.steels = A_NNS;
lexicon.steep = A_JJ_NN;
lexicon.steeped = A_VBN;
lexicon.steepness = A_NN;
lexicon.steer = A_VB_NN_VBP;
lexicon.steering = A_NN_JJ_VBG;
lexicon.steers = A_VBZ_NNS;
lexicon.steered = A_VBD_VBN;
lexicon.stem = A_VB_NN_VBP;
lexicon.stems = A_VBZ_NNS;
lexicon.stemmed = A_VBD_VBN;
lexicon.stemming = A_VBG;
lexicon.step = A_NN_VBP_VB;
lexicon.stepping = A_VBG_JJ;
lexicon.steps = A_NNS_VBZ;
lexicon.stepped = A_VBD_VBN;
lexicon.stereotypical = A_JJ;
lexicon.stereotype = A_NN;
lexicon.stereotypically = A_RB;
lexicon.stereotyped = A_JJ_VBN;
lexicon.stereotypes = A_NNS;
lexicon.sticks = A_NNS_VBZ;
lexicon.sticking = A_VBG_NN_JJ;
lexicon.stick = A_VB_VBP_NN;
lexicon.stiffness = A_NN;
lexicon.stiffs = A_NNS;
lexicon.stiff = A_JJ_NN_VB;
lexicon.stillness = A_NN;
lexicon.still = A_RB_JJ_NN_VB;
lexicon.stills = A_NNS;
lexicon.stimulates = A_VBZ;
lexicon.stimulated = A_VBN_VBD;
lexicon.stimulations = A_NNS;
lexicon.stimulative = A_JJ;
lexicon.stimulant = A_NN;
lexicon.stimulator = A_NN;
lexicon.stimulation = A_NN;
lexicon.stimulators = A_NNS;
lexicon.stimulate = A_VB_VBP;
lexicon.stimulating = A_VBG_JJ;
lexicon.stimulants = A_NNS;
lexicon.stimulus = A_NN;
lexicon.stir = A_VB_VBP_NN;
lexicon.stirred = A_VBD_VBN;
lexicon.stirrings = A_NNS;
lexicon.stirringly = A_RB;
lexicon.stirs = A_VBZ;
lexicon.stirring = A_VBG_JJ_NN;
lexicon.stocked = A_VBN_VBD;
lexicon.stocks = A_NNS_VBZ_RB;
lexicon.stocking = A_VBG_NN;
lexicon.stockings = A_NNS;
lexicon.stock = A_NN_VBP_JJ_VB;
lexicon.stomach = A_NN_VB;
lexicon.stomachs = A_NNS;
lexicon.stoned = A_VBN;
lexicon.stones = A_NNS;
lexicon.stone = A_NN_RB_VB;
lexicon.stop = A_VB_NN_VBP;
lexicon.stopped = A_VBD_VBN;
lexicon.stops = A_VBZ_NNS;
lexicon.stopping = A_VBG_NN;
lexicon.storage = A_NN_JJ;
lexicon.stores = A_NNS_VBZ;
lexicon.store = A_NN_VB_VBP;
lexicon.storing = A_VBG_NN;
lexicon.stored = A_VBN_VBD;
lexicon.stormed = A_VBD_VBN;
lexicon.storms = A_NNS;
lexicon.storming = A_VBG;
lexicon.storm = A_NN_VB_VBP;
lexicon.story = A_NN;
lexicon.storied = A_JJ;
lexicon.stories = A_NNS;
lexicon.stoves = A_NNS;
lexicon.stove = A_NN;
lexicon.straight = A_JJ_RB;
lexicon.straights = A_NNS;
lexicon.straighten = A_VB;
lexicon.straightened = A_VBD_VBN;
lexicon.straighteners = A_NNS;
lexicon.straightening = A_VBG_NN;
lexicon.straightens = A_VBZ;
lexicon.strains = A_NNS;
lexicon.straining = A_VBG;
lexicon.strained = A_VBD_JJ_VBN;
lexicon.strain = A_NN_VB_VBP;
lexicon.strange = A_JJ;
lexicon.strangeness = A_NN;
lexicon.strangely = A_RB;
lexicon.strangers = A_NNS;
lexicon.stranger = A_NN_JJR;
lexicon.strategically = A_RB;
lexicon.strategic = A_JJ;
lexicon.strategy = A_NN;
lexicon.strategies = A_NNS;
lexicon.straws = A_NNS;
lexicon.straw = A_NN_JJ;
lexicon.streaking = A_VBG;
lexicon.streaked = A_VBD_VBN;
lexicon.streak = A_NN_VBP;
lexicon.streaks = A_NNS;
lexicon.streaming = A_VBG;
lexicon.stream = A_NN_VB;
lexicon.streamed = A_VBD_VBN;
lexicon.streams = A_NNS;
lexicon.streets = A_NNS;
lexicon.street = A_NN;
lexicon.strength = A_NN;
lexicon.strengths = A_NNS;
lexicon.strengthening = A_VBG_JJ_NN;
lexicon.strengthened = A_VBN_JJ_VBD;
lexicon.strengthen = A_VB_VBP;
lexicon.strengthens = A_VBZ;
lexicon.stresses = A_NNS_VBZ;
lexicon.stressed = A_VBD_JJ_VBN;
lexicon.stressing = A_VBG;
lexicon.stress = A_NN_VBP_VB;
lexicon.stressful = A_JJ;
lexicon.stretch = A_NN_VBP_JJ_VB;
lexicon.stretches = A_NNS_VBZ;
lexicon.stretched = A_VBD_JJ_VBN;
lexicon.stretching = A_VBG_NN;
lexicon.strictly = A_RB;
lexicon.strict = A_JJ;
lexicon.strikes = A_NNS_VBZ;
lexicon.strikingly = A_RB;
lexicon.striking = A_JJ_VBG;
lexicon.strike = A_NN_VB_VBP;
lexicon.string = A_NN_VB;
lexicon.stringing = A_VBG;
lexicon.strings = A_NNS_VBZ;
lexicon.stringed = A_JJ;
lexicon.stripped = A_VBN_JJ_VBD;
lexicon.stripping = A_VBG_NN;
lexicon.strips = A_NNS_VBZ;
lexicon.strip = A_NN_VB_VBP;
lexicon.stroke = A_NN_VB;
lexicon.strokes = A_NNS_VBZ;
lexicon.stroked = A_VBD_VBN;
lexicon.stroking = A_NN_VBG;
lexicon.strongly = A_RB;
lexicon.strong = A_JJ_RB;
lexicon.structural = A_JJ;
lexicon.structurally = A_RB;
lexicon.structured = A_VBN_JJ_VBD;
lexicon.structures = A_NNS_VBZ;
lexicon.structuring = A_VBG_NN;
lexicon.structure = A_NN_VB;
lexicon.struggling = A_VBG_JJ;
lexicon.struggles = A_NNS_VBZ;
lexicon.struggled = A_VBD_VBN;
lexicon.struggle = A_NN_VBP_VB;
lexicon.students = A_NNS;
lexicon.student = A_NN;
lexicon.studios = A_NNS;
lexicon.studio = A_NN;
lexicon.studied = A_VBN_VBD_JJ;
lexicon.studies = A_NNS_VBZ;
lexicon.study = A_NN_VBP_VB;
lexicon.studying = A_VBG_NN;
lexicon.stuff = A_NN_VB_VBP;
lexicon.stumble = A_VB_VBP_NN;
lexicon.stumbled = A_VBD_VBN;
lexicon.stumbles = A_VBZ_NNS;
lexicon.stumbling = A_VBG_JJ_NN;
lexicon.stupidity = A_NN;
lexicon.stupid = A_JJ;
lexicon.stupidities = A_NNS;
lexicon.stupidly = A_RB;
lexicon.style = A_NN;
lexicon.styling = A_NN_VBG;
lexicon.styles = A_NNS;
lexicon.styled = A_VBN_VBD_JJ;
lexicon.subjects = A_NNS_VBZ;
lexicon.subjectively = A_RB;
lexicon.subjectivity = A_NN;
lexicon.subjecting = A_VBG;
lexicon.subjective = A_JJ;
lexicon.subjected = A_VBN;
lexicon.subject = A_NN_JJ_VB;
lexicon.submit = A_VB_VBP;
lexicon.submitted = A_VBN_VBD;
lexicon.submits = A_VBZ;
lexicon.submitting = A_VBG_NN;
lexicon.subsequently = A_RB;
lexicon.subsequent = A_JJ;
lexicon.subsidies = A_NNS;
lexicon.subsidy = A_NN;
lexicon.substance = A_NN;
lexicon.substances = A_NNS;
lexicon.substantiates = A_VBZ;
lexicon.substantiated = A_JJ;
lexicon.substantially = A_RB;
lexicon.substantiation = A_NN;
lexicon.substantial = A_JJ;
lexicon.substantiate = A_VB;
lexicon.subtle = A_JJ;
lexicon.suburbs = A_NNS;
lexicon.suburb = A_NN;
lexicon.suburbanized = A_VBN;
lexicon.suburban = A_JJ;
lexicon.succeed = A_VB_VBP;
lexicon.succeeded = A_VBN_VBD;
lexicon.succeeds = A_VBZ;
lexicon.succeeding = A_VBG_JJ_NN;
lexicon.successful = A_JJ;
lexicon.successes = A_NNS;
lexicon.successive = A_JJ;
lexicon.succession = A_NN;
lexicon.successfully = A_RB;
lexicon.successively = A_RB;
lexicon.success = A_NN;
lexicon.such = A_JJ_PDT_DT;
lexicon.sucking = A_VBG_NN;
lexicon.suck = A_VB_NN_VBP;
lexicon.sucks = A_VBZ;
lexicon.sucked = A_VBD_VBN;
lexicon.sudden = A_JJ;
lexicon.suddenness = A_NN;
lexicon.suddenly = A_RB;
lexicon.sue = A_VB_VBP;
lexicon.sues = A_VBZ;
lexicon.suffering = A_VBG_JJ_NN;
lexicon.sufferer = A_NN;
lexicon.suffered = A_VBD_VBN;
lexicon.sufferings = A_NNS;
lexicon.suffer = A_VB_VBP;
lexicon.suffers = A_VBZ;
lexicon.sufferers = A_NNS;
lexicon.sufficient = A_JJ;
lexicon.sufficiently = A_RB;
lexicon.sufficiency = A_NN;
lexicon.sugared = A_JJ_VBN;
lexicon.sugars = A_NNS;
lexicon.sugar = A_NN;
lexicon.suggests = A_VBZ;
lexicon.suggesting = A_VBG;
lexicon.suggestion = A_NN;
lexicon.suggest = A_VBP_VB;
lexicon.suggestibility = A_NN;
lexicon.suggested = A_VBD_VBN_JJ;
lexicon.suggestive = A_JJ;
lexicon.suggestions = A_NNS;
lexicon.suicides = A_NNS;
lexicon.suicide = A_NN;
lexicon.suicidal = A_JJ;
lexicon.suit = A_NN_VBP_RB_VB;
lexicon.suites = A_NNS;
lexicon.suited = A_VBN_VBD;
lexicon.suite = A_NN_FW;
lexicon.suits = A_NNS_VBZ;
lexicon.suitability = A_NN;
lexicon.suitably = A_RB;
lexicon.suitable = A_JJ;
lexicon.sums = A_NNS_VBZ;
lexicon.summing = A_VBG;
lexicon.sum = A_NN_VB;
lexicon.summed = A_VBD_VBN;
lexicon.summaries = A_NNS;
lexicon.summary = A_NN;
lexicon.summers = A_NNS;
lexicon.summer = A_NN;
lexicon.summit = A_NN_JJ;
lexicon.summiteers = A_NNS;
lexicon.summits = A_NNS;
lexicon.sun = A_NN_VB;
lexicon.sunning = A_VBG;
lexicon.suns = A_NNS;
lexicon.sunlight = A_NN;
lexicon.sunny = A_JJ;
lexicon.super = A_JJ_FW;
lexicon.superiority = A_NN;
lexicon.superiors = A_NNS;
lexicon.superior = A_JJ_NN;
lexicon.supermarket = A_NN;
lexicon.supermarkets = A_NNS;
lexicon.supervisors = A_NNS;
lexicon.supervisor = A_NN;
lexicon.suppliers = A_NNS;
lexicon.supplier = A_NN;
lexicon.supply = A_NN_VBP_VB;
lexicon.supplying = A_VBG;
lexicon.supplied = A_VBN_VBD;
lexicon.supplies = A_NNS_VBZ;
lexicon.supporters = A_NNS;
lexicon.supporting = A_VBG_JJ;
lexicon.support = A_NN_VB_VBP;
lexicon.supports = A_VBZ_NNS;
lexicon.supported = A_VBN_JJ_VBD;
lexicon.supporter = A_NN;
lexicon.supportive = A_JJ;
lexicon.supportable = A_JJ;
lexicon.supposing = A_VBG;
lexicon.suppose = A_VBP_VB;
lexicon.supposes = A_VBZ;
lexicon.supposed = A_VBN_JJ_VBD;
lexicon.supposedly = A_RB;
lexicon.sure = A_JJ_PDT_RB_UH;
lexicon.surely = A_RB;
lexicon.surface = A_NN_VB_VBP;
lexicon.surfaced = A_VBD_VBN;
lexicon.surfaces = A_NNS_VBZ;
lexicon.surfaceness = A_NN;
lexicon.surfacing = A_VBG;
lexicon.surgeon = A_NN;
lexicon.surgeons = A_NNS;
lexicon.surgeries = A_NNS;
lexicon.surgery = A_NN;
lexicon.surprises = A_NNS_VBZ;
lexicon.surprised = A_VBN_VBD_JJ;
lexicon.surprising = A_JJ_VBG;
lexicon.surprisingly = A_RB;
lexicon.surprise = A_NN_JJ_RB_VB;
lexicon.surrounded = A_VBN_VBD;
lexicon.surrounding = A_VBG_JJ_NN;
lexicon.surround = A_VBP_VB;
lexicon.surroundings = A_NNS;
lexicon.surrounds = A_VBZ;
lexicon.surveillance = A_NN;
lexicon.surveys = A_NNS_VBZ;
lexicon.surveyed = A_VBN_VBD;
lexicon.surveying = A_VBG_NN;
lexicon.survey = A_NN_VB_VBP;
lexicon.survivability = A_NN;
lexicon.survivable = A_JJ;
lexicon.survival = A_NN;
lexicon.survive = A_VB_VBP;
lexicon.survives = A_VBZ;
lexicon.survived = A_VBD_VBN;
lexicon.surviving = A_VBG;
lexicon.survivals = A_NNS;
lexicon.survivors = A_NNS;
lexicon.survivor = A_NN;
lexicon.suspect = A_VBP_JJ_NN_VB;
lexicon.suspecting = A_VBG;
lexicon.suspects = A_VBZ_NNS;
lexicon.suspected = A_VBN_VBD_JJ;
lexicon.suspend = A_VB_VBP;
lexicon.suspending = A_VBG;
lexicon.suspender = A_NN;
lexicon.suspends = A_VBZ;
lexicon.suspended = A_VBN_JJ_VBD;
lexicon.suspenders = A_NNS;
lexicon.suspicions = A_NNS;
lexicon.suspicion = A_NN;
lexicon.suspicious = A_JJ;
lexicon.suspiciously = A_RB;
lexicon.sustains = A_VBZ;
lexicon.sustain = A_VB_VBP;
lexicon.sustained = A_VBN_VBD_JJ;
lexicon.sustaining = A_VBG;
lexicon.sustainable = A_JJ;
lexicon.sustainability = A_NN;
lexicon.swallow = A_VB_NN_VBP;
lexicon.swallowed = A_VBN_VBD;
lexicon.swallowing = A_VBG;
lexicon.swallows = A_NNS_VBZ;
lexicon.swearing = A_NN_VBG;
lexicon.swears = A_VBZ;
lexicon.swear = A_VB_VBP;
lexicon.sweats = A_NNS;
lexicon.sweated = A_VBD_VBN;
lexicon.sweating = A_VBG_NN;
lexicon.sweat = A_NN_VBD_VBP_VB;
lexicon.sweater = A_NN;
lexicon.sweaters = A_NNS;
lexicon.sweeps = A_NNS_VBZ;
lexicon.sweepings = A_NNS;
lexicon.sweep = A_NN_VB;
lexicon.sweeping = A_VBG_JJ_NN;
lexicon.sweepingly = A_RB;
lexicon.sweetness = A_NN;
lexicon.sweets = A_NNS;
lexicon.sweetly = A_RB;
lexicon.sweet = A_JJ;
lexicon.swelling = A_VBG_JJ_NN;
lexicon.swells = A_NNS_VBZ;
lexicon.swellings = A_NNS;
lexicon.swell = A_VB_VBP_JJ_NN;
lexicon.swelled = A_VBD_VBN_JJ;
lexicon.swimming = A_VBG_JJ_NN;
lexicon.swim = A_VB_VBP_NN;
lexicon.swims = A_VBZ;
lexicon.swing = A_NN_VBP_JJ_VB;
lexicon.swinging = A_VBG_JJ;
lexicon.swings = A_NNS_VBZ;
lexicon.switching = A_VBG_NN;
lexicon.switched = A_VBD_VBN_JJ;
lexicon.switches = A_NNS_VBZ;
lexicon.switch = A_NN_VB_VBP;
lexicon.sword = A_NN;
lexicon.swords = A_NNS;
lexicon.sworde = A_NN;
lexicon.symbolism = A_NN;
lexicon.symbolizing = A_VBG;
lexicon.symbols = A_NNS;
lexicon.symbolized = A_VBD_VBN;
lexicon.symbolical = A_JJ;
lexicon.symbolize = A_VB_VBP;
lexicon.symbolizes = A_VBZ;
lexicon.symbolically = A_RB;
lexicon.symbolic = A_JJ;
lexicon.symbol = A_NN;
lexicon.sympathies = A_NNS;
lexicon.sympathy = A_NN;
lexicon.symptom = A_NN;
lexicon.symptoms = A_NNS;
lexicon.syndrome = A_NN;
lexicon.systemic = A_JJ;
lexicon.systems = A_NNS;
lexicon.system = A_NN;
lexicon.systemization = A_NN;
lexicon.tabling = A_VBG_JJ_NN;
lexicon.table = A_NN_VB;
lexicon.tables = A_NNS;
lexicon.tabled = A_VBN;
lexicon.tablespoonful = A_NN_JJ;
lexicon.tablespoons = A_NNS;
lexicon.tablespoon = A_NN;
lexicon.tablespoonfuls = A_NNS;
lexicon.tackling = A_VBG;
lexicon.tackle = A_VB_VBP_NN;
lexicon.tackles = A_VBZ_NNS;
lexicon.tackled = A_VBN;
lexicon.tactic = A_NN;
lexicon.tactics = A_NNS;
lexicon.tactically = A_RB;
lexicon.tactical = A_JJ;
lexicon.tagged = A_VBN_VBD_JJ;
lexicon.tagging = A_VBG;
lexicon.tags = A_NNS_VBZ;
lexicon.tag = A_NN_VB;
lexicon.tails = A_NNS;
lexicon.tailing = A_VBG;
lexicon.tail = A_NN_JJ_VB;
lexicon.take = A_VB_NN_VBP;
lexicon.takeing = A_VBG;
lexicon.takings = A_NNS;
lexicon.takes = A_VBZ;
lexicon.taking = A_VBG_NN;
lexicon.tale = A_NN;
lexicon.tales = A_NNS;
lexicon.talents = A_NNS;
lexicon.talent = A_NN;
lexicon.talented = A_JJ;
lexicon.talked = A_VBD_VBN;
lexicon.talking = A_VBG_NN;
lexicon.talk = A_VB_VBP_NN;
lexicon.talks = A_NNS_VBZ;
lexicon.tall = A_JJ;
lexicon.tanked = A_VBN;
lexicon.tanking = A_VBG;
lexicon.tanks = A_NNS;
lexicon.tank = A_NN_VB;
lexicon.taps = A_NNS_VBZ;
lexicon.tapped = A_VBD_VBN;
lexicon.tapping = A_VBG_NN;
lexicon.tap = A_VB_NN_VBP;
lexicon.tape = A_NN_VB_VBP;
lexicon.tapings = A_NNS;
lexicon.taping = A_NN_VBG;
lexicon.tapes = A_NNS;
lexicon.taped = A_VBN_JJ_VBD;
lexicon.targets = A_NNS_VBZ;
lexicon.targeted = A_VBN_VBD_JJ;
lexicon.target = A_NN_VBP_VB;
lexicon.targeting = A_VBG_NN;
lexicon.task = A_NN_VB;
lexicon.tasks = A_NNS;
lexicon.tasted = A_VBD_VBN;
lexicon.tastes = A_NNS_VBZ;
lexicon.tastefully = A_RB;
lexicon.tasteful = A_JJ;
lexicon.taste = A_NN_VB_VBP;
lexicon.tasting = A_VBG_NN;
lexicon.taxes = A_NNS_VBZ;
lexicon.taxed = A_VBN_JJ_VBD;
lexicon.taxing = A_VBG_JJ_NN;
lexicon.tax = A_NN_VB_VBP;
lexicon.taxpaying = A_JJ;
lexicon.taxpayer = A_NN;
lexicon.taxpayers = A_NNS;
lexicon.tea = A_NN;
lexicon.teas = A_NNS;
lexicon.teaches = A_VBZ;
lexicon.teachings = A_NNS;
lexicon.teach = A_VB_VBP;
lexicon.teaching = A_NN_VBG;
lexicon.teacher = A_NN;
lexicon.teachers = A_NNS;
lexicon.teamed = A_VBD_VBN;
lexicon.teams = A_NNS_VBZ;
lexicon.team = A_NN_VB_VBP;
lexicon.teaming = A_VBG;
lexicon.teammates = A_NNS;
lexicon.teammate = A_NN;
lexicon.tearfully = A_RB;
lexicon.tears = A_NNS_VBZ;
lexicon.tearing = A_VBG;
lexicon.tear = A_VB_VBP_NN;
lexicon.teaspoonful = A_JJ_NN;
lexicon.teaspoons = A_NNS;
lexicon.teaspoonfuls = A_NNS;
lexicon.teaspoon = A_NN;
lexicon.technical = A_JJ;
lexicon.technicalities = A_NNS;
lexicon.technically = A_RB;
lexicon.technicality = A_NN;
lexicon.technicians = A_NNS;
lexicon.technician = A_NN;
lexicon.technique = A_NN;
lexicon.techniques = A_NNS;
lexicon.technology = A_NN;
lexicon.technological = A_JJ;
lexicon.technologies = A_NNS;
lexicon.technologically = A_RB;
lexicon.teens = A_NNS_NN;
lexicon.teen = A_JJ_NN;
lexicon.teenage = A_JJ;
lexicon.teenagers = A_NNS;
lexicon.teenager = A_NN;
lexicon.telephoned = A_VBD_VBN;
lexicon.telephones = A_NNS;
lexicon.telephone = A_NN_VB;
lexicon.telephoning = A_VBG_NN;
lexicon.telescope = A_NN_VB;
lexicon.telescoping = A_NN;
lexicon.telescoped = A_VBN;
lexicon.telescopes = A_NNS;
lexicon.telescopic = A_JJ;
lexicon.televising = A_NN;
lexicon.television = A_NN;
lexicon.televised = A_VBN_JJ;
lexicon.televisions = A_NNS;
lexicon.telling = A_VBG_JJ_NN;
lexicon.tell = A_VB_VBP;
lexicon.tellingly = A_RB;
lexicon.tells = A_VBZ;
lexicon.temperature = A_NN;
lexicon.temperatures = A_NNS;
lexicon.temple = A_NN;
lexicon.temples = A_NNS;
lexicon.temporary = A_JJ;
lexicon.tens = A_NNS;
lexicon.tended = A_VBD_VBN_JJ;
lexicon.tend = A_VBP_VB;
lexicon.tends = A_VBZ;
lexicon.tending = A_VBG_NN;
lexicon.tendency = A_NN;
lexicon.tendencies = A_NNS;
lexicon.tender = A_NN_VBP_JJ_VB;
lexicon.tenderly = A_RB;
lexicon.tenderness = A_NN;
lexicon.tendered = A_VBN_JJ_VBD;
lexicon.tenders = A_NNS;
lexicon.tendering = A_VBG_NN;
lexicon.tennis = A_NN;
lexicon.tensions = A_NNS;
lexicon.tension = A_NN;
lexicon.tensioning = A_VBG;
lexicon.tensional = A_JJ;
lexicon.tenting = A_NN;
lexicon.tent = A_NN;
lexicon.tents = A_NNS;
lexicon.term = A_NN_VB_VBP;
lexicon.termed = A_VBD_VBN;
lexicon.terms = A_NNS_VBZ;
lexicon.terming = A_VBG;
lexicon.terrains = A_NNS;
lexicon.terrain = A_NN;
lexicon.terrible = A_JJ;
lexicon.terribly = A_RB;
lexicon.terrific = A_JJ;
lexicon.territories = A_NNS;
lexicon.territory = A_NN;
lexicon.territorial = A_JJ_NN;
lexicon.terrorism = A_NN;
lexicon.terror = A_NN;
lexicon.terrors = A_NNS;
lexicon.terrorize = A_VB;
lexicon.terrorizing = A_VBG;
lexicon.terrorized = A_VBN_VBD;
lexicon.terrorists = A_NNS;
lexicon.terrorist = A_JJ_NN;
lexicon.terroristic = A_JJ;
lexicon.test = A_NN_VBP_VB;
lexicon.testing = A_NN_VBG;
lexicon.tests = A_NNS_VBZ;
lexicon.tested = A_VBN_VBD_JJ;
lexicon.testings = A_NNS;
lexicon.testifying = A_VBG;
lexicon.testify = A_VB_VBP;
lexicon.testified = A_VBD_VBN;
lexicon.testifies = A_VBZ;
lexicon.testimonials = A_NNS;
lexicon.testimonial = A_JJ_NN;
lexicon.testimony = A_NN;
lexicon.texts = A_NNS;
lexicon.text = A_NN;
lexicon.textbook = A_NN;
lexicon.textbooks = A_NNS;
lexicon.textures = A_NNS;
lexicon.textured = A_JJ;
lexicon.texture = A_NN;
lexicon.than = A_IN_RB_RBR;
lexicon.thanking = A_VBG;
lexicon.thanks = A_NNS_VBZ_VB_UH;
lexicon.thankfully = A_RB;
lexicon.thank = A_VB_VBP;
lexicon.thankful = A_JJ;
lexicon.thankfulness = A_NN;
lexicon.thanked = A_VBD_VBN;
lexicon.that = A_IN_DT_NN_RB_RP_UH_WP_VBP_WDT;
lexicon.the = A_DT_VBD_VBP_IN_JJ_NN_NNP_PDT;
lexicon.theater = A_NN;
lexicon.theaters = A_NNS_VBD;
lexicon.theirs = A_PRP_JJ;
lexicon.their = A_PRP$_PRP;
lexicon.them = A_PRP_DT;
lexicon.theme = A_NN;
lexicon.themed = A_VBN;
lexicon.themes = A_NNS;
lexicon.themselves = A_PRP;
lexicon.then = A_RB_IN_JJ;
lexicon.theology = A_NN;
lexicon.theological = A_JJ;
lexicon.theoretically = A_RB;
lexicon.theoretical = A_JJ;
lexicon.theories = A_NNS;
lexicon.theory = A_NN;
lexicon.therapists = A_NNS;
lexicon.therapist = A_NN;
lexicon.therapy = A_NN;
lexicon.therapies = A_NNS;
lexicon.there = A_EX_RB_UH;
lexicon.thereby = A_RB;
lexicon.therefore = A_RB_CC;
lexicon.therefor = A_RB;
lexicon.therefores = A_NNS;
lexicon.theses = A_NNS;
lexicon.these = A_DT;
lexicon.they = A_PRP;
lexicon.thicknesses = A_NNS;
lexicon.thick = A_JJ_NN_RB;
lexicon.thickness = A_NN;
lexicon.thickly = A_RB;
lexicon.thigh = A_NN;
lexicon.thighs = A_NNS;
lexicon.thinly = A_RB;
lexicon.thin = A_JJ_RB_VB;
lexicon.thinned = A_VBN_VBD;
lexicon.thinness = A_NN;
lexicon.thinning = A_VBG;
lexicon.thing = A_NN;
lexicon.things = A_NNS;
lexicon.think = A_VBP_VB_NN;
lexicon.thinke = A_VBZ_VB;
lexicon.thinks = A_VBZ;
lexicon.thinking = A_VBG_JJ_NN;
lexicon.thirds = A_NNS;
lexicon.thirties = A_NNS;
lexicon.this = A_DT_RB_PDT;
lexicon.thoroughly = A_RB;
lexicon.thorough = A_JJ;
lexicon.thoroughness = A_NN;
lexicon.those = A_DT;
lexicon.though = A_IN_RB_VBD;
lexicon.thoughtful = A_JJ;
lexicon.thought = A_VBD_NN_VBN;
lexicon.thoughtfulness = A_NN;
lexicon.thoughtfully = A_RB;
lexicon.thoughts = A_NNS;
lexicon.threaded = A_VBN;
lexicon.threading = A_VBG;
lexicon.threads = A_NNS;
lexicon.thread = A_NN;
lexicon.threats = A_NNS_VBZ;
lexicon.threat = A_NN;
lexicon.threateningly = A_RB;
lexicon.threaten = A_VB_VBP;
lexicon.threatens = A_VBZ;
lexicon.threatening = A_VBG_JJ;
lexicon.threatened = A_VBN_VBD_JJ;
lexicon.threes = A_NNS;
lexicon.threshold = A_NN;
lexicon.thresholds = A_NNS;
lexicon.thrive = A_VB_VBP;
lexicon.thrived = A_VBD_VBN;
lexicon.thrives = A_VBZ;
lexicon.thriving = A_VBG_JJ;
lexicon.throat = A_NN;
lexicon.throats = A_NNS;
lexicon.through = A_IN_JJ_RB_RP;
lexicon.throughout = A_IN_RB;
lexicon.throw = A_VB_VBP_NN;
lexicon.throwed = A_VBD;
lexicon.throws = A_VBZ;
lexicon.throwing = A_VBG_NN;
lexicon.thumbing = A_VBG;
lexicon.thumb = A_NN_VB;
lexicon.thumbs = A_NNS_VBZ;
lexicon.thumbed = A_VBD_VBN;
lexicon.thus = A_RB;
lexicon.ticketed = A_VBN;
lexicon.tickets = A_NNS;
lexicon.ticket = A_NN;
lexicon.ticketing = A_VBG;
lexicon.tidings = A_NNS;
lexicon.tide = A_NN_VB;
lexicon.tides = A_NNS;
lexicon.tied = A_VBN_JJ_VBD;
lexicon.tie = A_NN_VBP_VB;
lexicon.tying = A_VBG;
lexicon.ties = A_NNS_VBZ;
lexicon.tightly = A_RB;
lexicon.tight = A_JJ_RB;
lexicon.tightness = A_NN;
lexicon.tightener = A_NN;
lexicon.tightened = A_VBD_VBN;
lexicon.tightening = A_VBG_JJ_NN;
lexicon.tightens = A_VBZ;
lexicon.tighten = A_VB_VBP;
lexicon.tile = A_NN;
lexicon.tiled = A_JJ_VBN;
lexicon.tiles = A_NNS;
lexicon.tilling = A_VBG;
lexicon.till = A_IN_VB;
lexicon.tilled = A_JJ;
lexicon.timber = A_NN_VB;
lexicon.timbered = A_JJ;
lexicon.timbers = A_NNS;
lexicon.times = A_NNS_VBZ_CC_RB;
lexicon.timed = A_VBN_VBD_JJ;
lexicon.timing = A_NN_VBG;
lexicon.timely = A_JJ_RB;
lexicon.time = A_NN_VB;
lexicon.tiny = A_JJ;
lexicon.tipped = A_VBD_VBN;
lexicon.tip = A_NN_VB_VBP;
lexicon.tipping = A_VBG_NN;
lexicon.tips = A_NNS_VBZ;
lexicon.tire = A_NN_VBP_VB;
lexicon.tired = A_VBN_JJ_VBD;
lexicon.tires = A_NNS_VBZ;
lexicon.tiring = A_VBG;
lexicon.tiredly = A_RB;
lexicon.tissue = A_NN;
lexicon.tissues = A_NNS;
lexicon.titled = A_VBN_JJ_VBD;
lexicon.titles = A_NNS;
lexicon.title = A_NN;
lexicon.to = A_TO_RB;
lexicon.tobacco = A_NN;
lexicon.today = A_NN_JJ_RB;
lexicon.toes = A_NNS;
lexicon.toe = A_NN_VB;
lexicon.togetherness = A_NN;
lexicon.together = A_RB_IN_RP;
lexicon.toilets = A_NNS;
lexicon.toilet = A_NN;
lexicon.toleration = A_NN;
lexicon.tolerating = A_VBG_JJ;
lexicon.tolerate = A_VB_VBP;
lexicon.tolerant = A_JJ;
lexicon.tolerable = A_JJ;
lexicon.tolerated = A_VBN_VBD;
lexicon.tolerates = A_VBZ;
lexicon.tolerance = A_NN;
lexicon.tolls = A_NNS;
lexicon.toll = A_NN_VB;
lexicon.tolled = A_VBN;
lexicon.tomatoes = A_NNS;
lexicon.tomato = A_NN;
lexicon.tomorrow = A_NN_JJ_RB;
lexicon.tone = A_NN_VB;
lexicon.toned = A_VBN;
lexicon.tones = A_NNS;
lexicon.tongues = A_NNS;
lexicon.tongued = A_VBD_JJ;
lexicon.tongue = A_NN;
lexicon.tonight = A_RB_NN;
lexicon.too = A_RB;
lexicon.tooling = A_VBG_NN;
lexicon.tool = A_NN;
lexicon.tools = A_NNS_VBZ;
lexicon.tooth = A_NN_RB;
lexicon.topped = A_VBD_VBN;
lexicon.toppings = A_NNS;
lexicon.tops = A_NNS_VBZ;
lexicon.top = A_JJ_NN_VBP_RB_VB;
lexicon.topping = A_VBG_NN;
lexicon.topical = A_JJ;
lexicon.topicality = A_NN;
lexicon.topic = A_NN;
lexicon.topics = A_NNS;
lexicon.tossed = A_VBD_VBN_JJ;
lexicon.tosses = A_NNS;
lexicon.tossing = A_VBG_NN;
lexicon.toss = A_VB_NN_VBP;
lexicon.totaled = A_VBD_VBN_VBP;
lexicon.totality = A_NN;
lexicon.totally = A_RB;
lexicon.totals = A_VBZ_NNS;
lexicon.totaling = A_VBG;
lexicon.totalled = A_VBD_VBN;
lexicon.total = A_JJ_NN_VB_VBP;
lexicon.totalling = A_VBG;
lexicon.touches = A_NNS_VBZ;
lexicon.touch = A_NN_RB_VB_VBP;
lexicon.touched = A_VBD_VBN;
lexicon.touching = A_VBG_JJ_NN;
lexicon.touchdown = A_NN;
lexicon.touchdowns = A_NNS;
lexicon.toughs = A_NNS;
lexicon.toughness = A_NN;
lexicon.toughing = A_VBG;
lexicon.tough = A_JJ_RB_VB;
lexicon.toured = A_VBD;
lexicon.tours = A_NNS_VBZ;
lexicon.touring = A_VBG_JJ_NN;
lexicon.tour = A_NN_FW_VB;
lexicon.tourism = A_NN;
lexicon.tourists = A_NNS;
lexicon.tourist = A_NN;
lexicon.tournament = A_NN;
lexicon.tournaments = A_NNS;
lexicon.towards = A_IN;
lexicon.toward = A_IN;
lexicon.towardes = A_IN;
lexicon.towel = A_NN;
lexicon.towels = A_NNS;
lexicon.toweling = A_NN;
lexicon.tower = A_NN_VB;
lexicon.towering = A_JJ_VBG;
lexicon.towers = A_NNS_VBZ;
lexicon.towne = A_NN;
lexicon.towns = A_NNS;
lexicon.town = A_NN;
lexicon.toxic = A_JJ_NN;
lexicon.toxicant = A_NN;
lexicon.toxicity = A_NN;
lexicon.toxics = A_NNS;
lexicon.toys = A_NNS_VBZ;
lexicon.toying = A_VBG;
lexicon.toy = A_NN_JJ;
lexicon.traced = A_VBN_VBD;
lexicon.traces = A_NNS_VBZ;
lexicon.trace = A_NN_JJ_VB;
lexicon.tracing = A_VBG_JJ_NN;
lexicon.tracings = A_NNS;
lexicon.tracking = A_VBG_NN;
lexicon.tracks = A_VBZ_NNS;
lexicon.track = A_NN_VBP_VB;
lexicon.tracked = A_VBN_VBD_JJ;
lexicon.trading = A_NN_JJ_VBG;
lexicon.trade = A_NN_VBP_VB;
lexicon.trades = A_NNS_VBZ;
lexicon.traded = A_VBN_VBD_JJ;
lexicon.tradition = A_NN;
lexicon.traditionalism = A_NN;
lexicon.traditions = A_NNS;
lexicon.traditionally = A_RB;
lexicon.traditional = A_JJ;
lexicon.traffic = A_NN;
lexicon.tragedies = A_NNS;
lexicon.tragedy = A_NN;
lexicon.tragically = A_RB;
lexicon.tragic = A_JJ_NN;
lexicon.trail = A_NN_VBP_VB;
lexicon.trails = A_NNS_VBZ;
lexicon.trailed = A_VBD_VBN;
lexicon.trailing = A_VBG;
lexicon.trailer = A_NN;
lexicon.trailers = A_NNS;
lexicon.trains = A_NNS_VBZ;
lexicon.train = A_NN_VB_VBP;
lexicon.training = A_NN_VBG_JJ;
lexicon.trained = A_VBN_VBD_JJ;
lexicon.trainers = A_NNS;
lexicon.trainer = A_NN;
lexicon.trait = A_NN;
lexicon.traits = A_NNS;
lexicon.transact = A_VB;
lexicon.transacting = A_VBG;
lexicon.transacted = A_VBN;
lexicon.transaction = A_NN;
lexicon.transactions = A_NNS;
lexicon.transferred = A_VBN_VBD_JJ;
lexicon.transfers = A_NNS_VBZ;
lexicon.transferring = A_VBG;
lexicon.transference = A_NN;
lexicon.transferable = A_JJ;
lexicon.transfer = A_NN_VB_VBP;
lexicon.transfered = A_VBN;
lexicon.transfering = A_VBG;
lexicon.transforming = A_VBG;
lexicon.transformed = A_VBN_JJ_VBD;
lexicon.transformers = A_NNS;
lexicon.transformation = A_NN;
lexicon.transforms = A_VBZ;
lexicon.transformer = A_NN;
lexicon.transform = A_VB_VBP;
lexicon.transition = A_NN;
lexicon.transit = A_NN_JJ;
lexicon.transitional = A_JJ;
lexicon.transitions = A_NNS;
lexicon.translator = A_NN;
lexicon.translating = A_VBG_NN;
lexicon.translation = A_NN;
lexicon.translates = A_VBZ;
lexicon.translated = A_VBN_VBD;
lexicon.translators = A_NNS;
lexicon.translate = A_VB_VBP;
lexicon.translations = A_NNS;
lexicon.transmission = A_NN;
lexicon.transmissible = A_JJ;
lexicon.transmissions = A_NNS;
lexicon.transmits = A_VBZ;
lexicon.transmit = A_VB_VBP;
lexicon.transmitted = A_VBN_JJ_VBD;
lexicon.transmitting = A_VBG_NN;
lexicon.transportable = A_JJ;
lexicon.transports = A_NNS_VBZ;
lexicon.transportation = A_NN;
lexicon.transported = A_VBN_VBD;
lexicon.transporters = A_NNS;
lexicon.transporting = A_VBG_NN;
lexicon.transporter = A_NN;
lexicon.transport = A_NN_VBP_VB;
lexicon.trapped = A_VBN_VBD_JJ;
lexicon.trapping = A_VBG_NN;
lexicon.traps = A_NNS_VBZ;
lexicon.trappings = A_NNS;
lexicon.trap = A_NN_VB;
lexicon.trashed = A_VBN;
lexicon.trash = A_NN_VB;
lexicon.trashing = A_NN_VBG;
lexicon.trauma = A_NN;
lexicon.traumas = A_NNS;
lexicon.travel = A_NN_VBP_VB;
lexicon.travelers = A_NNS;
lexicon.traveller = A_NN;
lexicon.travelled = A_JJ_VBD_VBN;
lexicon.travellers = A_NNS;
lexicon.traveled = A_VBD_JJ_VBN;
lexicon.travels = A_VBZ_NNS;
lexicon.travelling = A_VBG;
lexicon.traveling = A_VBG_NN;
lexicon.traveler = A_NN;
lexicon.trays = A_NNS;
lexicon.tray = A_NN;
lexicon.treasure = A_NN_VBP;
lexicon.treasures = A_NNS;
lexicon.treasurers = A_NNS;
lexicon.treasured = A_VBN_JJ;
lexicon.treasurer = A_NN;
lexicon.treating = A_VBG;
lexicon.treated = A_VBN_VBD;
lexicon.treat = A_VB_VBP_NN;
lexicon.treats = A_VBZ_NNS;
lexicon.treatment = A_NN;
lexicon.treatments = A_NNS;
lexicon.treaties = A_NNS;
lexicon.treaty = A_NN;
lexicon.trees = A_NNS;
lexicon.tree = A_NN;
lexicon.tremendous = A_JJ;
lexicon.tremendously = A_RB;
lexicon.trends = A_NNS;
lexicon.trended = A_VBN;
lexicon.trending = A_VBG;
lexicon.trend = A_NN_VB;
lexicon.trial = A_NN_VB;
lexicon.trials = A_NNS;
lexicon.tribal = A_JJ;
lexicon.tribes = A_NNS;
lexicon.tribe = A_NN;
lexicon.tricks = A_NNS_VBZ;
lexicon.tricked = A_VBN;
lexicon.trick = A_NN_VB;
lexicon.trigger = A_VB_NN_VBP;
lexicon.triggered = A_VBN_VBD_JJ;
lexicon.triggers = A_NNS_VBZ;
lexicon.triggering = A_VBG;
lexicon.trims = A_VBZ_NNS;
lexicon.trim = A_VB_JJ_NN;
lexicon.trimming = A_VBG_NN;
lexicon.trimmed = A_VBN_RBR_VBD_JJ;
lexicon.trimmings = A_NNS;
lexicon.trips = A_NNS;
lexicon.tripped = A_VBD_VBN;
lexicon.tripping = A_VBG;
lexicon.trip = A_NN_VB;
lexicon.triumph = A_NN_VB;
lexicon.triumphs = A_NNS_VBZ;
lexicon.triumphed = A_VBD_VBN;
lexicon.tropical = A_JJ_NN;
lexicon.tropics = A_NNS;
lexicon.troubles = A_NNS_VBZ;
lexicon.troubling = A_JJ_VBG;
lexicon.trouble = A_NN_VBD_VBP_JJ_VB;
lexicon.troubled = A_JJ_VBD_VBN;
lexicon.truck = A_NN_VB_VBP;
lexicon.trucks = A_NNS_VBZ;
lexicon.trucking = A_NN_VBG;
lexicon.trucked = A_VBN;
lexicon.true = A_JJ;
lexicon.truly = A_RB;
lexicon.trunk = A_NN;
lexicon.trunks = A_NNS;
lexicon.trustingly = A_RB;
lexicon.trustfully = A_RB;
lexicon.trust = A_NN_VBP_VB;
lexicon.trusting = A_JJ_VBG;
lexicon.trusts = A_NNS_VBZ;
lexicon.trusted = A_VBN_VBD_JJ;
lexicon.truths = A_NNS;
lexicon.truthfulness = A_NN;
lexicon.truth = A_NN;
lexicon.truthfully = A_RB;
lexicon.truthful = A_JJ;
lexicon.trying = A_VBG_JJ_NN;
lexicon.try = A_VB_VBP_NN;
lexicon.tries = A_VBZ_NNS;
lexicon.tried = A_VBD_JJ_VBN;
lexicon.tubing = A_NN;
lexicon.tubes = A_NNS;
lexicon.tube = A_NN;
lexicon.tucked = A_VBN_VBD;
lexicon.tuck = A_VBP_VB;
lexicon.tucking = A_VBG;
lexicon.tumors = A_NNS;
lexicon.tumor = A_NN;
lexicon.tuned = A_VBN_JJ_VBD;
lexicon.tune = A_NN_VB_VBP;
lexicon.tuning = A_VBG_NN;
lexicon.tunes = A_NNS_VBZ;
lexicon.tuneful = A_JJ;
lexicon.tunefulness = A_NN;
lexicon.tunnels = A_NNS;
lexicon.tunneled = A_VBD;
lexicon.tunnel = A_NN_VBP;
lexicon.turkey = A_NN_JJ;
lexicon.turkeys = A_NNS;
lexicon.turned = A_VBD_VBN;
lexicon.turns = A_VBZ_NNS;
lexicon.turne = A_VB;
lexicon.turnings = A_NNS;
lexicon.turn = A_VB_NN_RB_VBP;
lexicon.turning = A_VBG_JJ_NN;
lexicon.twentieth = A_JJ;
lexicon.twenties = A_NNS;
lexicon.twice = A_RB_JJ;
lexicon.twinned = A_VBN;
lexicon.twins = A_NNS;
lexicon.twin = A_JJ_NN;
lexicon.twisting = A_VBG_NN;
lexicon.twists = A_NNS_VBZ;
lexicon.twisted = A_VBN_JJ_VBD;
lexicon.twist = A_NN_VBP_VB;
lexicon.types = A_NNS;
lexicon.typed = A_VBN_JJ_VBD;
lexicon.typing = A_NN_VBG;
lexicon.type = A_NN_VB;
lexicon.typicality = A_NN;
lexicon.typical = A_JJ;
lexicon.typically = A_RB;
lexicon.ugly = A_JJ;
lexicon.ugliness = A_NN;
lexicon.uh = A_UH;
lexicon.ultimate = A_JJ;
lexicon.ultimately = A_RB;
lexicon.unable = A_JJ;
lexicon.uncertainly = A_RB;
lexicon.uncertain = A_JJ_RB;
lexicon.uncertainties = A_NNS;
lexicon.uncertainty = A_NN;
lexicon.uncles = A_NNS;
lexicon.uncle = A_NN;
lexicon.uncomfortably = A_RB;
lexicon.uncomforted = A_JJ;
lexicon.uncomfortable = A_JJ;
lexicon.uncovered = A_VBN_VBD_JJ;
lexicon.uncover = A_VB;
lexicon.uncovering = A_VBG;
lexicon.underlies = A_VBZ;
lexicon.underlying = A_VBG_JJ;
lexicon.under = A_IN_JJ_RB_RP;
lexicon.undergo = A_VB_VBP;
lexicon.undergoes = A_VBZ;
lexicon.undergoing = A_VBG;
lexicon.undergraduates = A_NNS;
lexicon.undergraduate = A_JJ_NNP_NN;
lexicon.undermine = A_VB_VBP;
lexicon.undermining = A_VBG;
lexicon.undermined = A_VBN_VBD_JJ;
lexicon.undermines = A_VBZ;
lexicon.understands = A_VBZ;
lexicon.understand = A_VB_VBP;
lexicon.understanding = A_NN_VBG_JJ;
lexicon.understandingly = A_RB;
lexicon.understandably = A_RB;
lexicon.understandable = A_JJ;
lexicon.understanded = A_VBN;
lexicon.understandings = A_NNS;
lexicon.undertaking = A_NN_VBG;
lexicon.undertakes = A_VBZ;
lexicon.undertaker = A_NN;
lexicon.undertakings = A_NNS;
lexicon.undertake = A_VB;
lexicon.undo = A_VB;
lexicon.undoing = A_NN_VBG;
lexicon.undone = A_VBN_JJ;
lexicon.unemployment = A_NN;
lexicon.unemployed = A_JJ;
lexicon.unexpected = A_JJ;
lexicon.unexpectedly = A_RB;
lexicon.unfairness = A_NN;
lexicon.unfair = A_JJ;
lexicon.unfairly = A_RB;
lexicon.unfolding = A_VBG_JJ;
lexicon.unfold = A_VB_VBP;
lexicon.unfolds = A_VBZ;
lexicon.unfoldment = A_NN;
lexicon.unfolded = A_VBD_VBN;
lexicon.unfortunates = A_NNS;
lexicon.unfortunately = A_RB;
lexicon.unfortunate = A_JJ_NN;
lexicon.unhappiness = A_NN;
lexicon.unhappy = A_JJ;
lexicon.uniformity = A_NN;
lexicon.uniformly = A_RB;
lexicon.uniforms = A_NNS;
lexicon.uniform = A_NN_JJ;
lexicon.uniformed = A_JJ;
lexicon.unionized = A_JJ_VBD_VBN;
lexicon.union = A_NN_JJ;
lexicon.unions = A_NNS;
lexicon.uniquely = A_RB;
lexicon.uniqueness = A_NN;
lexicon.unique = A_JJ_NN;
lexicon.units = A_NNS;
lexicon.unites = A_VBZ;
lexicon.uniting = A_VBG;
lexicon.unit = A_NN;
lexicon.unite = A_VB_VBP;
lexicon.unitized = A_VBN;
lexicon.united = A_VBN_VBD_JJ;
lexicon.unities = A_NNS;
lexicon.unity = A_NN;
lexicon.university = A_NN;
lexicon.universe = A_NN;
lexicon.universalize = A_VBP;
lexicon.universities = A_NNS;
lexicon.universally = A_RB;
lexicon.universality = A_NN;
lexicon.universal = A_JJ;
lexicon.universalization = A_NN;
lexicon.universals = A_NNS;
lexicon.unknowns = A_NNS;
lexicon.unknown = A_JJ_NN;
lexicon.unless = A_IN;
lexicon.unlike = A_IN_JJ_NN;
lexicon.unlikely = A_JJ_RB;
lexicon.unprecedented = A_JJ;
lexicon.unprecedentedly = A_RB;
lexicon.until = A_IN;
lexicon.unusual = A_JJ;
lexicon.unusually = A_RB;
lexicon.ups = A_NNS;
lexicon.up = A_IN_JJ_RB_RP_VB_NNP_RBR;
lexicon.upped = A_VBD_VBN;
lexicon.updating = A_VBG_NN;
lexicon.update = A_VB_VBP_NN;
lexicon.updated = A_VBN_JJ;
lexicon.updates = A_NNS_VBZ;
lexicon.upon = A_IN_RB_RP;
lexicon.upper = A_JJ_JJR_RB;
lexicon.upsetting = A_VBG_JJ_NN;
lexicon.upsets = A_NNS_VBZ;
lexicon.upset = A_VBN_NN_VB_VBD_VBP_JJ;
lexicon.upstairs = A_NN_RB_JJ;
lexicon.urbane = A_JJ;
lexicon.urbanization = A_NN;
lexicon.urbanism = A_NN;
lexicon.urban = A_JJ;
lexicon.urbanized = A_VBN_JJ;
lexicon.urging = A_VBG_NN;
lexicon.urge = A_VB_VBP_NN;
lexicon.urged = A_VBD_VBN;
lexicon.urges = A_VBZ_NNS;
lexicon.urgings = A_NNS;
lexicon.us = A_PRP;
lexicon.uses = A_VBZ_NNS;
lexicon.usefulness = A_NN;
lexicon.using = A_VBG;
lexicon.used = A_VBN_VBD_JJ;
lexicon.use = A_NN_VB_VBP;
lexicon.usefully = A_RB;
lexicon.useful = A_JJ;
lexicon.user = A_NN;
lexicon.users = A_NNS;
lexicon.usual = A_JJ_RB;
lexicon.usually = A_RB;
lexicon.utilities = A_NNS;
lexicon.utilizes = A_VBZ;
lexicon.utilized = A_VBN_VBD;
lexicon.utilization = A_NN;
lexicon.utility = A_NN_JJ;
lexicon.utilize = A_VB_VBP;
lexicon.utilizing = A_VBG;
lexicon.vacations = A_NNS;
lexicon.vacated = A_VBN_VBD;
lexicon.vacationed = A_VBD;
lexicon.vacationing = A_VBG_NN;
lexicon.vacation = A_NN_VBP;
lexicon.vacating = A_VBG;
lexicon.vacate = A_VB;
lexicon.vaccines = A_NNS;
lexicon.vaccination = A_NN;
lexicon.vaccinating = A_VBG;
lexicon.vaccine = A_NN;
lexicon.vacuumed = A_VBD;
lexicon.vacuuming = A_VBG_NN;
lexicon.vacuum = A_NN_JJ_VB_VBP;
lexicon.validly = A_RB;
lexicon.validated = A_VBN;
lexicon.validity = A_NN;
lexicon.valid = A_JJ;
lexicon.validation = A_NN;
lexicon.validate = A_VB;
lexicon.validating = A_VBG;
lexicon.valleys = A_NNS;
lexicon.valley = A_NN;
lexicon.valuable = A_JJ;
lexicon.valuing = A_VBG;
lexicon.values = A_NNS_VBZ;
lexicon.value = A_NN_VBP_VB;
lexicon.valued = A_VBN_JJ_VBD;
lexicon.van = A_NNP_NN;
lexicon.vans = A_NNS;
lexicon.vanish = A_VBP_VB;
lexicon.vanishing = A_VBG;
lexicon.vanishes = A_VBZ;
lexicon.vanished = A_VBD_VBN;
lexicon.variables = A_NNS;
lexicon.variable = A_JJ_NN;
lexicon.variability = A_NN;
lexicon.variation = A_NN;
lexicon.variations = A_NNS;
lexicon.variety = A_NN;
lexicon.varieties = A_NNS;
lexicon.various = A_JJ;
lexicon.variously = A_RB;
lexicon.varied = A_VBN_VBD_JJ;
lexicon.varies = A_VBZ;
lexicon.vary = A_VBP_VB;
lexicon.varying = A_VBG_JJ;
lexicon.vastly = A_RB;
lexicon.vast = A_JJ;
lexicon.vegetation = A_NN;
lexicon.vegetative = A_JJ;
lexicon.vegetables = A_NNS;
lexicon.vegetable = A_NN;
lexicon.vehicles = A_NNS;
lexicon.vehicle = A_NN;
lexicon.vendor = A_NN;
lexicon.vendors = A_NNS;
lexicon.venturing = A_VBG;
lexicon.venture = A_NN_VBP_JJ_VB;
lexicon.venturers = A_NNS;
lexicon.ventures = A_NNS_VBZ;
lexicon.ventured = A_VBD_VBN;
lexicon.verbal = A_JJ;
lexicon.verbally = A_RB;
lexicon.verdict = A_NN;
lexicon.verdicts = A_NNS;
lexicon.versions = A_NNS;
lexicon.version = A_NN;
lexicon.versus = A_IN_CC_FW;
lexicon.vertically = A_RB;
lexicon.vertical = A_JJ_NN;
lexicon.very = A_RB_JJ;
lexicon.verie = A_RB;
lexicon.vessels = A_NNS;
lexicon.vessel = A_NN;
lexicon.veterans = A_NNS;
lexicon.veteran = A_NN_JJ;
lexicon.via = A_IN;
lexicon.victimize = A_VBP;
lexicon.victims = A_NNS;
lexicon.victimized = A_VBN_JJ;
lexicon.victimizes = A_VBZ;
lexicon.victim = A_NN;
lexicon.victory = A_NN;
lexicon.victories = A_NNS;
lexicon.victoriously = A_RB;
lexicon.victorious = A_JJ;
lexicon.videos = A_NNS;
lexicon.video = A_NN_JJ;
lexicon.viewings = A_NNS;
lexicon.viewed = A_VBN_VBD;
lexicon.views = A_NNS_VBZ;
lexicon.viewing = A_VBG_NN;
lexicon.view = A_NN_VBP_VB;
lexicon.viewers = A_NNS;
lexicon.viewer = A_NN;
lexicon.villagers = A_NNS;
lexicon.villages = A_NNS;
lexicon.village = A_NN;
lexicon.villager = A_NN;
lexicon.violator = A_NN;
lexicon.violators = A_NNS;
lexicon.violated = A_VBD_VBN;
lexicon.violates = A_VBZ;
lexicon.violation = A_NN;
lexicon.violate = A_VB_VBP_JJ;
lexicon.violations = A_NNS;
lexicon.violating = A_VBG;
lexicon.violence = A_NN;
lexicon.violently = A_RB;
lexicon.violent = A_JJ;
lexicon.virtual = A_JJ;
lexicon.virtually = A_RB_IN_JJ;
lexicon.virtue = A_NN;
lexicon.virtues = A_NNS;
lexicon.virus = A_NN;
lexicon.viruses = A_NNS;
lexicon.visibly = A_RB;
lexicon.visible = A_JJ;
lexicon.visibility = A_NN;
lexicon.visions = A_NNS_VBZ;
lexicon.vision = A_NN;
lexicon.visitations = A_NNS;
lexicon.visits = A_NNS_VBZ;
lexicon.visited = A_VBD_VBN;
lexicon.visit = A_NN_VB_VBP;
lexicon.visiting = A_VBG_JJ;
lexicon.visitation = A_NN;
lexicon.visitor = A_NN;
lexicon.visitors = A_NNS;
lexicon.visually = A_RB;
lexicon.visualize = A_VB;
lexicon.visualization = A_NN;
lexicon.visuals = A_NNS;
lexicon.visualizes = A_VBZ;
lexicon.visualized = A_VBD_VBN;
lexicon.visual = A_JJ;
lexicon.visualizations = A_NNS;
lexicon.vitals = A_NNS;
lexicon.vitality = A_NN;
lexicon.vital = A_JJ;
lexicon.vitally = A_RB;
lexicon.vitamins = A_NNS;
lexicon.vitamin = A_NN;
lexicon.vocals = A_NNS;
lexicon.vocalic = A_JJ;
lexicon.vocally = A_RB;
lexicon.vocalization = A_NN;
lexicon.vocalism = A_NN;
lexicon.vocal = A_JJ_NN;
lexicon.vocalize = A_VB;
lexicon.voices = A_NNS_VBZ;
lexicon.voiced = A_VBD_JJ_VBN;
lexicon.voice = A_NN_VBP_VB;
lexicon.voicing = A_VBG;
lexicon.volumes = A_NNS;
lexicon.volume = A_NN;
lexicon.voluntary = A_JJ;
lexicon.volunteer = A_NN_VB_JJR_VBP;
lexicon.volunteering = A_VBG_NN;
lexicon.volunteers = A_NNS;
lexicon.volunteered = A_VBD_VBN;
lexicon.vote = A_NN_VB_VBP;
lexicon.votes = A_NNS_VBZ;
lexicon.voted = A_VBD_VBN;
lexicon.voting = A_NN_JJ_VBG;
lexicon.voters = A_NNS;
lexicon.voter = A_NN;
lexicon.vulnerable = A_JJ;
lexicon.vulnerability = A_NN;
lexicon.vulnerabilities = A_NNS;
lexicon.wage = A_NN_VB;
lexicon.waging = A_VBG;
lexicon.waged = A_VBN_VBD;
lexicon.wages = A_NNS;
lexicon.wagon = A_NN;
lexicon.wagons = A_NNS;
lexicon.waist = A_NN;
lexicon.waists = A_NNS;
lexicon.waits = A_VBZ;
lexicon.waited = A_VBD_VBN;
lexicon.wait = A_VB_VBP_NN;
lexicon.waiting = A_VBG_NN_JJ;
lexicon.wake = A_NN_VBP_VB;
lexicon.waked = A_VBD_VBN;
lexicon.wakeful = A_JJ;
lexicon.wakes = A_VBZ;
lexicon.waking = A_VBG_JJ;
lexicon.wakefulness = A_NN;
lexicon.walks = A_VBZ_NNS;
lexicon.walk = A_VB_VBP_NN;
lexicon.walking = A_VBG_JJ_NN;
lexicon.walked = A_VBD_VBN;
lexicon.walls = A_NNS;
lexicon.wall = A_NN_VBP_VB;
lexicon.walled = A_JJ_VBN;
lexicon.wandering = A_VBG;
lexicon.wander = A_VB_VBP;
lexicon.wanders = A_VBZ;
lexicon.wanderings = A_NNS;
lexicon.wanderer = A_NN;
lexicon.wandered = A_VBD;
lexicon.wanderers = A_NNS;
lexicon.want = A_VBP_VB_NN;
lexicon.wanted = A_VBD_JJ_VBN;
lexicon.wants = A_VBZ_NNS;
lexicon.wanting = A_VBG;
lexicon.warring = A_VBG;
lexicon.war = A_NN_NNP_VB;
lexicon.warred = A_VBD;
lexicon.wars = A_NNS;
lexicon.warehouses = A_NNS_VBZ;
lexicon.warehouse = A_NN_VB;
lexicon.warming = A_NN_VBG;
lexicon.warmly = A_RB;
lexicon.warms = A_VBZ;
lexicon.warm = A_JJ_VB;
lexicon.warmed = A_VBD_VBN;
lexicon.warmth = A_NN;
lexicon.warnings = A_NNS;
lexicon.warns = A_VBZ;
lexicon.warn = A_VB_VBP;
lexicon.warning = A_NN_VBG;
lexicon.warningly = A_RB;
lexicon.warned = A_VBD_VBN;
lexicon.warriors = A_NNS;
lexicon.warrior = A_NN;
lexicon.was = A_VBD;
lexicon.washings = A_NNS;
lexicon.washing = A_VBG_NN;
lexicon.wash = A_NN_VBP_JJ_VB;
lexicon.washed = A_VBN_VBD_JJ;
lexicon.washes = A_NNS_VBZ;
lexicon.wastes = A_NNS_VBZ;
lexicon.wasted = A_VBN_VBD_JJ;
lexicon.wasting = A_VBG_JJ_NN;
lexicon.wasteful = A_JJ;
lexicon.waste = A_NN_VBP_JJ_VB;
lexicon.watches = A_NNS_VBZ;
lexicon.watched = A_VBD_VBN_JJ;
lexicon.watchings = A_NNS;
lexicon.watch = A_VB_JJ_NN_VBP;
lexicon.watching = A_VBG_NN;
lexicon.watchful = A_JJ;
lexicon.watered = A_VBN_VBD;
lexicon.water = A_NN_VB_JJ;
lexicon.waters = A_NNS;
lexicon.watering = A_VBG_NN;
lexicon.waving = A_VBG_NN;
lexicon.waves = A_NNS;
lexicon.waved = A_VBD_VBN;
lexicon.wave = A_NN_VB_VBP;
lexicon.ways = A_NNS;
lexicon.way = A_NN_RB;
lexicon.we = A_PRP_VBP;
lexicon.weak = A_JJ;
lexicon.weaknesses = A_NNS;
lexicon.weakly = A_RB;
lexicon.weakness = A_NN;
lexicon.weakened = A_VBN_JJ_VBD;
lexicon.weaken = A_VB_VBP;
lexicon.weakening = A_VBG_JJ_NN;
lexicon.weakens = A_VBZ;
lexicon.wealth = A_NN;
lexicon.wealthy = A_JJ_NNS;
lexicon.weapon = A_NN;
lexicon.weapons = A_NNS;
lexicon.wear = A_VB_JJ_NN_VBP;
lexicon.wears = A_VBZ;
lexicon.wearing = A_VBG;
lexicon.weather = A_NN_VB_VBP;
lexicon.weathering = A_NN_VBG;
lexicon.weaves = A_NNS_VBZ;
lexicon.weaving = A_VBG_NN;
lexicon.weave = A_VB_NN;
lexicon.webs = A_NNS;
lexicon.web = A_NN_JJ;
lexicon.wed = A_VBN_VB;
lexicon.weddings = A_NNS;
lexicon.wedding = A_NN;
lexicon.wedded = A_VBN_JJ;
lexicon.weds = A_VBZ;
lexicon.weeded = A_VBN;
lexicon.weeding = A_VBG;
lexicon.weeds = A_NNS;
lexicon.weed = A_NN_VB;
lexicon.week = A_NN;
lexicon.weekly = A_JJ_NN_RB;
lexicon.weeklies = A_NNS;
lexicon.weeks = A_NNS;
lexicon.weeked = A_NN;
lexicon.weekends = A_NNS;
lexicon.weekend = A_NN;
lexicon.weighed = A_VBD_VBN;
lexicon.weigh = A_VB_VBP;
lexicon.weighing = A_VBG_NN;
lexicon.weighs = A_VBZ;
lexicon.weightings = A_NNS;
lexicon.weighted = A_JJ_VBD_VBN;
lexicon.weights = A_NNS_VBZ;
lexicon.weighting = A_NN;
lexicon.weight = A_NN_VB;
lexicon.weirdly = A_RB;
lexicon.weird = A_JJ_NN;
lexicon.welcomes = A_VBZ;
lexicon.welcome = A_JJ_NN_VB_VBP;
lexicon.welcomed = A_VBD_VBN;
lexicon.welcoming = A_VBG_NN_JJ;
lexicon.welfare = A_NN;
lexicon.wells = A_NNS;
lexicon.well = A_RB_VBP_JJ_NN_VB_UH;
lexicon.wellness = A_NN;
lexicon.welling = A_VBG;
lexicon.welled = A_VBD;
lexicon.west = A_NN_JJ_RB_JJS;
lexicon.western = A_JJ;
lexicon.wetting = A_VBG_NN;
lexicon.wetness = A_NN;
lexicon.wet = A_JJ_NN_VBD_VB_VBP;
lexicon.wetly = A_RB;
lexicon.wets = A_NNS;
lexicon.whales = A_NNS;
lexicon.whaling = A_NN;
lexicon.whale = A_NN;
lexicon.what = A_WP_WDT;
lexicon.whatever = A_WDT_RB_WP;
lexicon.wheat = A_NN_JJ;
lexicon.wheeling = A_NN_VBG;
lexicon.wheel = A_NN_VBP;
lexicon.wheeled = A_VBD_JJ_VBN;
lexicon.wheels = A_NNS;
lexicon.wheelchair = A_NN;
lexicon.when = A_WRB_IN;
lexicon.whenever = A_WRB;
lexicon.where = A_WRB;
lexicon.whereas = A_IN;
lexicon.wherever = A_WRB;
lexicon.whether = A_IN_CC;
lexicon.which = A_WDT_WP;
lexicon.while = A_IN_JJ_NN_RB_VB;
lexicon.whipping = A_VBG_JJ_NN;
lexicon.whips = A_NNS_VBZ;
lexicon.whip = A_NN_VB;
lexicon.whipped = A_VBD_VBN_JJ;
lexicon.whippings = A_NNS;
lexicon.whispers = A_NNS_VBZ;
lexicon.whispering = A_VBG_NN;
lexicon.whisper = A_NN_VB;
lexicon.whisperings = A_NNS;
lexicon.whispered = A_VBD_VBN_JJ;
lexicon.whiteness = A_NN;
lexicon.whitely = A_RB;
lexicon.whites = A_NNS;
lexicon.white = A_JJ_NN;
lexicon.who = A_WP_NN;
lexicon.whoever = A_WP;
lexicon.wholes = A_NNS;
lexicon.wholeness = A_NN;
lexicon.whole = A_JJ_NN_RP;
lexicon.whom = A_WP;
lexicon.whose = A_WP$;
lexicon.why = A_WRB;
lexicon.widely = A_RB;
lexicon.wide = A_JJ_RB;
lexicon.widespread = A_JJ;
lexicon.widow = A_NN;
lexicon.widower = A_NN;
lexicon.widowers = A_NNS;
lexicon.widowed = A_VBN_JJ;
lexicon.widows = A_NNS;
lexicon.wifely = A_JJ;
lexicon.wife = A_NN;
lexicon.wildly = A_RB;
lexicon.wildness = A_NN;
lexicon.wild = A_JJ_RB;
lexicon.wilderness = A_NN;
lexicon.wildlife = A_NN;
lexicon.willing = A_JJ_VBG;
lexicon.willingly = A_RB;
lexicon.willful = A_JJ;
lexicon.wills = A_NNS;
lexicon.willfully = A_RB;
lexicon.will = A_MD_VBP_NN_RB_VB;
lexicon.willed = A_VBD_VBN;
lexicon.willinge = A_JJ;
lexicon.willingness = A_NN;
lexicon.winnings = A_NNS;
lexicon.wins = A_VBZ_NNS;
lexicon.win = A_VB_NN_VBP;
lexicon.winning = A_VBG_JJ_NN;
lexicon.wind = A_NN_VBP_VB;
lexicon.winds = A_NNS_VBZ;
lexicon.winded = A_JJ_VBN;
lexicon.winding = A_VBG_JJ_NN;
lexicon.windows = A_NNS;
lexicon.window = A_NN;
lexicon.wine = A_NN_JJ;
lexicon.wines = A_NNS;
lexicon.wined = A_VBD;
lexicon.wing = A_NN_VBP;
lexicon.winging = A_VBG;
lexicon.winged = A_VBD_VBN_JJ;
lexicon.wings = A_NNS;
lexicon.winners = A_NNS;
lexicon.winner = A_NN;
lexicon.wintered = A_VBN;
lexicon.winters = A_NNS;
lexicon.wintering = A_VBG;
lexicon.winter = A_NN;
lexicon.wiping = A_VBG;
lexicon.wipe = A_VB_VBP;
lexicon.wiped = A_VBD_VBN;
lexicon.wipes = A_VBZ;
lexicon.wiring = A_NN_VBG;
lexicon.wires = A_NNS;
lexicon.wired = A_VBN_VBD;
lexicon.wire = A_NN_VB;
lexicon.wisdom = A_NN;
lexicon.wisely = A_RB;
lexicon.wise = A_JJ;
lexicon.wishing = A_VBG_NN;
lexicon.wishful = A_JJ;
lexicon.wish = A_VBP_NN_VB;
lexicon.wished = A_VBD_VBN;
lexicon.wishes = A_VBZ_NNS;
lexicon.with = A_IN_JJ_RB_RP;
lexicon.withes = A_NNS;
lexicon.withing = A_IN;
lexicon.withdraw = A_VB_VBP;
lexicon.withdrawal = A_NN;
lexicon.withdrawing = A_VBG_NN;
lexicon.withdrawals = A_NNS;
lexicon.withdraws = A_VBZ;
lexicon.within = A_IN_RB;
lexicon.without = A_IN;
lexicon.witness = A_NN_VB;
lexicon.witnessed = A_VBN_VBD;
lexicon.witnesses = A_NNS;
lexicon.wit = A_NN;
lexicon.wits = A_NNS;
lexicon.wittingly = A_RB;
lexicon.witnessing = A_VBG;
lexicon.wolf = A_NN;
lexicon.womanizing = A_VBG;
lexicon.woman = A_NN_VB;
lexicon.womanly = A_JJ;
lexicon.wonderful = A_JJ;
lexicon.wondered = A_VBD_VBN;
lexicon.wonderingly = A_RB;
lexicon.wonder = A_NN_VBP_JJ_VB_JJR;
lexicon.wonderfully = A_RB;
lexicon.wonders = A_NNS_VBZ;
lexicon.wondering = A_VBG_NN;
lexicon.wonderfulness = A_NN;
lexicon.wonderment = A_NN;
lexicon.wooded = A_JJ;
lexicon.woods = A_NNS;
lexicon.wood = A_NN;
lexicon.wooden = A_JJ;
lexicon.wording = A_NN;
lexicon.word = A_NN;
lexicon.worded = A_VBN_JJ_VBD;
lexicon.words = A_NNS;
lexicon.worked = A_VBD_VBN;
lexicon.works = A_NNS_VBZ;
lexicon.work = A_NN_VB_VBP;
lexicon.workings = A_NNS;
lexicon.working = A_VBG_JJ_NN;
lexicon.worker = A_NN;
lexicon.workers = A_NNS;
lexicon.workouts = A_NNS;
lexicon.workout = A_NN;
lexicon.workplace = A_NN_JJ;
lexicon.workplaces = A_NNS;
lexicon.workshops = A_NNS;
lexicon.workshop = A_NN;
lexicon.worlds = A_NNS;
lexicon.worldly = A_JJ;
lexicon.world = A_NN_RB;
lexicon.worldwide = A_JJ_RB;
lexicon.worriedly = A_RB;
lexicon.worrying = A_VBG_JJ;
lexicon.worried = A_VBN_VBD_JJ;
lexicon.worries = A_NNS_VBZ;
lexicon.worry = A_VB_NN_VBP;
lexicon.worth = A_JJ_IN_NN_RB_VBN_VBP;
lexicon.would = A_MD;
lexicon.wo = A_MD;
lexicon.wound = A_NN_VBD_VBN_VB;
lexicon.wounded = A_VBN_JJ;
lexicon.wounding = A_VBG;
lexicon.wounds = A_NNS;
lexicon.wowed = A_VBD;
lexicon.wows = A_VBZ;
lexicon.wraps = A_VBZ_NNS;
lexicon.wrapped = A_VBN_VBD;
lexicon.wrapping = A_VBG_NN;
lexicon.wrap = A_VB_NN_VBP;
lexicon.wrists = A_NNS;
lexicon.wrist = A_NN;
lexicon.write = A_VB_VBP;
lexicon.writes = A_VBZ;
lexicon.writings = A_NNS;
lexicon.writing = A_VBG_NN;
lexicon.writer = A_NN;
lexicon.writers = A_NNS;
lexicon.written = A_VBN_JJ;
lexicon.wrongful = A_JJ;
lexicon.wrongly = A_RB;
lexicon.wronged = A_VBN_JJ;
lexicon.wrongs = A_NNS;
lexicon.wrongness = A_NN;
lexicon.wrong = A_JJ_NN_RB;
lexicon.wrongfully = A_RB;
lexicon.yard = A_NN;
lexicon.yards = A_NNS;
lexicon.yeah = A_UH_NN;
lexicon.year = A_NN_JJ;
lexicon.yearly = A_JJ_RB;
lexicon.years = A_NNS;
lexicon.yelling = A_VBG_NN;
lexicon.yelled = A_VBD_VBN;
lexicon.yells = A_VBZ;
lexicon.yell = A_NN_VB;
lexicon.yellowing = A_VBG;
lexicon.yellowed = A_VBN;
lexicon.yellows = A_NNS;
lexicon.yellow = A_JJ_NN_VB;
lexicon.yes = A_UH_RB;
lexicon.yesterday = A_NN_RB;
lexicon.yet = A_RB_CC;
lexicon.yield = A_VB_VBP_JJ_NN;
lexicon.yielding = A_VBG_JJ_NN;
lexicon.yields = A_NNS_VBZ;
lexicon.yielded = A_VBD_VBN;
lexicon.you = A_PRP_VBP_RP;
lexicon.young = A_JJ_NN_NNS;
lexicon.youngsters = A_NNS;
lexicon.youngster = A_NN;
lexicon.yours = A_PRP_JJ;
lexicon.your = A_PRP$;
lexicon.yourself = A_PRP;
lexicon.youthful = A_JJ;
lexicon.youth = A_NN;
lexicon.youths = A_NNS;
lexicon.zone = A_NN;
lexicon.zoning = A_NN_VBG;
lexicon.zoned = A_VBN;
lexicon.zones = A_NNS;
lexicon.zero = A_CD;
lexicon.one = A_CD;
lexicon.two = A_CD;
lexicon.three = A_CD;
lexicon.four = A_CD;
lexicon.five = A_CD;
lexicon.six = A_CD;
lexicon.seven = A_CD;
lexicon.eight = A_CD;
lexicon.nine = A_CD;
lexicon.ten = A_CD;
lexicon.accrued = A_VBN_JJ;
lexicon.acres = A_NNS;
lexicon.adverse = A_JJ;
lexicon.advisory = A_JJ_NN;
lexicon.aerospace = A_NN_JJ;
lexicon.affidavit = A_NN;
lexicon.affiliate = A_NN_VB;
lexicon.affiliates = A_NNS_VBZ;
lexicon.affluent = A_JJ_NN;
lexicon.aftermath = A_NN;
lexicon.aftershocks = A_NNS;
lexicon.ailing = A_VBG_JJ;
lexicon.antitrust = A_JJ_NN;
lexicon.anytime = A_RB;
lexicon.apartheid = A_NN;
lexicon.apiece = A_RB_JJ;
lexicon.apparel = A_NN_VB;
lexicon.appellate = A_JJ_NN;
lexicon.appetite = A_NN;
lexicon.appliances = A_NNS;
lexicon.arbitrage = A_NN;
lexicon.arbitragers = A_NNS;
lexicon.asbestos = A_NN;
lexicon.assassination = A_NN;
lexicon.audit = A_NN_VB;
lexicon.automotive = A_JJ;
lexicon.autumn = A_NN;
lexicon.aviation = A_NN;
lexicon.backers = A_NNS;
lexicon.backlog = A_NN;
lexicon.bailout = A_NN;
lexicon.bargain = A_NN_VB;
lexicon.bargaining = A_NN_JJ_VBG;
lexicon.bargains = A_NNS_VBZ;
lexicon.barometer = A_NN;
lexicon.battered = A_VBN_VBD_JJ;
lexicon.bearish = A_JJ;
lexicon.became = A_VBD;
lexicon.been = A_VBN_VBP;
lexicon.began = A_VBD;
lexicon.begun = A_VBN;
lexicon.bellwether = A_NN_JJ;
lexicon.benchmark = A_NN_JJ;
lexicon.beneficial = A_JJ;
lexicon.beneficiaries = A_NNS;
lexicon.bidder = A_NN;
lexicon.bidders = A_NNS;
lexicon.bigger = A_JJR_RBR;
lexicon.biggest = A_JJS_RBS;
lexicon.billion = A_CD;
lexicon.biotechnology = A_NN;
lexicon.bloc = A_NN;
lexicon.bolster = A_VB_VBP_NN;
lexicon.bondholders = A_NNS;
lexicon.boomers = A_NNS;
lexicon.borough = A_NN;
lexicon.both = A_DT;
lexicon.bought = A_VBD_VBN;
lexicon.bound = A_VBN_JJ_NN_VBD;
lexicon.bourbon = A_NN;
lexicon.breach = A_NN_VB;
lexicon.breakdown = A_NN;
lexicon.breakers = A_NNS;
lexicon.brewing = A_NN_VBG;
lexicon.broader = A_JJR;
lexicon.broke = A_VBD_VBN_JJ_RB_VB;
lexicon.brokerage = A_NN;
lexicon.brought = A_VBN_VBD;
lexicon.built = A_VBN_JJ_VBD;
lexicon.bullish = A_JJ;
lexicon.buoyed = A_VBN_VBD;
lexicon.bureaucracy = A_NN;
lexicon.bureaucratic = A_JJ;
lexicon.bureaucrats = A_NNS;
lexicon.bushel = A_NN;
lexicon.businessmen = A_NNS;
lexicon.came = A_VBD;
lexicon.catastrophe = A_NN;
lexicon.catastrophic = A_JJ;
lexicon.caught = A_VBN_VBD;
lexicon.caution = A_NN_VBP_VB;
lexicon.cautioned = A_VBD_VBN;
lexicon.cautious = A_JJ;
lexicon.cellular = A_JJ;
lexicon.cement = A_NN_VB;
lexicon.cent = A_NN_FW;
lexicon.centennial = A_NN_JJ;
lexicon.cents = A_NNS;
lexicon.certificate = A_NN;
lexicon.certificates = A_NNS;
lexicon.cheaper = A_JJR_RBR;
lexicon.children = A_NNS;
lexicon.chose = A_VBD;
lexicon.chosen = A_VBN_JJ;
lexicon.circulation = A_NN;
lexicon.clause = A_NN;
lexicon.cleaner = A_JJR_NN;
lexicon.cleanup = A_NN;
lexicon.clearance = A_NN;
lexicon.clout = A_NN;
lexicon.cocoa = A_NN;
lexicon.collateral = A_NN_JJ;
lexicon.comeback = A_NN;
lexicon.comic = A_JJ_NN;
lexicon.communist = A_JJ_NN;
lexicon.compiled = A_VBN_VBD;
lexicon.comptroller = A_NN;
lexicon.computerized = A_JJ_NN_VB_VBN;
lexicon.concessions = A_NNS;
lexicon.conferees = A_NNS;
lexicon.conglomerate = A_NN_JJ;
lexicon.congressman = A_NN;
lexicon.consolidated = A_JJ_VBD_VBN;
lexicon.consolidation = A_NN;
lexicon.consortium = A_NN;
lexicon.contrary = A_JJ_NN;
lexicon.copper = A_NN;
lexicon.copyright = A_NN_JJ;
lexicon.cosmetics = A_NNS;
lexicon.coupon = A_NN;
lexicon.covert = A_JJ;
lexicon.credentials = A_NNS;
lexicon.creditor = A_NN;
lexicon.creditors = A_NNS;
lexicon.crude = A_NN_JJ;
lexicon.crunch = A_NN_VB;
lexicon.cubic = A_JJ;
lexicon.cumulative = A_JJ;
lexicon.curb = A_VB_NN;
lexicon.curtail = A_VB_VBP;
lexicon.cutbacks = A_NNS;
lexicon.cyclical = A_JJ;
lexicon.debacle = A_NN;
lexicon.debentures = A_NNS;
lexicon.deductions = A_NNS;
lexicon.deeper = A_JJR_RBR_RB;
lexicon.default = A_NN_VB;
lexicon.defaults = A_NNS_VBZ;
lexicon.delegation = A_NN;
lexicon.depositary = A_NN_JJ;
lexicon.depository = A_NN_JJ;
lexicon.depreciation = A_NN;
lexicon.deregulation = A_NN;
lexicon.desktop = A_NN_JJ;
lexicon.detectors = A_NNS;
lexicon.detergent = A_NN;
lexicon.deteriorating = A_VBG_JJ;
lexicon.deterioration = A_NN;
lexicon.did = A_VBD;
lexicon.diluted = A_VBN_JJ_VBD;
lexicon.disarray = A_NN;
lexicon.disclosure = A_NN;
lexicon.discontinued = A_VBN_JJ_VBD;
lexicon.discrepancies = A_NNS;
lexicon.dismal = A_JJ;
lexicon.disobedience = A_NN;
lexicon.disposable = A_JJ_NN;
lexicon.disposal = A_NN;
lexicon.dissident = A_JJ_NN;
lexicon.distributor = A_NN;
lexicon.distributors = A_NNS;
lexicon.diversified = A_JJ_VBD_VBN;
lexicon.dividend = A_NN;
lexicon.dividends = A_NNS;
lexicon.dollar = A_NN;
lexicon.dollars = A_NNS;
lexicon.done = A_VBN_JJ_RB_VBD;
lexicon.downgraded = A_VBD_VBN;
lexicon.downturn = A_NN;
lexicon.downward = A_JJ_RB;
lexicon.dozen = A_NN;
lexicon.drawn = A_VBN_JJ;
lexicon.drew = A_VBD;
lexicon.driven = A_VBN_JJ;
lexicon.drought = A_NN;
lexicon.drove = A_VBD_NN;
lexicon.dual = A_JJ;
lexicon.dubbed = A_VBN_VBD;
lexicon.durable = A_JJ;
lexicon.earlier = A_RBR_JJR_JJ_NN_RB;
lexicon.easier = A_JJR_RBR_RB;
lexicon.editorial = A_NN_JJ;
lexicon.environmentalists = A_NNS;
lexicon.exempt = A_JJ_VB;
lexicon.expenditures = A_NNS_VBZ;
lexicon.expiration = A_NN;
lexicon.expire = A_VB_VBP;
lexicon.expired = A_VBD_VBN_JJ;
lexicon.expires = A_VBZ;
lexicon.fallen = A_VBN_JJ;
lexicon.fancy = A_JJ_NN_VB;
lexicon.feet = A_NNS_NN;
lexicon.fell = A_VBD_JJ_NN_VBN;
lexicon.felt = A_VBD_VBN;
lexicon.fend = A_VB;
lexicon.first = A_JJ;
lexicon.flagship = A_NN_JJ;
lexicon.fled = A_VBD_VBN;
lexicon.fluctuations = A_NNS;
lexicon.forecast = A_NN_VBD_VBN_VBP_VB;
lexicon.forecasting = A_NN_JJ_VBG;
lexicon.forecasts = A_NNS_VBZ;
lexicon.fought = A_VBD_VBN;
lexicon.franchisees = A_NNS;
lexicon.francs = A_NNS;
lexicon.fraudulent = A_JJ;
lexicon.freeway = A_NN;
lexicon.freight = A_NN_VB;
lexicon.furor = A_NN;
lexicon.further = A_JJ_JJR_RBR_RB_VB;
lexicon.fusion = A_NN;
lexicon.gambling = A_NN_VBG;
lexicon.gave = A_VBD;
lexicon.glasnost = A_FW_NN;
lexicon.goes = A_VBZ;
lexicon.gone = A_VBN_JJ;
lexicon.got = A_VBD_VBN_VBP_VB;
lexicon.gotten = A_VBN;
lexicon.graphics = A_NNS_NN;
lexicon.greater = A_JJR_RBR;
lexicon.grew = A_VBD_VBN;
lexicon.grim = A_JJ;
lexicon.growers = A_NNS;
lexicon.grown = A_VBN_VBD_JJ;
lexicon.guerrillas = A_NNS;
lexicon.guilders = A_NNS;
lexicon.gyrations = A_NNS;
lexicon.had = A_VBD_VBN;
lexicon.half = A_NN;
lexicon.halt = A_NN_JJ_VB_VBP;
lexicon.halted = A_VBN_NN_VBD;
lexicon.hampered = A_VBN_VBD;
lexicon.harder = A_JJR_RBR_JJ_RB;
lexicon.heard = A_VBN_VBD;
lexicon.hedge = A_VB_JJ_NN_VBP;
lexicon.hefty = A_JJ;
lexicon.held = A_VBN_VBD_JJ;
lexicon.higher = A_JJR_RB_RBR;
lexicon.highest = A_JJS_RB_RBS;
lexicon.holder = A_NN;
lexicon.holders = A_NNS;
lexicon.homeowners = A_NNS;
lexicon.hottest = A_JJS;
lexicon.hundred = A_CD;
lexicon.hundreds = A_NNS;
lexicon.hybrid = A_JJ_NN;
lexicon.idle = A_JJ_VB;
lexicon.imminent = A_JJ;
lexicon.impeachment = A_NN;
lexicon.impending = A_JJ_VBG;
lexicon.improper = A_JJ;
lexicon.inability = A_NN;
lexicon.inadequate = A_JJ;
lexicon.incest = A_NN;
lexicon.inches = A_NNS_NN_VBZ;
lexicon.inclined = A_VBN_JJ;
lexicon.incurred = A_VBN_VBD;
lexicon.indicted = A_VBN_VBD;
lexicon.indictment = A_NN;
lexicon.induce = A_VB;
lexicon.industrywide = A_JJ_RB;
lexicon.injunction = A_NN;
lexicon.insolvent = A_JJ_NN;
lexicon.insulin = A_NN;
lexicon.interbank = A_NN_JJ_RB;
lexicon.interim = A_JJ_NN;
lexicon.interstate = A_JJ_NN;
lexicon.issuers = A_NNS;
lexicon.junk = A_NN_VB;
lexicon.kept = A_VBD_VBN;
lexicon.knew = A_VBD;
lexicon.knight = A_NN;
lexicon.la = A_FW_NNP_DT_NN;
lexicon.lackluster = A_JJ_NN_RB;
lexicon.lagged = A_VBN_VBD;
lexicon.lagging = A_VBG_JJ_NN;
lexicon.laid = A_VBN_VBD;
lexicon.laptop = A_NN_JJ;
lexicon.larger = A_JJR_RBR;
lexicon.largest = A_JJS_RBS;
lexicon.lease = A_NN_VBP_VB;
lexicon.leases = A_NNS_VBZ;
lexicon.leasing = A_NN_VBG;
lexicon.led = A_VBN_VBD_VB;
lexicon.lenders = A_NNS;
lexicon.leverage = A_NN_VB;
lexicon.leveraged = A_JJ_VBN_NN;
lexicon.liable = A_JJ;
lexicon.liquor = A_NN;
lexicon.lire = A_NNS_FW_NN;
lexicon.litigation = A_NN;
lexicon.lobbyist = A_NN;
lexicon.lobbyists = A_NNS;
lexicon.longer = A_RB_JJR_RBR;
lexicon.longstanding = A_JJ;
lexicon.losers = A_NNS;
lexicon.lowest = A_JJS_JJ;
lexicon.lucrative = A_JJ;
lexicon.lure = A_VB_NN;
lexicon.luxury = A_NN_JJ;
lexicon.machinery = A_NN;
lexicon.machinists = A_NNS;
lexicon.made = A_VBN_VBD_JJ;
lexicon.mainframe = A_NN_JJ;
lexicon.mainframes = A_NNS;
lexicon.mandatory = A_JJ_NN;
lexicon.mart = A_NNP_NN;
lexicon.massacre = A_NN_VB;
lexicon.massage = A_NN_VB;
lexicon.mature = A_JJ_VB_NNP_VBP;
lexicon.maturing = A_VBG;
lexicon.maturities = A_NNS;
lexicon.maturity = A_NN;
lexicon.meant = A_VBD_VBN;
lexicon.mediator = A_NN;
lexicon.men = A_NNS;
lexicon.merchandise = A_NN;
lexicon.merge = A_VB_NN_VBP;
lexicon.merged = A_VBN_JJ_VBD;
lexicon.merger = A_NN;
lexicon.mergers = A_NNS;
lexicon.met = A_VBD_VBN;
lexicon.metric = A_JJ_NN;
lexicon.microprocessor = A_NN;
lexicon.middlemen = A_NNS;
lexicon.miles = A_NNS;
lexicon.milestones = A_NNS;
lexicon.million = A_CD;
lexicon.millions = A_NNS;
lexicon.misleading = A_JJ_VBG;
lexicon.monetary = A_JJ;
lexicon.narrowly = A_RB;
lexicon.newsletter = A_NN;
lexicon.newsprint = A_NN;
lexicon.niche = A_NN;
lexicon.noncallable = A_JJ;
lexicon.nonperforming = A_JJ_VBG_NN;
lexicon.notably = A_RB;
lexicon.notified = A_VBN_VBD;
lexicon.offset = A_VB_JJ_VBD_VBN_VBP;
lexicon.offsetting = A_VBG_JJ;
lexicon.offshore = A_JJ_RB;
lexicon.older = A_JJR_RBR_JJ;
lexicon.omitted = A_VBN_VBD;
lexicon.optical = A_JJ;
lexicon.optimism = A_NN;
lexicon.ounce = A_NN;
lexicon.ounces = A_NNS_NN;
lexicon.oust = A_VB;
lexicon.ousted = A_VBN_VBD_JJ;
lexicon.outlays = A_NNS;
lexicon.outlook = A_NN;
lexicon.overhaul = A_NN_VB;
lexicon.overhead = A_JJ_NN_RB;
lexicon.overseas = A_JJ_NN_RB;
lexicon.oversight = A_NN;
lexicon.overtime = A_NN_JJ_RB;
lexicon.ozone = A_NN;
lexicon.pachinko = A_NN;
lexicon.pact = A_NN;
lexicon.paid = A_VBN_VBD_JJ;
lexicon.par = A_NN_FW_IN_JJ;
lexicon.parliamentary = A_JJ;
lexicon.passive = A_JJ_NN;
lexicon.payable = A_JJ;
lexicon.payroll = A_NN;
lexicon.pence = A_NN_NNS;
lexicon.pending = A_VBG_JJ;
lexicon.percent = A_NN;
lexicon.perestroika = A_FW_NN;
lexicon.pessimistic = A_JJ;
lexicon.pesticides = A_NNS;
lexicon.petrochemical = A_NN_JJ;
lexicon.petroleum = A_NN;
lexicon.pharmaceutical = A_JJ_NN;
lexicon.pharmaceuticals = A_NNS;
lexicon.pipeline = A_NN;
lexicon.platinum = A_NN;
lexicon.pledged = A_VBD_VBN;
lexicon.plummeted = A_VBD_VBN;
lexicon.poison = A_NN_JJ_VB;
lexicon.polyethylene = A_NN;
lexicon.portable = A_JJ_NN;
lexicon.postpone = A_VB_VBP;
lexicon.postponed = A_VBN_JJ_VBD;
lexicon.premier = A_NN_JJ_JJR;
lexicon.pretax = A_JJ_NN;
lexicon.probe = A_NN_VBP_VB;
lexicon.prolonged = A_VBN_VBD_JJ;
lexicon.proponents = A_NNS;
lexicon.prospectus = A_NN;
lexicon.provisional = A_JJ;
lexicon.proxy = A_NN_JJ;
lexicon.prudent = A_JJ;
lexicon.psyllium = A_NN;
lexicon.pulp = A_NN_VB;
lexicon.quake = A_NN;
lexicon.quota = A_NN;
lexicon.quotas = A_NNS;
lexicon.quotations = A_NNS;
lexicon.racketeering = A_NN_VBG;
lexicon.raider = A_NN;
lexicon.ran = A_VBD;
lexicon.rebates = A_NNS;
lexicon.rebound = A_NN_VBP_VB;
lexicon.rebounded = A_VBD_VBN_VBP_NN_VB;
lexicon.recapitalization = A_NN;
lexicon.receipts = A_NNS;
lexicon.reckless = A_JJ;
lexicon.redeem = A_VB_VBP;
lexicon.redeemed = A_VBN_VBD;
lexicon.redemption = A_NN;
lexicon.redemptions = A_NNS;
lexicon.refinancing = A_NN_VBG;
lexicon.refinery = A_NN;
lexicon.refining = A_NN_VBG;
lexicon.refund = A_NN_VB;
lexicon.refunding = A_VBG_JJ_NN;
lexicon.registration = A_NN;
lexicon.reinsurance = A_NN;
lexicon.remainder = A_NN;
lexicon.renewed = A_VBN_VBD_JJ;
lexicon.renewing = A_VBG;
lexicon.reopen = A_VB_VBP;
lexicon.reopened = A_VBD_VBN_VB;
lexicon.reorganization = A_NN;
lexicon.repaid = A_VBN_VBD;
lexicon.repay = A_VB_VBP;
lexicon.repayment = A_NN;
lexicon.repeal = A_NN_VB;
lexicon.repurchase = A_NN_VBD_VBN_JJ_VB;
lexicon.reset = A_NN_VBN_JJ_VB;
lexicon.restated = A_VBN_VBD_JJ;
lexicon.restraint = A_NN;
lexicon.restructure = A_VB_VBP_NN;
lexicon.restructured = A_VBN_VBD_JJ;
lexicon.restructuring = A_NN_VBG_JJ;
lexicon.revamped = A_VBN_VBD_JJ;
lexicon.revised = A_VBN_VBD_JJ;
lexicon.revive = A_VB_VBP;
lexicon.revived = A_VBN_VBD;
lexicon.ringers = A_NNS;
lexicon.risen = A_VBN;
lexicon.robust = A_JJ;
lexicon.rubles = A_NNS;
lexicon.said = A_VBD_VBN_JJ_VB;
lexicon.salesman = A_NN;
lexicon.salesmen = A_NNS;
lexicon.salespeople = A_NN_NNS;
lexicon.sanctions = A_NNS_VBZ;
lexicon.sank = A_VBD;
lexicon.sat = A_VBD_VBN;
lexicon.saw = A_VBD_NN;
lexicon.scrutiny = A_NN;
lexicon.second = A_JJ;
lexicon.sedan = A_NN;
lexicon.seen = A_VBN_VBD_JJ;
lexicon.semiconductor = A_NN;
lexicon.sent = A_VBD_VBN;
lexicon.setback = A_NN;
lexicon.shipments = A_NNS;
lexicon.shipyard = A_NN;
lexicon.shook = A_VBD_NN_VBN;
lexicon.shown = A_VBN_VBD;
lexicon.shutdown = A_NN;
lexicon.sidelines = A_NNS;
lexicon.sizable = A_JJ;
lexicon.skeptical = A_JJ;
lexicon.slash = A_VB_NN_VBP;
lexicon.slashed = A_VBD_VBN;
lexicon.slate = A_NN_JJ;
lexicon.slated = A_VBN_VBD;
lexicon.slid = A_VBD_NNP_VBN;
lexicon.slowdown = A_NN;
lexicon.slower = A_JJR_RBR;
lexicon.sluggish = A_JJ;
lexicon.slump = A_NN_VBP_VB;
lexicon.slumped = A_VBD_VBN;
lexicon.smaller = A_JJR_RBR;
lexicon.sold = A_VBN_VBD;
lexicon.solicitation = A_NN;
lexicon.sooner = A_RBR_RB;
lexicon.sought = A_VBD_VBN;
lexicon.sour = A_JJ_VBP_NN_RB_VB;
lexicon.soybean = A_NN;
lexicon.spent = A_VBD_JJ_VBN;
lexicon.spinoff = A_NN_JJ;
lexicon.spoke = A_VBD_NN;
lexicon.spokeswoman = A_NN;
lexicon.spur = A_VB_NN_VBP;
lexicon.spurred = A_VBN_VBD;
lexicon.staffers = A_NNS;
lexicon.stalled = A_VBN_JJ_VBD;
lexicon.standstill = A_JJ_NN;
lexicon.steelmaker = A_NN;
lexicon.steelmakers = A_NNS;
lexicon.sterling = A_NN_JJ;
lexicon.stockholders = A_NNS;
lexicon.stole = A_VBD;
lexicon.stolen = A_VBN_JJ;
lexicon.stood = A_VBD_VBN;
lexicon.strategist = A_NN;
lexicon.streamlining = A_VBG_NN;
lexicon.stronger = A_JJR_RBR;
lexicon.strongest = A_JJS;
lexicon.struck = A_VBD_VBN;
lexicon.stuck = A_VBN_VBD_JJ;
lexicon.subcommittee = A_NN;
lexicon.subordinated = A_VBN_JJ_VBD;
lexicon.subscribers = A_NNS;
lexicon.subsidiaries = A_NNS;
lexicon.subsidiary = A_NN_JJ;
lexicon.subsidized = A_JJ_VBN;
lexicon.substitute = A_NN_JJ_VB_VBP;
lexicon.successor = A_NN;
lexicon.sued = A_VBD_VBN;
lexicon.suitor = A_NN;
lexicon.supercomputer = A_NN;
lexicon.surge = A_NN_VB;
lexicon.surged = A_VBD_VBN;
lexicon.surplus = A_NN_JJ;
lexicon.suspension = A_NN;
lexicon.swap = A_NN_VBP_VB;
lexicon.sweetened = A_VBN_VBD_JJ;
lexicon.syndicate = A_NN_VB;
lexicon.taken = A_VBN_VBG;
lexicon.takeover = A_NN;
lexicon.takeovers = A_NNS;
lexicon.taught = A_VBN_VBD;
lexicon.taxable = A_JJ;
lexicon.telecommunications = A_NNS_JJ_NN;
lexicon.temblor = A_NN;
lexicon.temporarily = A_RB;
lexicon.tentative = A_JJ_NN;
lexicon.tentatively = A_RB;
lexicon.tenure = A_NN;
lexicon.terminal = A_NN_JJ;
lexicon.terminated = A_VBN_VBD;
lexicon.textile = A_NN_JJ;
lexicon.theft = A_NN;
lexicon.thereafter = A_RB;
lexicon.third = A_JJ;
lexicon.thousand = A_CD;
lexicon.thousands = A_NNS;
lexicon.threw = A_VBD;
lexicon.thrift = A_NN;
lexicon.thrifts = A_NNS;
lexicon.thrown = A_VBN;
lexicon.timetable = A_NN;
lexicon.told = A_VBD_VBN;
lexicon.ton = A_NN;
lexicon.tons = A_NNS;
lexicon.took = A_VBD;
lexicon.tougher = A_JJR_RBR;
lexicon.toxin = A_NN;
lexicon.trader = A_NN;
lexicon.traders = A_NNS;
lexicon.treasury = A_NN;
lexicon.trillion = A_CD;
lexicon.tripled = A_VBN_VBD;
lexicon.troops = A_NNS;
lexicon.tuition = A_NN;
lexicon.tumble = A_NN_VB;
lexicon.tumbled = A_VBD_VBN_JJ;
lexicon.turmoil = A_NN;
lexicon.turnaround = A_NN;
lexicon.turnover = A_NN;
lexicon.unchanged = A_JJ;
lexicon.unclear = A_JJ;
lexicon.unconsolidated = A_JJ_VBD_VBN;
lexicon.unconstitutional = A_JJ;
lexicon.understood = A_VBN_VBD;
lexicon.underwriter = A_NN;
lexicon.underwriters = A_NNS;
lexicon.underwriting = A_NN_VBG;
lexicon.undisclosed = A_JJ;
lexicon.undoubtedly = A_RB;
lexicon.unnecessary = A_JJ;
lexicon.unrelated = A_JJ;
lexicon.unsecured = A_JJ;
lexicon.unsettled = A_JJ_VBD_VBN;
lexicon.unspecified = A_JJ;
lexicon.unsuccessful = A_JJ;
lexicon.unveil = A_VB;
lexicon.unveiled = A_VBD_JJ_VBN;
lexicon.upheld = A_VBD_VBN;
lexicon.upscale = A_JJ_NN_RB;
lexicon.upside = A_RB_JJ_NN;
lexicon.upward = A_RB_JJ;
lexicon.vacancy = A_NN;
lexicon.vacant = A_JJ;
lexicon.veto = A_NN_VB;
lexicon.viable = A_JJ;
lexicon.vice = A_NN_FW_JJ_RB;
lexicon.volatile = A_JJ;
lexicon.volatility = A_NN;
lexicon.voluntarily = A_RB;
lexicon.vowed = A_VBD_VBN;
lexicon.warrant = A_NN_VBP_VB;
lexicon.warrants = A_NNS_VBZ;
lexicon.wary = A_JJ;
lexicon.weaker = A_JJR_RBR;
lexicon.went = A_VBD_VBN;
lexicon.were = A_VBD_VB;
lexicon.wholesale = A_JJ_NN;
lexicon.widened = A_VBD_VBN;
lexicon.wider = A_JJR_RBR;
lexicon.withdrawn = A_VBN;
lexicon.withdrew = A_VBD;
lexicon.women = A_NNS;
lexicon.won = A_VBD_NN_NNS_VBN;
lexicon.workstations = A_NNS;
lexicon.worse = A_JJR_JJ_RBR;
lexicon.worst = A_JJS_RBS_JJ;
lexicon.wrongdoing = A_NN;
lexicon.wrote = A_VBD;
lexicon.yen = A_NNS_NN;
lexicon.younger = A_JJR;
module.exports = lexicon;